module.exports =
  /******/
  (function (modules) { // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {}
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/
      if (installedModules[moduleId]) {
        /******/
        return installedModules[moduleId].exports
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/
        i: moduleId,
        /******/
        l: false,
        /******/
        exports: {}
        /******/
      }
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__)
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/
      if (!__webpack_require__.o(exports, name)) {
        /******/
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        })
        /******/
      }
      /******/
    }
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/
      if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        })
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      /******/
    }
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/
      if (mode & 1) value = __webpack_require__(value)
      /******/
      if (mode & 8) return value
      /******/
      if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value
      /******/
      var ns = Object.create(null)
      /******/
      __webpack_require__.r(ns)
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      })
      /******/
      if (mode & 2 && typeof value !== 'string') {
        for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key]
          }.bind(null, key))
        }
      }
      /******/
      return ns
      /******/
    }
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/
      var getter = module && module.__esModule
        /******/
        ? function getDefault() {
          return module.default
        }
        /******/
        : function getModuleExports() {
          return module
        }
      /******/
      __webpack_require__.d(getter, 'a', getter)
      /******/
      return getter
      /******/
    }
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property)
    }
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = ''
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 'fb15')
    /******/
  })
/************************************************************************/
/******/
({

  /***/
  '00ee':
    /***/
    function (module, exports, __webpack_require__) {
      var wellKnownSymbol = __webpack_require__('b622')

      var TO_STRING_TAG = wellKnownSymbol('toStringTag')
      var test = {}

      test[TO_STRING_TAG] = 'z'

      module.exports = String(test) === '[object z]'
      /***/
    },

  /***/
  '0366':
    /***/
    function (module, exports, __webpack_require__) {
      var aFunction = __webpack_require__('1c0b')

      // optional / simple context binding
      module.exports = function (fn, that, length) {
        aFunction(fn)
        if (that === undefined) return fn
        switch (length) {
          case 0:
            return function () {
              return fn.call(that)
            }
          case 1:
            return function (a) {
              return fn.call(that, a)
            }
          case 2:
            return function (a, b) {
              return fn.call(that, a, b)
            }
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c)
            }
        }
        return function (/* ...args */) {
          return fn.apply(that, arguments)
        }
      }
      /***/
    },

  /***/
  '057f':
    /***/
    function (module, exports, __webpack_require__) {
      /* eslint-disable es/no-object-getownpropertynames -- safe */
      var toIndexedObject = __webpack_require__('fc6a')
      var $getOwnPropertyNames = __webpack_require__('241c').f

      var toString = {}.toString

      var windowNames = typeof window === 'object' && window && Object.getOwnPropertyNames
        ? Object.getOwnPropertyNames(window) : []

      var getWindowNames = function (it) {
        try {
          return $getOwnPropertyNames(it)
        } catch (error) {
          return windowNames.slice()
        }
      }

      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]'
          ? getWindowNames(it)
          : $getOwnPropertyNames(toIndexedObject(it))
      }
      /***/
    },

  /***/
  '06cf':
    /***/
    function (module, exports, __webpack_require__) {
      var DESCRIPTORS = __webpack_require__('83ab')
      var propertyIsEnumerableModule = __webpack_require__('d1e7')
      var createPropertyDescriptor = __webpack_require__('5c6c')
      var toIndexedObject = __webpack_require__('fc6a')
      var toPrimitive = __webpack_require__('c04e')
      var has = __webpack_require__('5135')
      var IE8_DOM_DEFINE = __webpack_require__('0cfb')

      // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
      var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor

      // `Object.getOwnPropertyDescriptor` method
      // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
      exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O)
        P = toPrimitive(P, true)
        if (IE8_DOM_DEFINE) {
          try {
            return $getOwnPropertyDescriptor(O, P)
          } catch (error) {
            /* empty */
          }
        }
        if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P])
      }
      /***/
    },

  /***/
  '0cb2':
    /***/
    function (module, exports, __webpack_require__) {
      var toObject = __webpack_require__('7b0b')

      var floor = Math.floor
      var replace = ''.replace
      var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g
      var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g

      // `GetSubstitution` abstract operation
      // https://tc39.es/ecma262/#sec-getsubstitution
      module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length
        var m = captures.length
        var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED
        if (namedCaptures !== undefined) {
          namedCaptures = toObject(namedCaptures)
          symbols = SUBSTITUTION_SYMBOLS
        }
        return replace.call(replacement, symbols, function (match, ch) {
          var capture
          switch (ch.charAt(0)) {
            case '$':
              return '$'
            case '&':
              return matched
            case '`':
              return str.slice(0, position)
            case "'":
              return str.slice(tailPos)
            case '<':
              capture = namedCaptures[ch.slice(1, -1)]
              break
            default: // \d\d?
              var n = +ch
              if (n === 0) return match
              if (n > m) {
                var f = floor(n / 10)
                if (f === 0) return match
                if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1)
                return match
              }
              capture = captures[n - 1]
          }
          return capture === undefined ? '' : capture
        })
      }
      /***/
    },

  /***/
  '0cfb':
    /***/
    function (module, exports, __webpack_require__) {
      var DESCRIPTORS = __webpack_require__('83ab')
      var fails = __webpack_require__('d039')
      var createElement = __webpack_require__('cc12')

      // Thank's IE8 for his funny defineProperty
      module.exports = !DESCRIPTORS && !fails(function () {
        // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
        return Object.defineProperty(createElement('div'), 'a', {
          get: function () {
            return 7
          }
        }).a != 7
      })
      /***/
    },

  /***/
  '107c':
    /***/
    function (module, exports, __webpack_require__) {
      var fails = __webpack_require__('d039')

      module.exports = fails(function () {
        // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
        var re = RegExp('(?<a>b)', (typeof '').charAt(5))
        return re.exec('b').groups.a !== 'b' ||
          'b'.replace(re, '$<a>c') !== 'bc'
      })
      /***/
    },

  /***/
  1148:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var toInteger = __webpack_require__('a691')
      var requireObjectCoercible = __webpack_require__('1d80')

      // `String.prototype.repeat` method implementation
      // https://tc39.es/ecma262/#sec-string.prototype.repeat
      module.exports = function repeat(count) {
        var str = String(requireObjectCoercible(this))
        var result = ''
        var n = toInteger(count)
        if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions')
        for (; n > 0;
          (n >>>= 1) && (str += str)) {
          if (n & 1) result += str
        }
        return result
      }
      /***/
    },

  /***/
  1157:
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * jQuery JavaScript Library v3.5.0
       * https://jquery.com/
       *
       * Includes Sizzle.js
       * https://sizzlejs.com/
       *
       * Copyright JS Foundation and other contributors
       * Released under the MIT license
       * https://jquery.org/license
       *
       * Date: 2020-04-10T15:07Z
       */
      (function (global, factory) {
        'use strict'

        if (true && typeof module.exports === 'object') {
          // For CommonJS and CommonJS-like environments where a proper `window`
          // is present, execute the factory and get jQuery.
          // For environments that do not have a `window` with a `document`
          // (such as Node.js), expose a factory as module.exports.
          // This accentuates the need for the creation of a real `window`.
          // e.g. var jQuery = require("jquery")(window);
          // See ticket #14549 for more info.
          module.exports = global.document
            ? factory(global, true)
            : function (w) {
              if (!w.document) {
                throw new Error('jQuery requires a window with a document')
              }
              return factory(w)
            }
        } else {
          factory(global)
        }

        // Pass this if window is not defined yet
      })(typeof window !== 'undefined' ? window : this, function (window, noGlobal) {
        // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
        // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
        // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
        // enough that all such attempts are guarded in a try block.
        'use strict'

        var arr = []

        var getProto = Object.getPrototypeOf

        var slice = arr.slice

        var flat = arr.flat ? function (array) {
          return arr.flat.call(array)
        } : function (array) {
          return arr.concat.apply([], array)
        }

        var push = arr.push

        var indexOf = arr.indexOf

        var class2type = {}

        var toString = class2type.toString

        var hasOwn = class2type.hasOwnProperty

        var fnToString = hasOwn.toString

        var ObjectFunctionString = fnToString.call(Object)

        var support = {}

        var isFunction = function isFunction(obj) {
          // Support: Chrome <=57, Firefox <=52
          // In some browsers, typeof returns "function" for HTML <object> elements
          // (i.e., `typeof document.createElement( "object" ) === "function"`).
          // We don't want to classify *any* DOM node as a function.
          return typeof obj === 'function' && typeof obj.nodeType !== 'number'
        }

        var isWindow = function isWindow(obj) {
          return obj != null && obj === obj.window
        }

        var document = window.document

        var preservedScriptAttributes = {
          type: true,
          src: true,
          nonce: true,
          noModule: true
        }

        function DOMEval(code, node, doc) {
          doc = doc || document

          var i
          var val
          var script = doc.createElement('script')

          script.text = code
          if (node) {
            for (i in preservedScriptAttributes) {
              // Support: Firefox 64+, Edge 18+
              // Some browsers don't support the "nonce" property on scripts.
              // On the other hand, just using `getAttribute` is not enough as
              // the `nonce` attribute is reset to an empty string whenever it
              // becomes browsing-context connected.
              // See https://github.com/whatwg/html/issues/2369
              // See https://html.spec.whatwg.org/#nonce-attributes
              // The `node.getAttribute` check was added for the sake of
              // `jQuery.globalEval` so that it can fake a nonce-containing node
              // via an object.
              val = node[i] || node.getAttribute && node.getAttribute(i)
              if (val) {
                script.setAttribute(i, val)
              }
            }
          }
          doc.head.appendChild(script).parentNode.removeChild(script)
        }

        function toType(obj) {
          if (obj == null) {
            return obj + ''
          }

          // Support: Android <=2.3 only (functionish RegExp)
          return typeof obj === 'object' || typeof obj === 'function'
            ? class2type[toString.call(obj)] || 'object'
            : typeof obj
        }
        /* global Symbol */
        // Defining this global in .eslintrc.json would create a danger of using the global
        // unguarded in another place, it seems safer to define global only for this module

        var
          version = '3.5.0'

        // Define a local copy of jQuery
        var jQuery = function (selector, context) {
          // The jQuery object is actually just the init constructor 'enhanced'
          // Need init if jQuery is called (just allow error to be thrown if not included)
          return new jQuery.fn.init(selector, context)
        }

        jQuery.fn = jQuery.prototype = {

          // The current version of jQuery being used
          jquery: version,

          constructor: jQuery,

          // The default length of a jQuery object is 0
          length: 0,

          toArray: function () {
            return slice.call(this)
          },

          // Get the Nth element in the matched element set OR
          // Get the whole matched element set as a clean array
          get: function (num) {
            // Return all the elements in a clean array
            if (num == null) {
              return slice.call(this)
            }

            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num]
          },

          // Take an array of elements and push it onto the stack
          // (returning the new matched element set)
          pushStack: function (elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems)

            // Add the old object onto the stack (as a reference)
            ret.prevObject = this

            // Return the newly-formed element set
            return ret
          },

          // Execute a callback for every element in the matched set.
          each: function (callback) {
            return jQuery.each(this, callback)
          },

          map: function (callback) {
            return this.pushStack(jQuery.map(this, function (elem, i) {
              return callback.call(elem, i, elem)
            }))
          },

          slice: function () {
            return this.pushStack(slice.apply(this, arguments))
          },

          first: function () {
            return this.eq(0)
          },

          last: function () {
            return this.eq(-1)
          },

          even: function () {
            return this.pushStack(jQuery.grep(this, function (_elem, i) {
              return (i + 1) % 2
            }))
          },

          odd: function () {
            return this.pushStack(jQuery.grep(this, function (_elem, i) {
              return i % 2
            }))
          },

          eq: function (i) {
            var len = this.length
            var j = +i + (i < 0 ? len : 0)
            return this.pushStack(j >= 0 && j < len ? [this[j]] : [])
          },

          end: function () {
            return this.prevObject || this.constructor()
          },

          // For internal use only.
          // Behaves like an Array's method, not like a jQuery method.
          push: push,
          sort: arr.sort,
          splice: arr.splice
        }

        jQuery.extend = jQuery.fn.extend = function () {
          var options
          var name
          var src
          var copy
          var copyIsArray
          var clone
          var target = arguments[0] || {}
          var i = 1
          var length = arguments.length
          var deep = false

          // Handle a deep copy situation
          if (typeof target === 'boolean') {
            deep = target

            // Skip the boolean and the target
            target = arguments[i] || {}
            i++
          }

          // Handle case when target is a string or something (possible in deep copy)
          if (typeof target !== 'object' && !isFunction(target)) {
            target = {}
          }

          // Extend jQuery itself if only one argument is passed
          if (i === length) {
            target = this
            i--
          }

          for (; i < length; i++) {
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) {
              // Extend the base object
              for (name in options) {
                copy = options[name]

                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === '__proto__' || target === copy) {
                  continue
                }

                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) ||
                    (copyIsArray = Array.isArray(copy)))) {
                  src = target[name]

                  // Ensure proper type for the source value
                  if (copyIsArray && !Array.isArray(src)) {
                    clone = []
                  } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                    clone = {}
                  } else {
                    clone = src
                  }
                  copyIsArray = false

                  // Never move original objects, clone them
                  target[name] = jQuery.extend(deep, clone, copy)

                  // Don't bring in undefined values
                } else if (copy !== undefined) {
                  target[name] = copy
                }
              }
            }
          }

          // Return the modified object
          return target
        }

        jQuery.extend({

          // Unique for each copy of jQuery on the page
          expando: 'jQuery' + (version + Math.random()).replace(/\D/g, ''),

          // Assume jQuery is ready without the ready module
          isReady: true,

          error: function (msg) {
            throw new Error(msg)
          },

          noop: function () {},

          isPlainObject: function (obj) {
            var proto, Ctor

            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== '[object Object]') {
              return false
            }

            proto = getProto(obj)

            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) {
              return true
            }

            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, 'constructor') && proto.constructor
            return typeof Ctor === 'function' && fnToString.call(Ctor) === ObjectFunctionString
          },

          isEmptyObject: function (obj) {
            var name

            for (name in obj) {
              return false
            }
            return true
          },

          // Evaluates a script in a provided context; falls back to the global one
          // if not specified.
          globalEval: function (code, options, doc) {
            DOMEval(code, {
              nonce: options && options.nonce
            }, doc)
          },

          each: function (obj, callback) {
            var length
            var i = 0

            if (isArrayLike(obj)) {
              length = obj.length
              for (; i < length; i++) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break
                }
              }
            } else {
              for (i in obj) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break
                }
              }
            }

            return obj
          },

          // results is for internal usage only
          makeArray: function (arr, results) {
            var ret = results || []

            if (arr != null) {
              if (isArrayLike(Object(arr))) {
                jQuery.merge(ret,
                  typeof arr === 'string' ? [arr] : arr
                )
              } else {
                push.call(ret, arr)
              }
            }

            return ret
          },

          inArray: function (elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i)
          },

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          merge: function (first, second) {
            var len = +second.length
            var j = 0
            var i = first.length

            for (; j < len; j++) {
              first[i++] = second[j]
            }

            first.length = i

            return first
          },

          grep: function (elems, callback, invert) {
            var callbackInverse
            var matches = []
            var i = 0
            var length = elems.length
            var callbackExpect = !invert

            // Go through the array, only saving the items
            // that pass the validator function
            for (; i < length; i++) {
              callbackInverse = !callback(elems[i], i)
              if (callbackInverse !== callbackExpect) {
                matches.push(elems[i])
              }
            }

            return matches
          },

          // arg is for internal usage only
          map: function (elems, callback, arg) {
            var length
            var value
            var i = 0
            var ret = []

            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
              length = elems.length
              for (; i < length; i++) {
                value = callback(elems[i], i, arg)

                if (value != null) {
                  ret.push(value)
                }
              }

              // Go through every key on the object,
            } else {
              for (i in elems) {
                value = callback(elems[i], i, arg)

                if (value != null) {
                  ret.push(value)
                }
              }
            }

            // Flatten any nested arrays
            return flat(ret)
          },

          // A global GUID counter for objects
          guid: 1,

          // jQuery.support is not used in Core but other projects attach their
          // properties to it so it needs to exist.
          support: support
        })

        if (typeof Symbol === 'function') {
          jQuery.fn[Symbol.iterator] = arr[Symbol.iterator]
        }

        // Populate the class2type map
        jQuery.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
          function (_i, name) {
            class2type['[object ' + name + ']'] = name.toLowerCase()
          })

        function isArrayLike(obj) {
          // Support: real iOS 8.2 only (not reproducible in simulator)
          // `in` check used to prevent JIT error (gh-2145)
          // hasOwn isn't used here due to false negatives
          // regarding Nodelist length in IE
          var length = !!obj && 'length' in obj && obj.length
          var type = toType(obj)

          if (isFunction(obj) || isWindow(obj)) {
            return false
          }

          return type === 'array' || length === 0 ||
            typeof length === 'number' && length > 0 && (length - 1) in obj
        }
        var Sizzle =
          /*!
           * Sizzle CSS Selector Engine v2.3.5
           * https://sizzlejs.com/
           *
           * Copyright JS Foundation and other contributors
           * Released under the MIT license
           * https://js.foundation/
           *
           * Date: 2020-03-14
           */
          (function (window) {
            var i
            var support
            var Expr
            var getText
            var isXML
            var tokenize
            var compile
            var select
            var outermostContext
            var sortInput
            var hasDuplicate

            // Local document vars
            var setDocument
            var document
            var docElem
            var documentIsHTML
            var rbuggyQSA
            var rbuggyMatches
            var matches
            var contains

            // Instance-specific data
            var expando = 'sizzle' + 1 * new Date()
            var preferredDoc = window.document
            var dirruns = 0
            var done = 0
            var classCache = createCache()
            var tokenCache = createCache()
            var compilerCache = createCache()
            var nonnativeSelectorCache = createCache()
            var sortOrder = function (a, b) {
              if (a === b) {
                hasDuplicate = true
              }
              return 0
            }

            // Instance methods
            var hasOwn = ({}).hasOwnProperty
            var arr = []
            var pop = arr.pop
            var pushNative = arr.push
            var push = arr.push
            var slice = arr.slice

            // Use a stripped-down indexOf as it's faster than native
            // https://jsperf.com/thor-indexof-vs-for/5
            var indexOf = function (list, elem) {
              var i = 0
              var len = list.length
              for (; i < len; i++) {
                if (list[i] === elem) {
                  return i
                }
              }
              return -1
            }

            var booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|' +
              'ismap|loop|multiple|open|readonly|required|scoped'

            // Regular expressions

            // http://www.w3.org/TR/css3-selectors/#whitespace
            var whitespace = '[\\x20\\t\\r\\n\\f]'

            // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
            var identifier = '(?:\\\\[\\da-fA-F]{1,6}' + whitespace +
              '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+'

            // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
            var attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace +

              // Operator (capture 2)
              '*([*^$|!~]?=)' + whitespace +

              // "Attribute values must be CSS identifiers [capture 5]
              // or strings [capture 3 or capture 4]"
              "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + '))|)' +
              whitespace + '*\\]'

            var pseudos = ':(' + identifier + ')(?:\\((' +

              // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
              // 1. quoted (capture 3; capture 4 or capture 5)
              "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

              // 2. simple (capture 6)
              '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' +

              // 3. anything else (capture 2)
              '.*' +
              ')\\)|)'

            // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
            var rwhitespace = new RegExp(whitespace + '+', 'g')
            var rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' +
              whitespace + '+$', 'g')

            var rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*')
            var rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace +
              '*')
            var rdescend = new RegExp(whitespace + '|>')

            var rpseudo = new RegExp(pseudos)
            var ridentifier = new RegExp('^' + identifier + '$')

            var matchExpr = {
              ID: new RegExp('^#(' + identifier + ')'),
              CLASS: new RegExp('^\\.(' + identifier + ')'),
              TAG: new RegExp('^(' + identifier + '|[*])'),
              ATTR: new RegExp('^' + attributes),
              PSEUDO: new RegExp('^' + pseudos),
              CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' +
                whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
              bool: new RegExp('^(?:' + booleans + ')$', 'i'),

              // For use in libraries implementing .is()
              // We use this for POS matching in `select`
              needsContext: new RegExp('^' + whitespace +
                '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace +
                '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
            }

            var rhtml = /HTML$/i
            var rinputs = /^(?:input|select|textarea|button)$/i
            var rheader = /^h\d$/i

            var rnative = /^[^{]+\{\s*\[native \w/

            // Easily-parseable/retrievable ID or TAG or CLASS selectors
            var rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/

            var rsibling = /[+~]/

            // CSS escapes
            // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
            var runescape = new RegExp('\\\\[\\da-fA-F]{1,6}' + whitespace + '?|\\\\([^\\r\\n\\f])', 'g')
            var funescape = function (escape, nonHex) {
              var high = '0x' + escape.slice(1) - 0x10000

              return nonHex

                // Strip the backslash prefix from a non-hex escape sequence
                ? nonHex

                // Replace a hexadecimal escape sequence with the encoded Unicode code point
                // Support: IE <=11+
                // For values outside the Basic Multilingual Plane (BMP), manually construct a
                // surrogate pair
                : high < 0
                ? String.fromCharCode(high + 0x10000)
                : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00)
            }

            // CSS string/identifier serialization
            // https://drafts.csswg.org/cssom/#common-serializing-idioms
            var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g
            var fcssescape = function (ch, asCodePoint) {
              if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === '\0') {
                  return '\uFFFD'
                }

                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + '\\' +
                  ch.charCodeAt(ch.length - 1).toString(16) + ' '
              }

              // Other potentially-special ASCII characters get backslash-escaped
              return '\\' + ch
            }

            // Used for iframes
            // See setDocument()
            // Removing the function wrapper causes a "Permission Denied"
            // error in IE
            var unloadHandler = function () {
              setDocument()
            }

            var inDisabledFieldset = addCombinator(
              function (elem) {
                return elem.disabled === true && elem.nodeName.toLowerCase() === 'fieldset'
              }, {
                dir: 'parentNode',
                next: 'legend'
              }
            )

            // Optimize for push.apply( _, NodeList )
            try {
              push.apply(
                (arr = slice.call(preferredDoc.childNodes)),
                preferredDoc.childNodes
              )

              // Support: Android<4.0
              // Detect silently failing push.apply
              // eslint-disable-next-line no-unused-expressions
              arr[preferredDoc.childNodes.length].nodeType
            } catch (e) {
              push = {
                apply: arr.length

                  // Leverage slice if possible
                  ? function (target, els) {
                    pushNative.apply(target, slice.call(els))
                  }

                  // Support: IE<9
                  // Otherwise append directly
                  : function (target, els) {
                    var j = target.length
                    var i = 0

                    // Can't trust NodeList.length
                    while ((target[j++] = els[i++])) {}
                    target.length = j - 1
                  }
              }
            }

            function Sizzle(selector, context, results, seed) {
              var m
              var i
              var elem
              var nid
              var match
              var groups
              var newSelector
              var newContext = context && context.ownerDocument

              // nodeType defaults to 9, since context defaults to document
              var nodeType = context ? context.nodeType : 9

              results = results || []

              // Return early from calls with invalid selector or context
              if (typeof selector !== 'string' || !selector ||
                nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
                return results
              }

              // Try to shortcut find operations (as opposed to filters) in HTML documents
              if (!seed) {
                setDocument(context)
                context = context || document

                if (documentIsHTML) {
                  // If the selector is sufficiently simple, try using a "get*By*" DOM method
                  // (excepting DocumentFragment context, where the methods don't exist)
                  if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                    // ID selector
                    if ((m = match[1])) {
                      // Document context
                      if (nodeType === 9) {
                        if ((elem = context.getElementById(m))) {
                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (elem.id === m) {
                            results.push(elem)
                            return results
                          }
                        } else {
                          return results
                        }

                        // Element context
                      } else {
                        // Support: IE, Opera, Webkit
                        // TODO: identify versions
                        // getElementById can match elements by name instead of ID
                        if (newContext && (elem = newContext.getElementById(m)) &&
                          contains(context, elem) &&
                          elem.id === m) {
                          results.push(elem)
                          return results
                        }
                      }

                      // Type selector
                    } else if (match[2]) {
                      push.apply(results, context.getElementsByTagName(selector))
                      return results

                      // Class selector
                    } else if ((m = match[3]) && support.getElementsByClassName &&
                      context.getElementsByClassName) {
                      push.apply(results, context.getElementsByClassName(m))
                      return results
                    }
                  }

                  // Take advantage of querySelectorAll
                  if (support.qsa &&
                    !nonnativeSelectorCache[selector + ' '] &&
                    (!rbuggyQSA || !rbuggyQSA.test(selector)) &&

                    // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== 'object')) {
                    newSelector = selector
                    newContext = context

                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 &&
                      (rdescend.test(selector) || rcombinators.test(selector))) {
                      // Expand context for sibling selectors
                      newContext = rsibling.test(selector) && testContext(context.parentNode) ||
                        context

                      // We can use :scope instead of the ID hack if the browser
                      // supports it & if we're not changing the context.
                      if (newContext !== context || !support.scope) {
                        // Capture the context ID, setting it first if necessary
                        if ((nid = context.getAttribute('id'))) {
                          nid = nid.replace(rcssescape, fcssescape)
                        } else {
                          context.setAttribute('id', (nid = expando))
                        }
                      }

                      // Prefix every selector in the list
                      groups = tokenize(selector)
                      i = groups.length
                      while (i--) {
                        groups[i] = (nid ? '#' + nid : ':scope') + ' ' +
                          toSelector(groups[i])
                      }
                      newSelector = groups.join(',')
                    }

                    try {
                      push.apply(results,
                        newContext.querySelectorAll(newSelector)
                      )
                      return results
                    } catch (qsaError) {
                      nonnativeSelectorCache(selector, true)
                    } finally {
                      if (nid === expando) {
                        context.removeAttribute('id')
                      }
                    }
                  }
                }
              }

              // All others
              return select(selector.replace(rtrim, '$1'), context, results, seed)
            }

            /**
             * Create key-value caches of limited size
             * @returns {function(string, object)} Returns the Object data after storing it on itself with
             *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
             *	deleting the oldest entry
             */
            function createCache() {
              var keys = []

              function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + ' ') > Expr.cacheLength) {
                  // Only keep the most recent entries
                  delete cache[keys.shift()]
                }
                return (cache[key + ' '] = value)
              }
              return cache
            }

            /**
             * Mark a function for special use by Sizzle
             * @param {Function} fn The function to mark
             */
            function markFunction(fn) {
              fn[expando] = true
              return fn
            }

            /**
             * Support testing using an element
             * @param {Function} fn Passed the created element and returns a boolean result
             */
            function assert(fn) {
              var el = document.createElement('fieldset')

              try {
                return !!fn(el)
              } catch (e) {
                return false
              } finally {
                // Remove from its parent by default
                if (el.parentNode) {
                  el.parentNode.removeChild(el)
                }

                // release memory in IE
                el = null
              }
            }

            /**
             * Adds the same handler for all of the specified attrs
             * @param {String} attrs Pipe-separated list of attributes
             * @param {Function} handler The method that will be applied
             */
            function addHandle(attrs, handler) {
              var arr = attrs.split('|')
              var i = arr.length

              while (i--) {
                Expr.attrHandle[arr[i]] = handler
              }
            }

            /**
             * Checks document order of two siblings
             * @param {Element} a
             * @param {Element} b
             * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
             */
            function siblingCheck(a, b) {
              var cur = b && a
              var diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                a.sourceIndex - b.sourceIndex

              // Use IE sourceIndex if available on both nodes
              if (diff) {
                return diff
              }

              // Check if b follows a
              if (cur) {
                while ((cur = cur.nextSibling)) {
                  if (cur === b) {
                    return -1
                  }
                }
              }

              return a ? 1 : -1
            }

            /**
             * Returns a function to use in pseudos for input types
             * @param {String} type
             */
            function createInputPseudo(type) {
              return function (elem) {
                var name = elem.nodeName.toLowerCase()
                return name === 'input' && elem.type === type
              }
            }

            /**
             * Returns a function to use in pseudos for buttons
             * @param {String} type
             */
            function createButtonPseudo(type) {
              return function (elem) {
                var name = elem.nodeName.toLowerCase()
                return (name === 'input' || name === 'button') && elem.type === type
              }
            }

            /**
             * Returns a function to use in pseudos for :enabled/:disabled
             * @param {Boolean} disabled true for :disabled; false for :enabled
             */
            function createDisabledPseudo(disabled) {
              // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
              return function (elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ('form' in elem) {
                  // Check for inherited disabledness on relevant non-disabled elements:
                  // * listed form-associated elements in a disabled fieldset
                  //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                  //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                  // * option elements in a disabled optgroup
                  //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                  // All such elements have a "form" property.
                  if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ('label' in elem) {
                      if ('label' in elem.parentNode) {
                        return elem.parentNode.disabled === disabled
                      } else {
                        return elem.disabled === disabled
                      }
                    }

                    // Support: IE 6 - 11
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled ||

                      // Where there is no isDisabled, check manually
                      /* jshint -W018 */
                      elem.isDisabled !== !disabled &&
                      inDisabledFieldset(elem) === disabled
                  }

                  return elem.disabled === disabled

                  // Try to winnow out elements that can't be disabled before trusting the disabled property.
                  // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                  // even exist on them, let alone have a boolean value.
                } else if ('label' in elem) {
                  return elem.disabled === disabled
                }

                // Remaining elements are neither :enabled nor :disabled
                return false
              }
            }

            /**
             * Returns a function to use in pseudos for positionals
             * @param {Function} fn
             */
            function createPositionalPseudo(fn) {
              return markFunction(function (argument) {
                argument = +argument
                return markFunction(function (seed, matches) {
                  var j
                  var matchIndexes = fn([], seed.length, argument)
                  var i = matchIndexes.length

                  // Match elements found at the specified indexes
                  while (i--) {
                    if (seed[(j = matchIndexes[i])]) {
                      seed[j] = !(matches[j] = seed[j])
                    }
                  }
                })
              })
            }

            /**
             * Checks a node for validity as a Sizzle context
             * @param {Element|Object=} context
             * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
             */
            function testContext(context) {
              return context && typeof context.getElementsByTagName !== 'undefined' && context
            }

            // Expose support vars for convenience
            support = Sizzle.support = {}

            /**
             * Detects XML nodes
             * @param {Element|Object} elem An element or a document
             * @returns {Boolean} True iff elem is a non-HTML XML node
             */
            isXML = Sizzle.isXML = function (elem) {
              var namespace = elem.namespaceURI
              var docElem = (elem.ownerDocument || elem).documentElement

              // Support: IE <=8
              // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
              // https://bugs.jquery.com/ticket/4833
              return !rhtml.test(namespace || docElem && docElem.nodeName || 'HTML')
            }

            /**
             * Sets document-related variables once based on the current document
             * @param {Element|Object} [doc] An element or document object to use to set the document
             * @returns {Object} Returns the current document
             */
            setDocument = Sizzle.setDocument = function (node) {
              var hasCompare
              var subWindow
              var doc = node ? node.ownerDocument || node : preferredDoc

              // Return early if doc is invalid or already selected
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
                return document
              }

              // Update global variables
              document = doc
              docElem = document.documentElement
              documentIsHTML = !isXML(document)

              // Support: IE 9 - 11+, Edge 12 - 18+
              // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (preferredDoc != document &&
                (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) {
                  subWindow.addEventListener('unload', unloadHandler, false)

                  // Support: IE 9 - 10 only
                } else if (subWindow.attachEvent) {
                  subWindow.attachEvent('onunload', unloadHandler)
                }
              }

              // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
              // Safari 4 - 5 only, Opera <=11.6 - 12.x only
              // IE/Edge & older browsers don't support the :scope pseudo-class.
              // Support: Safari 6.0 only
              // Safari 6.0 supports :scope but it's an alias of :root there.
              support.scope = assert(function (el) {
                docElem.appendChild(el).appendChild(document.createElement('div'))
                return typeof el.querySelectorAll !== 'undefined' &&
                  !el.querySelectorAll(':scope fieldset div').length
              })

              /* Attributes
              ---------------------------------------------------------------------- */

              // Support: IE<8
              // Verify that getAttribute really returns attributes and not properties
              // (excepting IE8 booleans)
              support.attributes = assert(function (el) {
                el.className = 'i'
                return !el.getAttribute('className')
              })

              /* getElement(s)By*
              ---------------------------------------------------------------------- */

              // Check if getElementsByTagName("*") returns only elements
              support.getElementsByTagName = assert(function (el) {
                el.appendChild(document.createComment(''))
                return !el.getElementsByTagName('*').length
              })

              // Support: IE<9
              support.getElementsByClassName = rnative.test(document.getElementsByClassName)

              // Support: IE<10
              // Check if getElementById returns elements by name
              // The broken getElementById methods don't pick up programmatically-set names,
              // so use a roundabout getElementsByName test
              support.getById = assert(function (el) {
                docElem.appendChild(el).id = expando
                return !document.getElementsByName || !document.getElementsByName(expando).length
              })

              // ID filter and find
              if (support.getById) {
                Expr.filter.ID = function (id) {
                  var attrId = id.replace(runescape, funescape)
                  return function (elem) {
                    return elem.getAttribute('id') === attrId
                  }
                }
                Expr.find.ID = function (id, context) {
                  if (typeof context.getElementById !== 'undefined' && documentIsHTML) {
                    var elem = context.getElementById(id)
                    return elem ? [elem] : []
                  }
                }
              } else {
                Expr.filter.ID = function (id) {
                  var attrId = id.replace(runescape, funescape)
                  return function (elem) {
                    var node = typeof elem.getAttributeNode !== 'undefined' &&
                      elem.getAttributeNode('id')
                    return node && node.value === attrId
                  }
                }

                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function (id, context) {
                  if (typeof context.getElementById !== 'undefined' && documentIsHTML) {
                    var node
                    var i
                    var elems
                    var elem = context.getElementById(id)

                    if (elem) {
                      // Verify the id attribute
                      node = elem.getAttributeNode('id')
                      if (node && node.value === id) {
                        return [elem]
                      }

                      // Fall back on getElementsByName
                      elems = context.getElementsByName(id)
                      i = 0
                      while ((elem = elems[i++])) {
                        node = elem.getAttributeNode('id')
                        if (node && node.value === id) {
                          return [elem]
                        }
                      }
                    }

                    return []
                  }
                }
              }

              // Tag
              Expr.find.TAG = support.getElementsByTagName
                ? function (tag, context) {
                  if (typeof context.getElementsByTagName !== 'undefined') {
                    return context.getElementsByTagName(tag)

                    // DocumentFragment nodes don't have gEBTN
                  } else if (support.qsa) {
                    return context.querySelectorAll(tag)
                  }
                }

                : function (tag, context) {
                  var elem
                  var tmp = []
                  var i = 0

                  // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                  var results = context.getElementsByTagName(tag)

                  // Filter out possible comments
                  if (tag === '*') {
                    while ((elem = results[i++])) {
                      if (elem.nodeType === 1) {
                        tmp.push(elem)
                      }
                    }

                    return tmp
                  }
                  return results
                }

              // Class
              Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
                if (typeof context.getElementsByClassName !== 'undefined' && documentIsHTML) {
                  return context.getElementsByClassName(className)
                }
              }

              /* QSA/matchesSelector
              ---------------------------------------------------------------------- */

              // QSA and matchesSelector support

              // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
              rbuggyMatches = []

              // qSa(:focus) reports false when true (Chrome 21)
              // We allow this because of a bug in IE8/9 that throws an error
              // whenever `document.activeElement` is accessed on an iframe
              // So, we allow :focus to pass through QSA all the time to avoid the IE error
              // See https://bugs.jquery.com/ticket/13378
              rbuggyQSA = []

              if ((support.qsa = rnative.test(document.querySelectorAll))) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function (el) {
                  var input

                  // Select is set to empty string on purpose
                  // This is to test IE's treatment of not explicitly
                  // setting a boolean content attribute,
                  // since its presence should be enough
                  // https://bugs.jquery.com/ticket/12359
                  docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" +
                    "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                    "<option selected=''></option></select>"

                  // Support: IE8, Opera 11-12.16
                  // Nothing should be selected when empty strings follow ^= or $= or *=
                  // The test attribute must be unknown in Opera but "safe" for WinRT
                  // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                  if (el.querySelectorAll("[msallowcapture^='']").length) {
                    rbuggyQSA.push('[*^$]=' + whitespace + "*(?:''|\"\")")
                  }

                  // Support: IE8
                  // Boolean attributes and "value" are not treated correctly
                  if (!el.querySelectorAll('[selected]').length) {
                    rbuggyQSA.push('\\[' + whitespace + '*(?:value|' + booleans + ')')
                  }

                  // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                  if (!el.querySelectorAll('[id~=' + expando + '-]').length) {
                    rbuggyQSA.push('~=')
                  }

                  // Support: IE 11+, Edge 15 - 18+
                  // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                  // Adding a temporary attribute to the document before the selection works
                  // around the issue.
                  // Interestingly, IE 10 & older don't seem to have the issue.
                  input = document.createElement('input')
                  input.setAttribute('name', '')
                  el.appendChild(input)
                  if (!el.querySelectorAll("[name='']").length) {
                    rbuggyQSA.push('\\[' + whitespace + '*name' + whitespace + '*=' +
                      whitespace + "*(?:''|\"\")")
                  }

                  // Webkit/Opera - :checked should return selected option elements
                  // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                  // IE8 throws error here and will not see later tests
                  if (!el.querySelectorAll(':checked').length) {
                    rbuggyQSA.push(':checked')
                  }

                  // Support: Safari 8+, iOS 8+
                  // https://bugs.webkit.org/show_bug.cgi?id=136851
                  // In-page `selector#id sibling-combinator selector` fails
                  if (!el.querySelectorAll('a#' + expando + '+*').length) {
                    rbuggyQSA.push('.#.+[+~]')
                  }

                  // Support: Firefox <=3.6 - 5 only
                  // Old Firefox doesn't throw on a badly-escaped identifier.
                  el.querySelectorAll('\\\f')
                  rbuggyQSA.push('[\\r\\n\\f]')
                })

                assert(function (el) {
                  el.innerHTML = "<a href='' disabled='disabled'></a>" +
                    "<select disabled='disabled'><option/></select>"

                  // Support: Windows 8 Native Apps
                  // The type and name attributes are restricted during .innerHTML assignment
                  var input = document.createElement('input')
                  input.setAttribute('type', 'hidden')
                  el.appendChild(input).setAttribute('name', 'D')

                  // Support: IE8
                  // Enforce case-sensitivity of name attribute
                  if (el.querySelectorAll('[name=d]').length) {
                    rbuggyQSA.push('name' + whitespace + '*[*^$|!~]?=')
                  }

                  // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                  // IE8 throws error here and will not see later tests
                  if (el.querySelectorAll(':enabled').length !== 2) {
                    rbuggyQSA.push(':enabled', ':disabled')
                  }

                  // Support: IE9-11+
                  // IE's :disabled selector does not pick up the children of disabled fieldsets
                  docElem.appendChild(el).disabled = true
                  if (el.querySelectorAll(':disabled').length !== 2) {
                    rbuggyQSA.push(':enabled', ':disabled')
                  }

                  // Support: Opera 10 - 11 only
                  // Opera 10-11 does not throw on post-comma invalid pseudos
                  el.querySelectorAll('*,:x')
                  rbuggyQSA.push(',.*:')
                })
              }

              if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
                  docElem.webkitMatchesSelector ||
                  docElem.mozMatchesSelector ||
                  docElem.oMatchesSelector ||
                  docElem.msMatchesSelector)))) {
                assert(function (el) {
                  // Check to see if it's possible to do matchesSelector
                  // on a disconnected node (IE 9)
                  support.disconnectedMatch = matches.call(el, '*')

                  // This should fail with an exception
                  // Gecko does not error, returns false instead
                  matches.call(el, "[s!='']:x")
                  rbuggyMatches.push('!=', pseudos)
                })
              }

              rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'))
              rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'))

              /* Contains
              ---------------------------------------------------------------------- */
              hasCompare = rnative.test(docElem.compareDocumentPosition)

              // Element contains another
              // Purposefully self-exclusive
              // As in, an element does not contain itself
              contains = hasCompare || rnative.test(docElem.contains)
                ? function (a, b) {
                  var adown = a.nodeType === 9 ? a.documentElement : a
                  var bup = b && b.parentNode
                  return a === bup || !!(bup && bup.nodeType === 1 && (
                    adown.contains
                    ? adown.contains(bup)
                    : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
                  ))
                }
                : function (a, b) {
                  if (b) {
                    while ((b = b.parentNode)) {
                      if (b === a) {
                        return true
                      }
                    }
                  }
                  return false
                }

              /* Sorting
              ---------------------------------------------------------------------- */

              // Document order sorting
              sortOrder = hasCompare
                ? function (a, b) {
                  // Flag for duplicate removal
                  if (a === b) {
                    hasDuplicate = true
                    return 0
                  }

                  // Sort on method existence if only one input has compareDocumentPosition
                  var compare = !a.compareDocumentPosition - !b.compareDocumentPosition
                  if (compare) {
                    return compare
                  }

                  // Calculate position if both inputs belong to the same document
                  // Support: IE 11+, Edge 17 - 18+
                  // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                  // two documents; shallow comparisons work.
                  // eslint-disable-next-line eqeqeq
                  compare = (a.ownerDocument || a) == (b.ownerDocument || b)
                    ? a.compareDocumentPosition(b)

                    // Otherwise we know they are disconnected
                    : 1

                  // Disconnected nodes
                  if (compare & 1 ||
                    (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc &&
                      contains(preferredDoc, a)) {
                      return -1
                    }

                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc &&
                      contains(preferredDoc, b)) {
                      return 1
                    }

                    // Maintain original order
                    return sortInput
                      ? (indexOf(sortInput, a) - indexOf(sortInput, b))
                      : 0
                  }

                  return compare & 4 ? -1 : 1
                }
                : function (a, b) {
                  // Exit early if the nodes are identical
                  if (a === b) {
                    hasDuplicate = true
                    return 0
                  }

                  var cur
                  var i = 0
                  var aup = a.parentNode
                  var bup = b.parentNode
                  var ap = [a]
                  var bp = [b]

                  // Parentless nodes are either documents or disconnected
                  if (!aup || !bup) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    /* eslint-disable eqeqeq */
                    return a == document ? -1
                      : b == document ? 1
                      /* eslint-enable eqeqeq */
                      : aup ? -1
                      : bup ? 1
                      : sortInput
                      ? (indexOf(sortInput, a) - indexOf(sortInput, b))
                      : 0

                    // If the nodes are siblings, we can do a quick check
                  } else if (aup === bup) {
                    return siblingCheck(a, b)
                  }

                  // Otherwise we need full lists of their ancestors for comparison
                  cur = a
                  while ((cur = cur.parentNode)) {
                    ap.unshift(cur)
                  }
                  cur = b
                  while ((cur = cur.parentNode)) {
                    bp.unshift(cur)
                  }

                  // Walk down the tree looking for a discrepancy
                  while (ap[i] === bp[i]) {
                    i++
                  }

                  return i

                    // Do a sibling check if the nodes have a common ancestor
                    ? siblingCheck(ap[i], bp[i])

                    // Otherwise nodes in our document sort first
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    /* eslint-disable eqeqeq */
                    : ap[i] == preferredDoc ? -1
                    : bp[i] == preferredDoc ? 1
                    /* eslint-enable eqeqeq */
                    : 0
                }

              return document
            }

            Sizzle.matches = function (expr, elements) {
              return Sizzle(expr, null, null, elements)
            }

            Sizzle.matchesSelector = function (elem, expr) {
              setDocument(elem)

              if (support.matchesSelector && documentIsHTML &&
                !nonnativeSelectorCache[expr + ' '] &&
                (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                (!rbuggyQSA || !rbuggyQSA.test(expr))) {
                try {
                  var ret = matches.call(elem, expr)

                  // IE 9's matchesSelector returns false on disconnected nodes
                  if (ret || support.disconnectedMatch ||

                    // As well, disconnected nodes are said to be in a document
                    // fragment in IE 9
                    elem.document && elem.document.nodeType !== 11) {
                    return ret
                  }
                } catch (e) {
                  nonnativeSelectorCache(expr, true)
                }
              }

              return Sizzle(expr, document, null, [elem]).length > 0
            }

            Sizzle.contains = function (context, elem) {
              // Set document vars if needed
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ((context.ownerDocument || context) != document) {
                setDocument(context)
              }
              return contains(context, elem)
            }

            Sizzle.attr = function (elem, name) {
              // Set document vars if needed
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if ((elem.ownerDocument || elem) != document) {
                setDocument(elem)
              }

              var fn = Expr.attrHandle[name.toLowerCase()]

              // Don't get fooled by Object.prototype properties (jQuery #13807)
              var val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
                ? fn(elem, name, !documentIsHTML)
                : undefined

              return val !== undefined
                ? val
                : support.attributes || !documentIsHTML
                ? elem.getAttribute(name)
                : (val = elem.getAttributeNode(name)) && val.specified
                ? val.value
                : null
            }

            Sizzle.escape = function (sel) {
              return (sel + '').replace(rcssescape, fcssescape)
            }

            Sizzle.error = function (msg) {
              throw new Error('Syntax error, unrecognized expression: ' + msg)
            }

            /**
             * Document sorting and removing duplicates
             * @param {ArrayLike} results
             */
            Sizzle.uniqueSort = function (results) {
              var elem
              var duplicates = []
              var j = 0
              var i = 0

              // Unless we *know* we can detect duplicates, assume their presence
              hasDuplicate = !support.detectDuplicates
              sortInput = !support.sortStable && results.slice(0)
              results.sort(sortOrder)

              if (hasDuplicate) {
                while ((elem = results[i++])) {
                  if (elem === results[i]) {
                    j = duplicates.push(i)
                  }
                }
                while (j--) {
                  results.splice(duplicates[j], 1)
                }
              }

              // Clear input after sorting to release objects
              // See https://github.com/jquery/sizzle/pull/225
              sortInput = null

              return results
            }

            /**
             * Utility function for retrieving the text value of an array of DOM nodes
             * @param {Array|Element} elem
             */
            getText = Sizzle.getText = function (elem) {
              var node
              var ret = ''
              var i = 0
              var nodeType = elem.nodeType

              if (!nodeType) {
                // If no nodeType, this is expected to be an array
                while ((node = elem[i++])) {
                  // Do not traverse comment nodes
                  ret += getText(node)
                }
              } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === 'string') {
                  return elem.textContent
                } else {
                  // Traverse its children
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    ret += getText(elem)
                  }
                }
              } else if (nodeType === 3 || nodeType === 4) {
                return elem.nodeValue
              }

              // Do not include comment or processing instruction nodes

              return ret
            }

            Expr = Sizzle.selectors = {

              // Can be adjusted by the user
              cacheLength: 50,

              createPseudo: markFunction,

              match: matchExpr,

              attrHandle: {},

              find: {},

              relative: {
                '>': {
                  dir: 'parentNode',
                  first: true
                },
                ' ': {
                  dir: 'parentNode'
                },
                '+': {
                  dir: 'previousSibling',
                  first: true
                },
                '~': {
                  dir: 'previousSibling'
                }
              },

              preFilter: {
                ATTR: function (match) {
                  match[1] = match[1].replace(runescape, funescape)

                  // Move the given value to match[3] whether quoted or unquoted
                  match[3] = (match[3] || match[4] ||
                    match[5] || '').replace(runescape, funescape)

                  if (match[2] === '~=') {
                    match[3] = ' ' + match[3] + ' '
                  }

                  return match.slice(0, 4)
                },

                CHILD: function (match) {
                  /* matches from matchExpr["CHILD"]
                  	1 type (only|nth|...)
                  	2 what (child|of-type)
                  	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                  	4 xn-component of xn+y argument ([+-]?\d*n|)
                  	5 sign of xn-component
                  	6 x of xn-component
                  	7 sign of y-component
                  	8 y of y-component
                  */
                  match[1] = match[1].toLowerCase()

                  if (match[1].slice(0, 3) === 'nth') {
                    // nth-* requires argument
                    if (!match[3]) {
                      Sizzle.error(match[0])
                    }

                    // numeric x and y parameters for Expr.filter.CHILD
                    // remember that false/true cast respectively to 0/1
                    match[4] = +(match[4]
                      ? match[5] + (match[6] || 1)
                      : 2 * (match[3] === 'even' || match[3] === 'odd'))
                    match[5] = +((match[7] + match[8]) || match[3] === 'odd')

                    // other types prohibit arguments
                  } else if (match[3]) {
                    Sizzle.error(match[0])
                  }

                  return match
                },

                PSEUDO: function (match) {
                  var excess
                  var unquoted = !match[6] && match[2]

                  if (matchExpr.CHILD.test(match[0])) {
                    return null
                  }

                  // Accept quoted arguments as-is
                  if (match[3]) {
                    match[2] = match[4] || match[5] || ''

                    // Strip excess characters from unquoted arguments
                  } else if (unquoted && rpseudo.test(unquoted) &&

                    // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) &&

                    // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
                    // excess is a negative index
                    match[0] = match[0].slice(0, excess)
                    match[2] = unquoted.slice(0, excess)
                  }

                  // Return only captures needed by the pseudo filter method (type and argument)
                  return match.slice(0, 3)
                }
              },

              filter: {

                TAG: function (nodeNameSelector) {
                  var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase()
                  return nodeNameSelector === '*'
                    ? function () {
                      return true
                    }
                    : function (elem) {
                      return elem.nodeName && elem.nodeName.toLowerCase() === nodeName
                    }
                },

                CLASS: function (className) {
                  var pattern = classCache[className + ' ']

                  return pattern ||
                    (pattern = new RegExp('(^|' + whitespace +
                      ')' + className + '(' + whitespace + '|$)')) && classCache(
                      className,
                      function (elem) {
                        return pattern.test(
                          typeof elem.className === 'string' && elem.className ||
                          typeof elem.getAttribute !== 'undefined' &&
                          elem.getAttribute('class') ||
                          ''
                        )
                      })
                },

                ATTR: function (name, operator, check) {
                  return function (elem) {
                    var result = Sizzle.attr(elem, name)

                    if (result == null) {
                      return operator === '!='
                    }
                    if (!operator) {
                      return true
                    }

                    result += ''

                    /* eslint-disable max-len */

                    return operator === '=' ? result === check
                      : operator === '!=' ? result !== check
                      : operator === '^=' ? check && result.indexOf(check) === 0
                      : operator === '*=' ? check && result.indexOf(check) > -1
                      : operator === '$=' ? check && result.slice(-check.length) === check
                      : operator === '~=' ? (' ' + result.replace(rwhitespace, ' ') + ' ').indexOf(check) > -1
                      : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-'
                      : false
                    /* eslint-enable max-len */
                  }
                },

                CHILD: function (type, what, _argument, first, last) {
                  var simple = type.slice(0, 3) !== 'nth'
                  var forward = type.slice(-4) !== 'last'
                  var ofType = what === 'of-type'

                  return first === 1 && last === 0

                    // Shortcut for :nth-*(n)
                    ? function (elem) {
                      return !!elem.parentNode
                    }

                    : function (elem, _context, xml) {
                      var cache
                      var uniqueCache
                      var outerCache
                      var node
                      var nodeIndex
                      var start
                      var dir = simple !== forward ? 'nextSibling' : 'previousSibling'
                      var parent = elem.parentNode
                      var name = ofType && elem.nodeName.toLowerCase()
                      var useCache = !xml && !ofType
                      var diff = false

                      if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                          while (dir) {
                            node = elem
                            while ((node = node[dir])) {
                              if (ofType
                                ? node.nodeName.toLowerCase() === name
                                : node.nodeType === 1) {
                                return false
                              }
                            }

                            // Reverse direction for :only-* (if we haven't yet done so)
                            start = dir = type === 'only' && !start && 'nextSibling'
                          }
                          return true
                        }

                        start = [forward ? parent.firstChild : parent.lastChild]

                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                          // Seek `elem` from a previously-cached index

                          // ...in a gzip-friendly way
                          node = parent
                          outerCache = node[expando] || (node[expando] = {})

                          // Support: IE <9 only
                          // Defend against cloned attroperties (jQuery gh-1709)
                          uniqueCache = outerCache[node.uniqueID] ||
                            (outerCache[node.uniqueID] = {})

                          cache = uniqueCache[type] || []
                          nodeIndex = cache[0] === dirruns && cache[1]
                          diff = nodeIndex && cache[2]
                          node = nodeIndex && parent.childNodes[nodeIndex]

                          while ((node = ++nodeIndex && node && node[dir] ||

                              // Fallback to seeking `elem` from the start
                              (diff = nodeIndex = 0) || start.pop())) {
                            // When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                              uniqueCache[type] = [dirruns, nodeIndex, diff]
                              break
                            }
                          }
                        } else {
                          // Use previously-cached element index if available
                          if (useCache) {
                            // ...in a gzip-friendly way
                            node = elem
                            outerCache = node[expando] || (node[expando] = {})

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache = outerCache[node.uniqueID] ||
                              (outerCache[node.uniqueID] = {})

                            cache = uniqueCache[type] || []
                            nodeIndex = cache[0] === dirruns && cache[1]
                            diff = nodeIndex
                          }

                          // xml :nth-child(...)
                          // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                          if (diff === false) {
                            // Use the same loop as above to seek `elem` from the start
                            while ((node = ++nodeIndex && node && node[dir] ||
                                (diff = nodeIndex = 0) || start.pop())) {
                              if ((ofType
                                  ? node.nodeName.toLowerCase() === name
                                  : node.nodeType === 1) &&
                                ++diff) {
                                // Cache the index of each encountered element
                                if (useCache) {
                                  outerCache = node[expando] ||
                                    (node[expando] = {})

                                  // Support: IE <9 only
                                  // Defend against cloned attroperties (jQuery gh-1709)
                                  uniqueCache = outerCache[node.uniqueID] ||
                                    (outerCache[node.uniqueID] = {})

                                  uniqueCache[type] = [dirruns, diff]
                                }

                                if (node === elem) {
                                  break
                                }
                              }
                            }
                          }
                        }

                        // Incorporate the offset, then check against cycle size
                        diff -= last
                        return diff === first || (diff % first === 0 && diff / first >= 0)
                      }
                    }
                },

                PSEUDO: function (pseudo, argument) {
                  // pseudo-class names are case-insensitive
                  // http://www.w3.org/TR/selectors/#pseudo-classes
                  // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                  // Remember that setFilters inherits from pseudos
                  var args
                  var fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
                    Sizzle.error('unsupported pseudo: ' + pseudo)

                  // The user may use createPseudo to indicate that
                  // arguments are needed to create the filter function
                  // just as Sizzle does
                  if (fn[expando]) {
                    return fn(argument)
                  }

                  // But maintain support for old signatures
                  if (fn.length > 1) {
                    args = [pseudo, pseudo, '', argument]
                    return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())
                      ? markFunction(function (seed, matches) {
                        var idx
                        var matched = fn(seed, argument)
                        var i = matched.length
                        while (i--) {
                          idx = indexOf(seed, matched[i])
                          seed[idx] = !(matches[idx] = matched[i])
                        }
                      })
                      : function (elem) {
                        return fn(elem, 0, args)
                      }
                  }

                  return fn
                }
              },

              pseudos: {

                // Potentially complex pseudos
                not: markFunction(function (selector) {
                  // Trim the selector passed to compile
                  // to avoid treating leading and trailing
                  // spaces as combinators
                  var input = []
                  var results = []
                  var matcher = compile(selector.replace(rtrim, '$1'))

                  return matcher[expando]
                    ? markFunction(function (seed, matches, _context, xml) {
                      var elem
                      var unmatched = matcher(seed, null, xml, [])
                      var i = seed.length

                      // Match elements unmatched by `matcher`
                      while (i--) {
                        if ((elem = unmatched[i])) {
                          seed[i] = !(matches[i] = elem)
                        }
                      }
                    })
                    : function (elem, _context, xml) {
                      input[0] = elem
                      matcher(input, null, xml, results)

                      // Don't keep the element (issue #299)
                      input[0] = null
                      return !results.pop()
                    }
                }),

                has: markFunction(function (selector) {
                  return function (elem) {
                    return Sizzle(selector, elem).length > 0
                  }
                }),

                contains: markFunction(function (text) {
                  text = text.replace(runescape, funescape)
                  return function (elem) {
                    return (elem.textContent || getText(elem)).indexOf(text) > -1
                  }
                }),

                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function (lang) {
                  // lang value must be a valid identifier
                  if (!ridentifier.test(lang || '')) {
                    Sizzle.error('unsupported lang: ' + lang)
                  }
                  lang = lang.replace(runescape, funescape).toLowerCase()
                  return function (elem) {
                    var elemLang
                    do {
                      if ((elemLang = documentIsHTML
                          ? elem.lang
                          : elem.getAttribute('xml:lang') || elem.getAttribute('lang'))) {
                        elemLang = elemLang.toLowerCase()
                        return elemLang === lang || elemLang.indexOf(lang + '-') === 0
                      }
                    } while ((elem = elem.parentNode) && elem.nodeType === 1)
                    return false
                  }
                }),

                // Miscellaneous
                target: function (elem) {
                  var hash = window.location && window.location.hash
                  return hash && hash.slice(1) === elem.id
                },

                root: function (elem) {
                  return elem === docElem
                },

                focus: function (elem) {
                  return elem === document.activeElement &&
                    (!document.hasFocus || document.hasFocus()) &&
                    !!(elem.type || elem.href || ~elem.tabIndex)
                },

                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),

                checked: function (elem) {
                  // In CSS3, :checked should return both checked and selected elements
                  // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                  var nodeName = elem.nodeName.toLowerCase()
                  return (nodeName === 'input' && !!elem.checked) ||
                    (nodeName === 'option' && !!elem.selected)
                },

                selected: function (elem) {
                  // Accessing this property makes selected-by-default
                  // options in Safari work properly
                  if (elem.parentNode) {
                    // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex
                  }

                  return elem.selected === true
                },

                // Contents
                empty: function (elem) {
                  // http://www.w3.org/TR/selectors/#empty-pseudo
                  // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                  //   but not by others (comment: 8; processing instruction: 7; etc.)
                  // nodeType < 6 works because attributes (2) do not appear as children
                  for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                    if (elem.nodeType < 6) {
                      return false
                    }
                  }
                  return true
                },

                parent: function (elem) {
                  return !Expr.pseudos.empty(elem)
                },

                // Element/input types
                header: function (elem) {
                  return rheader.test(elem.nodeName)
                },

                input: function (elem) {
                  return rinputs.test(elem.nodeName)
                },

                button: function (elem) {
                  var name = elem.nodeName.toLowerCase()
                  return name === 'input' && elem.type === 'button' || name === 'button'
                },

                text: function (elem) {
                  var attr
                  return elem.nodeName.toLowerCase() === 'input' &&
                    elem.type === 'text' &&

                    // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute('type')) == null ||
                      attr.toLowerCase() === 'text')
                },

                // Position-in-collection
                first: createPositionalPseudo(function () {
                  return [0]
                }),

                last: createPositionalPseudo(function (_matchIndexes, length) {
                  return [length - 1]
                }),

                eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
                  return [argument < 0 ? argument + length : argument]
                }),

                even: createPositionalPseudo(function (matchIndexes, length) {
                  var i = 0
                  for (; i < length; i += 2) {
                    matchIndexes.push(i)
                  }
                  return matchIndexes
                }),

                odd: createPositionalPseudo(function (matchIndexes, length) {
                  var i = 1
                  for (; i < length; i += 2) {
                    matchIndexes.push(i)
                  }
                  return matchIndexes
                }),

                lt: createPositionalPseudo(function (matchIndexes, length, argument) {
                  var i = argument < 0
                    ? argument + length
                    : argument > length
                    ? length
                    : argument
                  for (; --i >= 0;) {
                    matchIndexes.push(i)
                  }
                  return matchIndexes
                }),

                gt: createPositionalPseudo(function (matchIndexes, length, argument) {
                  var i = argument < 0 ? argument + length : argument
                  for (; ++i < length;) {
                    matchIndexes.push(i)
                  }
                  return matchIndexes
                })
              }
            }

            Expr.pseudos.nth = Expr.pseudos.eq

            // Add button/input type pseudos
            for (i in {
                radio: true,
                checkbox: true,
                file: true,
                password: true,
                image: true
              }) {
              Expr.pseudos[i] = createInputPseudo(i)
            }
            for (i in {
                submit: true,
                reset: true
              }) {
              Expr.pseudos[i] = createButtonPseudo(i)
            }

            // Easy API for creating new setFilters
            function setFilters() {}
            setFilters.prototype = Expr.filters = Expr.pseudos
            Expr.setFilters = new setFilters()

            tokenize = Sizzle.tokenize = function (selector, parseOnly) {
              var matched
              var match
              var tokens
              var type
              var soFar
              var groups
              var preFilters
              var cached = tokenCache[selector + ' ']

              if (cached) {
                return parseOnly ? 0 : cached.slice(0)
              }

              soFar = selector
              groups = []
              preFilters = Expr.preFilter

              while (soFar) {
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                  if (match) {
                    // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar
                  }
                  groups.push((tokens = []))
                }

                matched = false

                // Combinators
                if ((match = rcombinators.exec(soFar))) {
                  matched = match.shift()
                  tokens.push({
                    value: matched,

                    // Cast descendant combinators to space
                    type: match[0].replace(rtrim, ' ')
                  })
                  soFar = soFar.slice(matched.length)
                }

                // Filters
                for (type in Expr.filter) {
                  if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
                      (match = preFilters[type](match)))) {
                    matched = match.shift()
                    tokens.push({
                      value: matched,
                      type: type,
                      matches: match
                    })
                    soFar = soFar.slice(matched.length)
                  }
                }

                if (!matched) {
                  break
                }
              }

              // Return the length of the invalid excess
              // if we're just parsing
              // Otherwise, throw an error or return tokens
              return parseOnly
                ? soFar.length
                : soFar
                ? Sizzle.error(selector)

                // Cache the tokens
                : tokenCache(selector, groups).slice(0)
            }

            function toSelector(tokens) {
              var i = 0
              var len = tokens.length
              var selector = ''
              for (; i < len; i++) {
                selector += tokens[i].value
              }
              return selector
            }

            function addCombinator(matcher, combinator, base) {
              var dir = combinator.dir
              var skip = combinator.next
              var key = skip || dir
              var checkNonElements = base && key === 'parentNode'
              var doneName = done++

              return combinator.first

                // Check against closest ancestor/preceding element
                ? function (elem, context, xml) {
                  while ((elem = elem[dir])) {
                    if (elem.nodeType === 1 || checkNonElements) {
                      return matcher(elem, context, xml)
                    }
                  }
                  return false
                }

                // Check against all ancestor/preceding elements
                : function (elem, context, xml) {
                  var oldCache
                  var uniqueCache
                  var outerCache
                  var newCache = [dirruns, doneName]

                  // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                  if (xml) {
                    while ((elem = elem[dir])) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) {
                          return true
                        }
                      }
                    }
                  } else {
                    while ((elem = elem[dir])) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {})

                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] ||
                          (outerCache[elem.uniqueID] = {})

                        if (skip && skip === elem.nodeName.toLowerCase()) {
                          elem = elem[dir] || elem
                        } else if ((oldCache = uniqueCache[key]) &&
                          oldCache[0] === dirruns && oldCache[1] === doneName) {
                          // Assign to newCache so results back-propagate to previous elements
                          return (newCache[2] = oldCache[2])
                        } else {
                          // Reuse newcache so results back-propagate to previous elements
                          uniqueCache[key] = newCache

                          // A match means we're done; a fail means we have to keep checking
                          if ((newCache[2] = matcher(elem, context, xml))) {
                            return true
                          }
                        }
                      }
                    }
                  }
                  return false
                }
            }

            function elementMatcher(matchers) {
              return matchers.length > 1
                ? function (elem, context, xml) {
                  var i = matchers.length
                  while (i--) {
                    if (!matchers[i](elem, context, xml)) {
                      return false
                    }
                  }
                  return true
                }
                : matchers[0]
            }

            function multipleContexts(selector, contexts, results) {
              var i = 0
              var len = contexts.length
              for (; i < len; i++) {
                Sizzle(selector, contexts[i], results)
              }
              return results
            }

            function condense(unmatched, map, filter, context, xml) {
              var elem
              var newUnmatched = []
              var i = 0
              var len = unmatched.length
              var mapped = map != null

              for (; i < len; i++) {
                if ((elem = unmatched[i])) {
                  if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem)
                    if (mapped) {
                      map.push(i)
                    }
                  }
                }
              }

              return newUnmatched
            }

            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
              if (postFilter && !postFilter[expando]) {
                postFilter = setMatcher(postFilter)
              }
              if (postFinder && !postFinder[expando]) {
                postFinder = setMatcher(postFinder, postSelector)
              }
              return markFunction(function (seed, results, context, xml) {
                var temp
                var i
                var elem
                var preMap = []
                var postMap = []
                var preexisting = results.length

                // Get initial elements from seed or context
                var elems = seed || multipleContexts(
                  selector || '*',
                  context.nodeType ? [context] : context,
                  []
                )

                // Prefilter to get matcher input, preserving a map for seed-results synchronization
                var matcherIn = preFilter && (seed || !selector)
                  ? condense(elems, preMap, preFilter, context, xml)
                  : elems

                var matcherOut = matcher

                  // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                  ? postFinder || (seed ? preFilter : preexisting || postFilter)

                  // ...intermediate processing is necessary
                  ? []

                  // ...otherwise use results directly
                  : results
                  : matcherIn

                // Find primary matches
                if (matcher) {
                  matcher(matcherIn, matcherOut, context, xml)
                }

                // Apply postFilter
                if (postFilter) {
                  temp = condense(matcherOut, postMap)
                  postFilter(temp, [], context, xml)

                  // Un-match failing elements by moving them back to matcherIn
                  i = temp.length
                  while (i--) {
                    if ((elem = temp[i])) {
                      matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem)
                    }
                  }
                }

                if (seed) {
                  if (postFinder || preFilter) {
                    if (postFinder) {
                      // Get the final matcherOut by condensing this intermediate into postFinder contexts
                      temp = []
                      i = matcherOut.length
                      while (i--) {
                        if ((elem = matcherOut[i])) {
                          // Restore matcherIn since elem is not yet a final match
                          temp.push((matcherIn[i] = elem))
                        }
                      }
                      postFinder(null, (matcherOut = []), temp, xml)
                    }

                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length
                    while (i--) {
                      if ((elem = matcherOut[i]) &&
                        (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                        seed[temp] = !(results[temp] = elem)
                      }
                    }
                  }

                  // Add elements to results, through postFinder if defined
                } else {
                  matcherOut = condense(
                    matcherOut === results
                    ? matcherOut.splice(preexisting, matcherOut.length)
                    : matcherOut
                  )
                  if (postFinder) {
                    postFinder(null, results, matcherOut, xml)
                  } else {
                    push.apply(results, matcherOut)
                  }
                }
              })
            }

            function matcherFromTokens(tokens) {
              var checkContext
              var matcher
              var j
              var len = tokens.length
              var leadingRelative = Expr.relative[tokens[0].type]
              var implicitRelative = leadingRelative || Expr.relative[' ']
              var i = leadingRelative ? 1 : 0

              // The foundational matcher ensures that elements are reachable from top-level context(s)
              var matchContext = addCombinator(function (elem) {
                return elem === checkContext
              }, implicitRelative, true)
              var matchAnyContext = addCombinator(function (elem) {
                return indexOf(checkContext, elem) > -1
              }, implicitRelative, true)
              var matchers = [function (elem, context, xml) {
                var ret = (!leadingRelative && (xml || context !== outermostContext)) || (
                  (checkContext = context).nodeType
                  ? matchContext(elem, context, xml)
                  : matchAnyContext(elem, context, xml))

                // Avoid hanging onto element (issue #299)
                checkContext = null
                return ret
              }]

              for (; i < len; i++) {
                if ((matcher = Expr.relative[tokens[i].type])) {
                  matchers = [addCombinator(elementMatcher(matchers), matcher)]
                } else {
                  matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches)

                  // Return special upon seeing a positional matcher
                  if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i
                    for (; j < len; j++) {
                      if (Expr.relative[tokens[j].type]) {
                        break
                      }
                    }
                    return setMatcher(
                      i > 1 && elementMatcher(matchers),
                      i > 1 && toSelector(

                        // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                        tokens
                        .slice(0, i - 1)
                        .concat({
                          value: tokens[i - 2].type === ' ' ? '*' : ''
                        })
                      ).replace(rtrim, '$1'),
                      matcher,
                      i < j && matcherFromTokens(tokens.slice(i, j)),
                      j < len && matcherFromTokens((tokens = tokens.slice(j))),
                      j < len && toSelector(tokens)
                    )
                  }
                  matchers.push(matcher)
                }
              }

              return elementMatcher(matchers)
            }

            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
              var bySet = setMatchers.length > 0
              var byElement = elementMatchers.length > 0
              var superMatcher = function (seed, context, xml, results, outermost) {
                var elem
                var j
                var matcher
                var matchedCount = 0
                var i = '0'
                var unmatched = seed && []
                var setMatched = []
                var contextBackup = outermostContext

                // We must always have either seed elements or outermost context
                var elems = seed || byElement && Expr.find.TAG('*', outermost)

                // Use integer dirruns iff this is the outermost matcher
                var dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1)
                var len = elems.length

                if (outermost) {
                  // Support: IE 11+, Edge 17 - 18+
                  // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                  // two documents; shallow comparisons work.
                  // eslint-disable-next-line eqeqeq
                  outermostContext = context == document || context || outermost
                }

                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for (; i !== len && (elem = elems[i]) != null; i++) {
                  if (byElement && elem) {
                    j = 0

                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                      setDocument(elem)
                      xml = !documentIsHTML
                    }
                    while ((matcher = elementMatchers[j++])) {
                      if (matcher(elem, context || document, xml)) {
                        results.push(elem)
                        break
                      }
                    }
                    if (outermost) {
                      dirruns = dirrunsUnique
                    }
                  }

                  // Track unmatched elements for set filters
                  if (bySet) {
                    // They will have gone through all possible matchers
                    if ((elem = !matcher && elem)) {
                      matchedCount--
                    }

                    // Lengthen the array for every element, matched or not
                    if (seed) {
                      unmatched.push(elem)
                    }
                  }
                }

                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i

                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                  j = 0
                  while ((matcher = setMatchers[j++])) {
                    matcher(unmatched, setMatched, context, xml)
                  }

                  if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                      while (i--) {
                        if (!(unmatched[i] || setMatched[i])) {
                          setMatched[i] = pop.call(results)
                        }
                      }
                    }

                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched)
                  }

                  // Add matches to results
                  push.apply(results, setMatched)

                  // Seedless set matches succeeding multiple successful matchers stipulate sorting
                  if (outermost && !seed && setMatched.length > 0 &&
                    (matchedCount + setMatchers.length) > 1) {
                    Sizzle.uniqueSort(results)
                  }
                }

                // Override manipulation of globals by nested matchers
                if (outermost) {
                  dirruns = dirrunsUnique
                  outermostContext = contextBackup
                }

                return unmatched
              }

              return bySet
                ? markFunction(superMatcher)
                : superMatcher
            }

            compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
              var i
              var setMatchers = []
              var elementMatchers = []
              var cached = compilerCache[selector + ' ']

              if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) {
                  match = tokenize(selector)
                }
                i = match.length
                while (i--) {
                  cached = matcherFromTokens(match[i])
                  if (cached[expando]) {
                    setMatchers.push(cached)
                  } else {
                    elementMatchers.push(cached)
                  }
                }

                // Cache the compiled function
                cached = compilerCache(
                  selector,
                  matcherFromGroupMatchers(elementMatchers, setMatchers)
                )

                // Save selector and tokenization
                cached.selector = selector
              }
              return cached
            }

            /**
             * A low-level selection function that works with Sizzle's compiled
             *  selector functions
             * @param {String|Function} selector A selector or a pre-compiled
             *  selector function built with Sizzle.compile
             * @param {Element} context
             * @param {Array} [results]
             * @param {Array} [seed] A set of elements to match against
             */
            select = Sizzle.select = function (selector, context, results, seed) {
              var i
              var tokens
              var token
              var type
              var find
              var compiled = typeof selector === 'function' && selector
              var match = !seed && tokenize((selector = compiled.selector || selector))

              results = results || []

              // Try to minimize operations if there is only one selector in the list and no seed
              // (the latter of which guarantees us context)
              if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0)
                if (tokens.length > 2 && (token = tokens[0]).type === 'ID' &&
                  context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                  context = (Expr.find.ID(token.matches[0]
                    .replace(runescape, funescape), context) || [])[0]
                  if (!context) {
                    return results

                    // Precompiled matchers will still verify ancestry, so step up a level
                  } else if (compiled) {
                    context = context.parentNode
                  }

                  selector = selector.slice(tokens.shift().value.length)
                }

                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length
                while (i--) {
                  token = tokens[i]

                  // Abort if we hit a combinator
                  if (Expr.relative[(type = token.type)]) {
                    break
                  }
                  if ((find = Expr.find[type])) {
                    // Search, expanding context for leading sibling combinators
                    if ((seed = find(
                        token.matches[0].replace(runescape, funescape),
                        rsibling.test(tokens[0].type) && testContext(context.parentNode) ||
                        context
                      ))) {
                      // If seed is empty or no tokens remain, we can return early
                      tokens.splice(i, 1)
                      selector = seed.length && toSelector(tokens)
                      if (!selector) {
                        push.apply(results, seed)
                        return results
                      }

                      break
                    }
                  }
                }
              }

              // Compile and execute a filtering function if one is not provided
              // Provide `match` to avoid retokenization if we modified the selector above
              (compiled || compile(selector, match))(
                seed,
                context,
                !documentIsHTML,
                results,
                !context || rsibling.test(selector) && testContext(context.parentNode) || context
              )
              return results
            }

            // One-time assignments

            // Sort stability
            support.sortStable = expando.split('').sort(sortOrder).join('') === expando

            // Support: Chrome 14-35+
            // Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate

            // Initialize against the default document
            setDocument()

            // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
            // Detached nodes confoundingly follow *each other*
            support.sortDetached = assert(function (el) {
              // Should return 1, but returns 4 (following)
              return el.compareDocumentPosition(document.createElement('fieldset')) & 1
            })

            // Support: IE<8
            // Prevent attribute/property "interpolation"
            // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
            if (!assert(function (el) {
                el.innerHTML = "<a href='#'></a>"
                return el.firstChild.getAttribute('href') === '#'
              })) {
              addHandle('type|href|height|width', function (elem, name, isXML) {
                if (!isXML) {
                  return elem.getAttribute(name, name.toLowerCase() === 'type' ? 1 : 2)
                }
              })
            }

            // Support: IE<9
            // Use defaultValue in place of getAttribute("value")
            if (!support.attributes || !assert(function (el) {
                el.innerHTML = '<input/>'
                el.firstChild.setAttribute('value', '')
                return el.firstChild.getAttribute('value') === ''
              })) {
              addHandle('value', function (elem, _name, isXML) {
                if (!isXML && elem.nodeName.toLowerCase() === 'input') {
                  return elem.defaultValue
                }
              })
            }

            // Support: IE<9
            // Use getAttributeNode to fetch booleans when getAttribute lies
            if (!assert(function (el) {
                return el.getAttribute('disabled') == null
              })) {
              addHandle(booleans, function (elem, name, isXML) {
                var val
                if (!isXML) {
                  return elem[name] === true ? name.toLowerCase()
                    : (val = elem.getAttributeNode(name)) && val.specified
                    ? val.value
                    : null
                }
              })
            }

            return Sizzle
          })(window)

        jQuery.find = Sizzle
        jQuery.expr = Sizzle.selectors

        // Deprecated
        jQuery.expr[':'] = jQuery.expr.pseudos
        jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort
        jQuery.text = Sizzle.getText
        jQuery.isXMLDoc = Sizzle.isXML
        jQuery.contains = Sizzle.contains
        jQuery.escapeSelector = Sizzle.escape

        var dir = function (elem, dir, until) {
          var matched = []
          var truncate = until !== undefined

          while ((elem = elem[dir]) && elem.nodeType !== 9) {
            if (elem.nodeType === 1) {
              if (truncate && jQuery(elem).is(until)) {
                break
              }
              matched.push(elem)
            }
          }
          return matched
        }

        var siblings = function (n, elem) {
          var matched = []

          for (; n; n = n.nextSibling) {
            if (n.nodeType === 1 && n !== elem) {
              matched.push(n)
            }
          }

          return matched
        }

        var rneedsContext = jQuery.expr.match.needsContext

        function nodeName(elem, name) {
          return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase()
        }
        var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i)

        // Implement the identical functionality for filter and not
        function winnow(elements, qualifier, not) {
          if (isFunction(qualifier)) {
            return jQuery.grep(elements, function (elem, i) {
              return !!qualifier.call(elem, i, elem) !== not
            })
          }

          // Single element
          if (qualifier.nodeType) {
            return jQuery.grep(elements, function (elem) {
              return (elem === qualifier) !== not
            })
          }

          // Arraylike of elements (jQuery, arguments, Array)
          if (typeof qualifier !== 'string') {
            return jQuery.grep(elements, function (elem) {
              return (indexOf.call(qualifier, elem) > -1) !== not
            })
          }

          // Filtered directly for both simple and complex selectors
          return jQuery.filter(qualifier, elements, not)
        }

        jQuery.filter = function (expr, elems, not) {
          var elem = elems[0]

          if (not) {
            expr = ':not(' + expr + ')'
          }

          if (elems.length === 1 && elem.nodeType === 1) {
            return jQuery.find.matchesSelector(elem, expr) ? [elem] : []
          }

          return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
            return elem.nodeType === 1
          }))
        }

        jQuery.fn.extend({
          find: function (selector) {
            var i
            var ret
            var len = this.length
            var self = this

            if (typeof selector !== 'string') {
              return this.pushStack(jQuery(selector).filter(function () {
                for (i = 0; i < len; i++) {
                  if (jQuery.contains(self[i], this)) {
                    return true
                  }
                }
              }))
            }

            ret = this.pushStack([])

            for (i = 0; i < len; i++) {
              jQuery.find(selector, self[i], ret)
            }

            return len > 1 ? jQuery.uniqueSort(ret) : ret
          },
          filter: function (selector) {
            return this.pushStack(winnow(this, selector || [], false))
          },
          not: function (selector) {
            return this.pushStack(winnow(this, selector || [], true))
          },
          is: function (selector) {
            return !!winnow(
              this,

              // If this is a positional/relative selector, check membership in the returned set
              // so $("p:first").is("p:last") won't return true for a doc with two "p".
              typeof selector === 'string' && rneedsContext.test(selector)
              ? jQuery(selector)
              : selector || [],
              false
            ).length
          }
        })

        // Initialize a jQuery object

        // A central reference to the root jQuery(document)
        var rootjQuery

        // A simple way to check for HTML strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        // Strict HTML recognition (#11290: must start with <)
        // Shortcut simple #id case for speed
        var rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/

        var init = jQuery.fn.init = function (selector, context, root) {
          var match, elem

          // HANDLE: $(""), $(null), $(undefined), $(false)
          if (!selector) {
            return this
          }

          // Method init() accepts an alternate rootjQuery
          // so migrate can support jQuery.sub (gh-2101)
          root = root || rootjQuery

          // Handle HTML strings
          if (typeof selector === 'string') {
            if (selector[0] === '<' &&
              selector[selector.length - 1] === '>' &&
              selector.length >= 3) {
              // Assume that strings that start and end with <> are HTML and skip the regex check
              match = [null, selector, null]
            } else {
              match = rquickExpr.exec(selector)
            }

            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
              // HANDLE: $(html) -> $(array)
              if (match[1]) {
                context = context instanceof jQuery ? context[0] : context

                // Option to run scripts is true for back-compat
                // Intentionally let the error be thrown if parseHTML is not present
                jQuery.merge(this, jQuery.parseHTML(
                  match[1],
                  context && context.nodeType ? context.ownerDocument || context : document,
                  true
                ))

                // HANDLE: $(html, props)
                if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                  for (match in context) {
                    // Properties of context are called as methods if possible
                    if (isFunction(this[match])) {
                      this[match](context[match])

                      // ...and otherwise set as attributes
                    } else {
                      this.attr(match, context[match])
                    }
                  }
                }

                return this

                // HANDLE: $(#id)
              } else {
                elem = document.getElementById(match[2])

                if (elem) {
                  // Inject the element directly into the jQuery object
                  this[0] = elem
                  this.length = 1
                }
                return this
              }

              // HANDLE: $(expr, $(...))
            } else if (!context || context.jquery) {
              return (context || root).find(selector)

              // HANDLE: $(expr, context)
              // (which is just equivalent to: $(context).find(expr)
            } else {
              return this.constructor(context).find(selector)
            }

            // HANDLE: $(DOMElement)
          } else if (selector.nodeType) {
            this[0] = selector
            this.length = 1
            return this

            // HANDLE: $(function)
            // Shortcut for document ready
          } else if (isFunction(selector)) {
            return root.ready !== undefined
              ? root.ready(selector)

              // Execute immediately if ready is not present
              : selector(jQuery)
          }

          return jQuery.makeArray(selector, this)
        }

        // Give the init function the jQuery prototype for later instantiation
        init.prototype = jQuery.fn

        // Initialize central reference
        rootjQuery = jQuery(document)

        var rparentsprev = /^(?:parents|prev(?:Until|All))/

        // Methods guaranteed to produce a unique set when starting from a unique set
        var guaranteedUnique = {
          children: true,
          contents: true,
          next: true,
          prev: true
        }

        jQuery.fn.extend({
          has: function (target) {
            var targets = jQuery(target, this)
            var l = targets.length

            return this.filter(function () {
              var i = 0
              for (; i < l; i++) {
                if (jQuery.contains(this, targets[i])) {
                  return true
                }
              }
            })
          },

          closest: function (selectors, context) {
            var cur
            var i = 0
            var l = this.length
            var matched = []
            var targets = typeof selectors !== 'string' && jQuery(selectors)

            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) {
              for (; i < l; i++) {
                for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                  // Always skip document fragments
                  if (cur.nodeType < 11 && (targets
                      ? targets.index(cur) > -1

                      // Don't pass non-elements to Sizzle
                      : cur.nodeType === 1 &&
                      jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur)
                    break
                  }
                }
              }
            }

            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched)
          },

          // Determine the position of an element within the set
          index: function (elem) {
            // No argument, return index in parent
            if (!elem) {
              return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1
            }

            // Index in selector
            if (typeof elem === 'string') {
              return indexOf.call(jQuery(elem), this[0])
            }

            // Locate the position of the desired element
            return indexOf.call(this,

              // If it receives a jQuery object, the first element is used
              elem.jquery ? elem[0] : elem
            )
          },

          add: function (selector, context) {
            return this.pushStack(
              jQuery.uniqueSort(
                jQuery.merge(this.get(), jQuery(selector, context))
              )
            )
          },

          addBack: function (selector) {
            return this.add(selector == null
              ? this.prevObject : this.prevObject.filter(selector)
            )
          }
        })

        function sibling(cur, dir) {
          while ((cur = cur[dir]) && cur.nodeType !== 1) {}
          return cur
        }

        jQuery.each({
          parent: function (elem) {
            var parent = elem.parentNode
            return parent && parent.nodeType !== 11 ? parent : null
          },
          parents: function (elem) {
            return dir(elem, 'parentNode')
          },
          parentsUntil: function (elem, _i, until) {
            return dir(elem, 'parentNode', until)
          },
          next: function (elem) {
            return sibling(elem, 'nextSibling')
          },
          prev: function (elem) {
            return sibling(elem, 'previousSibling')
          },
          nextAll: function (elem) {
            return dir(elem, 'nextSibling')
          },
          prevAll: function (elem) {
            return dir(elem, 'previousSibling')
          },
          nextUntil: function (elem, _i, until) {
            return dir(elem, 'nextSibling', until)
          },
          prevUntil: function (elem, _i, until) {
            return dir(elem, 'previousSibling', until)
          },
          siblings: function (elem) {
            return siblings((elem.parentNode || {}).firstChild, elem)
          },
          children: function (elem) {
            return siblings(elem.firstChild)
          },
          contents: function (elem) {
            if (elem.contentDocument != null &&

              // Support: IE 11+
              // <object> elements with no `data` attribute has an object
              // `contentDocument` with a `null` prototype.
              getProto(elem.contentDocument)) {
              return elem.contentDocument
            }

            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, 'template')) {
              elem = elem.content || elem
            }

            return jQuery.merge([], elem.childNodes)
          }
        }, function (name, fn) {
          jQuery.fn[name] = function (until, selector) {
            var matched = jQuery.map(this, fn, until)

            if (name.slice(-5) !== 'Until') {
              selector = until
            }

            if (selector && typeof selector === 'string') {
              matched = jQuery.filter(selector, matched)
            }

            if (this.length > 1) {
              // Remove duplicates
              if (!guaranteedUnique[name]) {
                jQuery.uniqueSort(matched)
              }

              // Reverse order for parents* and prev-derivatives
              if (rparentsprev.test(name)) {
                matched.reverse()
              }
            }

            return this.pushStack(matched)
          }
        })
        var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g)

        // Convert String-formatted options into Object-formatted ones
        function createOptions(options) {
          var object = {}
          jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
            object[flag] = true
          })
          return object
        }

        /*
         * Create a callback list using the following parameters:
         *
         *	options: an optional list of space-separated options that will change how
         *			the callback list behaves or a more traditional option object
         *
         * By default a callback list will act like an event callback list and can be
         * "fired" multiple times.
         *
         * Possible options:
         *
         *	once:			will ensure the callback list can only be fired once (like a Deferred)
         *
         *	memory:			will keep track of previous values and will call any callback added
         *					after the list has been fired right away with the latest "memorized"
         *					values (like a Deferred)
         *
         *	unique:			will ensure a callback can only be added once (no duplicate in the list)
         *
         *	stopOnFalse:	interrupt callings when a callback returns false
         *
         */
        jQuery.Callbacks = function (options) {
          // Convert options from String-formatted to Object-formatted if needed
          // (we check in cache first)
          options = typeof options === 'string'
            ? createOptions(options)
            : jQuery.extend({}, options)

          var // Flag to know if list is currently firing
            firing

          // Last fire value for non-forgettable lists
          var memory

          // Flag to know if list was already fired
          var fired

          // Flag to prevent firing
          var locked

          // Actual callback list
          var list = []

          // Queue of execution data for repeatable lists
          var queue = []

          // Index of currently firing callback (modified by add/remove as needed)
          var firingIndex = -1

          // Fire callbacks
          var fire = function () {
            // Enforce single-firing
            locked = locked || options.once

            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true
            for (; queue.length; firingIndex = -1) {
              memory = queue.shift()
              while (++firingIndex < list.length) {
                // Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false &&
                  options.stopOnFalse) {
                  // Jump to end and forget the data so .add doesn't re-fire
                  firingIndex = list.length
                  memory = false
                }
              }
            }

            // Forget the data if we're done with it
            if (!options.memory) {
              memory = false
            }

            firing = false

            // Clean up if we're done firing for good
            if (locked) {
              // Keep an empty list if we have data for future add calls
              if (memory) {
                list = []

                // Otherwise, this object is spent
              } else {
                list = ''
              }
            }
          }

          // Actual Callbacks object
          var self = {

            // Add a callback or a collection of callbacks to the list
            add: function () {
              if (list) {
                // If we have memory from a past run, we should fire after adding
                if (memory && !firing) {
                  firingIndex = list.length - 1
                  queue.push(memory)
                }

                (function add(args) {
                  jQuery.each(args, function (_, arg) {
                    if (isFunction(arg)) {
                      if (!options.unique || !self.has(arg)) {
                        list.push(arg)
                      }
                    } else if (arg && arg.length && toType(arg) !== 'string') {
                      // Inspect recursively
                      add(arg)
                    }
                  })
                })(arguments)

                if (memory && !firing) {
                  fire()
                }
              }
              return this
            },

            // Remove a callback from the list
            remove: function () {
              jQuery.each(arguments, function (_, arg) {
                var index
                while ((index = jQuery.inArray(arg, list, index)) > -1) {
                  list.splice(index, 1)

                  // Handle firing indexes
                  if (index <= firingIndex) {
                    firingIndex--
                  }
                }
              })
              return this
            },

            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function (fn) {
              return fn
                ? jQuery.inArray(fn, list) > -1
                : list.length > 0
            },

            // Remove all callbacks from the list
            empty: function () {
              if (list) {
                list = []
              }
              return this
            },

            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function () {
              locked = queue = []
              list = memory = ''
              return this
            },
            disabled: function () {
              return !list
            },

            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function () {
              locked = queue = []
              if (!memory && !firing) {
                list = memory = ''
              }
              return this
            },
            locked: function () {
              return !!locked
            },

            // Call all callbacks with the given context and arguments
            fireWith: function (context, args) {
              if (!locked) {
                args = args || []
                args = [context, args.slice ? args.slice() : args]
                queue.push(args)
                if (!firing) {
                  fire()
                }
              }
              return this
            },

            // Call all the callbacks with the given arguments
            fire: function () {
              self.fireWith(this, arguments)
              return this
            },

            // To know if the callbacks have already been called at least once
            fired: function () {
              return !!fired
            }
          }

          return self
        }

        function Identity(v) {
          return v
        }

        function Thrower(ex) {
          throw ex
        }

        function adoptValue(value, resolve, reject, noValue) {
          var method

          try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction((method = value.promise))) {
              method.call(value).done(resolve).fail(reject)

              // Other thenables
            } else if (value && isFunction((method = value.then))) {
              method.call(value, resolve, reject)

              // Other non-thenables
            } else {
              // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
              // * false: [ value ].slice( 0 ) => resolve( value )
              // * true: [ value ].slice( 1 ) => resolve()
              resolve.apply(undefined, [value].slice(noValue))
            }

            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
          } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [value])
          }
        }

        jQuery.extend({

          Deferred: function (func) {
            var tuples = [

              // action, add listener, callbacks,
              // ... .then handlers, argument index, [final state]
              ['notify', 'progress', jQuery.Callbacks('memory'),
                jQuery.Callbacks('memory'), 2
              ],
              ['resolve', 'done', jQuery.Callbacks('once memory'),
                jQuery.Callbacks('once memory'), 0, 'resolved'
              ],
              ['reject', 'fail', jQuery.Callbacks('once memory'),
                jQuery.Callbacks('once memory'), 1, 'rejected'
              ]
            ]
            var state = 'pending'
            var promise = {
              state: function () {
                return state
              },
              always: function () {
                deferred.done(arguments).fail(arguments)
                return this
              },
              catch: function (fn) {
                return promise.then(null, fn)
              },

              // Keep pipe for back-compat
              pipe: function (/* fnDone, fnFail, fnProgress */) {
                var fns = arguments

                return jQuery.Deferred(function (newDefer) {
                  jQuery.each(tuples, function (_i, tuple) {
                    // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                    var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]]

                    // deferred.progress(function() { bind to newDefer or newDefer.notify })
                    // deferred.done(function() { bind to newDefer or newDefer.resolve })
                    // deferred.fail(function() { bind to newDefer or newDefer.reject })
                    deferred[tuple[1]](function () {
                      var returned = fn && fn.apply(this, arguments)
                      if (returned && isFunction(returned.promise)) {
                        returned.promise()
                          .progress(newDefer.notify)
                          .done(newDefer.resolve)
                          .fail(newDefer.reject)
                      } else {
                        newDefer[tuple[0] + 'With'](
                          this,
                          fn ? [returned] : arguments
                        )
                      }
                    })
                  })
                  fns = null
                }).promise()
              },
              then: function (onFulfilled, onRejected, onProgress) {
                var maxDepth = 0

                function resolve(depth, deferred, handler, special) {
                  return function () {
                    var that = this
                    var args = arguments
                    var mightThrow = function () {
                      var returned, then

                      // Support: Promises/A+ section 2.3.3.3.3
                      // https://promisesaplus.com/#point-59
                      // Ignore double-resolution attempts
                      if (depth < maxDepth) {
                        return
                      }

                      returned = handler.apply(that, args)

                      // Support: Promises/A+ section 2.3.1
                      // https://promisesaplus.com/#point-48
                      if (returned === deferred.promise()) {
                        throw new TypeError('Thenable self-resolution')
                      }

                      // Support: Promises/A+ sections 2.3.3.1, 3.5
                      // https://promisesaplus.com/#point-54
                      // https://promisesaplus.com/#point-75
                      // Retrieve `then` only once
                      then = returned &&

                        // Support: Promises/A+ section 2.3.4
                        // https://promisesaplus.com/#point-64
                        // Only check objects and functions for thenability
                        (typeof returned === 'object' ||
                          typeof returned === 'function') &&
                        returned.then

                      // Handle a returned thenable
                      if (isFunction(then)) {
                        // Special processors (notify) just wait for resolution
                        if (special) {
                          then.call(
                            returned,
                            resolve(maxDepth, deferred, Identity, special),
                            resolve(maxDepth, deferred, Thrower, special)
                          )

                          // Normal processors (resolve) also hook into progress
                        } else {
                          // ...and disregard older resolution values
                          maxDepth++

                          then.call(
                            returned,
                            resolve(maxDepth, deferred, Identity, special),
                            resolve(maxDepth, deferred, Thrower, special),
                            resolve(maxDepth, deferred, Identity,
                              deferred.notifyWith)
                          )
                        }

                        // Handle all other returned values
                      } else {
                        // Only substitute handlers pass on context
                        // and multiple values (non-spec behavior)
                        if (handler !== Identity) {
                          that = undefined
                          args = [returned]
                        }

                        // Process the value(s)
                        // Default process is resolve
                        (special || deferred.resolveWith)(that, args)
                      }
                    }

                    // Only normal processors (resolve) catch and reject exceptions
                    var process = special
                      ? mightThrow
                      : function () {
                        try {
                          mightThrow()
                        } catch (e) {
                          if (jQuery.Deferred.exceptionHook) {
                            jQuery.Deferred.exceptionHook(e,
                              process.stackTrace)
                          }

                          // Support: Promises/A+ section 2.3.3.3.4.1
                          // https://promisesaplus.com/#point-61
                          // Ignore post-resolution exceptions
                          if (depth + 1 >= maxDepth) {
                            // Only substitute handlers pass on context
                            // and multiple values (non-spec behavior)
                            if (handler !== Thrower) {
                              that = undefined
                              args = [e]
                            }

                            deferred.rejectWith(that, args)
                          }
                        }
                      }

                    // Support: Promises/A+ section 2.3.3.3.1
                    // https://promisesaplus.com/#point-57
                    // Re-resolve promises immediately to dodge false rejection from
                    // subsequent errors
                    if (depth) {
                      process()
                    } else {
                      // Call an optional hook to record the stack, in case of exception
                      // since it's otherwise lost when execution goes async
                      if (jQuery.Deferred.getStackHook) {
                        process.stackTrace = jQuery.Deferred.getStackHook()
                      }
                      window.setTimeout(process)
                    }
                  }
                }

                return jQuery.Deferred(function (newDefer) {
                  // progress_handlers.add( ... )
                  tuples[0][3].add(
                    resolve(
                      0,
                      newDefer,
                      isFunction(onProgress)
                      ? onProgress
                      : Identity,
                      newDefer.notifyWith
                    )
                  )

                  // fulfilled_handlers.add( ... )
                  tuples[1][3].add(
                    resolve(
                      0,
                      newDefer,
                      isFunction(onFulfilled)
                      ? onFulfilled
                      : Identity
                    )
                  )

                  // rejected_handlers.add( ... )
                  tuples[2][3].add(
                    resolve(
                      0,
                      newDefer,
                      isFunction(onRejected)
                      ? onRejected
                      : Thrower
                    )
                  )
                }).promise()
              },

              // Get a promise for this deferred
              // If obj is provided, the promise aspect is added to the object
              promise: function (obj) {
                return obj != null ? jQuery.extend(obj, promise) : promise
              }
            }
            var deferred = {}

            // Add list-specific methods
            jQuery.each(tuples, function (i, tuple) {
              var list = tuple[2]
              var stateString = tuple[5]

              // promise.progress = list.add
              // promise.done = list.add
              // promise.fail = list.add
              promise[tuple[1]] = list.add

              // Handle state
              if (stateString) {
                list.add(
                  function () {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString
                  },

                  // rejected_callbacks.disable
                  // fulfilled_callbacks.disable
                  tuples[3 - i][2].disable,

                  // rejected_handlers.disable
                  // fulfilled_handlers.disable
                  tuples[3 - i][3].disable,

                  // progress_callbacks.lock
                  tuples[0][2].lock,

                  // progress_handlers.lock
                  tuples[0][3].lock
                )
              }

              // progress_handlers.fire
              // fulfilled_handlers.fire
              // rejected_handlers.fire
              list.add(tuple[3].fire)

              // deferred.notify = function() { deferred.notifyWith(...) }
              // deferred.resolve = function() { deferred.resolveWith(...) }
              // deferred.reject = function() { deferred.rejectWith(...) }
              deferred[tuple[0]] = function () {
                deferred[tuple[0] + 'With'](this === deferred ? undefined : this, arguments)
                return this
              }

              // deferred.notifyWith = list.fireWith
              // deferred.resolveWith = list.fireWith
              // deferred.rejectWith = list.fireWith
              deferred[tuple[0] + 'With'] = list.fireWith
            })

            // Make the deferred a promise
            promise.promise(deferred)

            // Call given func if any
            if (func) {
              func.call(deferred, deferred)
            }

            // All done!
            return deferred
          },

          // Deferred helper
          when: function (singleValue) {
            var

              // count of uncompleted subordinates
              remaining = arguments.length

            // count of unprocessed arguments
            var i = remaining

            // subordinate fulfillment data
            var resolveContexts = Array(i)
            var resolveValues = slice.call(arguments)

            // the master Deferred
            var master = jQuery.Deferred()

            // subordinate callback factory
            var updateFunc = function (i) {
              return function (value) {
                resolveContexts[i] = this
                resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value
                if (!(--remaining)) {
                  master.resolveWith(resolveContexts, resolveValues)
                }
              }
            }

            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
              adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject,
                !remaining)

              // Use .then() to unwrap secondary thenables (cf. gh-3000)
              if (master.state() === 'pending' ||
                isFunction(resolveValues[i] && resolveValues[i].then)) {
                return master.then()
              }
            }

            // Multiple arguments are aggregated like Promise.all array elements
            while (i--) {
              adoptValue(resolveValues[i], updateFunc(i), master.reject)
            }

            return master.promise()
          }
        })

        // These usually indicate a programmer mistake during development,
        // warn about them ASAP rather than swallowing them by default.
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/

        jQuery.Deferred.exceptionHook = function (error, stack) {
          // Support: IE 8 - 9 only
          // Console exists when dev tools are open, which can happen at any time
          if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
            window.console.warn('jQuery.Deferred exception: ' + error.message, error.stack, stack)
          }
        }

        jQuery.readyException = function (error) {
          window.setTimeout(function () {
            throw error
          })
        }

        // The deferred used on DOM ready
        var readyList = jQuery.Deferred()

        jQuery.fn.ready = function (fn) {
          readyList
            .then(fn)

            // Wrap jQuery.readyException in a function so that the lookup
            // happens at the time of error handling instead of callback
            // registration.
            .catch(function (error) {
              jQuery.readyException(error)
            })

          return this
        }

        jQuery.extend({

          // Is the DOM ready to be used? Set to true once it occurs.
          isReady: false,

          // A counter to track how many items to wait for before
          // the ready event fires. See #6781
          readyWait: 1,

          // Handle when the DOM is ready
          ready: function (wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
              return
            }

            // Remember that the DOM is ready
            jQuery.isReady = true

            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) {
              return
            }

            // If there are functions bound, to execute
            readyList.resolveWith(document, [jQuery])
          }
        })

        jQuery.ready.then = readyList.then

        // The ready event handler and self cleanup method
        function completed() {
          document.removeEventListener('DOMContentLoaded', completed)
          window.removeEventListener('load', completed)
          jQuery.ready()
        }

        // Catch cases where $(document).ready() is called
        // after the browser event has already occurred.
        // Support: IE <=9 - 10 only
        // Older IE sometimes signals "interactive" too soon
        if (document.readyState === 'complete' ||
          (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
          // Handle it asynchronously to allow scripts the opportunity to delay ready
          window.setTimeout(jQuery.ready)
        } else {
          // Use the handy event callback
          document.addEventListener('DOMContentLoaded', completed)

          // A fallback to window.onload, that will always work
          window.addEventListener('load', completed)
        }

        // Multifunctional method to get and set values of a collection
        // The value/s can optionally be executed if it's a function
        var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
          var i = 0
          var len = elems.length
          var bulk = key == null

          // Sets many values
          if (toType(key) === 'object') {
            chainable = true
            for (i in key) {
              access(elems, fn, i, key[i], true, emptyGet, raw)
            }

            // Sets one value
          } else if (value !== undefined) {
            chainable = true

            if (!isFunction(value)) {
              raw = true
            }

            if (bulk) {
              // Bulk operations run against the entire set
              if (raw) {
                fn.call(elems, value)
                fn = null

                // ...except when executing function values
              } else {
                bulk = fn
                fn = function (elem, _key, value) {
                  return bulk.call(jQuery(elem), value)
                }
              }
            }

            if (fn) {
              for (; i < len; i++) {
                fn(
                  elems[i], key, raw
                  ? value
                  : value.call(elems[i], i, fn(elems[i], key))
                )
              }
            }
          }

          if (chainable) {
            return elems
          }

          // Gets
          if (bulk) {
            return fn.call(elems)
          }

          return len ? fn(elems[0], key) : emptyGet
        }

        // Matches dashed string for camelizing
        var rmsPrefix = /^-ms-/
        var rdashAlpha = /-([a-z])/g

        // Used by camelCase as callback to replace()
        function fcamelCase(_all, letter) {
          return letter.toUpperCase()
        }

        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 15
        // Microsoft forgot to hump their vendor prefix (#9572)
        function camelCase(string) {
          return string.replace(rmsPrefix, 'ms-').replace(rdashAlpha, fcamelCase)
        }
        var acceptData = function (owner) {
          // Accepts only:
          //  - Node
          //    - Node.ELEMENT_NODE
          //    - Node.DOCUMENT_NODE
          //  - Object
          //    - Any
          return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType)
        }

        function Data() {
          this.expando = jQuery.expando + Data.uid++
        }

        Data.uid = 1

        Data.prototype = {

          cache: function (owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando]

            // If not, create one
            if (!value) {
              value = Object.create(null)

              // We can accept data for non-element nodes in modern browsers,
              // but we should not, see #8335.
              // Always return an empty object.
              if (acceptData(owner)) {
                // If it is a node unlikely to be stringify-ed or looped over
                // use plain assignment
                if (owner.nodeType) {
                  owner[this.expando] = value

                  // Otherwise secure it in a non-enumerable property
                  // configurable must be true to allow the property to be
                  // deleted when data is removed
                } else {
                  Object.defineProperty(owner, this.expando, {
                    value: value,
                    configurable: true
                  })
                }
              }
            }

            return value
          },
          set: function (owner, data, value) {
            var prop
            var cache = this.cache(owner)

            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === 'string') {
              cache[camelCase(data)] = value

              // Handle: [ owner, { properties } ] args
            } else {
              // Copy the properties one-by-one to the cache object
              for (prop in data) {
                cache[camelCase(prop)] = data[prop]
              }
            }
            return cache
          },
          get: function (owner, key) {
            return key === undefined
              ? this.cache(owner)

              // Always use camelCase key (gh-2257)
              : owner[this.expando] && owner[this.expando][camelCase(key)]
          },
          access: function (owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined ||
              ((key && typeof key === 'string') && value === undefined)) {
              return this.get(owner, key)
            }

            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value)

            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key
          },
          remove: function (owner, key) {
            var i
            var cache = owner[this.expando]

            if (cache === undefined) {
              return
            }

            if (key !== undefined) {
              // Support array or space separated string of keys
              if (Array.isArray(key)) {
                // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase)
              } else {
                key = camelCase(key)

                // If a key with the spaces exists, use it.
                // Otherwise, create an array by matching non-whitespace
                key = key in cache ? [key]
                  : (key.match(rnothtmlwhite) || [])
              }

              i = key.length

              while (i--) {
                delete cache[key[i]]
              }
            }

            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
              // Support: Chrome <=35 - 45
              // Webkit & Blink performance suffers when deleting properties
              // from DOM nodes, so set to undefined instead
              // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
              if (owner.nodeType) {
                owner[this.expando] = undefined
              } else {
                delete owner[this.expando]
              }
            }
          },
          hasData: function (owner) {
            var cache = owner[this.expando]
            return cache !== undefined && !jQuery.isEmptyObject(cache)
          }
        }
        var dataPriv = new Data()

        var dataUser = new Data()

        //	Implementation Summary
        //
        //	1. Enforce API surface and semantic compatibility with 1.9.x branch
        //	2. Improve the module's maintainability by reducing the storage
        //		paths to a single mechanism.
        //	3. Use the same single mechanism to support "private" and "user" data.
        //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
        //	5. Avoid exposing implementation details on user objects (eg. expando properties)
        //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
        var rmultiDash = /[A-Z]/g

        function getData(data) {
          if (data === 'true') {
            return true
          }

          if (data === 'false') {
            return false
          }

          if (data === 'null') {
            return null
          }

          // Only convert to a number if it doesn't change the string
          if (data === +data + '') {
            return +data
          }

          if (rbrace.test(data)) {
            return JSON.parse(data)
          }

          return data
        }

        function dataAttr(elem, key, data) {
          var name

          // If nothing was found internally, try to fetch any
          // data from the HTML5 data-* attribute
          if (data === undefined && elem.nodeType === 1) {
            name = 'data-' + key.replace(rmultiDash, '-$&').toLowerCase()
            data = elem.getAttribute(name)

            if (typeof data === 'string') {
              try {
                data = getData(data)
              } catch (e) {}

              // Make sure we set the data so it isn't changed later
              dataUser.set(elem, key, data)
            } else {
              data = undefined
            }
          }
          return data
        }

        jQuery.extend({
          hasData: function (elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem)
          },

          data: function (elem, name, data) {
            return dataUser.access(elem, name, data)
          },

          removeData: function (elem, name) {
            dataUser.remove(elem, name)
          },

          // TODO: Now that all calls to _data and _removeData have been replaced
          // with direct calls to dataPriv methods, these can be deprecated.
          _data: function (elem, name, data) {
            return dataPriv.access(elem, name, data)
          },

          _removeData: function (elem, name) {
            dataPriv.remove(elem, name)
          }
        })

        jQuery.fn.extend({
          data: function (key, value) {
            var i
            var name
            var data
            var elem = this[0]
            var attrs = elem && elem.attributes

            // Gets all values
            if (key === undefined) {
              if (this.length) {
                data = dataUser.get(elem)

                if (elem.nodeType === 1 && !dataPriv.get(elem, 'hasDataAttrs')) {
                  i = attrs.length
                  while (i--) {
                    // Support: IE 11 only
                    // The attrs elements can be null (#14894)
                    if (attrs[i]) {
                      name = attrs[i].name
                      if (name.indexOf('data-') === 0) {
                        name = camelCase(name.slice(5))
                        dataAttr(elem, name, data[name])
                      }
                    }
                  }
                  dataPriv.set(elem, 'hasDataAttrs', true)
                }
              }

              return data
            }

            // Sets multiple values
            if (typeof key === 'object') {
              return this.each(function () {
                dataUser.set(this, key)
              })
            }

            return access(this, function (value) {
              var data

              // The calling jQuery object (element matches) is not empty
              // (and therefore has an element appears at this[ 0 ]) and the
              // `value` parameter was not undefined. An empty jQuery object
              // will result in `undefined` for elem = this[ 0 ] which will
              // throw an exception if an attempt to read a data cache is made.
              if (elem && value === undefined) {
                // Attempt to get data from the cache
                // The key will always be camelCased in Data
                data = dataUser.get(elem, key)
                if (data !== undefined) {
                  return data
                }

                // Attempt to "discover" the data in
                // HTML5 custom data-* attrs
                data = dataAttr(elem, key)
                if (data !== undefined) {
                  return data
                }

                // We tried really hard, but the data doesn't exist.
                return
              }

              // Set the data...
              this.each(function () {
                // We always store the camelCased key
                dataUser.set(this, key, value)
              })
            }, null, value, arguments.length > 1, null, true)
          },

          removeData: function (key) {
            return this.each(function () {
              dataUser.remove(this, key)
            })
          }
        })

        jQuery.extend({
          queue: function (elem, type, data) {
            var queue

            if (elem) {
              type = (type || 'fx') + 'queue'
              queue = dataPriv.get(elem, type)

              // Speed up dequeue by getting out quickly if this is just a lookup
              if (data) {
                if (!queue || Array.isArray(data)) {
                  queue = dataPriv.access(elem, type, jQuery.makeArray(data))
                } else {
                  queue.push(data)
                }
              }
              return queue || []
            }
          },

          dequeue: function (elem, type) {
            type = type || 'fx'

            var queue = jQuery.queue(elem, type)
            var startLength = queue.length
            var fn = queue.shift()
            var hooks = jQuery._queueHooks(elem, type)
            var next = function () {
              jQuery.dequeue(elem, type)
            }

            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === 'inprogress') {
              fn = queue.shift()
              startLength--
            }

            if (fn) {
              // Add a progress sentinel to prevent the fx queue from being
              // automatically dequeued
              if (type === 'fx') {
                queue.unshift('inprogress')
              }

              // Clear up the last queue stop function
              delete hooks.stop
              fn.call(elem, next, hooks)
            }

            if (!startLength && hooks) {
              hooks.empty.fire()
            }
          },

          // Not public - generate a queueHooks object, or return the current one
          _queueHooks: function (elem, type) {
            var key = type + 'queueHooks'
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
              empty: jQuery.Callbacks('once memory').add(function () {
                dataPriv.remove(elem, [type + 'queue', key])
              })
            })
          }
        })

        jQuery.fn.extend({
          queue: function (type, data) {
            var setter = 2

            if (typeof type !== 'string') {
              data = type
              type = 'fx'
              setter--
            }

            if (arguments.length < setter) {
              return jQuery.queue(this[0], type)
            }

            return data === undefined
              ? this
              : this.each(function () {
                var queue = jQuery.queue(this, type, data)

                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type)

                if (type === 'fx' && queue[0] !== 'inprogress') {
                  jQuery.dequeue(this, type)
                }
              })
          },
          dequeue: function (type) {
            return this.each(function () {
              jQuery.dequeue(this, type)
            })
          },
          clearQueue: function (type) {
            return this.queue(type || 'fx', [])
          },

          // Get a promise resolved when queues of a certain type
          // are emptied (fx is the type by default)
          promise: function (type, obj) {
            var tmp
            var count = 1
            var defer = jQuery.Deferred()
            var elements = this
            var i = this.length
            var resolve = function () {
              if (!(--count)) {
                defer.resolveWith(elements, [elements])
              }
            }

            if (typeof type !== 'string') {
              obj = type
              type = undefined
            }
            type = type || 'fx'

            while (i--) {
              tmp = dataPriv.get(elements[i], type + 'queueHooks')
              if (tmp && tmp.empty) {
                count++
                tmp.empty.add(resolve)
              }
            }
            resolve()
            return defer.promise(obj)
          }
        })
        var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source

        var rcssNum = new RegExp('^(?:([+-])=|)(' + pnum + ')([a-z%]*)$', 'i')

        var cssExpand = ['Top', 'Right', 'Bottom', 'Left']

        var documentElement = document.documentElement

        var isAttached = function (elem) {
          return jQuery.contains(elem.ownerDocument, elem)
        }
        var composed = {
          composed: true
        }

        // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
        // Check attachment across shadow DOM boundaries when possible (gh-3504)
        // Support: iOS 10.0-10.2 only
        // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
        // leading to errors. We need to check for `getRootNode`.
        if (documentElement.getRootNode) {
          isAttached = function (elem) {
            return jQuery.contains(elem.ownerDocument, elem) ||
              elem.getRootNode(composed) === elem.ownerDocument
          }
        }
        var isHiddenWithinTree = function (elem, el) {
          // isHiddenWithinTree might be called from jQuery#filter function;
          // in that case, element will be second argument
          elem = el || elem

          // Inline style trumps all
          return elem.style.display === 'none' ||
            elem.style.display === '' &&

            // Otherwise, check computed style
            // Support: Firefox <=43 - 45
            // Disconnected elements can have computed display: none, so first confirm that elem is
            // in the document.
            isAttached(elem) &&

            jQuery.css(elem, 'display') === 'none'
        }

        function adjustCSS(elem, prop, valueParts, tween) {
          var adjusted
          var scale
          var maxIterations = 20
          var currentValue = tween
            ? function () {
              return tween.cur()
            }
            : function () {
              return jQuery.css(elem, prop, '')
            }
          var initial = currentValue()
          var unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? '' : 'px')

          // Starting value computation is required for potential unit mismatches
          var initialInUnit = elem.nodeType &&
            (jQuery.cssNumber[prop] || unit !== 'px' && +initial) &&
            rcssNum.exec(jQuery.css(elem, prop))

          if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2

            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3]

            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1

            while (maxIterations--) {
              // Evaluate and update our best guess (doubling guesses that zero out).
              // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
              jQuery.style(elem, prop, initialInUnit + unit)
              if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                maxIterations = 0
              }
              initialInUnit = initialInUnit / scale
            }

            initialInUnit = initialInUnit * 2
            jQuery.style(elem, prop, initialInUnit + unit)

            // Make sure we update the tween properties later on
            valueParts = valueParts || []
          }

          if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0

            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1]
              ? initialInUnit + (valueParts[1] + 1) * valueParts[2]
              : +valueParts[2]
            if (tween) {
              tween.unit = unit
              tween.start = initialInUnit
              tween.end = adjusted
            }
          }
          return adjusted
        }

        var defaultDisplayMap = {}

        function getDefaultDisplay(elem) {
          var temp
          var doc = elem.ownerDocument
          var nodeName = elem.nodeName
          var display = defaultDisplayMap[nodeName]

          if (display) {
            return display
          }

          temp = doc.body.appendChild(doc.createElement(nodeName))
          display = jQuery.css(temp, 'display')

          temp.parentNode.removeChild(temp)

          if (display === 'none') {
            display = 'block'
          }
          defaultDisplayMap[nodeName] = display

          return display
        }

        function showHide(elements, show) {
          var display
          var elem
          var values = []
          var index = 0
          var length = elements.length

          // Determine new display value for elements that need to change
          for (; index < length; index++) {
            elem = elements[index]
            if (!elem.style) {
              continue
            }

            display = elem.style.display
            if (show) {
              // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
              // check is required in this first loop unless we have a nonempty display value (either
              // inline or about-to-be-restored)
              if (display === 'none') {
                values[index] = dataPriv.get(elem, 'display') || null
                if (!values[index]) {
                  elem.style.display = ''
                }
              }
              if (elem.style.display === '' && isHiddenWithinTree(elem)) {
                values[index] = getDefaultDisplay(elem)
              }
            } else {
              if (display !== 'none') {
                values[index] = 'none'

                // Remember what we're overwriting
                dataPriv.set(elem, 'display', display)
              }
            }
          }

          // Set the display of the elements in a second loop to avoid constant reflow
          for (index = 0; index < length; index++) {
            if (values[index] != null) {
              elements[index].style.display = values[index]
            }
          }

          return elements
        }

        jQuery.fn.extend({
          show: function () {
            return showHide(this, true)
          },
          hide: function () {
            return showHide(this)
          },
          toggle: function (state) {
            if (typeof state === 'boolean') {
              return state ? this.show() : this.hide()
            }

            return this.each(function () {
              if (isHiddenWithinTree(this)) {
                jQuery(this).show()
              } else {
                jQuery(this).hide()
              }
            })
          }
        })
        var rcheckableType = (/^(?:checkbox|radio)$/i)

        var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]*)/i)

        var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);

        (function () {
          var fragment = document.createDocumentFragment()
          var div = fragment.appendChild(document.createElement('div'))
          var input = document.createElement('input')

          // Support: Android 4.0 - 4.3 only
          // Check state lost if the name is set (#11217)
          // Support: Windows Web Apps (WWA)
          // `name` and `type` must use .setAttribute for WWA (#14901)
          input.setAttribute('type', 'radio')
          input.setAttribute('checked', 'checked')
          input.setAttribute('name', 't')

          div.appendChild(input)

          // Support: Android <=4.1 only
          // Older WebKit doesn't clone checked state correctly in fragments
          support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked

          // Support: IE <=11 only
          // Make sure textarea (and checkbox) defaultValue is properly cloned
          div.innerHTML = '<textarea>x</textarea>'
          support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue

          // Support: IE <=9 only
          // IE <=9 replaces <option> tags with their contents when inserted outside of
          // the select element.
          div.innerHTML = '<option></option>'
          support.option = !!div.lastChild
        })()

        // We have to close these tags to support XHTML (#13200)
        var wrapMap = {

          // XHTML parsers do not magically insert elements in the
          // same way that tag soup parsers do. So we cannot shorten
          // this by omitting <tbody> or other required elements.
          thead: [1, '<table>', '</table>'],
          col: [2, '<table><colgroup>', '</colgroup></table>'],
          tr: [2, '<table><tbody>', '</tbody></table>'],
          td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],

          _default: [0, '', '']
        }

        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead
        wrapMap.th = wrapMap.td

        // Support: IE <=9 only
        if (!support.option) {
          wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", '</select>']
        }

        function getAll(context, tag) {
          // Support: IE <=9 - 11 only
          // Use typeof to avoid zero-argument method invocation on host objects (#15151)
          var ret

          if (typeof context.getElementsByTagName !== 'undefined') {
            ret = context.getElementsByTagName(tag || '*')
          } else if (typeof context.querySelectorAll !== 'undefined') {
            ret = context.querySelectorAll(tag || '*')
          } else {
            ret = []
          }

          if (tag === undefined || tag && nodeName(context, tag)) {
            return jQuery.merge([context], ret)
          }

          return ret
        }

        // Mark scripts as having already been evaluated
        function setGlobalEval(elems, refElements) {
          var i = 0
          var l = elems.length

          for (; i < l; i++) {
            dataPriv.set(
              elems[i],
              'globalEval',
              !refElements || dataPriv.get(refElements[i], 'globalEval')
            )
          }
        }

        var rhtml = /<|&#?\w+;/

        function buildFragment(elems, context, scripts, selection, ignored) {
          var elem
          var tmp
          var tag
          var wrap
          var attached
          var j
          var fragment = context.createDocumentFragment()
          var nodes = []
          var i = 0
          var l = elems.length

          for (; i < l; i++) {
            elem = elems[i]

            if (elem || elem === 0) {
              // Add nodes directly
              if (toType(elem) === 'object') {
                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [elem] : elem)

                // Convert non-html into a text node
              } else if (!rhtml.test(elem)) {
                nodes.push(context.createTextNode(elem))

                // Convert html into DOM nodes
              } else {
                tmp = tmp || fragment.appendChild(context.createElement('div'))

                // Deserialize a standard representation
                tag = (rtagName.exec(elem) || ['', ''])[1].toLowerCase()
                wrap = wrapMap[tag] || wrapMap._default
                tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2]

                // Descend through wrappers to the right content
                j = wrap[0]
                while (j--) {
                  tmp = tmp.lastChild
                }

                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, tmp.childNodes)

                // Remember the top-level container
                tmp = fragment.firstChild

                // Ensure the created nodes are orphaned (#12392)
                tmp.textContent = ''
              }
            }
          }

          // Remove wrapper from fragment
          fragment.textContent = ''

          i = 0
          while ((elem = nodes[i++])) {
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
              if (ignored) {
                ignored.push(elem)
              }
              continue
            }

            attached = isAttached(elem)

            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), 'script')

            // Preserve script evaluation history
            if (attached) {
              setGlobalEval(tmp)
            }

            // Capture executables
            if (scripts) {
              j = 0
              while ((elem = tmp[j++])) {
                if (rscriptType.test(elem.type || '')) {
                  scripts.push(elem)
                }
              }
            }
          }

          return fragment
        }

        var
          rkeyEvent = /^key/
        var rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
        var rtypenamespace = /^([^.]*)(?:\.(.+)|)/

        function returnTrue() {
          return true
        }

        function returnFalse() {
          return false
        }

        // Support: IE <=9 - 11+
        // focus() and blur() are asynchronous, except when they are no-op.
        // So expect focus to be synchronous when the element is already active,
        // and blur to be synchronous when the element is not already active.
        // (focus and blur are always synchronous in other supported browsers,
        // this just defines when we can count on it).
        function expectSync(elem, type) {
          return (elem === safeActiveElement()) === (type === 'focus')
        }

        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
          try {
            return document.activeElement
          } catch (err) {}
        }

        function on(elem, types, selector, data, fn, one) {
          var origFn, type

          // Types can be a map of types/handlers
          if (typeof types === 'object') {
            // ( types-Object, selector, data )
            if (typeof selector !== 'string') {
              // ( types-Object, data )
              data = data || selector
              selector = undefined
            }
            for (type in types) {
              on(elem, type, selector, data, types[type], one)
            }
            return elem
          }

          if (data == null && fn == null) {
            // ( types, fn )
            fn = selector
            data = selector = undefined
          } else if (fn == null) {
            if (typeof selector === 'string') {
              // ( types, selector, fn )
              fn = data
              data = undefined
            } else {
              // ( types, data, fn )
              fn = data
              data = selector
              selector = undefined
            }
          }
          if (fn === false) {
            fn = returnFalse
          } else if (!fn) {
            return elem
          }

          if (one === 1) {
            origFn = fn
            fn = function (event) {
              // Can use an empty set, since event contains the info
              jQuery().off(event)
              return origFn.apply(this, arguments)
            }

            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++)
          }
          return elem.each(function () {
            jQuery.event.add(this, types, fn, data, selector)
          })
        }

        /*
         * Helper functions for managing events -- not part of the public interface.
         * Props to Dean Edwards' addEvent library for many of the ideas.
         */
        jQuery.event = {

          global: {},

          add: function (elem, types, handler, data, selector) {
            var handleObjIn
            var eventHandle
            var tmp
            var events
            var t
            var handleObj
            var special
            var handlers
            var type
            var namespaces
            var origType
            var elemData = dataPriv.get(elem)

            // Only attach events to objects that accept data
            if (!acceptData(elem)) {
              return
            }

            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
              handleObjIn = handler
              handler = handleObjIn.handler
              selector = handleObjIn.selector
            }

            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) {
              jQuery.find.matchesSelector(documentElement, selector)
            }

            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) {
              handler.guid = jQuery.guid++
            }

            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) {
              events = elemData.events = Object.create(null)
            }
            if (!(eventHandle = elemData.handle)) {
              eventHandle = elemData.handle = function (e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== 'undefined' && jQuery.event.triggered !== e.type
                  ? jQuery.event.dispatch.apply(elem, arguments) : undefined
              }
            }

            // Handle multiple events separated by a space
            types = (types || '').match(rnothtmlwhite) || ['']
            t = types.length
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || []
              type = origType = tmp[1]
              namespaces = (tmp[2] || '').split('.').sort()

              // There *must* be a type, no attaching namespace-only handlers
              if (!type) {
                continue
              }

              // If event changes its type, use the special event handlers for the changed type
              special = jQuery.event.special[type] || {}

              // If selector defined, determine special event api type, otherwise given type
              type = (selector ? special.delegateType : special.bindType) || type

              // Update special based on newly reset type
              special = jQuery.event.special[type] || {}

              // handleObj is passed to all event handlers
              handleObj = jQuery.extend({
                type: type,
                origType: origType,
                data: data,
                handler: handler,
                guid: handler.guid,
                selector: selector,
                needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                namespace: namespaces.join('.')
              }, handleObjIn)

              // Init the event handler queue if we're the first
              if (!(handlers = events[type])) {
                handlers = events[type] = []
                handlers.delegateCount = 0

                // Only use addEventListener if the special events handler returns false
                if (!special.setup ||
                  special.setup.call(elem, data, namespaces, eventHandle) === false) {
                  if (elem.addEventListener) {
                    elem.addEventListener(type, eventHandle)
                  }
                }
              }

              if (special.add) {
                special.add.call(elem, handleObj)

                if (!handleObj.handler.guid) {
                  handleObj.handler.guid = handler.guid
                }
              }

              // Add to the element's handler list, delegates in front
              if (selector) {
                handlers.splice(handlers.delegateCount++, 0, handleObj)
              } else {
                handlers.push(handleObj)
              }

              // Keep track of which events have ever been used, for event optimization
              jQuery.event.global[type] = true
            }
          },

          // Detach an event or set of events from an element
          remove: function (elem, types, handler, selector, mappedTypes) {
            var j
            var origCount
            var tmp
            var events
            var t
            var handleObj
            var special
            var handlers
            var type
            var namespaces
            var origType
            var elemData = dataPriv.hasData(elem) && dataPriv.get(elem)

            if (!elemData || !(events = elemData.events)) {
              return
            }

            // Once for each type.namespace in types; type may be omitted
            types = (types || '').match(rnothtmlwhite) || ['']
            t = types.length
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || []
              type = origType = tmp[1]
              namespaces = (tmp[2] || '').split('.').sort()

              // Unbind all events (on this namespace, if provided) for the element
              if (!type) {
                for (type in events) {
                  jQuery.event.remove(elem, type + types[t], handler, selector, true)
                }
                continue
              }

              special = jQuery.event.special[type] || {}
              type = (selector ? special.delegateType : special.bindType) || type
              handlers = events[type] || []
              tmp = tmp[2] &&
                new RegExp('(^|\\.)' + namespaces.join('\\.(?:.*\\.|)') + '(\\.|$)')

              // Remove matching events
              origCount = j = handlers.length
              while (j--) {
                handleObj = handlers[j]

                if ((mappedTypes || origType === handleObj.origType) &&
                  (!handler || handler.guid === handleObj.guid) &&
                  (!tmp || tmp.test(handleObj.namespace)) &&
                  (!selector || selector === handleObj.selector ||
                    selector === '**' && handleObj.selector)) {
                  handlers.splice(j, 1)

                  if (handleObj.selector) {
                    handlers.delegateCount--
                  }
                  if (special.remove) {
                    special.remove.call(elem, handleObj)
                  }
                }
              }

              // Remove generic event handler if we removed something and no more handlers exist
              // (avoids potential for endless recursion during removal of special event handlers)
              if (origCount && !handlers.length) {
                if (!special.teardown ||
                  special.teardown.call(elem, namespaces, elemData.handle) === false) {
                  jQuery.removeEvent(elem, type, elemData.handle)
                }

                delete events[type]
              }
            }

            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) {
              dataPriv.remove(elem, 'handle events')
            }
          },

          dispatch: function (nativeEvent) {
            var i
            var j
            var ret
            var matched
            var handleObj
            var handlerQueue
            var args = new Array(arguments.length)

            // Make a writable jQuery.Event from the native event object
            var event = jQuery.event.fix(nativeEvent)

            var handlers = (
              dataPriv.get(this, 'events') || Object.create(null)
            )[event.type] || []
            var special = jQuery.event.special[event.type] || {}

            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event

            for (i = 1; i < arguments.length; i++) {
              args[i] = arguments[i]
            }

            event.delegateTarget = this

            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) {
              return
            }

            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers)

            // Run delegates first; they may want to stop propagation beneath us
            i = 0
            while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
              event.currentTarget = matched.elem

              j = 0
              while ((handleObj = matched.handlers[j++]) &&
                !event.isImmediatePropagationStopped()) {
                // If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false ||
                  event.rnamespace.test(handleObj.namespace)) {
                  event.handleObj = handleObj
                  event.data = handleObj.data

                  ret = ((jQuery.event.special[handleObj.origType] || {}).handle ||
                    handleObj.handler).apply(matched.elem, args)

                  if (ret !== undefined) {
                    if ((event.result = ret) === false) {
                      event.preventDefault()
                      event.stopPropagation()
                    }
                  }
                }
              }
            }

            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) {
              special.postDispatch.call(this, event)
            }

            return event.result
          },

          handlers: function (event, handlers) {
            var i
            var handleObj
            var sel
            var matchedHandlers
            var matchedSelectors
            var handlerQueue = []
            var delegateCount = handlers.delegateCount
            var cur = event.target

            // Find delegate handlers
            if (delegateCount &&

              // Support: IE <=9
              // Black-hole SVG <use> instance trees (trac-13180)
              cur.nodeType &&

              // Support: Firefox <=42
              // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
              // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
              // Support: IE 11 only
              // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
              !(event.type === 'click' && event.button >= 1)) {
              for (; cur !== this; cur = cur.parentNode || this) {
                // Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === 'click' && cur.disabled === true)) {
                  matchedHandlers = []
                  matchedSelectors = {}
                  for (i = 0; i < delegateCount; i++) {
                    handleObj = handlers[i]

                    // Don't conflict with Object.prototype properties (#13203)
                    sel = handleObj.selector + ' '

                    if (matchedSelectors[sel] === undefined) {
                      matchedSelectors[sel] = handleObj.needsContext
                        ? jQuery(sel, this).index(cur) > -1
                        : jQuery.find(sel, this, null, [cur]).length
                    }
                    if (matchedSelectors[sel]) {
                      matchedHandlers.push(handleObj)
                    }
                  }
                  if (matchedHandlers.length) {
                    handlerQueue.push({
                      elem: cur,
                      handlers: matchedHandlers
                    })
                  }
                }
              }
            }

            // Add the remaining (directly-bound) handlers
            cur = this
            if (delegateCount < handlers.length) {
              handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
              })
            }

            return handlerQueue
          },

          addProp: function (name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
              enumerable: true,
              configurable: true,

              get: isFunction(hook)
                ? function () {
                  if (this.originalEvent) {
                    return hook(this.originalEvent)
                  }
                } : function () {
                  if (this.originalEvent) {
                    return this.originalEvent[name]
                  }
                },

              set: function (value) {
                Object.defineProperty(this, name, {
                  enumerable: true,
                  configurable: true,
                  writable: true,
                  value: value
                })
              }
            })
          },

          fix: function (originalEvent) {
            return originalEvent[jQuery.expando]
              ? originalEvent
              : new jQuery.Event(originalEvent)
          },

          special: {
            load: {

              // Prevent triggered image.load events from bubbling to window.load
              noBubble: true
            },
            click: {

              // Utilize native event to ensure correct state for checkable inputs
              setup: function (data) {
                // For mutual compressibility with _default, replace `this` access with a local var.
                // `|| data` is dead code meant only to preserve the variable through minification.
                var el = this || data

                // Claim the first handler
                if (rcheckableType.test(el.type) &&
                  el.click && nodeName(el, 'input')) {
                  // dataPriv.set( el, "click", ... )
                  leverageNative(el, 'click', returnTrue)
                }

                // Return false to allow normal processing in the caller
                return false
              },
              trigger: function (data) {
                // For mutual compressibility with _default, replace `this` access with a local var.
                // `|| data` is dead code meant only to preserve the variable through minification.
                var el = this || data

                // Force setup before triggering a click
                if (rcheckableType.test(el.type) &&
                  el.click && nodeName(el, 'input')) {
                  leverageNative(el, 'click')
                }

                // Return non-false to allow normal event-path propagation
                return true
              },

              // For cross-browser consistency, suppress native .click() on links
              // Also prevent it if we're currently inside a leveraged native-event stack
              _default: function (event) {
                var target = event.target
                return rcheckableType.test(target.type) &&
                  target.click && nodeName(target, 'input') &&
                  dataPriv.get(target, 'click') ||
                  nodeName(target, 'a')
              }
            },

            beforeunload: {
              postDispatch: function (event) {
                // Support: Firefox 20+
                // Firefox doesn't alert if the returnValue field is not set.
                if (event.result !== undefined && event.originalEvent) {
                  event.originalEvent.returnValue = event.result
                }
              }
            }
          }
        }

        // Ensure the presence of an event listener that handles manually-triggered
        // synthetic events by interrupting progress until reinvoked in response to
        // *native* events that it fires directly, ensuring that state changes have
        // already occurred before other listeners are invoked.
        function leverageNative(el, type, expectSync) {
          // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
          if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) {
              jQuery.event.add(el, type, returnTrue)
            }
            return
          }

          // Register the controller as a special universal handler for all event namespaces
          dataPriv.set(el, type, false)
          jQuery.event.add(el, type, {
            namespace: false,
            handler: function (event) {
              var notAsync
              var result
              var saved = dataPriv.get(this, type)

              if ((event.isTrigger & 1) && this[type]) {
                // Interrupt processing of the outer synthetic .trigger()ed event
                // Saved data should be false in such cases, but might be a leftover capture object
                // from an async native handler (gh-4350)
                if (!saved.length) {
                  // Store arguments for use when handling the inner native event
                  // There will always be at least one argument (an event object), so this array
                  // will not be confused with a leftover capture object.
                  saved = slice.call(arguments)
                  dataPriv.set(this, type, saved)

                  // Trigger the native event and capture its result
                  // Support: IE <=9 - 11+
                  // focus() and blur() are asynchronous
                  notAsync = expectSync(this, type)
                  this[type]()
                  result = dataPriv.get(this, type)
                  if (saved !== result || notAsync) {
                    dataPriv.set(this, type, false)
                  } else {
                    result = {}
                  }
                  if (saved !== result) {
                    // Cancel the outer synthetic event
                    event.stopImmediatePropagation()
                    event.preventDefault()
                    return result.value
                  }

                  // If this is an inner synthetic event for an event with a bubbling surrogate
                  // (focus or blur), assume that the surrogate already propagated from triggering the
                  // native event and prevent that from happening again here.
                  // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                  // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                  // less bad than duplication.
                } else if ((jQuery.event.special[type] || {}).delegateType) {
                  event.stopPropagation()
                }

                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
              } else if (saved.length) {
                // ...and capture the result
                dataPriv.set(this, type, {
                  value: jQuery.event.trigger(

                    // Support: IE <=9 - 11+
                    // Extend with the prototype to reset the above stopImmediatePropagation()
                    jQuery.extend(saved[0], jQuery.Event.prototype),
                    saved.slice(1),
                    this
                  )
                })

                // Abort handling of the native event
                event.stopImmediatePropagation()
              }
            }
          })
        }

        jQuery.removeEvent = function (elem, type, handle) {
          // This "if" is needed for plain objects
          if (elem.removeEventListener) {
            elem.removeEventListener(type, handle)
          }
        }

        jQuery.Event = function (src, props) {
          // Allow instantiation without the 'new' keyword
          if (!(this instanceof jQuery.Event)) {
            return new jQuery.Event(src, props)
          }

          // Event object
          if (src && src.type) {
            this.originalEvent = src
            this.type = src.type

            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ||
              src.defaultPrevented === undefined &&

              // Support: Android <=2.3 only
              src.returnValue === false
              ? returnTrue
              : returnFalse

            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = (src.target && src.target.nodeType === 3)
              ? src.target.parentNode
              : src.target

            this.currentTarget = src.currentTarget
            this.relatedTarget = src.relatedTarget

            // Event type
          } else {
            this.type = src
          }

          // Put explicitly provided properties onto the event object
          if (props) {
            jQuery.extend(this, props)
          }

          // Create a timestamp if incoming event doesn't have one
          this.timeStamp = src && src.timeStamp || Date.now()

          // Mark it as fixed
          this[jQuery.expando] = true
        }

        // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
        // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
        jQuery.Event.prototype = {
          constructor: jQuery.Event,
          isDefaultPrevented: returnFalse,
          isPropagationStopped: returnFalse,
          isImmediatePropagationStopped: returnFalse,
          isSimulated: false,

          preventDefault: function () {
            var e = this.originalEvent

            this.isDefaultPrevented = returnTrue

            if (e && !this.isSimulated) {
              e.preventDefault()
            }
          },
          stopPropagation: function () {
            var e = this.originalEvent

            this.isPropagationStopped = returnTrue

            if (e && !this.isSimulated) {
              e.stopPropagation()
            }
          },
          stopImmediatePropagation: function () {
            var e = this.originalEvent

            this.isImmediatePropagationStopped = returnTrue

            if (e && !this.isSimulated) {
              e.stopImmediatePropagation()
            }

            this.stopPropagation()
          }
        }

        // Includes all common event props including KeyEvent and MouseEvent specific props
        jQuery.each({
          altKey: true,
          bubbles: true,
          cancelable: true,
          changedTouches: true,
          ctrlKey: true,
          detail: true,
          eventPhase: true,
          metaKey: true,
          pageX: true,
          pageY: true,
          shiftKey: true,
          view: true,
          char: true,
          code: true,
          charCode: true,
          key: true,
          keyCode: true,
          button: true,
          buttons: true,
          clientX: true,
          clientY: true,
          offsetX: true,
          offsetY: true,
          pointerId: true,
          pointerType: true,
          screenX: true,
          screenY: true,
          targetTouches: true,
          toElement: true,
          touches: true,

          which: function (event) {
            var button = event.button

            // Add which for key events
            if (event.which == null && rkeyEvent.test(event.type)) {
              return event.charCode != null ? event.charCode : event.keyCode
            }

            // Add which for click: 1 === left; 2 === middle; 3 === right
            if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
              if (button & 1) {
                return 1
              }

              if (button & 2) {
                return 3
              }

              if (button & 4) {
                return 2
              }

              return 0
            }

            return event.which
          }
        }, jQuery.event.addProp)

        jQuery.each({
          focus: 'focusin',
          blur: 'focusout'
        }, function (type, delegateType) {
          jQuery.event.special[type] = {

            // Utilize native event if possible so blur/focus sequence is correct
            setup: function () {
              // Claim the first handler
              // dataPriv.set( this, "focus", ... )
              // dataPriv.set( this, "blur", ... )
              leverageNative(this, type, expectSync)

              // Return false to allow normal processing in the caller
              return false
            },
            trigger: function () {
              // Force setup before trigger
              leverageNative(this, type)

              // Return non-false to allow normal event-path propagation
              return true
            },

            delegateType: delegateType
          }
        })

        // Create mouseenter/leave events using mouseover/out and event-time checks
        // so that event delegation works in jQuery.
        // Do the same for pointerenter/pointerleave and pointerover/pointerout
        //
        // Support: Safari 7 only
        // Safari sends mouseenter too often; see:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
        // for the description of the bug (it existed in older Chrome versions as well).
        jQuery.each({
          mouseenter: 'mouseover',
          mouseleave: 'mouseout',
          pointerenter: 'pointerover',
          pointerleave: 'pointerout'
        }, function (orig, fix) {
          jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,

            handle: function (event) {
              var ret
              var target = this
              var related = event.relatedTarget
              var handleObj = event.handleObj

              // For mouseenter/leave call the handler if related is outside the target.
              // NB: No relatedTarget if the mouse left/entered the browser window
              if (!related || (related !== target && !jQuery.contains(target, related))) {
                event.type = handleObj.origType
                ret = handleObj.handler.apply(this, arguments)
                event.type = fix
              }
              return ret
            }
          }
        })

        jQuery.fn.extend({

          on: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn)
          },
          one: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1)
          },
          off: function (types, selector, fn) {
            var handleObj, type
            if (types && types.preventDefault && types.handleObj) {
              // ( event )  dispatched jQuery.Event
              handleObj = types.handleObj
              jQuery(types.delegateTarget).off(
                handleObj.namespace
                ? handleObj.origType + '.' + handleObj.namespace
                : handleObj.origType,
                handleObj.selector,
                handleObj.handler
              )
              return this
            }
            if (typeof types === 'object') {
              // ( types-object [, selector] )
              for (type in types) {
                this.off(type, selector, types[type])
              }
              return this
            }
            if (selector === false || typeof selector === 'function') {
              // ( types [, fn] )
              fn = selector
              selector = undefined
            }
            if (fn === false) {
              fn = returnFalse
            }
            return this.each(function () {
              jQuery.event.remove(this, types, fn, selector)
            })
          }
        })

        var

          // Support: IE <=10 - 11, Edge 12 - 13 only
          // In IE/Edge using regex groups here causes severe slowdowns.
          // See https://connect.microsoft.com/IE/feedback/details/1736512/
          rnoInnerhtml = /<script|<style|<link/i

        // checked="checked" or checked
        var rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i
        var rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g

        // Prefer a tbody over its parent table for containing new rows
        function manipulationTarget(elem, content) {
          if (nodeName(elem, 'table') &&
            nodeName(content.nodeType !== 11 ? content : content.firstChild, 'tr')) {
            return jQuery(elem).children('tbody')[0] || elem
          }

          return elem
        }

        // Replace/restore the type attribute of script elements for safe DOM manipulation
        function disableScript(elem) {
          elem.type = (elem.getAttribute('type') !== null) + '/' + elem.type
          return elem
        }

        function restoreScript(elem) {
          if ((elem.type || '').slice(0, 5) === 'true/') {
            elem.type = elem.type.slice(5)
          } else {
            elem.removeAttribute('type')
          }

          return elem
        }

        function cloneCopyEvent(src, dest) {
          var i, l, type, pdataOld, udataOld, udataCur, events

          if (dest.nodeType !== 1) {
            return
          }

          // 1. Copy private data: events, handlers, etc.
          if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src)
            events = pdataOld.events

            if (events) {
              dataPriv.remove(dest, 'handle events')

              for (type in events) {
                for (i = 0, l = events[type].length; i < l; i++) {
                  jQuery.event.add(dest, type, events[type][i])
                }
              }
            }
          }

          // 2. Copy user data
          if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src)
            udataCur = jQuery.extend({}, udataOld)

            dataUser.set(dest, udataCur)
          }
        }

        // Fix IE bugs, see support tests
        function fixInput(src, dest) {
          var nodeName = dest.nodeName.toLowerCase()

          // Fails to persist the checked state of a cloned checkbox or radio button.
          if (nodeName === 'input' && rcheckableType.test(src.type)) {
            dest.checked = src.checked

            // Fails to return the selected option to the default selected state when cloning options
          } else if (nodeName === 'input' || nodeName === 'textarea') {
            dest.defaultValue = src.defaultValue
          }
        }

        function domManip(collection, args, callback, ignored) {
          // Flatten any nested arrays
          args = flat(args)

          var fragment
          var first
          var scripts
          var hasScripts
          var node
          var doc
          var i = 0
          var l = collection.length
          var iNoClone = l - 1
          var value = args[0]
          var valueIsFunction = isFunction(value)

          // We can't cloneNode fragments that contain checked, in WebKit
          if (valueIsFunction ||
            (l > 1 && typeof value === 'string' &&
              !support.checkClone && rchecked.test(value))) {
            return collection.each(function (index) {
              var self = collection.eq(index)
              if (valueIsFunction) {
                args[0] = value.call(this, index, self.html())
              }
              domManip(self, args, callback, ignored)
            })
          }

          if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored)
            first = fragment.firstChild

            if (fragment.childNodes.length === 1) {
              fragment = first
            }

            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
              scripts = jQuery.map(getAll(fragment, 'script'), disableScript)
              hasScripts = scripts.length

              // Use the original fragment for the last item
              // instead of the first because it can end up
              // being emptied incorrectly in certain situations (#8070).
              for (; i < l; i++) {
                node = fragment

                if (i !== iNoClone) {
                  node = jQuery.clone(node, true, true)

                  // Keep references to cloned scripts for later restoration
                  if (hasScripts) {
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(scripts, getAll(node, 'script'))
                  }
                }

                callback.call(collection[i], node, i)
              }

              if (hasScripts) {
                doc = scripts[scripts.length - 1].ownerDocument

                // Reenable scripts
                jQuery.map(scripts, restoreScript)

                // Evaluate executable scripts on first document insertion
                for (i = 0; i < hasScripts; i++) {
                  node = scripts[i]
                  if (rscriptType.test(node.type || '') &&
                    !dataPriv.access(node, 'globalEval') &&
                    jQuery.contains(doc, node)) {
                    if (node.src && (node.type || '').toLowerCase() !== 'module') {
                      // Optional AJAX dependency, but won't run scripts if not present
                      if (jQuery._evalUrl && !node.noModule) {
                        jQuery._evalUrl(node.src, {
                          nonce: node.nonce || node.getAttribute('nonce')
                        }, doc)
                      }
                    } else {
                      DOMEval(node.textContent.replace(rcleanScript, ''), node, doc)
                    }
                  }
                }
              }
            }
          }

          return collection
        }

        function remove(elem, selector, keepData) {
          var node
          var nodes = selector ? jQuery.filter(selector, elem) : elem
          var i = 0

          for (;
            (node = nodes[i]) != null; i++) {
            if (!keepData && node.nodeType === 1) {
              jQuery.cleanData(getAll(node))
            }

            if (node.parentNode) {
              if (keepData && isAttached(node)) {
                setGlobalEval(getAll(node, 'script'))
              }
              node.parentNode.removeChild(node)
            }
          }

          return elem
        }

        jQuery.extend({
          htmlPrefilter: function (html) {
            return html
          },

          clone: function (elem, dataAndEvents, deepDataAndEvents) {
            var i
            var l
            var srcElements
            var destElements
            var clone = elem.cloneNode(true)
            var inPage = isAttached(elem)

            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) &&
              !jQuery.isXMLDoc(elem)) {
              // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
              destElements = getAll(clone)
              srcElements = getAll(elem)

              for (i = 0, l = srcElements.length; i < l; i++) {
                fixInput(srcElements[i], destElements[i])
              }
            }

            // Copy the events from the original to the clone
            if (dataAndEvents) {
              if (deepDataAndEvents) {
                srcElements = srcElements || getAll(elem)
                destElements = destElements || getAll(clone)

                for (i = 0, l = srcElements.length; i < l; i++) {
                  cloneCopyEvent(srcElements[i], destElements[i])
                }
              } else {
                cloneCopyEvent(elem, clone)
              }
            }

            // Preserve script evaluation history
            destElements = getAll(clone, 'script')
            if (destElements.length > 0) {
              setGlobalEval(destElements, !inPage && getAll(elem, 'script'))
            }

            // Return the cloned set
            return clone
          },

          cleanData: function (elems) {
            var data
            var elem
            var type
            var special = jQuery.event.special
            var i = 0

            for (;
              (elem = elems[i]) !== undefined; i++) {
              if (acceptData(elem)) {
                if ((data = elem[dataPriv.expando])) {
                  if (data.events) {
                    for (type in data.events) {
                      if (special[type]) {
                        jQuery.event.remove(elem, type)

                        // This is a shortcut to avoid jQuery.event.remove's overhead
                      } else {
                        jQuery.removeEvent(elem, type, data.handle)
                      }
                    }
                  }

                  // Support: Chrome <=35 - 45+
                  // Assign undefined instead of using delete, see Data#remove
                  elem[dataPriv.expando] = undefined
                }
                if (elem[dataUser.expando]) {
                  // Support: Chrome <=35 - 45+
                  // Assign undefined instead of using delete, see Data#remove
                  elem[dataUser.expando] = undefined
                }
              }
            }
          }
        })

        jQuery.fn.extend({
          detach: function (selector) {
            return remove(this, selector, true)
          },

          remove: function (selector) {
            return remove(this, selector)
          },

          text: function (value) {
            return access(this, function (value) {
              return value === undefined
                ? jQuery.text(this)
                : this.empty().each(function () {
                  if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    this.textContent = value
                  }
                })
            }, null, value, arguments.length)
          },

          append: function () {
            return domManip(this, arguments, function (elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem)
                target.appendChild(elem)
              }
            })
          },

          prepend: function () {
            return domManip(this, arguments, function (elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem)
                target.insertBefore(elem, target.firstChild)
              }
            })
          },

          before: function () {
            return domManip(this, arguments, function (elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this)
              }
            })
          },

          after: function () {
            return domManip(this, arguments, function (elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this.nextSibling)
              }
            })
          },

          empty: function () {
            var elem
            var i = 0

            for (;
              (elem = this[i]) != null; i++) {
              if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false))

                // Remove any remaining nodes
                elem.textContent = ''
              }
            }

            return this
          },

          clone: function (dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents

            return this.map(function () {
              return jQuery.clone(this, dataAndEvents, deepDataAndEvents)
            })
          },

          html: function (value) {
            return access(this, function (value) {
              var elem = this[0] || {}
              var i = 0
              var l = this.length

              if (value === undefined && elem.nodeType === 1) {
                return elem.innerHTML
              }

              // See if we can take a shortcut and just use innerHTML
              if (typeof value === 'string' && !rnoInnerhtml.test(value) &&
                !wrapMap[(rtagName.exec(value) || ['', ''])[1].toLowerCase()]) {
                value = jQuery.htmlPrefilter(value)

                try {
                  for (; i < l; i++) {
                    elem = this[i] || {}

                    // Remove element nodes and prevent memory leaks
                    if (elem.nodeType === 1) {
                      jQuery.cleanData(getAll(elem, false))
                      elem.innerHTML = value
                    }
                  }

                  elem = 0

                  // If using innerHTML throws an exception, use the fallback method
                } catch (e) {}
              }

              if (elem) {
                this.empty().append(value)
              }
            }, null, value, arguments.length)
          },

          replaceWith: function () {
            var ignored = []

            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function (elem) {
              var parent = this.parentNode

              if (jQuery.inArray(this, ignored) < 0) {
                jQuery.cleanData(getAll(this))
                if (parent) {
                  parent.replaceChild(elem, this)
                }
              }

              // Force callback invocation
            }, ignored)
          }
        })

        jQuery.each({
          appendTo: 'append',
          prependTo: 'prepend',
          insertBefore: 'before',
          insertAfter: 'after',
          replaceAll: 'replaceWith'
        }, function (name, original) {
          jQuery.fn[name] = function (selector) {
            var elems
            var ret = []
            var insert = jQuery(selector)
            var last = insert.length - 1
            var i = 0

            for (; i <= last; i++) {
              elems = i === last ? this : this.clone(true)
              jQuery(insert[i])[original](elems)

              // Support: Android <=4.0 only, PhantomJS 1 only
              // .get() because push.apply(_, arraylike) throws on ancient WebKit
              push.apply(ret, elems.get())
            }

            return this.pushStack(ret)
          }
        })
        var rnumnonpx = new RegExp('^(' + pnum + ')(?!px)[a-z%]+$', 'i')

        var getStyles = function (elem) {
          // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
          // IE throws on elements created in popups
          // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
          var view = elem.ownerDocument.defaultView

          if (!view || !view.opener) {
            view = window
          }

          return view.getComputedStyle(elem)
        }

        var swap = function (elem, options, callback) {
          var ret
          var name
          var old = {}

          // Remember the old values, and insert the new ones
          for (name in options) {
            old[name] = elem.style[name]
            elem.style[name] = options[name]
          }

          ret = callback.call(elem)

          // Revert the old values
          for (name in options) {
            elem.style[name] = old[name]
          }

          return ret
        }

        var rboxStyle = new RegExp(cssExpand.join('|'), 'i');

        (function () {
          // Executing both pixelPosition & boxSizingReliable tests require only one layout
          // so they're executed at the same time to save the second computation.
          function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) {
              return
            }

            container.style.cssText = 'position:absolute;left:-11111px;width:60px;' +
              'margin-top:1px;padding:0;border:0'
            div.style.cssText =
              'position:relative;display:block;box-sizing:border-box;overflow:scroll;' +
              'margin:auto;border:1px;padding:1px;' +
              'width:60%;top:1%'
            documentElement.appendChild(container).appendChild(div)

            var divStyle = window.getComputedStyle(div)
            pixelPositionVal = divStyle.top !== '1%'

            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12

            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = '60%'
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36

            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36

            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = 'absolute'
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12

            documentElement.removeChild(container)

            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null
          }

          function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure))
          }

          var pixelPositionVal
          var boxSizingReliableVal
          var scrollboxSizeVal
          var pixelBoxStylesVal
          var reliableTrDimensionsVal
          var reliableMarginLeftVal
          var container = document.createElement('div')
          var div = document.createElement('div')

          // Finish early in limited (non-browser) environments
          if (!div.style) {
            return
          }

          // Support: IE <=9 - 11 only
          // Style of cloned element affects source element cloned (#8908)
          div.style.backgroundClip = 'content-box'
          div.cloneNode(true).style.backgroundClip = ''
          support.clearCloneStyle = div.style.backgroundClip === 'content-box'

          jQuery.extend(support, {
            boxSizingReliable: function () {
              computeStyleTests()
              return boxSizingReliableVal
            },
            pixelBoxStyles: function () {
              computeStyleTests()
              return pixelBoxStylesVal
            },
            pixelPosition: function () {
              computeStyleTests()
              return pixelPositionVal
            },
            reliableMarginLeft: function () {
              computeStyleTests()
              return reliableMarginLeftVal
            },
            scrollboxSize: function () {
              computeStyleTests()
              return scrollboxSizeVal
            },

            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            reliableTrDimensions: function () {
              var table, tr, trChild, trStyle
              if (reliableTrDimensionsVal == null) {
                table = document.createElement('table')
                tr = document.createElement('tr')
                trChild = document.createElement('div')

                table.style.cssText = 'position:absolute;left:-11111px'
                tr.style.height = '1px'
                trChild.style.height = '9px'

                documentElement
                  .appendChild(table)
                  .appendChild(tr)
                  .appendChild(trChild)

                trStyle = window.getComputedStyle(tr)
                reliableTrDimensionsVal = parseInt(trStyle.height) > 3

                documentElement.removeChild(table)
              }
              return reliableTrDimensionsVal
            }
          })
        })()

        function curCSS(elem, name, computed) {
          var width
          var minWidth
          var maxWidth
          var ret

          // Support: Firefox 51+
          // Retrieving style before computed somehow
          // fixes an issue with getting wrong values
          // on detached elements
          var style = elem.style

          computed = computed || getStyles(elem)

          // getPropertyValue is needed for:
          //   .css('filter') (IE 9 only, #12537)
          //   .css('--customProperty) (#3144)
          if (computed) {
            ret = computed.getPropertyValue(name) || computed[name]

            if (ret === '' && !isAttached(elem)) {
              ret = jQuery.style(elem, name)
            }

            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
              // Remember the original values
              width = style.width
              minWidth = style.minWidth
              maxWidth = style.maxWidth

              // Put in the new values to get a computed value out
              style.minWidth = style.maxWidth = style.width = ret
              ret = computed.width

              // Revert the changed values
              style.width = width
              style.minWidth = minWidth
              style.maxWidth = maxWidth
            }
          }

          return ret !== undefined

            // Support: IE <=9 - 11 only
            // IE returns zIndex value as an integer.
            ? ret + ''
            : ret
        }

        function addGetHookIf(conditionFn, hookFn) {
          // Define the hook, we'll check on the first run if it's really needed.
          return {
            get: function () {
              if (conditionFn()) {
                // Hook not needed (or it's not possible to use it due
                // to missing dependency), remove it.
                delete this.get
                return
              }

              // Hook needed; redefine it so that the support test is not executed again.
              return (this.get = hookFn).apply(this, arguments)
            }
          }
        }

        var cssPrefixes = ['Webkit', 'Moz', 'ms']
        var emptyStyle = document.createElement('div').style
        var vendorProps = {}

        // Return a vendor-prefixed property or undefined
        function vendorPropName(name) {
          // Check for vendor prefixed names
          var capName = name[0].toUpperCase() + name.slice(1)
          var i = cssPrefixes.length

          while (i--) {
            name = cssPrefixes[i] + capName
            if (name in emptyStyle) {
              return name
            }
          }
        }

        // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
        function finalPropName(name) {
          var final = jQuery.cssProps[name] || vendorProps[name]

          if (final) {
            return final
          }
          if (name in emptyStyle) {
            return name
          }
          return vendorProps[name] = vendorPropName(name) || name
        }

        var

          // Swappable if display is none or starts with table
          // except "table", "table-cell", or "table-caption"
          // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
          rdisplayswap = /^(none|table(?!-c[ea]).+)/
        var rcustomProp = /^--/
        var cssShow = {
          position: 'absolute',
          visibility: 'hidden',
          display: 'block'
        }
        var cssNormalTransform = {
          letterSpacing: '0',
          fontWeight: '400'
        }

        function setPositiveNumber(_elem, value, subtract) {
          // Any relative (+/-) values have already been
          // normalized at this point
          var matches = rcssNum.exec(value)
          return matches

            // Guard against undefined "subtract", e.g., when used as in cssHooks
            ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || 'px')
            : value
        }

        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
          var i = dimension === 'width' ? 1 : 0
          var extra = 0
          var delta = 0

          // Adjustment may not be necessary
          if (box === (isBorderBox ? 'border' : 'content')) {
            return 0
          }

          for (; i < 4; i += 2) {
            // Both box models exclude margin
            if (box === 'margin') {
              delta += jQuery.css(elem, box + cssExpand[i], true, styles)
            }

            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
              // Add padding
              delta += jQuery.css(elem, 'padding' + cssExpand[i], true, styles)

              // For "border" or "margin", add border
              if (box !== 'padding') {
                delta += jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles)

                // But still keep track of it otherwise
              } else {
                extra += jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles)
              }

              // If we get here with a border-box (content + padding + border), we're seeking "content" or
              // "padding" or "margin"
            } else {
              // For "content", subtract padding
              if (box === 'content') {
                delta -= jQuery.css(elem, 'padding' + cssExpand[i], true, styles)
              }

              // For "content" or "padding", subtract border
              if (box !== 'margin') {
                delta -= jQuery.css(elem, 'border' + cssExpand[i] + 'Width', true, styles)
              }
            }
          }

          // Account for positive content-box scroll gutter when requested by providing computedVal
          if (!isBorderBox && computedVal >= 0) {
            // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
            // Assuming integer scroll gutter, subtract the rest and round down
            delta += Math.max(0, Math.ceil(
              elem['offset' + dimension[0].toUpperCase() + dimension.slice(1)] -
              computedVal -
              delta -
              extra -
              0.5

              // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
              // Use an explicit zero to avoid NaN (gh-3964)
            )) || 0
          }

          return delta
        }

        function getWidthOrHeight(elem, dimension, extra) {
          // Start with computed style
          var styles = getStyles(elem)

          // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
          // Fake content-box until we know it's needed to know the true value.
          var boxSizingNeeded = !support.boxSizingReliable() || extra
          var isBorderBox = boxSizingNeeded &&
            jQuery.css(elem, 'boxSizing', false, styles) === 'border-box'
          var valueIsBorderBox = isBorderBox

          var val = curCSS(elem, dimension, styles)
          var offsetProp = 'offset' + dimension[0].toUpperCase() + dimension.slice(1)

          // Support: Firefox <=54
          // Return a confounding non-pixel value or feign ignorance, as appropriate.
          if (rnumnonpx.test(val)) {
            if (!extra) {
              return val
            }
            val = 'auto'
          }

          // Support: IE 9 - 11 only
          // Use offsetWidth/offsetHeight for when box sizing is unreliable.
          // In those cases, the computed value can be trusted to be border-box.
          if ((!support.boxSizingReliable() && isBorderBox ||

              // Support: IE 10 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Interestingly, in some cases IE 9 doesn't suffer from this issue.
              !support.reliableTrDimensions() && nodeName(elem, 'tr') ||

              // Fall back to offsetWidth/offsetHeight when value is "auto"
              // This happens for inline elements with no explicit setting (gh-3571)
              val === 'auto' ||

              // Support: Android <=4.1 - 4.3 only
              // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
              !parseFloat(val) && jQuery.css(elem, 'display', false, styles) === 'inline') &&

            // Make sure the element is visible & connected
            elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, 'boxSizing', false, styles) === 'border-box'

            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem
            if (valueIsBorderBox) {
              val = elem[offsetProp]
            }
          }

          // Normalize "" and auto
          val = parseFloat(val) || 0

          // Adjust for the element's box model
          return (val +
            boxModelAdjustment(
              elem,
              dimension,
              extra || (isBorderBox ? 'border' : 'content'),
              valueIsBorderBox,
              styles,

              // Provide the current computed size to request scroll gutter calculation (gh-3589)
              val
            )
          ) + 'px'
        }

        jQuery.extend({

          // Add in style property hooks for overriding the default
          // behavior of getting and setting a style property
          cssHooks: {
            opacity: {
              get: function (elem, computed) {
                if (computed) {
                  // We should always get a number back from opacity
                  var ret = curCSS(elem, 'opacity')
                  return ret === '' ? '1' : ret
                }
              }
            }
          },

          // Don't automatically add "px" to these possibly-unitless properties
          cssNumber: {
            animationIterationCount: true,
            columnCount: true,
            fillOpacity: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            widows: true,
            zIndex: true,
            zoom: true
          },

          // Add in properties whose names you wish to fix before
          // setting or getting the value
          cssProps: {},

          // Get and set the style property on a DOM Node
          style: function (elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
              return
            }

            // Make sure that we're working with the right name
            var ret
            var type
            var hooks
            var origName = camelCase(name)
            var isCustomProp = rcustomProp.test(name)
            var style = elem.style

            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
              name = finalPropName(origName)
            }

            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]

            // Check if we're setting a value
            if (value !== undefined) {
              type = typeof value

              // Convert "+=" or "-=" to relative numbers (#7345)
              if (type === 'string' && (ret = rcssNum.exec(value)) && ret[1]) {
                value = adjustCSS(elem, name, ret)

                // Fixes bug #9237
                type = 'number'
              }

              // Make sure that null and NaN values aren't set (#7116)
              if (value == null || value !== value) {
                return
              }

              // If a number was passed in, add the unit (except for certain CSS properties)
              // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
              // "px" to a few hardcoded values.
              if (type === 'number' && !isCustomProp) {
                value += ret && ret[3] || (jQuery.cssNumber[origName] ? '' : 'px')
              }

              // background-* props affect original clone's values
              if (!support.clearCloneStyle && value === '' && name.indexOf('background') === 0) {
                style[name] = 'inherit'
              }

              // If a hook was provided, use that value, otherwise just set the specified value
              if (!hooks || !('set' in hooks) ||
                (value = hooks.set(elem, value, extra)) !== undefined) {
                if (isCustomProp) {
                  style.setProperty(name, value)
                } else {
                  style[name] = value
                }
              }
            } else {
              // If a hook was provided get the non-computed value from there
              if (hooks && 'get' in hooks &&
                (ret = hooks.get(elem, false, extra)) !== undefined) {
                return ret
              }

              // Otherwise just get the value from the style object
              return style[name]
            }
          },

          css: function (elem, name, extra, styles) {
            var val
            var num
            var hooks
            var origName = camelCase(name)
            var isCustomProp = rcustomProp.test(name)

            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
              name = finalPropName(origName)
            }

            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]

            // If a hook was provided get the computed value from there
            if (hooks && 'get' in hooks) {
              val = hooks.get(elem, true, extra)
            }

            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) {
              val = curCSS(elem, name, styles)
            }

            // Convert "normal" to computed value
            if (val === 'normal' && name in cssNormalTransform) {
              val = cssNormalTransform[name]
            }

            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === '' || extra) {
              num = parseFloat(val)
              return extra === true || isFinite(num) ? num || 0 : val
            }

            return val
          }
        })

        jQuery.each(['height', 'width'], function (_i, dimension) {
          jQuery.cssHooks[dimension] = {
            get: function (elem, computed, extra) {
              if (computed) {
                // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, 'display')) &&

                  // Support: Safari 8+
                  // Table columns in Safari have non-zero offsetWidth & zero
                  // getBoundingClientRect().width unless display is changed.
                  // Support: IE <=11 only
                  // Running getBoundingClientRect on a disconnected node
                  // in IE throws an error.
                  (!elem.getClientRects().length || !elem.getBoundingClientRect().width)
                  ? swap(elem, cssShow, function () {
                    return getWidthOrHeight(elem, dimension, extra)
                  })
                  : getWidthOrHeight(elem, dimension, extra)
              }
            },

            set: function (elem, value, extra) {
              var matches
              var styles = getStyles(elem)

              // Only read styles.position if the test has a chance to fail
              // to avoid forcing a reflow.
              var scrollboxSizeBuggy = !support.scrollboxSize() &&
                styles.position === 'absolute'

              // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
              var boxSizingNeeded = scrollboxSizeBuggy || extra
              var isBorderBox = boxSizingNeeded &&
                jQuery.css(elem, 'boxSizing', false, styles) === 'border-box'
              var subtract = extra
                ? boxModelAdjustment(
                  elem,
                  dimension,
                  extra,
                  isBorderBox,
                  styles
                )
                : 0

              // Account for unreliable border-box dimensions by comparing offset* to computed and
              // faking a content-box to get border and padding (gh-3699)
              if (isBorderBox && scrollboxSizeBuggy) {
                subtract -= Math.ceil(
                  elem['offset' + dimension[0].toUpperCase() + dimension.slice(1)] -
                  parseFloat(styles[dimension]) -
                  boxModelAdjustment(elem, dimension, 'border', false, styles) -
                  0.5
                )
              }

              // Convert to pixels if value adjustment is needed
              if (subtract && (matches = rcssNum.exec(value)) &&
                (matches[3] || 'px') !== 'px') {
                elem.style[dimension] = value
                value = jQuery.css(elem, dimension)
              }

              return setPositiveNumber(elem, value, subtract)
            }
          }
        })

        jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft,
          function (elem, computed) {
            if (computed) {
              return (parseFloat(curCSS(elem, 'marginLeft')) ||
                elem.getBoundingClientRect().left -
                swap(elem, {
                  marginLeft: 0
                }, function () {
                  return elem.getBoundingClientRect().left
                })
              ) + 'px'
            }
          }
        )

        // These hooks are used by animate to expand properties
        jQuery.each({
          margin: '',
          padding: '',
          border: 'Width'
        }, function (prefix, suffix) {
          jQuery.cssHooks[prefix + suffix] = {
            expand: function (value) {
              var i = 0
              var expanded = {}

              // Assumes a single number if not a string
              var parts = typeof value === 'string' ? value.split(' ') : [value]

              for (; i < 4; i++) {
                expanded[prefix + cssExpand[i] + suffix] =
                  parts[i] || parts[i - 2] || parts[0]
              }

              return expanded
            }
          }

          if (prefix !== 'margin') {
            jQuery.cssHooks[prefix + suffix].set = setPositiveNumber
          }
        })

        jQuery.fn.extend({
          css: function (name, value) {
            return access(this, function (elem, name, value) {
              var styles
              var len
              var map = {}
              var i = 0

              if (Array.isArray(name)) {
                styles = getStyles(elem)
                len = name.length

                for (; i < len; i++) {
                  map[name[i]] = jQuery.css(elem, name[i], false, styles)
                }

                return map
              }

              return value !== undefined
                ? jQuery.style(elem, name, value)
                : jQuery.css(elem, name)
            }, name, value, arguments.length > 1)
          }
        })

        function Tween(elem, options, prop, end, easing) {
          return new Tween.prototype.init(elem, options, prop, end, easing)
        }
        jQuery.Tween = Tween

        Tween.prototype = {
          constructor: Tween,
          init: function (elem, options, prop, end, easing, unit) {
            this.elem = elem
            this.prop = prop
            this.easing = easing || jQuery.easing._default
            this.options = options
            this.start = this.now = this.cur()
            this.end = end
            this.unit = unit || (jQuery.cssNumber[prop] ? '' : 'px')
          },
          cur: function () {
            var hooks = Tween.propHooks[this.prop]

            return hooks && hooks.get
              ? hooks.get(this)
              : Tween.propHooks._default.get(this)
          },
          run: function (percent) {
            var eased
            var hooks = Tween.propHooks[this.prop]

            if (this.options.duration) {
              this.pos = eased = jQuery.easing[this.easing](
                percent, this.options.duration * percent, 0, 1, this.options.duration
              )
            } else {
              this.pos = eased = percent
            }
            this.now = (this.end - this.start) * eased + this.start

            if (this.options.step) {
              this.options.step.call(this.elem, this.now, this)
            }

            if (hooks && hooks.set) {
              hooks.set(this)
            } else {
              Tween.propHooks._default.set(this)
            }
            return this
          }
        }

        Tween.prototype.init.prototype = Tween.prototype

        Tween.propHooks = {
          _default: {
            get: function (tween) {
              var result

              // Use a property on the element directly when it is not a DOM element,
              // or when there is no matching style property that exists.
              if (tween.elem.nodeType !== 1 ||
                tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
                return tween.elem[tween.prop]
              }

              // Passing an empty string as a 3rd parameter to .css will automatically
              // attempt a parseFloat and fallback to a string if the parse fails.
              // Simple values such as "10px" are parsed to Float;
              // complex values such as "rotate(1rad)" are returned as-is.
              result = jQuery.css(tween.elem, tween.prop, '')

              // Empty strings, null, undefined and "auto" are converted to 0.
              return !result || result === 'auto' ? 0 : result
            },
            set: function (tween) {
              // Use step hook for back compat.
              // Use cssHook if its there.
              // Use .style if available and use plain properties where available.
              if (jQuery.fx.step[tween.prop]) {
                jQuery.fx.step[tween.prop](tween)
              } else if (tween.elem.nodeType === 1 && (
                  jQuery.cssHooks[tween.prop] ||
                  tween.elem.style[finalPropName(tween.prop)] != null)) {
                jQuery.style(tween.elem, tween.prop, tween.now + tween.unit)
              } else {
                tween.elem[tween.prop] = tween.now
              }
            }
          }
        }

        // Support: IE <=9 only
        // Panic based approach to setting things on disconnected nodes
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
          set: function (tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) {
              tween.elem[tween.prop] = tween.now
            }
          }
        }

        jQuery.easing = {
          linear: function (p) {
            return p
          },
          swing: function (p) {
            return 0.5 - Math.cos(p * Math.PI) / 2
          },
          _default: 'swing'
        }

        jQuery.fx = Tween.prototype.init

        // Back compat <1.8 extension point
        jQuery.fx.step = {}

        var
          fxNow
        var inProgress
        var rfxtypes = /^(?:toggle|show|hide)$/
        var rrun = /queueHooks$/

        function schedule() {
          if (inProgress) {
            if (document.hidden === false && window.requestAnimationFrame) {
              window.requestAnimationFrame(schedule)
            } else {
              window.setTimeout(schedule, jQuery.fx.interval)
            }

            jQuery.fx.tick()
          }
        }

        // Animations created synchronously will run synchronously
        function createFxNow() {
          window.setTimeout(function () {
            fxNow = undefined
          })
          return (fxNow = Date.now())
        }

        // Generate parameters to create a standard animation
        function genFx(type, includeWidth) {
          var which
          var i = 0
          var attrs = {
            height: type
          }

          // If we include width, step value is 1 to do all cssExpand values,
          // otherwise step value is 2 to skip over Left and Right
          includeWidth = includeWidth ? 1 : 0
          for (; i < 4; i += 2 - includeWidth) {
            which = cssExpand[i]
            attrs['margin' + which] = attrs['padding' + which] = type
          }

          if (includeWidth) {
            attrs.opacity = attrs.width = type
          }

          return attrs
        }

        function createTween(value, prop, animation) {
          var tween
          var collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners['*'])
          var index = 0
          var length = collection.length
          for (; index < length; index++) {
            if ((tween = collection[index].call(animation, prop, value))) {
              // We're done with this property
              return tween
            }
          }
        }

        function defaultPrefilter(elem, props, opts) {
          var prop
          var value
          var toggle
          var hooks
          var oldfire
          var propTween
          var restoreDisplay
          var display
          var isBox = 'width' in props || 'height' in props
          var anim = this
          var orig = {}
          var style = elem.style
          var hidden = elem.nodeType && isHiddenWithinTree(elem)
          var dataShow = dataPriv.get(elem, 'fxshow')

          // Queue-skipping animations hijack the fx hooks
          if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, 'fx')
            if (hooks.unqueued == null) {
              hooks.unqueued = 0
              oldfire = hooks.empty.fire
              hooks.empty.fire = function () {
                if (!hooks.unqueued) {
                  oldfire()
                }
              }
            }
            hooks.unqueued++

            anim.always(function () {
              // Ensure the complete handler is called before this completes
              anim.always(function () {
                hooks.unqueued--
                if (!jQuery.queue(elem, 'fx').length) {
                  hooks.empty.fire()
                }
              })
            })
          }

          // Detect show/hide animations
          for (prop in props) {
            value = props[prop]
            if (rfxtypes.test(value)) {
              delete props[prop]
              toggle = toggle || value === 'toggle'
              if (value === (hidden ? 'hide' : 'show')) {
                // Pretend to be hidden if this is a "show" and
                // there is still data from a stopped show/hide
                if (value === 'show' && dataShow && dataShow[prop] !== undefined) {
                  hidden = true

                  // Ignore all other no-op show/hide data
                } else {
                  continue
                }
              }
              orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop)
            }
          }

          // Bail out if this is a no-op like .hide().hide()
          propTween = !jQuery.isEmptyObject(props)
          if (!propTween && jQuery.isEmptyObject(orig)) {
            return
          }

          // Restrict "overflow" and "display" styles during box animations
          if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [style.overflow, style.overflowX, style.overflowY]

            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display
            if (restoreDisplay == null) {
              restoreDisplay = dataPriv.get(elem, 'display')
            }
            display = jQuery.css(elem, 'display')
            if (display === 'none') {
              if (restoreDisplay) {
                display = restoreDisplay
              } else {
                // Get nonempty value(s) by temporarily forcing visibility
                showHide([elem], true)
                restoreDisplay = elem.style.display || restoreDisplay
                display = jQuery.css(elem, 'display')
                showHide([elem])
              }
            }

            // Animate inline elements as inline-block
            if (display === 'inline' || display === 'inline-block' && restoreDisplay != null) {
              if (jQuery.css(elem, 'float') === 'none') {
                // Restore the original display value at the end of pure show/hide animations
                if (!propTween) {
                  anim.done(function () {
                    style.display = restoreDisplay
                  })
                  if (restoreDisplay == null) {
                    display = style.display
                    restoreDisplay = display === 'none' ? '' : display
                  }
                }
                style.display = 'inline-block'
              }
            }
          }

          if (opts.overflow) {
            style.overflow = 'hidden'
            anim.always(function () {
              style.overflow = opts.overflow[0]
              style.overflowX = opts.overflow[1]
              style.overflowY = opts.overflow[2]
            })
          }

          // Implement show/hide animations
          propTween = false
          for (prop in orig) {
            // General show/hide setup for this element animation
            if (!propTween) {
              if (dataShow) {
                if ('hidden' in dataShow) {
                  hidden = dataShow.hidden
                }
              } else {
                dataShow = dataPriv.access(elem, 'fxshow', {
                  display: restoreDisplay
                })
              }

              // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
              if (toggle) {
                dataShow.hidden = !hidden
              }

              // Show elements before animating them
              if (hidden) {
                showHide([elem], true)
              }

              /* eslint-disable no-loop-func */

              anim.done(function () {
                /* eslint-enable no-loop-func */

                // The final step of a "hide" animation is actually hiding the element
                if (!hidden) {
                  showHide([elem])
                }
                dataPriv.remove(elem, 'fxshow')
                for (prop in orig) {
                  jQuery.style(elem, prop, orig[prop])
                }
              })
            }

            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim)
            if (!(prop in dataShow)) {
              dataShow[prop] = propTween.start
              if (hidden) {
                propTween.end = propTween.start
                propTween.start = 0
              }
            }
          }
        }

        function propFilter(props, specialEasing) {
          var index, name, easing, value, hooks

          // camelCase, specialEasing and expand cssHook pass
          for (index in props) {
            name = camelCase(index)
            easing = specialEasing[name]
            value = props[index]
            if (Array.isArray(value)) {
              easing = value[1]
              value = props[index] = value[0]
            }

            if (index !== name) {
              props[name] = value
              delete props[index]
            }

            hooks = jQuery.cssHooks[name]
            if (hooks && 'expand' in hooks) {
              value = hooks.expand(value)
              delete props[name]

              // Not quite $.extend, this won't overwrite existing keys.
              // Reusing 'index' because we have the correct "name"
              for (index in value) {
                if (!(index in props)) {
                  props[index] = value[index]
                  specialEasing[index] = easing
                }
              }
            } else {
              specialEasing[name] = easing
            }
          }
        }

        function Animation(elem, properties, options) {
          var result
          var stopped
          var index = 0
          var length = Animation.prefilters.length
          var deferred = jQuery.Deferred().always(function () {
            // Don't match elem in the :animated selector
            delete tick.elem
          })
          var tick = function () {
            if (stopped) {
              return false
            }
            var currentTime = fxNow || createFxNow()
            var remaining = Math.max(0, animation.startTime + animation.duration - currentTime)

            // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            var temp = remaining / animation.duration || 0
            var percent = 1 - temp
            var index = 0
            var length = animation.tweens.length

            for (; index < length; index++) {
              animation.tweens[index].run(percent)
            }

            deferred.notifyWith(elem, [animation, percent, remaining])

            // If there's more to do, yield
            if (percent < 1 && length) {
              return remaining
            }

            // If this was an empty animation, synthesize a final progress notification
            if (!length) {
              deferred.notifyWith(elem, [animation, 1, 0])
            }

            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [animation])
            return false
          }
          var animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
              specialEasing: {},
              easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function (prop, end) {
              var tween = jQuery.Tween(elem, animation.opts, prop, end,
                animation.opts.specialEasing[prop] || animation.opts.easing)
              animation.tweens.push(tween)
              return tween
            },
            stop: function (gotoEnd) {
              var index = 0

              // If we are going to the end, we want to run all the tweens
              // otherwise we skip this part
              var length = gotoEnd ? animation.tweens.length : 0
              if (stopped) {
                return this
              }
              stopped = true
              for (; index < length; index++) {
                animation.tweens[index].run(1)
              }

              // Resolve when we played the last frame; otherwise, reject
              if (gotoEnd) {
                deferred.notifyWith(elem, [animation, 1, 0])
                deferred.resolveWith(elem, [animation, gotoEnd])
              } else {
                deferred.rejectWith(elem, [animation, gotoEnd])
              }
              return this
            }
          })
          var props = animation.props

          propFilter(props, animation.opts.specialEasing)

          for (; index < length; index++) {
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts)
            if (result) {
              if (isFunction(result.stop)) {
                jQuery._queueHooks(animation.elem, animation.opts.queue).stop =
                  result.stop.bind(result)
              }
              return result
            }
          }

          jQuery.map(props, createTween, animation)

          if (isFunction(animation.opts.start)) {
            animation.opts.start.call(elem, animation)
          }

          // Attach callbacks from options
          animation
            .progress(animation.opts.progress)
            .done(animation.opts.done, animation.opts.complete)
            .fail(animation.opts.fail)
            .always(animation.opts.always)

          jQuery.fx.timer(
            jQuery.extend(tick, {
              elem: elem,
              anim: animation,
              queue: animation.opts.queue
            })
          )

          return animation
        }

        jQuery.Animation = jQuery.extend(Animation, {

          tweeners: {
            '*': [function (prop, value) {
              var tween = this.createTween(prop, value)
              adjustCSS(tween.elem, prop, rcssNum.exec(value), tween)
              return tween
            }]
          },

          tweener: function (props, callback) {
            if (isFunction(props)) {
              callback = props
              props = ['*']
            } else {
              props = props.match(rnothtmlwhite)
            }

            var prop
            var index = 0
            var length = props.length

            for (; index < length; index++) {
              prop = props[index]
              Animation.tweeners[prop] = Animation.tweeners[prop] || []
              Animation.tweeners[prop].unshift(callback)
            }
          },

          prefilters: [defaultPrefilter],

          prefilter: function (callback, prepend) {
            if (prepend) {
              Animation.prefilters.unshift(callback)
            } else {
              Animation.prefilters.push(callback)
            }
          }
        })

        jQuery.speed = function (speed, easing, fn) {
          var opt = speed && typeof speed === 'object' ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing ||
              isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
          }

          // Go to the end state if fx are off
          if (jQuery.fx.off) {
            opt.duration = 0
          } else {
            if (typeof opt.duration !== 'number') {
              if (opt.duration in jQuery.fx.speeds) {
                opt.duration = jQuery.fx.speeds[opt.duration]
              } else {
                opt.duration = jQuery.fx.speeds._default
              }
            }
          }

          // Normalize opt.queue - true/undefined/null -> "fx"
          if (opt.queue == null || opt.queue === true) {
            opt.queue = 'fx'
          }

          // Queueing
          opt.old = opt.complete

          opt.complete = function () {
            if (isFunction(opt.old)) {
              opt.old.call(this)
            }

            if (opt.queue) {
              jQuery.dequeue(this, opt.queue)
            }
          }

          return opt
        }

        jQuery.fn.extend({
          fadeTo: function (speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css('opacity', 0).show()

              // Animate to the value specified
              .end().animate({
                opacity: to
              }, speed, easing, callback)
          },
          animate: function (prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop)
            var optall = jQuery.speed(speed, easing, callback)
            var doAnimation = function () {
              // Operate on a copy of prop so per-property easing won't be lost
              var anim = Animation(this, jQuery.extend({}, prop), optall)

              // Empty animations, or finishing resolves immediately
              if (empty || dataPriv.get(this, 'finish')) {
                anim.stop(true)
              }
            }
            doAnimation.finish = doAnimation

            return empty || optall.queue === false
              ? this.each(doAnimation)
              : this.queue(optall.queue, doAnimation)
          },
          stop: function (type, clearQueue, gotoEnd) {
            var stopQueue = function (hooks) {
              var stop = hooks.stop
              delete hooks.stop
              stop(gotoEnd)
            }

            if (typeof type !== 'string') {
              gotoEnd = clearQueue
              clearQueue = type
              type = undefined
            }
            if (clearQueue) {
              this.queue(type || 'fx', [])
            }

            return this.each(function () {
              var dequeue = true
              var index = type != null && type + 'queueHooks'
              var timers = jQuery.timers
              var data = dataPriv.get(this)

              if (index) {
                if (data[index] && data[index].stop) {
                  stopQueue(data[index])
                }
              } else {
                for (index in data) {
                  if (data[index] && data[index].stop && rrun.test(index)) {
                    stopQueue(data[index])
                  }
                }
              }

              for (index = timers.length; index--;) {
                if (timers[index].elem === this &&
                  (type == null || timers[index].queue === type)) {
                  timers[index].anim.stop(gotoEnd)
                  dequeue = false
                  timers.splice(index, 1)
                }
              }

              // Start the next in the queue if the last step wasn't forced.
              // Timers currently will call their complete callbacks, which
              // will dequeue but only if they were gotoEnd.
              if (dequeue || !gotoEnd) {
                jQuery.dequeue(this, type)
              }
            })
          },
          finish: function (type) {
            if (type !== false) {
              type = type || 'fx'
            }
            return this.each(function () {
              var index
              var data = dataPriv.get(this)
              var queue = data[type + 'queue']
              var hooks = data[type + 'queueHooks']
              var timers = jQuery.timers
              var length = queue ? queue.length : 0

              // Enable finishing flag on private data
              data.finish = true

              // Empty the queue first
              jQuery.queue(this, type, [])

              if (hooks && hooks.stop) {
                hooks.stop.call(this, true)
              }

              // Look for any active animations, and finish them
              for (index = timers.length; index--;) {
                if (timers[index].elem === this && timers[index].queue === type) {
                  timers[index].anim.stop(true)
                  timers.splice(index, 1)
                }
              }

              // Look for any animations in the old queue and finish them
              for (index = 0; index < length; index++) {
                if (queue[index] && queue[index].finish) {
                  queue[index].finish.call(this)
                }
              }

              // Turn off finishing flag
              delete data.finish
            })
          }
        })

        jQuery.each(['toggle', 'show', 'hide'], function (_i, name) {
          var cssFn = jQuery.fn[name]
          jQuery.fn[name] = function (speed, easing, callback) {
            return speed == null || typeof speed === 'boolean'
              ? cssFn.apply(this, arguments)
              : this.animate(genFx(name, true), speed, easing, callback)
          }
        })

        // Generate shortcuts for custom animations
        jQuery.each({
          slideDown: genFx('show'),
          slideUp: genFx('hide'),
          slideToggle: genFx('toggle'),
          fadeIn: {
            opacity: 'show'
          },
          fadeOut: {
            opacity: 'hide'
          },
          fadeToggle: {
            opacity: 'toggle'
          }
        }, function (name, props) {
          jQuery.fn[name] = function (speed, easing, callback) {
            return this.animate(props, speed, easing, callback)
          }
        })

        jQuery.timers = []
        jQuery.fx.tick = function () {
          var timer
          var i = 0
          var timers = jQuery.timers

          fxNow = Date.now()

          for (; i < timers.length; i++) {
            timer = timers[i]

            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) {
              timers.splice(i--, 1)
            }
          }

          if (!timers.length) {
            jQuery.fx.stop()
          }
          fxNow = undefined
        }

        jQuery.fx.timer = function (timer) {
          jQuery.timers.push(timer)
          jQuery.fx.start()
        }

        jQuery.fx.interval = 13
        jQuery.fx.start = function () {
          if (inProgress) {
            return
          }

          inProgress = true
          schedule()
        }

        jQuery.fx.stop = function () {
          inProgress = null
        }

        jQuery.fx.speeds = {
          slow: 600,
          fast: 200,

          // Default speed
          _default: 400
        }

        // Based off of the plugin by Clint Helfers, with permission.
        // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
        jQuery.fn.delay = function (time, type) {
          time = jQuery.fx ? jQuery.fx.speeds[time] || time : time
          type = type || 'fx'

          return this.queue(type, function (next, hooks) {
            var timeout = window.setTimeout(next, time)
            hooks.stop = function () {
              window.clearTimeout(timeout)
            }
          })
        };

        (function () {
          var input = document.createElement('input')
          var select = document.createElement('select')
          var opt = select.appendChild(document.createElement('option'))

          input.type = 'checkbox'

          // Support: Android <=4.3 only
          // Default value for a checkbox should be "on"
          support.checkOn = input.value !== ''

          // Support: IE <=11 only
          // Must access selectedIndex to make default options select
          support.optSelected = opt.selected

          // Support: IE <=11 only
          // An input loses its value after becoming a radio
          input = document.createElement('input')
          input.value = 't'
          input.type = 'radio'
          support.radioValue = input.value === 't'
        })()

        var boolHook
        var attrHandle = jQuery.expr.attrHandle

        jQuery.fn.extend({
          attr: function (name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1)
          },

          removeAttr: function (name) {
            return this.each(function () {
              jQuery.removeAttr(this, name)
            })
          }
        })

        jQuery.extend({
          attr: function (elem, name, value) {
            var ret
            var hooks
            var nType = elem.nodeType

            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
              return
            }

            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === 'undefined') {
              return jQuery.prop(elem, name, value)
            }

            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              hooks = jQuery.attrHooks[name.toLowerCase()] ||
                (jQuery.expr.match.bool.test(name) ? boolHook : undefined)
            }

            if (value !== undefined) {
              if (value === null) {
                jQuery.removeAttr(elem, name)
                return
              }

              if (hooks && 'set' in hooks &&
                (ret = hooks.set(elem, value, name)) !== undefined) {
                return ret
              }

              elem.setAttribute(name, value + '')
              return value
            }

            if (hooks && 'get' in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret
            }

            ret = jQuery.find.attr(elem, name)

            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret
          },

          attrHooks: {
            type: {
              set: function (elem, value) {
                if (!support.radioValue && value === 'radio' &&
                  nodeName(elem, 'input')) {
                  var val = elem.value
                  elem.setAttribute('type', value)
                  if (val) {
                    elem.value = val
                  }
                  return value
                }
              }
            }
          },

          removeAttr: function (elem, value) {
            var name
            var i = 0

            // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            var attrNames = value && value.match(rnothtmlwhite)

            if (attrNames && elem.nodeType === 1) {
              while ((name = attrNames[i++])) {
                elem.removeAttribute(name)
              }
            }
          }
        })

        // Hooks for boolean attributes
        boolHook = {
          set: function (elem, value, name) {
            if (value === false) {
              // Remove boolean attributes when set to false
              jQuery.removeAttr(elem, name)
            } else {
              elem.setAttribute(name, name)
            }
            return name
          }
        }

        jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
          var getter = attrHandle[name] || jQuery.find.attr

          attrHandle[name] = function (elem, name, isXML) {
            var ret
            var handle
            var lowercaseName = name.toLowerCase()

            if (!isXML) {
              // Avoid an infinite loop by temporarily removing this function from the getter
              handle = attrHandle[lowercaseName]
              attrHandle[lowercaseName] = ret
              ret = getter(elem, name, isXML) != null
                ? lowercaseName
                : null
              attrHandle[lowercaseName] = handle
            }
            return ret
          }
        })

        var rfocusable = /^(?:input|select|textarea|button)$/i
        var rclickable = /^(?:a|area)$/i

        jQuery.fn.extend({
          prop: function (name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1)
          },

          removeProp: function (name) {
            return this.each(function () {
              delete this[jQuery.propFix[name] || name]
            })
          }
        })

        jQuery.extend({
          prop: function (elem, name, value) {
            var ret
            var hooks
            var nType = elem.nodeType

            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
              return
            }

            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              // Fix name and attach hooks
              name = jQuery.propFix[name] || name
              hooks = jQuery.propHooks[name]
            }

            if (value !== undefined) {
              if (hooks && 'set' in hooks &&
                (ret = hooks.set(elem, value, name)) !== undefined) {
                return ret
              }

              return (elem[name] = value)
            }

            if (hooks && 'get' in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret
            }

            return elem[name]
          },

          propHooks: {
            tabIndex: {
              get: function (elem) {
                // Support: IE <=9 - 11 only
                // elem.tabIndex doesn't always return the
                // correct value when it hasn't been explicitly set
                // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                // Use proper attribute retrieval(#12072)
                var tabindex = jQuery.find.attr(elem, 'tabindex')

                if (tabindex) {
                  return parseInt(tabindex, 10)
                }

                if (
                  rfocusable.test(elem.nodeName) ||
                  rclickable.test(elem.nodeName) &&
                  elem.href
                ) {
                  return 0
                }

                return -1
              }
            }
          },

          propFix: {
            for: 'htmlFor',
            class: 'className'
          }
        })

        // Support: IE <=11 only
        // Accessing the selectedIndex property
        // forces the browser to respect setting selected
        // on the option
        // The getter ensures a default option is selected
        // when in an optgroup
        // eslint rule "no-unused-expressions" is disabled for this code
        // since it considers such accessions noop
        if (!support.optSelected) {
          jQuery.propHooks.selected = {
            get: function (elem) {
              /* eslint no-unused-expressions: "off" */

              var parent = elem.parentNode
              if (parent && parent.parentNode) {
                parent.parentNode.selectedIndex
              }
              return null
            },
            set: function (elem) {
              /* eslint no-unused-expressions: "off" */

              var parent = elem.parentNode
              if (parent) {
                parent.selectedIndex

                if (parent.parentNode) {
                  parent.parentNode.selectedIndex
                }
              }
            }
          }
        }

        jQuery.each([
          'tabIndex',
          'readOnly',
          'maxLength',
          'cellSpacing',
          'cellPadding',
          'rowSpan',
          'colSpan',
          'useMap',
          'frameBorder',
          'contentEditable'
        ], function () {
          jQuery.propFix[this.toLowerCase()] = this
        })

        // Strip and collapse whitespace according to HTML spec
        // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
        function stripAndCollapse(value) {
          var tokens = value.match(rnothtmlwhite) || []
          return tokens.join(' ')
        }

        function getClass(elem) {
          return elem.getAttribute && elem.getAttribute('class') || ''
        }

        function classesToArray(value) {
          if (Array.isArray(value)) {
            return value
          }
          if (typeof value === 'string') {
            return value.match(rnothtmlwhite) || []
          }
          return []
        }

        jQuery.fn.extend({
          addClass: function (value) {
            var classes
            var elem
            var cur
            var curValue
            var clazz
            var j
            var finalValue
            var i = 0

            if (isFunction(value)) {
              return this.each(function (j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)))
              })
            }

            classes = classesToArray(value)

            if (classes.length) {
              while ((elem = this[i++])) {
                curValue = getClass(elem)
                cur = elem.nodeType === 1 && (' ' + stripAndCollapse(curValue) + ' ')

                if (cur) {
                  j = 0
                  while ((clazz = classes[j++])) {
                    if (cur.indexOf(' ' + clazz + ' ') < 0) {
                      cur += clazz + ' '
                    }
                  }

                  // Only assign if different to avoid unneeded rendering.
                  finalValue = stripAndCollapse(cur)
                  if (curValue !== finalValue) {
                    elem.setAttribute('class', finalValue)
                  }
                }
              }
            }

            return this
          },

          removeClass: function (value) {
            var classes
            var elem
            var cur
            var curValue
            var clazz
            var j
            var finalValue
            var i = 0

            if (isFunction(value)) {
              return this.each(function (j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)))
              })
            }

            if (!arguments.length) {
              return this.attr('class', '')
            }

            classes = classesToArray(value)

            if (classes.length) {
              while ((elem = this[i++])) {
                curValue = getClass(elem)

                // This expression is here for better compressibility (see addClass)
                cur = elem.nodeType === 1 && (' ' + stripAndCollapse(curValue) + ' ')

                if (cur) {
                  j = 0
                  while ((clazz = classes[j++])) {
                    // Remove *all* instances
                    while (cur.indexOf(' ' + clazz + ' ') > -1) {
                      cur = cur.replace(' ' + clazz + ' ', ' ')
                    }
                  }

                  // Only assign if different to avoid unneeded rendering.
                  finalValue = stripAndCollapse(cur)
                  if (curValue !== finalValue) {
                    elem.setAttribute('class', finalValue)
                  }
                }
              }
            }

            return this
          },

          toggleClass: function (value, stateVal) {
            var type = typeof value
            var isValidValue = type === 'string' || Array.isArray(value)

            if (typeof stateVal === 'boolean' && isValidValue) {
              return stateVal ? this.addClass(value) : this.removeClass(value)
            }

            if (isFunction(value)) {
              return this.each(function (i) {
                jQuery(this).toggleClass(
                  value.call(this, i, getClass(this), stateVal),
                  stateVal
                )
              })
            }

            return this.each(function () {
              var className, i, self, classNames

              if (isValidValue) {
                // Toggle individual class names
                i = 0
                self = jQuery(this)
                classNames = classesToArray(value)

                while ((className = classNames[i++])) {
                  // Check each className given, space separated list
                  if (self.hasClass(className)) {
                    self.removeClass(className)
                  } else {
                    self.addClass(className)
                  }
                }

                // Toggle whole class name
              } else if (value === undefined || type === 'boolean') {
                className = getClass(this)
                if (className) {
                  // Store className if set
                  dataPriv.set(this, '__className__', className)
                }

                // If the element has a class name or if we're passed `false`,
                // then remove the whole classname (if there was one, the above saved it).
                // Otherwise bring back whatever was previously saved (if anything),
                // falling back to the empty string if nothing was stored.
                if (this.setAttribute) {
                  this.setAttribute('class',
                    className || value === false
                    ? ''
                    : dataPriv.get(this, '__className__') || ''
                  )
                }
              }
            })
          },

          hasClass: function (selector) {
            var className
            var elem
            var i = 0

            className = ' ' + selector + ' '
            while ((elem = this[i++])) {
              if (elem.nodeType === 1 &&
                (' ' + stripAndCollapse(getClass(elem)) + ' ').indexOf(className) > -1) {
                return true
              }
            }

            return false
          }
        })

        var rreturn = /\r/g

        jQuery.fn.extend({
          val: function (value) {
            var hooks
            var ret
            var valueIsFunction
            var elem = this[0]

            if (!arguments.length) {
              if (elem) {
                hooks = jQuery.valHooks[elem.type] ||
                  jQuery.valHooks[elem.nodeName.toLowerCase()]

                if (hooks &&
                  'get' in hooks &&
                  (ret = hooks.get(elem, 'value')) !== undefined
                ) {
                  return ret
                }

                ret = elem.value

                // Handle most common string cases
                if (typeof ret === 'string') {
                  return ret.replace(rreturn, '')
                }

                // Handle cases where value is null/undef or number
                return ret == null ? '' : ret
              }

              return
            }

            valueIsFunction = isFunction(value)

            return this.each(function (i) {
              var val

              if (this.nodeType !== 1) {
                return
              }

              if (valueIsFunction) {
                val = value.call(this, i, jQuery(this).val())
              } else {
                val = value
              }

              // Treat null/undefined as ""; convert numbers to string
              if (val == null) {
                val = ''
              } else if (typeof val === 'number') {
                val += ''
              } else if (Array.isArray(val)) {
                val = jQuery.map(val, function (value) {
                  return value == null ? '' : value + ''
                })
              }

              hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()]

              // If set returns undefined, fall back to normal setting
              if (!hooks || !('set' in hooks) || hooks.set(this, val, 'value') === undefined) {
                this.value = val
              }
            })
          }
        })

        jQuery.extend({
          valHooks: {
            option: {
              get: function (elem) {
                var val = jQuery.find.attr(elem, 'value')
                return val != null
                  ? val

                  // Support: IE <=10 - 11 only
                  // option.text throws exceptions (#14686, #14858)
                  // Strip and collapse whitespace
                  // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                  : stripAndCollapse(jQuery.text(elem))
              }
            },
            select: {
              get: function (elem) {
                var value
                var option
                var i
                var options = elem.options
                var index = elem.selectedIndex
                var one = elem.type === 'select-one'
                var values = one ? null : []
                var max = one ? index + 1 : options.length

                if (index < 0) {
                  i = max
                } else {
                  i = one ? index : 0
                }

                // Loop through all the selected options
                for (; i < max; i++) {
                  option = options[i]

                  // Support: IE <=9 only
                  // IE8-9 doesn't update selected after form reset (#2551)
                  if ((option.selected || i === index) &&

                    // Don't return options that are disabled or in a disabled optgroup
                    !option.disabled &&
                    (!option.parentNode.disabled ||
                      !nodeName(option.parentNode, 'optgroup'))) {
                    // Get the specific value for the option
                    value = jQuery(option).val()

                    // We don't need an array for one selects
                    if (one) {
                      return value
                    }

                    // Multi-Selects return an array
                    values.push(value)
                  }
                }

                return values
              },

              set: function (elem, value) {
                var optionSet
                var option
                var options = elem.options
                var values = jQuery.makeArray(value)
                var i = options.length

                while (i--) {
                  option = options[i]

                  /* eslint-disable no-cond-assign */

                  if (option.selected =
                    jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1
                  ) {
                    optionSet = true
                  }

                  /* eslint-enable no-cond-assign */
                }

                // Force browsers to behave consistently when non-matching value is set
                if (!optionSet) {
                  elem.selectedIndex = -1
                }
                return values
              }
            }
          }
        })

        // Radios and checkboxes getter/setter
        jQuery.each(['radio', 'checkbox'], function () {
          jQuery.valHooks[this] = {
            set: function (elem, value) {
              if (Array.isArray(value)) {
                return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1)
              }
            }
          }
          if (!support.checkOn) {
            jQuery.valHooks[this].get = function (elem) {
              return elem.getAttribute('value') === null ? 'on' : elem.value
            }
          }
        })

        // Return jQuery for attributes-only inclusion

        support.focusin = 'onfocusin' in window

        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/
        var stopPropagationCallback = function (e) {
          e.stopPropagation()
        }

        jQuery.extend(jQuery.event, {

          trigger: function (event, data, elem, onlyHandlers) {
            var i
            var cur
            var tmp
            var bubbleType
            var ontype
            var handle
            var special
            var lastElement
            var eventPath = [elem || document]
            var type = hasOwn.call(event, 'type') ? event.type : event
            var namespaces = hasOwn.call(event, 'namespace') ? event.namespace.split('.') : []

            cur = lastElement = tmp = elem = elem || document

            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) {
              return
            }

            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) {
              return
            }

            if (type.indexOf('.') > -1) {
              // Namespaced trigger; create a regexp to match event type in handle()
              namespaces = type.split('.')
              type = namespaces.shift()
              namespaces.sort()
            }
            ontype = type.indexOf(':') < 0 && 'on' + type

            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando]
              ? event
              : new jQuery.Event(type, typeof event === 'object' && event)

            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3
            event.namespace = namespaces.join('.')
            event.rnamespace = event.namespace
              ? new RegExp('(^|\\.)' + namespaces.join('\\.(?:.*\\.|)') + '(\\.|$)')
              : null

            // Clean up the event in case it is being reused
            event.result = undefined
            if (!event.target) {
              event.target = elem
            }

            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [event]
              : jQuery.makeArray(data, [event])

            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {}
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
              return
            }

            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
              bubbleType = special.delegateType || type
              if (!rfocusMorph.test(bubbleType + type)) {
                cur = cur.parentNode
              }
              for (; cur; cur = cur.parentNode) {
                eventPath.push(cur)
                tmp = cur
              }

              // Only add window if we got to document (e.g., not plain obj or detached DOM)
              if (tmp === (elem.ownerDocument || document)) {
                eventPath.push(tmp.defaultView || tmp.parentWindow || window)
              }
            }

            // Fire handlers on the event path
            i = 0
            while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
              lastElement = cur
              event.type = i > 1
                ? bubbleType
                : special.bindType || type

              // jQuery handler
              handle = (
                  dataPriv.get(cur, 'events') || Object.create(null)
                )[event.type] &&
                dataPriv.get(cur, 'handle')
              if (handle) {
                handle.apply(cur, data)
              }

              // Native handler
              handle = ontype && cur[ontype]
              if (handle && handle.apply && acceptData(cur)) {
                event.result = handle.apply(cur, data)
                if (event.result === false) {
                  event.preventDefault()
                }
              }
            }
            event.type = type

            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
              if ((!special._default ||
                  special._default.apply(eventPath.pop(), data) === false) &&
                acceptData(elem)) {
                // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                  // Don't re-trigger an onFOO event when we call its FOO() method
                  tmp = elem[ontype]

                  if (tmp) {
                    elem[ontype] = null
                  }

                  // Prevent re-triggering of the same event, since we already bubbled it above
                  jQuery.event.triggered = type

                  if (event.isPropagationStopped()) {
                    lastElement.addEventListener(type, stopPropagationCallback)
                  }

                  elem[type]()

                  if (event.isPropagationStopped()) {
                    lastElement.removeEventListener(type, stopPropagationCallback)
                  }

                  jQuery.event.triggered = undefined

                  if (tmp) {
                    elem[ontype] = tmp
                  }
                }
              }
            }

            return event.result
          },

          // Piggyback on a donor event to simulate a different one
          // Used only for `focus(in | out)` events
          simulate: function (type, elem, event) {
            var e = jQuery.extend(
              new jQuery.Event(),
              event, {
                type: type,
                isSimulated: true
              }
            )

            jQuery.event.trigger(e, null, elem)
          }

        })

        jQuery.fn.extend({

          trigger: function (type, data) {
            return this.each(function () {
              jQuery.event.trigger(type, data, this)
            })
          },
          triggerHandler: function (type, data) {
            var elem = this[0]
            if (elem) {
              return jQuery.event.trigger(type, data, elem, true)
            }
          }
        })

        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        if (!support.focusin) {
          jQuery.each({
            focus: 'focusin',
            blur: 'focusout'
          }, function (orig, fix) {
            // Attach a single capturing handler on the document while someone wants focusin/focusout
            var handler = function (event) {
              jQuery.event.simulate(fix, event.target, jQuery.event.fix(event))
            }

            jQuery.event.special[fix] = {
              setup: function () {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this
                var attaches = dataPriv.access(doc, fix)

                if (!attaches) {
                  doc.addEventListener(orig, handler, true)
                }
                dataPriv.access(doc, fix, (attaches || 0) + 1)
              },
              teardown: function () {
                var doc = this.ownerDocument || this.document || this
                var attaches = dataPriv.access(doc, fix) - 1

                if (!attaches) {
                  doc.removeEventListener(orig, handler, true)
                  dataPriv.remove(doc, fix)
                } else {
                  dataPriv.access(doc, fix, attaches)
                }
              }
            }
          })
        }
        var location = window.location

        var nonce = {
          guid: Date.now()
        }

        var rquery = (/\?/)

        // Cross-browser xml parsing
        jQuery.parseXML = function (data) {
          var xml
          if (!data || typeof data !== 'string') {
            return null
          }

          // Support: IE 9 - 11 only
          // IE throws on parseFromString with invalid input.
          try {
            xml = (new window.DOMParser()).parseFromString(data, 'text/xml')
          } catch (e) {
            xml = undefined
          }

          if (!xml || xml.getElementsByTagName('parsererror').length) {
            jQuery.error('Invalid XML: ' + data)
          }
          return xml
        }

        var
          rbracket = /\[\]$/
        var rCRLF = /\r?\n/g
        var rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i
        var rsubmittable = /^(?:input|select|textarea|keygen)/i

        function buildParams(prefix, obj, traditional, add) {
          var name

          if (Array.isArray(obj)) {
            // Serialize array item.
            jQuery.each(obj, function (i, v) {
              if (traditional || rbracket.test(prefix)) {
                // Treat each array item as a scalar.
                add(prefix, v)
              } else {
                // Item is non-scalar (array or object), encode its numeric index.
                buildParams(
                  prefix + '[' + (typeof v === 'object' && v != null ? i : '') + ']',
                  v,
                  traditional,
                  add
                )
              }
            })
          } else if (!traditional && toType(obj) === 'object') {
            // Serialize object item.
            for (name in obj) {
              buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
            }
          } else {
            // Serialize scalar item.
            add(prefix, obj)
          }
        }

        // Serialize an array of form elements or a set of
        // key/values into a query string
        jQuery.param = function (a, traditional) {
          var prefix
          var s = []
          var add = function (key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction)
              ? valueOrFunction()
              : valueOrFunction

            s[s.length] = encodeURIComponent(key) + '=' +
              encodeURIComponent(value == null ? '' : value)
          }

          if (a == null) {
            return ''
          }

          // If an array was passed in, assume that it is an array of form elements.
          if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
            // Serialize the form elements
            jQuery.each(a, function () {
              add(this.name, this.value)
            })
          } else {
            // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for (prefix in a) {
              buildParams(prefix, a[prefix], traditional, add)
            }
          }

          // Return the resulting serialization
          return s.join('&')
        }

        jQuery.fn.extend({
          serialize: function () {
            return jQuery.param(this.serializeArray())
          },
          serializeArray: function () {
            return this.map(function () {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, 'elements')
                return elements ? jQuery.makeArray(elements) : this
              })
              .filter(function () {
                var type = this.type

                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(':disabled') &&
                  rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
                  (this.checked || !rcheckableType.test(type))
              })
              .map(function (_i, elem) {
                var val = jQuery(this).val()

                if (val == null) {
                  return null
                }

                if (Array.isArray(val)) {
                  return jQuery.map(val, function (val) {
                    return {
                      name: elem.name,
                      value: val.replace(rCRLF, '\r\n')
                    }
                  })
                }

                return {
                  name: elem.name,
                  value: val.replace(rCRLF, '\r\n')
                }
              }).get()
          }
        })

        var
          r20 = /%20/g
        var rhash = /#.*$/
        var rantiCache = /([?&])_=[^&]*/
        var rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg

        // #7653, #8125, #8152: local protocol detection
        var rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
        var rnoContent = /^(?:GET|HEAD)$/
        var rprotocol = /^\/\//

        /* Prefilters
         * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
         * 2) These are called:
         *    - BEFORE asking for a transport
         *    - AFTER param serialization (s.data is a string if s.processData is true)
         * 3) key is the dataType
         * 4) the catchall symbol "*" can be used
         * 5) execution will start with transport dataType and THEN continue down to "*" if needed
         */
        var prefilters = {}

        /* Transports bindings
         * 1) key is the dataType
         * 2) the catchall symbol "*" can be used
         * 3) selection will start with transport dataType and THEN go to "*" if needed
         */
        var transports = {}

        // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
        var allTypes = '*/'.concat('*')

        // Anchor tag for parsing the document origin
        var originAnchor = document.createElement('a')
        originAnchor.href = location.href

        // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
        function addToPrefiltersOrTransports(structure) {
          // dataTypeExpression is optional and defaults to "*"
          return function (dataTypeExpression, func) {
            if (typeof dataTypeExpression !== 'string') {
              func = dataTypeExpression
              dataTypeExpression = '*'
            }

            var dataType
            var i = 0
            var dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || []

            if (isFunction(func)) {
              // For each dataType in the dataTypeExpression
              while ((dataType = dataTypes[i++])) {
                // Prepend if requested
                if (dataType[0] === '+') {
                  dataType = dataType.slice(1) || '*';
                  (structure[dataType] = structure[dataType] || []).unshift(func)

                  // Otherwise append
                } else {
                  (structure[dataType] = structure[dataType] || []).push(func)
                }
              }
            }
          }
        }

        // Base inspection function for prefilters and transports
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
          var inspected = {}
          var seekingTransport = (structure === transports)

          function inspect(dataType) {
            var selected
            inspected[dataType] = true
            jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
              var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR)
              if (typeof dataTypeOrTransport === 'string' &&
                !seekingTransport && !inspected[dataTypeOrTransport]) {
                options.dataTypes.unshift(dataTypeOrTransport)
                inspect(dataTypeOrTransport)
                return false
              } else if (seekingTransport) {
                return !(selected = dataTypeOrTransport)
              }
            })
            return selected
          }

          return inspect(options.dataTypes[0]) || !inspected['*'] && inspect('*')
        }

        // A special extend for ajax options
        // that takes "flat" options (not to be deep extended)
        // Fixes #9887
        function ajaxExtend(target, src) {
          var key
          var deep
          var flatOptions = jQuery.ajaxSettings.flatOptions || {}

          for (key in src) {
            if (src[key] !== undefined) {
              (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key]
            }
          }
          if (deep) {
            jQuery.extend(true, target, deep)
          }

          return target
        }

        /* Handles responses to an ajax request:
         * - finds the right dataType (mediates between content-type and expected dataType)
         * - returns the corresponding response
         */
        function ajaxHandleResponses(s, jqXHR, responses) {
          var ct
          var type
          var finalDataType
          var firstDataType
          var contents = s.contents
          var dataTypes = s.dataTypes

          // Remove auto dataType and get content-type in the process
          while (dataTypes[0] === '*') {
            dataTypes.shift()
            if (ct === undefined) {
              ct = s.mimeType || jqXHR.getResponseHeader('Content-Type')
            }
          }

          // Check if we're dealing with a known content-type
          if (ct) {
            for (type in contents) {
              if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type)
                break
              }
            }
          }

          // Check to see if we have a response for the expected dataType
          if (dataTypes[0] in responses) {
            finalDataType = dataTypes[0]
          } else {
            // Try convertible dataTypes
            for (type in responses) {
              if (!dataTypes[0] || s.converters[type + ' ' + dataTypes[0]]) {
                finalDataType = type
                break
              }
              if (!firstDataType) {
                firstDataType = type
              }
            }

            // Or just use first one
            finalDataType = finalDataType || firstDataType
          }

          // If we found a dataType
          // We add the dataType to the list if needed
          // and return the corresponding response
          if (finalDataType) {
            if (finalDataType !== dataTypes[0]) {
              dataTypes.unshift(finalDataType)
            }
            return responses[finalDataType]
          }
        }

        /* Chain conversions given the request and the original response
         * Also sets the responseXXX fields on the jqXHR instance
         */
        function ajaxConvert(s, response, jqXHR, isSuccess) {
          var conv2
          var current
          var conv
          var tmp
          var prev
          var converters = {}

          // Work with a copy of dataTypes in case we need to modify it for conversion
          var dataTypes = s.dataTypes.slice()

          // Create converters map with lowercased keys
          if (dataTypes[1]) {
            for (conv in s.converters) {
              converters[conv.toLowerCase()] = s.converters[conv]
            }
          }

          current = dataTypes.shift()

          // Convert to each sequential dataType
          while (current) {
            if (s.responseFields[current]) {
              jqXHR[s.responseFields[current]] = response
            }

            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) {
              response = s.dataFilter(response, s.dataType)
            }

            prev = current
            current = dataTypes.shift()

            if (current) {
              // There's only work to do if current dataType is non-auto
              if (current === '*') {
                current = prev

                // Convert response if prev dataType is non-auto and differs from current
              } else if (prev !== '*' && prev !== current) {
                // Seek a direct converter
                conv = converters[prev + ' ' + current] || converters['* ' + current]

                // If none found, seek a pair
                if (!conv) {
                  for (conv2 in converters) {
                    // If conv2 outputs current
                    tmp = conv2.split(' ')
                    if (tmp[1] === current) {
                      // If prev can be converted to accepted input
                      conv = converters[prev + ' ' + tmp[0]] ||
                        converters['* ' + tmp[0]]
                      if (conv) {
                        // Condense equivalence converters
                        if (conv === true) {
                          conv = converters[conv2]

                          // Otherwise, insert the intermediate dataType
                        } else if (converters[conv2] !== true) {
                          current = tmp[0]
                          dataTypes.unshift(tmp[1])
                        }
                        break
                      }
                    }
                  }
                }

                // Apply converter (if not an equivalence)
                if (conv !== true) {
                  // Unless errors are allowed to bubble, catch and return them
                  if (conv && s.throws) {
                    response = conv(response)
                  } else {
                    try {
                      response = conv(response)
                    } catch (e) {
                      return {
                        state: 'parsererror',
                        error: conv ? e : 'No conversion from ' + prev + ' to ' + current
                      }
                    }
                  }
                }
              }
            }
          }

          return {
            state: 'success',
            data: response
          }
        }

        jQuery.extend({

          // Counter for holding the number of active queries
          active: 0,

          // Last-Modified header cache for next request
          lastModified: {},
          etag: {},

          ajaxSettings: {
            url: location.href,
            type: 'GET',
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',

            /*
            timeout: 0,
            data: null,
            dataType: null,
            username: null,
            password: null,
            cache: null,
            throws: false,
            traditional: false,
            headers: {},
            */

            accepts: {
              '*': allTypes,
              text: 'text/plain',
              html: 'text/html',
              xml: 'application/xml, text/xml',
              json: 'application/json, text/javascript'
            },

            contents: {
              xml: /\bxml\b/,
              html: /\bhtml/,
              json: /\bjson\b/
            },

            responseFields: {
              xml: 'responseXML',
              text: 'responseText',
              json: 'responseJSON'
            },

            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {

              // Convert anything to text
              '* text': String,

              // Text to html (true = no transformation)
              'text html': true,

              // Evaluate text as a json expression
              'text json': JSON.parse,

              // Parse text as xml
              'text xml': jQuery.parseXML
            },

            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
              url: true,
              context: true
            }
          },

          // Creates a full fledged settings object into target
          // with both ajaxSettings and settings fields.
          // If target is omitted, writes into ajaxSettings.
          ajaxSetup: function (target, settings) {
            return settings

              // Building a settings object
              ? ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)

              // Extending ajaxSettings
              : ajaxExtend(jQuery.ajaxSettings, target)
          },

          ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
          ajaxTransport: addToPrefiltersOrTransports(transports),

          // Main method
          ajax: function (url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === 'object') {
              options = url
              url = undefined
            }

            // Force options to be an object
            options = options || {}

            var transport

            // URL without anti-cache param
            var cacheURL

            // Response headers
            var responseHeadersString
            var responseHeaders

            // timeout handle
            var timeoutTimer

            // Url cleanup var
            var urlAnchor

            // Request state (becomes false upon send and true upon completion)
            var completed

            // To know if global events are to be dispatched
            var fireGlobals

            // Loop variable
            var i

            // uncached part of the url
            var uncached

            // Create the final options object
            var s = jQuery.ajaxSetup({}, options)

            // Callbacks context
            var callbackContext = s.context || s

            // Context for global events is callbackContext if it is a DOM node or jQuery collection
            var globalEventContext = s.context &&
              (callbackContext.nodeType || callbackContext.jquery)
              ? jQuery(callbackContext)
              : jQuery.event

            // Deferreds
            var deferred = jQuery.Deferred()
            var completeDeferred = jQuery.Callbacks('once memory')

            // Status-dependent callbacks
            var statusCode = s.statusCode || {}

            // Headers (they are sent all at once)
            var requestHeaders = {}
            var requestHeadersNames = {}

            // Default abort message
            var strAbort = 'canceled'

            // Fake xhr
            var jqXHR = {
              readyState: 0,

              // Builds headers hashtable if needed
              getResponseHeader: function (key) {
                var match
                if (completed) {
                  if (!responseHeaders) {
                    responseHeaders = {}
                    while ((match = rheaders.exec(responseHeadersString))) {
                      responseHeaders[match[1].toLowerCase() + ' '] =
                        (responseHeaders[match[1].toLowerCase() + ' '] || [])
                        .concat(match[2])
                    }
                  }
                  match = responseHeaders[key.toLowerCase() + ' ']
                }
                return match == null ? null : match.join(', ')
              },

              // Raw string
              getAllResponseHeaders: function () {
                return completed ? responseHeadersString : null
              },

              // Caches the header
              setRequestHeader: function (name, value) {
                if (completed == null) {
                  name = requestHeadersNames[name.toLowerCase()] =
                    requestHeadersNames[name.toLowerCase()] || name
                  requestHeaders[name] = value
                }
                return this
              },

              // Overrides response content-type header
              overrideMimeType: function (type) {
                if (completed == null) {
                  s.mimeType = type
                }
                return this
              },

              // Status-dependent callbacks
              statusCode: function (map) {
                var code
                if (map) {
                  if (completed) {
                    // Execute the appropriate callbacks
                    jqXHR.always(map[jqXHR.status])
                  } else {
                    // Lazy-add the new callbacks in a way that preserves old ones
                    for (code in map) {
                      statusCode[code] = [statusCode[code], map[code]]
                    }
                  }
                }
                return this
              },

              // Cancel the request
              abort: function (statusText) {
                var finalText = statusText || strAbort
                if (transport) {
                  transport.abort(finalText)
                }
                done(0, finalText)
                return this
              }
            }

            // Attach deferreds
            deferred.promise(jqXHR)

            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + '')
              .replace(rprotocol, location.protocol + '//')

            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type

            // Extract dataTypes list
            s.dataTypes = (s.dataType || '*').toLowerCase().match(rnothtmlwhite) || ['']

            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
              urlAnchor = document.createElement('a')

              // Support: IE <=8 - 11, Edge 12 - 15
              // IE throws exception on accessing the href property if url is malformed,
              // e.g. http://example.com:80x/
              try {
                urlAnchor.href = s.url

                // Support: IE <=8 - 11 only
                // Anchor's host property isn't correctly set when s.url is relative
                urlAnchor.href = urlAnchor.href
                s.crossDomain = originAnchor.protocol + '//' + originAnchor.host !==
                  urlAnchor.protocol + '//' + urlAnchor.host
              } catch (e) {
                // If there is an error parsing the URL, assume it is crossDomain,
                // it can be rejected by the transport if it is invalid
                s.crossDomain = true
              }
            }

            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== 'string') {
              s.data = jQuery.param(s.data, s.traditional)
            }

            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR)

            // If request was aborted inside a prefilter, stop there
            if (completed) {
              return jqXHR
            }

            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global

            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) {
              jQuery.event.trigger('ajaxStart')
            }

            // Uppercase the type
            s.type = s.type.toUpperCase()

            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type)

            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, '')

            // More options handling for requests with no content
            if (!s.hasContent) {
              // Remember the hash so we can put it back
              uncached = s.url.slice(cacheURL.length)

              // If data is available and should be processed, append data to url
              if (s.data && (s.processData || typeof s.data === 'string')) {
                cacheURL += (rquery.test(cacheURL) ? '&' : '?') + s.data

                // #9682: remove data so that it's not used in an eventual retry
                delete s.data
              }

              // Add or update anti-cache param if needed
              if (s.cache === false) {
                cacheURL = cacheURL.replace(rantiCache, '$1')
                uncached = (rquery.test(cacheURL) ? '&' : '?') + '_=' + (nonce.guid++) +
                  uncached
              }

              // Put hash and anti-cache on the URL that will be requested (gh-1732)
              s.url = cacheURL + uncached

              // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData &&
              (s.contentType || '').indexOf('application/x-www-form-urlencoded') === 0) {
              s.data = s.data.replace(r20, '+')
            }

            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
              if (jQuery.lastModified[cacheURL]) {
                jqXHR.setRequestHeader('If-Modified-Since', jQuery.lastModified[cacheURL])
              }
              if (jQuery.etag[cacheURL]) {
                jqXHR.setRequestHeader('If-None-Match', jQuery.etag[cacheURL])
              }
            }

            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
              jqXHR.setRequestHeader('Content-Type', s.contentType)
            }

            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader(
              'Accept',
              s.dataTypes[0] && s.accepts[s.dataTypes[0]]
              ? s.accepts[s.dataTypes[0]] +
              (s.dataTypes[0] !== '*' ? ', ' + allTypes + '; q=0.01' : '')
              : s.accepts['*']
            )

            // Check for headers option
            for (i in s.headers) {
              jqXHR.setRequestHeader(i, s.headers[i])
            }

            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend &&
              (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
              // Abort if not done already and return
              return jqXHR.abort()
            }

            // Aborting is no longer a cancellation
            strAbort = 'abort'

            // Install callbacks on deferreds
            completeDeferred.add(s.complete)
            jqXHR.done(s.success)
            jqXHR.fail(s.error)

            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR)

            // If no transport, we auto-abort
            if (!transport) {
              done(-1, 'No Transport')
            } else {
              jqXHR.readyState = 1

              // Send global event
              if (fireGlobals) {
                globalEventContext.trigger('ajaxSend', [jqXHR, s])
              }

              // If request was aborted inside ajaxSend, stop there
              if (completed) {
                return jqXHR
              }

              // Timeout
              if (s.async && s.timeout > 0) {
                timeoutTimer = window.setTimeout(function () {
                  jqXHR.abort('timeout')
                }, s.timeout)
              }

              try {
                completed = false
                transport.send(requestHeaders, done)
              } catch (e) {
                // Rethrow post-completion exceptions
                if (completed) {
                  throw e
                }

                // Propagate others as results
                done(-1, e)
              }
            }

            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
              var isSuccess
              var success
              var error
              var response
              var modified
              var statusText = nativeStatusText

              // Ignore repeat invocations
              if (completed) {
                return
              }

              completed = true

              // Clear timeout if it exists
              if (timeoutTimer) {
                window.clearTimeout(timeoutTimer)
              }

              // Dereference transport for early garbage collection
              // (no matter how long the jqXHR object will be used)
              transport = undefined

              // Cache response headers
              responseHeadersString = headers || ''

              // Set readyState
              jqXHR.readyState = status > 0 ? 4 : 0

              // Determine if successful
              isSuccess = status >= 200 && status < 300 || status === 304

              // Get response data
              if (responses) {
                response = ajaxHandleResponses(s, jqXHR, responses)
              }

              // Use a noop converter for missing script
              if (!isSuccess && jQuery.inArray('script', s.dataTypes) > -1) {
                s.converters['text script'] = function () {}
              }

              // Convert no matter what (that way responseXXX fields are always set)
              response = ajaxConvert(s, response, jqXHR, isSuccess)

              // If successful, handle type chaining
              if (isSuccess) {
                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                if (s.ifModified) {
                  modified = jqXHR.getResponseHeader('Last-Modified')
                  if (modified) {
                    jQuery.lastModified[cacheURL] = modified
                  }
                  modified = jqXHR.getResponseHeader('etag')
                  if (modified) {
                    jQuery.etag[cacheURL] = modified
                  }
                }

                // if no content
                if (status === 204 || s.type === 'HEAD') {
                  statusText = 'nocontent'

                  // if not modified
                } else if (status === 304) {
                  statusText = 'notmodified'

                  // If we have data, let's convert it
                } else {
                  statusText = response.state
                  success = response.data
                  error = response.error
                  isSuccess = !error
                }
              } else {
                // Extract error from statusText and normalize for non-aborts
                error = statusText
                if (status || !statusText) {
                  statusText = 'error'
                  if (status < 0) {
                    status = 0
                  }
                }
              }

              // Set data for the fake xhr object
              jqXHR.status = status
              jqXHR.statusText = (nativeStatusText || statusText) + ''

              // Success/Error
              if (isSuccess) {
                deferred.resolveWith(callbackContext, [success, statusText, jqXHR])
              } else {
                deferred.rejectWith(callbackContext, [jqXHR, statusText, error])
              }

              // Status-dependent callbacks
              jqXHR.statusCode(statusCode)
              statusCode = undefined

              if (fireGlobals) {
                globalEventContext.trigger(isSuccess ? 'ajaxSuccess' : 'ajaxError',
                  [jqXHR, s, isSuccess ? success : error])
              }

              // Complete
              completeDeferred.fireWith(callbackContext, [jqXHR, statusText])

              if (fireGlobals) {
                globalEventContext.trigger('ajaxComplete', [jqXHR, s])

                // Handle the global AJAX counter
                if (!(--jQuery.active)) {
                  jQuery.event.trigger('ajaxStop')
                }
              }
            }

            return jqXHR
          },

          getJSON: function (url, data, callback) {
            return jQuery.get(url, data, callback, 'json')
          },

          getScript: function (url, callback) {
            return jQuery.get(url, undefined, callback, 'script')
          }
        })

        jQuery.each(['get', 'post'], function (_i, method) {
          jQuery[method] = function (url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
              type = type || callback
              callback = data
              data = undefined
            }

            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
              url: url,
              type: method,
              dataType: type,
              data: data,
              success: callback
            }, jQuery.isPlainObject(url) && url))
          }
        })

        jQuery.ajaxPrefilter(function (s) {
          var i
          for (i in s.headers) {
            if (i.toLowerCase() === 'content-type') {
              s.contentType = s.headers[i] || ''
            }
          }
        })

        jQuery._evalUrl = function (url, options, doc) {
          return jQuery.ajax({
            url: url,

            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: 'GET',
            dataType: 'script',
            cache: true,
            async: false,
            global: false,

            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
              'text script': function () {}
            },
            dataFilter: function (response) {
              jQuery.globalEval(response, options, doc)
            }
          })
        }

        jQuery.fn.extend({
          wrapAll: function (html) {
            var wrap

            if (this[0]) {
              if (isFunction(html)) {
                html = html.call(this[0])
              }

              // The elements to wrap the target around
              wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true)

              if (this[0].parentNode) {
                wrap.insertBefore(this[0])
              }

              wrap.map(function () {
                var elem = this

                while (elem.firstElementChild) {
                  elem = elem.firstElementChild
                }

                return elem
              }).append(this)
            }

            return this
          },

          wrapInner: function (html) {
            if (isFunction(html)) {
              return this.each(function (i) {
                jQuery(this).wrapInner(html.call(this, i))
              })
            }

            return this.each(function () {
              var self = jQuery(this)
              var contents = self.contents()

              if (contents.length) {
                contents.wrapAll(html)
              } else {
                self.append(html)
              }
            })
          },

          wrap: function (html) {
            var htmlIsFunction = isFunction(html)

            return this.each(function (i) {
              jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html)
            })
          },

          unwrap: function (selector) {
            this.parent(selector).not('body').each(function () {
              jQuery(this).replaceWith(this.childNodes)
            })
            return this
          }
        })

        jQuery.expr.pseudos.hidden = function (elem) {
          return !jQuery.expr.pseudos.visible(elem)
        }
        jQuery.expr.pseudos.visible = function (elem) {
          return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
        }

        jQuery.ajaxSettings.xhr = function () {
          try {
            return new window.XMLHttpRequest()
          } catch (e) {}
        }

        var xhrSuccessStatus = {

          // File protocol always yields status code 0, assume 200
          0: 200,

          // Support: IE <=9 only
          // #1450: sometimes IE returns 1223 when it should be 204
          1223: 204
        }
        var xhrSupported = jQuery.ajaxSettings.xhr()

        support.cors = !!xhrSupported && ('withCredentials' in xhrSupported)
        support.ajax = xhrSupported = !!xhrSupported

        jQuery.ajaxTransport(function (options) {
          var callback, errorCallback

          // Cross domain only allowed if supported through XMLHttpRequest
          if (support.cors || xhrSupported && !options.crossDomain) {
            return {
              send: function (headers, complete) {
                var i
                var xhr = options.xhr()

                xhr.open(
                  options.type,
                  options.url,
                  options.async,
                  options.username,
                  options.password
                )

                // Apply custom fields if provided
                if (options.xhrFields) {
                  for (i in options.xhrFields) {
                    xhr[i] = options.xhrFields[i]
                  }
                }

                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) {
                  xhr.overrideMimeType(options.mimeType)
                }

                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers['X-Requested-With']) {
                  headers['X-Requested-With'] = 'XMLHttpRequest'
                }

                // Set headers
                for (i in headers) {
                  xhr.setRequestHeader(i, headers[i])
                }

                // Callback
                callback = function (type) {
                  return function () {
                    if (callback) {
                      callback = errorCallback = xhr.onload =
                        xhr.onerror = xhr.onabort = xhr.ontimeout =
                        xhr.onreadystatechange = null

                      if (type === 'abort') {
                        xhr.abort()
                      } else if (type === 'error') {
                        // Support: IE <=9 only
                        // On a manual native abort, IE9 throws
                        // errors on any property access that is not readyState
                        if (typeof xhr.status !== 'number') {
                          complete(0, 'error')
                        } else {
                          complete(

                            // File: protocol always yields status 0; see #8605, #14207
                            xhr.status,
                            xhr.statusText
                          )
                        }
                      } else {
                        complete(
                          xhrSuccessStatus[xhr.status] || xhr.status,
                          xhr.statusText,

                          // Support: IE <=9 only
                          // IE9 has no XHR2 but throws on binary (trac-11426)
                          // For XHR2 non-text, let the caller handle it (gh-2498)
                          (xhr.responseType || 'text') !== 'text' ||
                          typeof xhr.responseText !== 'string' ? {
                            binary: xhr.response
                          } : {
                            text: xhr.responseText
                          },
                          xhr.getAllResponseHeaders()
                        )
                      }
                    }
                  }
                }

                // Listen to events
                xhr.onload = callback()
                errorCallback = xhr.onerror = xhr.ontimeout = callback('error')

                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) {
                  xhr.onabort = errorCallback
                } else {
                  xhr.onreadystatechange = function () {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) {
                      // Allow onerror to be called first,
                      // but that will not handle a native abort
                      // Also, save errorCallback to a variable
                      // as xhr.onerror cannot be accessed
                      window.setTimeout(function () {
                        if (callback) {
                          errorCallback()
                        }
                      })
                    }
                  }
                }

                // Create the abort callback
                callback = callback('abort')

                try {
                  // Do send the request (this may raise an exception)
                  xhr.send(options.hasContent && options.data || null)
                } catch (e) {
                  // #14683: Only rethrow if this hasn't been notified as an error yet
                  if (callback) {
                    throw e
                  }
                }
              },

              abort: function () {
                if (callback) {
                  callback()
                }
              }
            }
          }
        })

        // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
        jQuery.ajaxPrefilter(function (s) {
          if (s.crossDomain) {
            s.contents.script = false
          }
        })

        // Install script dataType
        jQuery.ajaxSetup({
          accepts: {
            script: 'text/javascript, application/javascript, ' +
              'application/ecmascript, application/x-ecmascript'
          },
          contents: {
            script: /\b(?:java|ecma)script\b/
          },
          converters: {
            'text script': function (text) {
              jQuery.globalEval(text)
              return text
            }
          }
        })

        // Handle cache's special case and crossDomain
        jQuery.ajaxPrefilter('script', function (s) {
          if (s.cache === undefined) {
            s.cache = false
          }
          if (s.crossDomain) {
            s.type = 'GET'
          }
        })

        // Bind script tag hack transport
        jQuery.ajaxTransport('script', function (s) {
          // This transport only deals with cross domain or forced-by-attrs requests
          if (s.crossDomain || s.scriptAttrs) {
            var script, callback
            return {
              send: function (_, complete) {
                script = jQuery('<script>')
                  .attr(s.scriptAttrs || {})
                  .prop({
                    charset: s.scriptCharset,
                    src: s.url
                  })
                  .on('load error', callback = function (evt) {
                    script.remove()
                    callback = null
                    if (evt) {
                      complete(evt.type === 'error' ? 404 : 200, evt.type)
                    }
                  })

                // Use native DOM manipulation to avoid our domManip AJAX trickery
                document.head.appendChild(script[0])
              },
              abort: function () {
                if (callback) {
                  callback()
                }
              }
            }
          }
        })

        var oldCallbacks = []
        var rjsonp = /(=)\?(?=&|$)|\?\?/

        // Default jsonp settings
        jQuery.ajaxSetup({
          jsonp: 'callback',
          jsonpCallback: function () {
            var callback = oldCallbacks.pop() || (jQuery.expando + '_' + (nonce.guid++))
            this[callback] = true
            return callback
          }
        })

        // Detect, normalize options and install callbacks for jsonp requests
        jQuery.ajaxPrefilter('json jsonp', function (s, originalSettings, jqXHR) {
          var callbackName
          var overwritten
          var responseContainer
          var jsonProp = s.jsonp !== false && (rjsonp.test(s.url)
            ? 'url'
            : typeof s.data === 'string' &&
            (s.contentType || '')
            .indexOf('application/x-www-form-urlencoded') === 0 &&
            rjsonp.test(s.data) && 'data'
          )

          // Handle iff the expected data type is "jsonp" or we have a parameter to set
          if (jsonProp || s.dataTypes[0] === 'jsonp') {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback)
              ? s.jsonpCallback()
              : s.jsonpCallback

            // Insert callback into url or form data
            if (jsonProp) {
              s[jsonProp] = s[jsonProp].replace(rjsonp, '$1' + callbackName)
            } else if (s.jsonp !== false) {
              s.url += (rquery.test(s.url) ? '&' : '?') + s.jsonp + '=' + callbackName
            }

            // Use data converter to retrieve json after script execution
            s.converters['script json'] = function () {
              if (!responseContainer) {
                jQuery.error(callbackName + ' was not called')
              }
              return responseContainer[0]
            }

            // Force json dataType
            s.dataTypes[0] = 'json'

            // Install callback
            overwritten = window[callbackName]
            window[callbackName] = function () {
              responseContainer = arguments
            }

            // Clean-up function (fires after converters)
            jqXHR.always(function () {
              // If previous value didn't exist - remove it
              if (overwritten === undefined) {
                jQuery(window).removeProp(callbackName)

                // Otherwise restore preexisting value
              } else {
                window[callbackName] = overwritten
              }

              // Save back as free
              if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback

                // Save the callback name for future use
                oldCallbacks.push(callbackName)
              }

              // Call if it was a function and we have a response
              if (responseContainer && isFunction(overwritten)) {
                overwritten(responseContainer[0])
              }

              responseContainer = overwritten = undefined
            })

            // Delegate to script
            return 'script'
          }
        })

        // Support: Safari 8 only
        // In Safari 8 documents created via document.implementation.createHTMLDocument
        // collapse sibling forms: the second one becomes a child of the first one.
        // Because of that, this security measure has to be disabled in Safari 8.
        // https://bugs.webkit.org/show_bug.cgi?id=137337
        support.createHTMLDocument = (function () {
          var body = document.implementation.createHTMLDocument('').body
          body.innerHTML = '<form></form><form></form>'
          return body.childNodes.length === 2
        })()

        // Argument "data" should be string of html
        // context (optional): If specified, the fragment will be created in this context,
        // defaults to document
        // keepScripts (optional): If true, will include scripts passed in the html string
        jQuery.parseHTML = function (data, context, keepScripts) {
          if (typeof data !== 'string') {
            return []
          }
          if (typeof context === 'boolean') {
            keepScripts = context
            context = false
          }

          var base, parsed, scripts

          if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
              context = document.implementation.createHTMLDocument('')

              // Set the base href for the created document
              // so any parsed elements with URLs
              // are based on the document's URL (gh-2965)
              base = context.createElement('base')
              base.href = document.location.href
              context.head.appendChild(base)
            } else {
              context = document
            }
          }

          parsed = rsingleTag.exec(data)
          scripts = !keepScripts && []

          // Single tag
          if (parsed) {
            return [context.createElement(parsed[1])]
          }

          parsed = buildFragment([data], context, scripts)

          if (scripts && scripts.length) {
            jQuery(scripts).remove()
          }

          return jQuery.merge([], parsed.childNodes)
        }

        /**
         * Load a url into a page
         */
        jQuery.fn.load = function (url, params, callback) {
          var selector
          var type
          var response
          var self = this
          var off = url.indexOf(' ')

          if (off > -1) {
            selector = stripAndCollapse(url.slice(off))
            url = url.slice(0, off)
          }

          // If it's a function
          if (isFunction(params)) {
            // We assume that it's the callback
            callback = params
            params = undefined

            // Otherwise, build a param string
          } else if (params && typeof params === 'object') {
            type = 'POST'
          }

          // If we have elements to modify, make the request
          if (self.length > 0) {
            jQuery.ajax({
              url: url,

              // If "type" variable is undefined, then "GET" method will be used.
              // Make value of this field explicit since
              // user can override it through ajaxSetup method
              type: type || 'GET',
              dataType: 'html',
              data: params
            }).done(function (responseText) {
              // Save response for use in complete callback
              response = arguments

              self.html(selector

                // If a selector was specified, locate the right elements in a dummy div
                // Exclude scripts to avoid IE 'Permission Denied' errors
                ? jQuery('<div>').append(jQuery.parseHTML(responseText)).find(selector)

                // Otherwise use the full result
                : responseText)

              // If the request succeeds, this function gets "data", "status", "jqXHR"
              // but they are ignored because response was set above.
              // If it fails, this function gets "jqXHR", "status", "error"
            }).always(callback && function (jqXHR, status) {
              self.each(function () {
                callback.apply(this, response || [jqXHR.responseText, status, jqXHR])
              })
            })
          }

          return this
        }

        jQuery.expr.pseudos.animated = function (elem) {
          return jQuery.grep(jQuery.timers, function (fn) {
            return elem === fn.elem
          }).length
        }

        jQuery.offset = {
          setOffset: function (elem, options, i) {
            var curPosition
            var curLeft
            var curCSSTop
            var curTop
            var curOffset
            var curCSSLeft
            var calculatePosition
            var position = jQuery.css(elem, 'position')
            var curElem = jQuery(elem)
            var props = {}

            // Set position first, in-case top/left are set even on static elem
            if (position === 'static') {
              elem.style.position = 'relative'
            }

            curOffset = curElem.offset()
            curCSSTop = jQuery.css(elem, 'top')
            curCSSLeft = jQuery.css(elem, 'left')
            calculatePosition = (position === 'absolute' || position === 'fixed') &&
              (curCSSTop + curCSSLeft).indexOf('auto') > -1

            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
              curPosition = curElem.position()
              curTop = curPosition.top
              curLeft = curPosition.left
            } else {
              curTop = parseFloat(curCSSTop) || 0
              curLeft = parseFloat(curCSSLeft) || 0
            }

            if (isFunction(options)) {
              // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
              options = options.call(elem, i, jQuery.extend({}, curOffset))
            }

            if (options.top != null) {
              props.top = (options.top - curOffset.top) + curTop
            }
            if (options.left != null) {
              props.left = (options.left - curOffset.left) + curLeft
            }

            if ('using' in options) {
              options.using.call(elem, props)
            } else {
              if (typeof props.top === 'number') {
                props.top += 'px'
              }
              if (typeof props.left === 'number') {
                props.left += 'px'
              }
              curElem.css(props)
            }
          }
        }

        jQuery.fn.extend({

          // offset() relates an element's border box to the document origin
          offset: function (options) {
            // Preserve chaining for setter
            if (arguments.length) {
              return options === undefined
                ? this
                : this.each(function (i) {
                  jQuery.offset.setOffset(this, options, i)
                })
            }

            var rect
            var win
            var elem = this[0]

            if (!elem) {
              return
            }

            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) {
              return {
                top: 0,
                left: 0
              }
            }

            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect()
            win = elem.ownerDocument.defaultView
            return {
              top: rect.top + win.pageYOffset,
              left: rect.left + win.pageXOffset
            }
          },

          // position() relates an element's margin box to its offset parent's padding box
          // This corresponds to the behavior of CSS absolute positioning
          position: function () {
            if (!this[0]) {
              return
            }

            var offsetParent
            var offset
            var doc
            var elem = this[0]
            var parentOffset = {
              top: 0,
              left: 0
            }

            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, 'position') === 'fixed') {
              // Assume position:fixed implies availability of getBoundingClientRect
              offset = elem.getBoundingClientRect()
            } else {
              offset = this.offset()

              // Account for the *real* offset parent, which can be the document or its root element
              // when a statically positioned element is identified
              doc = elem.ownerDocument
              offsetParent = elem.offsetParent || doc.documentElement
              while (offsetParent &&
                (offsetParent === doc.body || offsetParent === doc.documentElement) &&
                jQuery.css(offsetParent, 'position') === 'static') {
                offsetParent = offsetParent.parentNode
              }
              if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                // Incorporate borders into its offset, since they are outside its content origin
                parentOffset = jQuery(offsetParent).offset()
                parentOffset.top += jQuery.css(offsetParent, 'borderTopWidth', true)
                parentOffset.left += jQuery.css(offsetParent, 'borderLeftWidth', true)
              }
            }

            // Subtract parent offsets and element margins
            return {
              top: offset.top - parentOffset.top - jQuery.css(elem, 'marginTop', true),
              left: offset.left - parentOffset.left - jQuery.css(elem, 'marginLeft', true)
            }
          },

          // This method will return documentElement in the following cases:
          // 1) For the element inside the iframe without offsetParent, this method will return
          //    documentElement of the parent window
          // 2) For the hidden or detached element
          // 3) For body or html element, i.e. in case of the html node - it will return itself
          //
          // but those exceptions were never presented as a real life use-cases
          // and might be considered as more preferable results.
          //
          // This logic, however, is not guaranteed and can change at any point in the future
          offsetParent: function () {
            return this.map(function () {
              var offsetParent = this.offsetParent

              while (offsetParent && jQuery.css(offsetParent, 'position') === 'static') {
                offsetParent = offsetParent.offsetParent
              }

              return offsetParent || documentElement
            })
          }
        })

        // Create scrollLeft and scrollTop methods
        jQuery.each({
          scrollLeft: 'pageXOffset',
          scrollTop: 'pageYOffset'
        }, function (method, prop) {
          var top = prop === 'pageYOffset'

          jQuery.fn[method] = function (val) {
            return access(this, function (elem, method, val) {
              // Coalesce documents and windows
              var win
              if (isWindow(elem)) {
                win = elem
              } else if (elem.nodeType === 9) {
                win = elem.defaultView
              }

              if (val === undefined) {
                return win ? win[prop] : elem[method]
              }

              if (win) {
                win.scrollTo(
                  !top ? val : win.pageXOffset,
                  top ? val : win.pageYOffset
                )
              } else {
                elem[method] = val
              }
            }, method, val, arguments.length)
          }
        })

        // Support: Safari <=7 - 9.1, Chrome <=37 - 49
        // Add the top/left cssHooks using jQuery.fn.position
        // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
        // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
        // getComputedStyle returns percent when specified for top/left/bottom/right;
        // rather than make the css module depend on the offset module, just check for it here
        jQuery.each(['top', 'left'], function (_i, prop) {
          jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition,
            function (elem, computed) {
              if (computed) {
                computed = curCSS(elem, prop)

                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed)
                  ? jQuery(elem).position()[prop] + 'px'
                  : computed
              }
            }
          )
        })

        // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
        jQuery.each({
          Height: 'height',
          Width: 'width'
        }, function (name, type) {
          jQuery.each({
              padding: 'inner' + name,
              content: type,
              '': 'outer' + name
            },
            function (defaultExtra, funcName) {
              // Margin is only for outerHeight, outerWidth
              jQuery.fn[funcName] = function (margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== 'boolean')
                var extra = defaultExtra || (margin === true || value === true ? 'margin' : 'border')

                return access(this, function (elem, type, value) {
                  var doc

                  if (isWindow(elem)) {
                    // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf('outer') === 0
                      ? elem['inner' + name]
                      : elem.document.documentElement['client' + name]
                  }

                  // Get document width or height
                  if (elem.nodeType === 9) {
                    doc = elem.documentElement

                    // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                    // whichever is greatest
                    return Math.max(
                      elem.body['scroll' + name], doc['scroll' + name],
                      elem.body['offset' + name], doc['offset' + name],
                      doc['client' + name]
                    )
                  }

                  return value === undefined

                    // Get width or height on the element, requesting but not forcing parseFloat
                    ? jQuery.css(elem, type, extra)

                    // Set width or height on the element
                    : jQuery.style(elem, type, value, extra)
                }, type, chainable ? margin : undefined, chainable)
              }
            })
        })

        jQuery.each([
          'ajaxStart',
          'ajaxStop',
          'ajaxComplete',
          'ajaxError',
          'ajaxSuccess',
          'ajaxSend'
        ], function (_i, type) {
          jQuery.fn[type] = function (fn) {
            return this.on(type, fn)
          }
        })

        jQuery.fn.extend({

          bind: function (types, data, fn) {
            return this.on(types, null, data, fn)
          },
          unbind: function (types, fn) {
            return this.off(types, null, fn)
          },

          delegate: function (selector, types, data, fn) {
            return this.on(types, selector, data, fn)
          },
          undelegate: function (selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1
              ? this.off(selector, '**')
              : this.off(types, selector || '**', fn)
          },

          hover: function (fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver)
          }
        })

        jQuery.each(('blur focus focusin focusout resize scroll click dblclick ' +
            'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' +
            'change select submit keydown keypress keyup contextmenu').split(' '),
          function (_i, name) {
            // Handle event binding
            jQuery.fn[name] = function (data, fn) {
              return arguments.length > 0
                ? this.on(name, null, data, fn)
                : this.trigger(name)
            }
          })

        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g

        // Bind a function to a context, optionally partially applying any
        // arguments.
        // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
        // However, it is not slated for removal any time soon
        jQuery.proxy = function (fn, context) {
          var tmp, args, proxy

          if (typeof context === 'string') {
            tmp = fn[context]
            context = fn
            fn = tmp
          }

          // Quick check to determine if target is callable, in the spec
          // this throws a TypeError, but we will just return undefined.
          if (!isFunction(fn)) {
            return undefined
          }

          // Simulated bind
          args = slice.call(arguments, 2)
          proxy = function () {
            return fn.apply(context || this, args.concat(slice.call(arguments)))
          }

          // Set the guid of unique handler to the same of original handler, so it can be removed
          proxy.guid = fn.guid = fn.guid || jQuery.guid++

          return proxy
        }

        jQuery.holdReady = function (hold) {
          if (hold) {
            jQuery.readyWait++
          } else {
            jQuery.ready(true)
          }
        }
        jQuery.isArray = Array.isArray
        jQuery.parseJSON = JSON.parse
        jQuery.nodeName = nodeName
        jQuery.isFunction = isFunction
        jQuery.isWindow = isWindow
        jQuery.camelCase = camelCase
        jQuery.type = toType

        jQuery.now = Date.now

        jQuery.isNumeric = function (obj) {
          // As of jQuery 3.0, isNumeric is limited to
          // strings and numbers (primitives or objects)
          // that can be coerced to finite numbers (gh-2662)
          var type = jQuery.type(obj)
          return (type === 'number' || type === 'string') &&

            // parseFloat NaNs numeric-cast false positives ("")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            !isNaN(obj - parseFloat(obj))
        }

        jQuery.trim = function (text) {
          return text == null
            ? ''
            : (text + '').replace(rtrim, '')
        }

        // Register as a named AMD module, since jQuery can be concatenated with other
        // files that may use define, but not via a proper concatenation script that
        // understands anonymous AMD modules. A named AMD is safest and most robust
        // way to register. Lowercase jquery is used because AMD module names are
        // derived from file names, and jQuery is normally delivered in a lowercase
        // file name. Do this after creating the global so that if an AMD module wants
        // to call noConflict to hide this version of jQuery, it will work.

        // Note that for maximum portability, libraries that are not jQuery should
        // declare themselves as anonymous modules, and avoid setting a global if an
        // AMD loader is present. jQuery is a special case. For more information, see
        // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

        if (true) {
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
              return jQuery
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }

        var

          // Map over jQuery in case of overwrite
          _jQuery = window.jQuery

        // Map over the $ in case of overwrite
        var _$ = window.$

        jQuery.noConflict = function (deep) {
          if (window.$ === jQuery) {
            window.$ = _$
          }

          if (deep && window.jQuery === jQuery) {
            window.jQuery = _jQuery
          }

          return jQuery
        }

        // Expose jQuery and $ identifiers, even in AMD
        // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
        // and CommonJS for browser emulators (#13566)
        if (typeof noGlobal === 'undefined') {
          window.jQuery = window.$ = jQuery
        }

        return jQuery
      })
      /***/
    },

  /***/
  1276:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var fixRegExpWellKnownSymbolLogic = __webpack_require__('d784')
      var isRegExp = __webpack_require__('44e7')
      var anObject = __webpack_require__('825a')
      var requireObjectCoercible = __webpack_require__('1d80')
      var speciesConstructor = __webpack_require__('4840')
      var advanceStringIndex = __webpack_require__('8aa5')
      var toLength = __webpack_require__('50c4')
      var callRegExpExec = __webpack_require__('14c3')
      var regexpExec = __webpack_require__('9263')
      var stickyHelpers = __webpack_require__('9f7f')
      var fails = __webpack_require__('d039')

      var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y
      var arrayPush = [].push
      var min = Math.min
      var MAX_UINT32 = 0xFFFFFFFF

      // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
      // Weex JS has frozen built-in prototypes, so use try / catch wrapper
      var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
        // eslint-disable-next-line regexp/no-empty-group -- required for testing
        var re = /(?:)/
        var originalExec = re.exec
        re.exec = function () {
          return originalExec.apply(this, arguments)
        }
        var result = 'ab'.split(re)
        return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b'
      })

      // @@split logic
      fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
        var internalSplit
        if (
          'abbc'.split(/(b)*/)[1] == 'c' ||
          // eslint-disable-next-line regexp/no-empty-group -- required for testing
          'test'.split(/(?:)/, -1).length != 4 ||
          'ab'.split(/(?:ab)*/).length != 2 ||
          '.'.split(/(.?)(.?)/).length != 4 ||
          // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
          '.'.split(/()()/).length > 1 ||
          ''.split(/.?/).length
        ) {
          // based on es5-shim implementation, need to rework it
          internalSplit = function (separator, limit) {
            var string = String(requireObjectCoercible(this))
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0
            if (lim === 0) return []
            if (separator === undefined) return [string]
            // If `separator` is not a regex, use native split
            if (!isRegExp(separator)) {
              return nativeSplit.call(string, separator, lim)
            }
            var output = []
            var flags = (separator.ignoreCase ? 'i' : '') +
              (separator.multiline ? 'm' : '') +
              (separator.unicode ? 'u' : '') +
              (separator.sticky ? 'y' : '')
            var lastLastIndex = 0
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + 'g')
            var match, lastIndex, lastLength
            while (match = regexpExec.call(separatorCopy, string)) {
              lastIndex = separatorCopy.lastIndex
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index))
                if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1))
                lastLength = match[0].length
                lastLastIndex = lastIndex
                if (output.length >= lim) break
              }
              if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++ // Avoid an infinite loop
            }
            if (lastLastIndex === string.length) {
              if (lastLength || !separatorCopy.test('')) output.push('')
            } else output.push(string.slice(lastLastIndex))
            return output.length > lim ? output.slice(0, lim) : output
          }
          // Chakra, V8
        } else if ('0'.split(undefined, 0).length) {
          internalSplit = function (separator, limit) {
            return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit)
          }
        } else internalSplit = nativeSplit

        return [
          // `String.prototype.split` method
          // https://tc39.es/ecma262/#sec-string.prototype.split
          function split(separator, limit) {
            var O = requireObjectCoercible(this)
            var splitter = separator == undefined ? undefined : separator[SPLIT]
            return splitter !== undefined
              ? splitter.call(separator, O, limit)
              : internalSplit.call(String(O), separator, limit)
          },
          // `RegExp.prototype[@@split]` method
          // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
          //
          // NOTE: This cannot be properly polyfilled in engines that don't support
          // the 'y' flag.
          function (string, limit) {
            var res = maybeCallNative(internalSplit, this, string, limit, internalSplit !== nativeSplit)
            if (res.done) return res.value

            var rx = anObject(this)
            var S = String(string)
            var C = speciesConstructor(rx, RegExp)

            var unicodeMatching = rx.unicode
            var flags = (rx.ignoreCase ? 'i' : '') +
              (rx.multiline ? 'm' : '') +
              (rx.unicode ? 'u' : '') +
              (UNSUPPORTED_Y ? 'g' : 'y')

            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags)
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0
            if (lim === 0) return []
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : []
            var p = 0
            var q = 0
            var A = []
            while (q < S.length) {
              splitter.lastIndex = UNSUPPORTED_Y ? 0 : q
              var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S)
              var e
              if (
                z === null ||
                (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
              ) {
                q = advanceStringIndex(S, q, unicodeMatching)
              } else {
                A.push(S.slice(p, q))
                if (A.length === lim) return A
                for (var i = 1; i <= z.length - 1; i++) {
                  A.push(z[i])
                  if (A.length === lim) return A
                }
                q = p = e
              }
            }
            A.push(S.slice(p))
            return A
          }
        ]
      }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y)
      /***/
    },

  /***/
  '129f':
    /***/
    function (module, exports) {
      // `SameValue` abstract operation
      // https://tc39.es/ecma262/#sec-samevalue
      // eslint-disable-next-line es/no-object-is -- safe
      module.exports = Object.is || function is(x, y) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y
      }
      /***/
    },

  /***/
  1393:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var $ = __webpack_require__('23e7')
      var createHTML = __webpack_require__('857a')
      var forcedStringHTMLMethod = __webpack_require__('af03')

      // `String.prototype.big` method
      // https://tc39.es/ecma262/#sec-string.prototype.big
      $({
        target: 'String',
        proto: true,
        forced: forcedStringHTMLMethod('big')
      }, {
        big: function big() {
          return createHTML(this, 'big', '', '')
        }
      })
      /***/
    },

  /***/
  '14c3':
    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__('c6b6')
      var regexpExec = __webpack_require__('9263')

      // `RegExpExec` abstract operation
      // https://tc39.es/ecma262/#sec-regexpexec
      module.exports = function (R, S) {
        var exec = R.exec
        if (typeof exec === 'function') {
          var result = exec.call(R, S)
          if (typeof result !== 'object') {
            throw TypeError('RegExp exec method returned something other than an Object or null')
          }
          return result
        }

        if (classof(R) !== 'RegExp') {
          throw TypeError('RegExp#exec called on incompatible receiver')
        }

        return regexpExec.call(R, S)
      }
      /***/
    },

  /***/
  '19aa':
    /***/
    function (module, exports) {
      module.exports = function (it, Constructor, name) {
        if (!(it instanceof Constructor)) {
          throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation')
        }
        return it
      }
      /***/
    },

  /***/
  '1be4':
    /***/
    function (module, exports, __webpack_require__) {
      var getBuiltIn = __webpack_require__('d066')

      module.exports = getBuiltIn('document', 'documentElement')
      /***/
    },

  /***/
  '1c0b':
    /***/
    function (module, exports) {
      module.exports = function (it) {
        if (typeof it !== 'function') {
          throw TypeError(String(it) + ' is not a function')
        }
        return it
      }
      /***/
    },

  /***/
  '1c7e':
    /***/
    function (module, exports, __webpack_require__) {
      var wellKnownSymbol = __webpack_require__('b622')

      var ITERATOR = wellKnownSymbol('iterator')
      var SAFE_CLOSING = false

      try {
        var called = 0
        var iteratorWithReturn = {
          next: function () {
            return {
              done: !!called++
            }
          },
          return: function () {
            SAFE_CLOSING = true
          }
        }
        iteratorWithReturn[ITERATOR] = function () {
          return this
        }
        // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
        Array.from(iteratorWithReturn, function () {
          throw 2
        })
      } catch (error) {
        /* empty */
      }

      module.exports = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false
        var ITERATION_SUPPORT = false
        try {
          var object = {}
          object[ITERATOR] = function () {
            return {
              next: function () {
                return {
                  done: ITERATION_SUPPORT = true
                }
              }
            }
          }
          exec(object)
        } catch (error) {
          /* empty */
        }
        return ITERATION_SUPPORT
      }
      /***/
    },

  /***/
  '1cdc':
    /***/
    function (module, exports, __webpack_require__) {
      var userAgent = __webpack_require__('342f')

      module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent)
      /***/
    },

  /***/
  '1d80':
    /***/
    function (module, exports) {
      // `RequireObjectCoercible` abstract operation
      // https://tc39.es/ecma262/#sec-requireobjectcoercible
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on " + it)
        return it
      }
      /***/
    },

  /***/
  '1dde':
    /***/
    function (module, exports, __webpack_require__) {
      var fails = __webpack_require__('d039')
      var wellKnownSymbol = __webpack_require__('b622')
      var V8_VERSION = __webpack_require__('2d00')

      var SPECIES = wellKnownSymbol('species')

      module.exports = function (METHOD_NAME) {
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/677
        return V8_VERSION >= 51 || !fails(function () {
          var array = []
          var constructor = array.constructor = {}
          constructor[SPECIES] = function () {
            return {
              foo: 1
            }
          }
          return array[METHOD_NAME](Boolean).foo !== 1
        })
      }
      /***/
    },

  /***/
  2266:
    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__('825a')
      var isArrayIteratorMethod = __webpack_require__('e95a')
      var toLength = __webpack_require__('50c4')
      var bind = __webpack_require__('0366')
      var getIteratorMethod = __webpack_require__('35a1')
      var iteratorClose = __webpack_require__('2a62')

      var Result = function (stopped, result) {
        this.stopped = stopped
        this.result = result
      }

      module.exports = function (iterable, unboundFunction, options) {
        var that = options && options.that
        var AS_ENTRIES = !!(options && options.AS_ENTRIES)
        var IS_ITERATOR = !!(options && options.IS_ITERATOR)
        var INTERRUPTED = !!(options && options.INTERRUPTED)
        var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED)
        var iterator, iterFn, index, length, result, next, step

        var stop = function (condition) {
          if (iterator) iteratorClose(iterator)
          return new Result(true, condition)
        }

        var callFn = function (value) {
          if (AS_ENTRIES) {
            anObject(value)
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1])
          }
          return INTERRUPTED ? fn(value, stop) : fn(value)
        }

        if (IS_ITERATOR) {
          iterator = iterable
        } else {
          iterFn = getIteratorMethod(iterable)
          if (typeof iterFn !== 'function') throw TypeError('Target is not iterable')
          // optimisation for array iterators
          if (isArrayIteratorMethod(iterFn)) {
            for (index = 0, length = toLength(iterable.length); length > index; index++) {
              result = callFn(iterable[index])
              if (result && result instanceof Result) return result
            }
            return new Result(false)
          }
          iterator = iterFn.call(iterable)
        }

        next = iterator.next
        while (!(step = next.call(iterator)).done) {
          try {
            result = callFn(step.value)
          } catch (error) {
            iteratorClose(iterator)
            throw error
          }
          if (typeof result === 'object' && result && result instanceof Result) return result
        }
        return new Result(false)
      }
      /***/
    },

  /***/
  '23cb':
    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__('a691')

      var max = Math.max
      var min = Math.min

      // Helper for a popular repeating case of the spec:
      // Let integer be ? ToInteger(index).
      // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
      module.exports = function (index, length) {
        var integer = toInteger(index)
        return integer < 0 ? max(integer + length, 0) : min(integer, length)
      }
      /***/
    },

  /***/
  '23e7':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')
      var getOwnPropertyDescriptor = __webpack_require__('06cf').f
      var createNonEnumerableProperty = __webpack_require__('9112')
      var redefine = __webpack_require__('6eeb')
      var setGlobal = __webpack_require__('ce4e')
      var copyConstructorProperties = __webpack_require__('e893')
      var isForced = __webpack_require__('94ca')

      /*
        options.target      - name of the target object
        options.global      - target is the global object
        options.stat        - export as static methods of target
        options.proto       - export as prototype methods of target
        options.real        - real prototype method for the `pure` version
        options.forced      - export even if the native feature is available
        options.bind        - bind methods to the target, required for the `pure` version
        options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
        options.unsafe      - use the simple assignment of property instead of delete + defineProperty
        options.sham        - add a flag to not completely full polyfills
        options.enumerable  - export as enumerable property
        options.noTargetGet - prevent calling a getter on target
      */
      module.exports = function (options, source) {
        var TARGET = options.target
        var GLOBAL = options.global
        var STATIC = options.stat
        var FORCED, target, key, targetProperty, sourceProperty, descriptor
        if (GLOBAL) {
          target = global
        } else if (STATIC) {
          target = global[TARGET] || setGlobal(TARGET, {})
        } else {
          target = (global[TARGET] || {}).prototype
        }
        if (target) {
          for (key in source) {
            sourceProperty = source[key]
            if (options.noTargetGet) {
              descriptor = getOwnPropertyDescriptor(target, key)
              targetProperty = descriptor && descriptor.value
            } else targetProperty = target[key]
            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced)
            // contained in target
            if (!FORCED && targetProperty !== undefined) {
              if (typeof sourceProperty === typeof targetProperty) continue
              copyConstructorProperties(sourceProperty, targetProperty)
            }
            // add a flag to not completely full polyfills
            if (options.sham || (targetProperty && targetProperty.sham)) {
              createNonEnumerableProperty(sourceProperty, 'sham', true)
            }
            // extend global
            redefine(target, key, sourceProperty, options)
          }
        }
      }
      /***/
    },

  /***/
  '241c':
    /***/
    function (module, exports, __webpack_require__) {
      var internalObjectKeys = __webpack_require__('ca84')
      var enumBugKeys = __webpack_require__('7839')

      var hiddenKeys = enumBugKeys.concat('length', 'prototype')

      // `Object.getOwnPropertyNames` method
      // https://tc39.es/ecma262/#sec-object.getownpropertynames
      // eslint-disable-next-line es/no-object-getownpropertynames -- safe
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return internalObjectKeys(O, hiddenKeys)
      }
      /***/
    },

  /***/
  '25f0':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var redefine = __webpack_require__('6eeb')
      var anObject = __webpack_require__('825a')
      var fails = __webpack_require__('d039')
      var flags = __webpack_require__('ad6d')

      var TO_STRING = 'toString'
      var RegExpPrototype = RegExp.prototype
      var nativeToString = RegExpPrototype[TO_STRING]

      var NOT_GENERIC = fails(function () {
        return nativeToString.call({
          source: 'a',
          flags: 'b'
        }) != '/a/b'
      })
      // FF44- RegExp#toString has a wrong name
      var INCORRECT_NAME = nativeToString.name != TO_STRING

      // `RegExp.prototype.toString` method
      // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
      if (NOT_GENERIC || INCORRECT_NAME) {
        redefine(RegExp.prototype, TO_STRING, function toString() {
          var R = anObject(this)
          var p = String(R.source)
          var rf = R.flags
          var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf)
          return '/' + p + '/' + f
        }, {
          unsafe: true
        })
      }
      /***/
    },

  /***/
  2626:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var getBuiltIn = __webpack_require__('d066')
      var definePropertyModule = __webpack_require__('9bf2')
      var wellKnownSymbol = __webpack_require__('b622')
      var DESCRIPTORS = __webpack_require__('83ab')

      var SPECIES = wellKnownSymbol('species')

      module.exports = function (CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn(CONSTRUCTOR_NAME)
        var defineProperty = definePropertyModule.f

        if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
          defineProperty(Constructor, SPECIES, {
            configurable: true,
            get: function () {
              return this
            }
          })
        }
      }
      /***/
    },

  /***/
  '2a62':
    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__('825a')

      module.exports = function (iterator) {
        var returnMethod = iterator.return
        if (returnMethod !== undefined) {
          return anObject(returnMethod.call(iterator)).value
        }
      }
      /***/
    },

  /***/
  '2cf4':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')
      var fails = __webpack_require__('d039')
      var bind = __webpack_require__('0366')
      var html = __webpack_require__('1be4')
      var createElement = __webpack_require__('cc12')
      var IS_IOS = __webpack_require__('1cdc')
      var IS_NODE = __webpack_require__('605d')

      var location = global.location
      var set = global.setImmediate
      var clear = global.clearImmediate
      var process = global.process
      var MessageChannel = global.MessageChannel
      var Dispatch = global.Dispatch
      var counter = 0
      var queue = {}
      var ONREADYSTATECHANGE = 'onreadystatechange'
      var defer, channel, port

      var run = function (id) {
        // eslint-disable-next-line no-prototype-builtins -- safe
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id]
          delete queue[id]
          fn()
        }
      }

      var runner = function (id) {
        return function () {
          run(id)
        }
      }

      var listener = function (event) {
        run(event.data)
      }

      var post = function (id) {
        // old engines have not location.origin
        global.postMessage(id + '', location.protocol + '//' + location.host)
      }

      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!set || !clear) {
        set = function setImmediate(fn) {
          var args = []
          var i = 1
          while (arguments.length > i) args.push(arguments[i++])
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func -- spec requirement
            (typeof fn === 'function' ? fn : Function(fn)).apply(undefined, args)
          }
          defer(counter)
          return counter
        }
        clear = function clearImmediate(id) {
          delete queue[id]
        }
        // Node.js 0.8-
        if (IS_NODE) {
          defer = function (id) {
            process.nextTick(runner(id))
          }
          // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(runner(id))
          }
          // Browsers with MessageChannel, includes WebWorkers
          // except iOS - https://github.com/zloirock/core-js/issues/624
        } else if (MessageChannel && !IS_IOS) {
          channel = new MessageChannel()
          port = channel.port2
          channel.port1.onmessage = listener
          defer = bind(port.postMessage, port, 1)
          // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (
          global.addEventListener &&
          typeof postMessage === 'function' &&
          !global.importScripts &&
          location && location.protocol !== 'file:' &&
          !fails(post)
        ) {
          defer = post
          global.addEventListener('message', listener, false)
          // IE8-
        } else if (ONREADYSTATECHANGE in createElement('script')) {
          defer = function (id) {
            html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this)
              run(id)
            }
          }
          // Rest old browsers
        } else {
          defer = function (id) {
            setTimeout(runner(id), 0)
          }
        }
      }

      module.exports = {
        set: set,
        clear: clear
      }
      /***/
    },

  /***/
  '2d00':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')
      var userAgent = __webpack_require__('342f')

      var process = global.process
      var versions = process && process.versions
      var v8 = versions && versions.v8
      var match, version

      if (v8) {
        match = v8.split('.')
        version = match[0] < 4 ? 1 : match[0] + match[1]
      } else if (userAgent) {
        match = userAgent.match(/Edge\/(\d+)/)
        if (!match || match[1] >= 74) {
          match = userAgent.match(/Chrome\/(\d+)/)
          if (match) version = match[1]
        }
      }

      module.exports = version && +version
      /***/
    },

  /***/
  '342f':
    /***/
    function (module, exports, __webpack_require__) {
      var getBuiltIn = __webpack_require__('d066')

      module.exports = getBuiltIn('navigator', 'userAgent') || ''
      /***/
    },

  /***/
  '35a1':
    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__('f5df')
      var Iterators = __webpack_require__('3f8c')
      var wellKnownSymbol = __webpack_require__('b622')

      var ITERATOR = wellKnownSymbol('iterator')

      module.exports = function (it) {
        if (it != undefined) {
          return it[ITERATOR] ||
            it['@@iterator'] ||
            Iterators[classof(it)]
        }
      }
      /***/
    },

  /***/
  '37e8':
    /***/
    function (module, exports, __webpack_require__) {
      var DESCRIPTORS = __webpack_require__('83ab')
      var definePropertyModule = __webpack_require__('9bf2')
      var anObject = __webpack_require__('825a')
      var objectKeys = __webpack_require__('df75')

      // `Object.defineProperties` method
      // https://tc39.es/ecma262/#sec-object.defineproperties
      // eslint-disable-next-line es/no-object-defineproperties -- safe
      module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O)
        var keys = objectKeys(Properties)
        var length = keys.length
        var index = 0
        var key
        while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key])
        return O
      }
      /***/
    },

  /***/
  '3bbe':
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__('861d')

      module.exports = function (it) {
        if (!isObject(it) && it !== null) {
          throw TypeError("Can't set " + String(it) + ' as a prototype')
        }
        return it
      }
      /***/
    },

  /***/
  '3c35':
    /***/
    function (module, exports) {
      /* WEBPACK VAR INJECTION */
      (function (__webpack_amd_options__) {
        /* globals __webpack_amd_options__ */
        module.exports = __webpack_amd_options__
        /* WEBPACK VAR INJECTION */
      }.call(this, {}))
      /***/
    },

  /***/
  '3ca3':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var charAt = __webpack_require__('6547').charAt
      var InternalStateModule = __webpack_require__('69f3')
      var defineIterator = __webpack_require__('7dd0')

      var STRING_ITERATOR = 'String Iterator'
      var setInternalState = InternalStateModule.set
      var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR)

      // `String.prototype[@@iterator]` method
      // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
      defineIterator(String, 'String', function (iterated) {
        setInternalState(this, {
          type: STRING_ITERATOR,
          string: String(iterated),
          index: 0
        })
        // `%StringIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
      }, function next() {
        var state = getInternalState(this)
        var string = state.string
        var index = state.index
        var point
        if (index >= string.length) {
          return {
            value: undefined,
            done: true
          }
        }
        point = charAt(string, index)
        state.index += point.length
        return {
          value: point,
          done: false
        }
      })
      /***/
    },

  /***/
  '3f8c':
    /***/
    function (module, exports) {
      module.exports = {}
      /***/
    },

  /***/
  '408a':
    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__('c6b6')

      // `thisNumberValue` abstract operation
      // https://tc39.es/ecma262/#sec-thisnumbervalue
      module.exports = function (value) {
        if (typeof value !== 'number' && classof(value) != 'Number') {
          throw TypeError('Incorrect invocation')
        }
        return +value
      }
      /***/
    },

  /***/
  '428f':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')

      module.exports = global
      /***/
    },

  /***/
  '44ad':
    /***/
    function (module, exports, __webpack_require__) {
      var fails = __webpack_require__('d039')
      var classof = __webpack_require__('c6b6')

      var split = ''.split

      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      module.exports = fails(function () {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
        return !Object('z').propertyIsEnumerable(0)
      }) ? function (it) {
        return classof(it) == 'String' ? split.call(it, '') : Object(it)
      } : Object
      /***/
    },

  /***/
  '44d2':
    /***/
    function (module, exports, __webpack_require__) {
      var wellKnownSymbol = __webpack_require__('b622')
      var create = __webpack_require__('7c73')
      var definePropertyModule = __webpack_require__('9bf2')

      var UNSCOPABLES = wellKnownSymbol('unscopables')
      var ArrayPrototype = Array.prototype

      // Array.prototype[@@unscopables]
      // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
      if (ArrayPrototype[UNSCOPABLES] == undefined) {
        definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
          configurable: true,
          value: create(null)
        })
      }

      // add a key to Array.prototype[@@unscopables]
      module.exports = function (key) {
        ArrayPrototype[UNSCOPABLES][key] = true
      }
      /***/
    },

  /***/
  '44de':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')

      module.exports = function (a, b) {
        var console = global.console
        if (console && console.error) {
          arguments.length === 1 ? console.error(a) : console.error(a, b)
        }
      }
      /***/
    },

  /***/
  '44e7':
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__('861d')
      var classof = __webpack_require__('c6b6')
      var wellKnownSymbol = __webpack_require__('b622')

      var MATCH = wellKnownSymbol('match')

      // `IsRegExp` abstract operation
      // https://tc39.es/ecma262/#sec-isregexp
      module.exports = function (it) {
        var isRegExp
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp')
      }
      /***/
    },

  /***/
  4840:
    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__('825a')
      var aFunction = __webpack_require__('1c0b')
      var wellKnownSymbol = __webpack_require__('b622')

      var SPECIES = wellKnownSymbol('species')

      // `SpeciesConstructor` abstract operation
      // https://tc39.es/ecma262/#sec-speciesconstructor
      module.exports = function (O, defaultConstructor) {
        var C = anObject(O).constructor
        var S
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S)
      }
      /***/
    },

  /***/
  4930:
    /***/
    function (module, exports, __webpack_require__) {
      /* eslint-disable es/no-symbol -- required for testing */
      var V8_VERSION = __webpack_require__('2d00')
      var fails = __webpack_require__('d039')

      // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
      module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
        var symbol = Symbol()
        // Chrome 38 Symbol has incorrect toString conversion
        // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
        return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
          // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
          !Symbol.sham && V8_VERSION && V8_VERSION < 41
      })
      /***/
    },

  /***/
  '4d64':
    /***/
    function (module, exports, __webpack_require__) {
      var toIndexedObject = __webpack_require__('fc6a')
      var toLength = __webpack_require__('50c4')
      var toAbsoluteIndex = __webpack_require__('23cb')

      // `Array.prototype.{ indexOf, includes }` methods implementation
      var createMethod = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIndexedObject($this)
          var length = toLength(O.length)
          var index = toAbsoluteIndex(fromIndex, length)
          var value
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare -- NaN check
          if (IS_INCLUDES && el != el) {
            while (length > index) {
              value = O[index++]
              // eslint-disable-next-line no-self-compare -- NaN check
              if (value != value) return true
              // Array#indexOf ignores holes, Array#includes - not
            }
          } else {
            for (; length > index; index++) {
              if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0
            }
          }
          return !IS_INCLUDES && -1
        }
      }

      module.exports = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod(false)
      }
      /***/
    },

  /***/
  '4df4':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var bind = __webpack_require__('0366')
      var toObject = __webpack_require__('7b0b')
      var callWithSafeIterationClosing = __webpack_require__('9bdd')
      var isArrayIteratorMethod = __webpack_require__('e95a')
      var toLength = __webpack_require__('50c4')
      var createProperty = __webpack_require__('8418')
      var getIteratorMethod = __webpack_require__('35a1')

      // `Array.from` method implementation
      // https://tc39.es/ecma262/#sec-array.from
      module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
        var O = toObject(arrayLike)
        var C = typeof this === 'function' ? this : Array
        var argumentsLength = arguments.length
        var mapfn = argumentsLength > 1 ? arguments[1] : undefined
        var mapping = mapfn !== undefined
        var iteratorMethod = getIteratorMethod(O)
        var index = 0
        var length, result, step, iterator, next, value
        if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2)
        // if the target is not iterable or it's an array with the default iterator - use a simple case
        if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
          iterator = iteratorMethod.call(O)
          next = iterator.next
          result = new C()
          for (; !(step = next.call(iterator)).done; index++) {
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value
            createProperty(result, index, value)
          }
        } else {
          length = toLength(O.length)
          result = new C(length)
          for (; length > index; index++) {
            value = mapping ? mapfn(O[index], index) : O[index]
            createProperty(result, index, value)
          }
        }
        result.length = index
        return result
      }
      /***/
    },

  /***/
  '50c4':
    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__('a691')

      var min = Math.min

      // `ToLength` abstract operation
      // https://tc39.es/ecma262/#sec-tolength
      module.exports = function (argument) {
        return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0 // 2 ** 53 - 1 == 9007199254740991
      }
      /***/
    },

  /***/
  5135:
    /***/
    function (module, exports, __webpack_require__) {
      var toObject = __webpack_require__('7b0b')

      var hasOwnProperty = {}.hasOwnProperty

      module.exports = Object.hasOwn || function hasOwn(it, key) {
        return hasOwnProperty.call(toObject(it), key)
      }
      /***/
    },

  /***/
  5319:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var fixRegExpWellKnownSymbolLogic = __webpack_require__('d784')
      var fails = __webpack_require__('d039')
      var anObject = __webpack_require__('825a')
      var toLength = __webpack_require__('50c4')
      var toInteger = __webpack_require__('a691')
      var requireObjectCoercible = __webpack_require__('1d80')
      var advanceStringIndex = __webpack_require__('8aa5')
      var getSubstitution = __webpack_require__('0cb2')
      var regExpExec = __webpack_require__('14c3')
      var wellKnownSymbol = __webpack_require__('b622')

      var REPLACE = wellKnownSymbol('replace')
      var max = Math.max
      var min = Math.min

      var maybeToString = function (it) {
        return it === undefined ? it : String(it)
      }

      // IE <= 11 replaces $0 with the whole match, as if it was $&
      // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
      var REPLACE_KEEPS_$0 = (function () {
        // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
        return 'a'.replace(/./, '$0') === '$0'
      })()

      // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
      var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
        if (/./[REPLACE]) {
          return /./[REPLACE]('a', '$0') === ''
        }
        return false
      })()

      var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
        var re = /./
        re.exec = function () {
          var result = []
          result.groups = {
            a: '7'
          }
          return result
        }
        return ''.replace(re, '$<a>') !== '7'
      })

      // @@replace logic
      fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
        var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0'

        return [
          // `String.prototype.replace` method
          // https://tc39.es/ecma262/#sec-string.prototype.replace
          function replace(searchValue, replaceValue) {
            var O = requireObjectCoercible(this)
            var replacer = searchValue == undefined ? undefined : searchValue[REPLACE]
            return replacer !== undefined
              ? replacer.call(searchValue, O, replaceValue)
              : nativeReplace.call(String(O), searchValue, replaceValue)
          },
          // `RegExp.prototype[@@replace]` method
          // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
          function (string, replaceValue) {
            if (
              typeof replaceValue === 'string' &&
              replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
              replaceValue.indexOf('$<') === -1
            ) {
              var res = maybeCallNative(nativeReplace, this, string, replaceValue)
              if (res.done) return res.value
            }

            var rx = anObject(this)
            var S = String(string)

            var functionalReplace = typeof replaceValue === 'function'
            if (!functionalReplace) replaceValue = String(replaceValue)

            var global = rx.global
            if (global) {
              var fullUnicode = rx.unicode
              rx.lastIndex = 0
            }
            var results = []
            while (true) {
              var result = regExpExec(rx, S)
              if (result === null) break

              results.push(result)
              if (!global) break

              var matchStr = String(result[0])
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode)
            }

            var accumulatedResult = ''
            var nextSourcePosition = 0
            for (var i = 0; i < results.length; i++) {
              result = results[i]

              var matched = String(result[0])
              var position = max(min(toInteger(result.index), S.length), 0)
              var captures = []
              // NOTE: This is equivalent to
              //   captures = result.slice(1).map(maybeToString)
              // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
              // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
              // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
              for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]))
              var namedCaptures = result.groups
              if (functionalReplace) {
                var replacerArgs = [matched].concat(captures, position, S)
                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures)
                var replacement = String(replaceValue.apply(undefined, replacerArgs))
              } else {
                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue)
              }
              if (position >= nextSourcePosition) {
                accumulatedResult += S.slice(nextSourcePosition, position) + replacement
                nextSourcePosition = position + matched.length
              }
            }
            return accumulatedResult + S.slice(nextSourcePosition)
          }
        ]
      }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE)
      /***/
    },

  /***/
  5692:
    /***/
    function (module, exports, __webpack_require__) {
      var IS_PURE = __webpack_require__('c430')
      var store = __webpack_require__('c6cd');

      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {})
      })('versions', []).push({
        version: '3.15.1',
        mode: IS_PURE ? 'pure' : 'global',
        copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
      })
      /***/
    },

  /***/
  '56ef':
    /***/
    function (module, exports, __webpack_require__) {
      var getBuiltIn = __webpack_require__('d066')
      var getOwnPropertyNamesModule = __webpack_require__('241c')
      var getOwnPropertySymbolsModule = __webpack_require__('7418')
      var anObject = __webpack_require__('825a')

      // all object keys, includes non-enumerable and symbols
      module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = getOwnPropertyNamesModule.f(anObject(it))
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys
      }
      /***/
    },

  /***/
  5899:
    /***/
    function (module, exports) {
      // a string of all valid unicode whitespaces
      module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
        '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
      /***/
    },

  /***/
  '58a8':
    /***/
    function (module, exports, __webpack_require__) {
      var requireObjectCoercible = __webpack_require__('1d80')
      var whitespaces = __webpack_require__('5899')

      var whitespace = '[' + whitespaces + ']'
      var ltrim = RegExp('^' + whitespace + whitespace + '*')
      var rtrim = RegExp(whitespace + whitespace + '*$')

      // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
      var createMethod = function (TYPE) {
        return function ($this) {
          var string = String(requireObjectCoercible($this))
          if (TYPE & 1) string = string.replace(ltrim, '')
          if (TYPE & 2) string = string.replace(rtrim, '')
          return string
        }
      }

      module.exports = {
        // `String.prototype.{ trimLeft, trimStart }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimstart
        start: createMethod(1),
        // `String.prototype.{ trimRight, trimEnd }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimend
        end: createMethod(2),
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        trim: createMethod(3)
      }
      /***/
    },

  /***/
  '5c6c':
    /***/
    function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        }
      }
      /***/
    },

  /***/
  '605d':
    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__('c6b6')
      var global = __webpack_require__('da84')

      module.exports = classof(global.process) == 'process'
      /***/
    },

  /***/
  6069:
    /***/
    function (module, exports) {
      module.exports = typeof window === 'object'
      /***/
    },

  /***/
  6547:
    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__('a691')
      var requireObjectCoercible = __webpack_require__('1d80')

      // `String.prototype.{ codePointAt, at }` methods implementation
      var createMethod = function (CONVERT_TO_STRING) {
        return function ($this, pos) {
          var S = String(requireObjectCoercible($this))
          var position = toInteger(pos)
          var size = S.length
          var first, second
          if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined
          first = S.charCodeAt(position)
          return first < 0xD800 || first > 0xDBFF || position + 1 === size ||
            (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
            ? CONVERT_TO_STRING ? S.charAt(position) : first
            : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000
        }
      }

      module.exports = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod(true)
      }
      /***/
    },

  /***/
  '65f0':
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__('861d')
      var isArray = __webpack_require__('e8b5')
      var wellKnownSymbol = __webpack_require__('b622')

      var SPECIES = wellKnownSymbol('species')

      // `ArraySpeciesCreate` abstract operation
      // https://tc39.es/ecma262/#sec-arrayspeciescreate
      module.exports = function (originalArray, length) {
        var C
        if (isArray(originalArray)) {
          C = originalArray.constructor
          // cross-realm fallback
          if (typeof C === 'function' && (C === Array || isArray(C.prototype))) C = undefined
          else if (isObject(C)) {
            C = C[SPECIES]
            if (C === null) C = undefined
          }
        }
        return new (C === undefined ? Array : C)(length === 0 ? 0 : length)
      }
      /***/
    },

  /***/
  '69f3':
    /***/
    function (module, exports, __webpack_require__) {
      var NATIVE_WEAK_MAP = __webpack_require__('7f9a')
      var global = __webpack_require__('da84')
      var isObject = __webpack_require__('861d')
      var createNonEnumerableProperty = __webpack_require__('9112')
      var objectHas = __webpack_require__('5135')
      var shared = __webpack_require__('c6cd')
      var sharedKey = __webpack_require__('f772')
      var hiddenKeys = __webpack_require__('d012')

      var OBJECT_ALREADY_INITIALIZED = 'Object already initialized'
      var WeakMap = global.WeakMap
      var set, get, has

      var enforce = function (it) {
        return has(it) ? get(it) : set(it, {})
      }

      var getterFor = function (TYPE) {
        return function (it) {
          var state
          if (!isObject(it) || (state = get(it)).type !== TYPE) {
            throw TypeError('Incompatible receiver, ' + TYPE + ' required')
          }
          return state
        }
      }

      if (NATIVE_WEAK_MAP || shared.state) {
        var store = shared.state || (shared.state = new WeakMap())
        var wmget = store.get
        var wmhas = store.has
        var wmset = store.set
        set = function (it, metadata) {
          if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED)
          metadata.facade = it
          wmset.call(store, it, metadata)
          return metadata
        }
        get = function (it) {
          return wmget.call(store, it) || {}
        }
        has = function (it) {
          return wmhas.call(store, it)
        }
      } else {
        var STATE = sharedKey('state')
        hiddenKeys[STATE] = true
        set = function (it, metadata) {
          if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED)
          metadata.facade = it
          createNonEnumerableProperty(it, STATE, metadata)
          return metadata
        }
        get = function (it) {
          return objectHas(it, STATE) ? it[STATE] : {}
        }
        has = function (it) {
          return objectHas(it, STATE)
        }
      }

      module.exports = {
        set: set,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
      }
      /***/
    },

  /***/
  '6eeb':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')
      var createNonEnumerableProperty = __webpack_require__('9112')
      var has = __webpack_require__('5135')
      var setGlobal = __webpack_require__('ce4e')
      var inspectSource = __webpack_require__('8925')
      var InternalStateModule = __webpack_require__('69f3')

      var getInternalState = InternalStateModule.get
      var enforceInternalState = InternalStateModule.enforce
      var TEMPLATE = String(String).split('String');

      (module.exports = function (O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false
        var simple = options ? !!options.enumerable : false
        var noTargetGet = options ? !!options.noTargetGet : false
        var state
        if (typeof value === 'function') {
          if (typeof key === 'string' && !has(value, 'name')) {
            createNonEnumerableProperty(value, 'name', key)
          }
          state = enforceInternalState(value)
          if (!state.source) {
            state.source = TEMPLATE.join(typeof key === 'string' ? key : '')
          }
        }
        if (O === global) {
          if (simple) O[key] = value
          else setGlobal(key, value)
          return
        } else if (!unsafe) {
          delete O[key]
        } else if (!noTargetGet && O[key]) {
          simple = true
        }
        if (simple) O[key] = value
        else createNonEnumerableProperty(O, key, value)
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
      })(Function.prototype, 'toString', function toString() {
        return typeof this === 'function' && getInternalState(this).source || inspectSource(this)
      })
      /***/
    },

  /***/
  7037:
    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__('a4d3')

      __webpack_require__('e01a')

      __webpack_require__('d3b7')

      __webpack_require__('d28b')

      __webpack_require__('e260')

      __webpack_require__('3ca3')

      __webpack_require__('ddb0')

      function _typeof(obj) {
        '@babel/helpers - typeof'

        if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
          module.exports = _typeof = function _typeof(obj) {
            return typeof obj
          }

          module.exports.default = module.exports, module.exports.__esModule = true
        } else {
          module.exports = _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
          }

          module.exports.default = module.exports, module.exports.__esModule = true
        }

        return _typeof(obj)
      }

      module.exports = _typeof
      module.exports.default = module.exports, module.exports.__esModule = true
      /***/
    },

  /***/
  7156:
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__('861d')
      var setPrototypeOf = __webpack_require__('d2bb')

      // makes subclassing work correct for wrapped built-ins
      module.exports = function ($this, dummy, Wrapper) {
        var NewTarget, NewTargetPrototype
        if (
          // it can work only with native `setPrototypeOf`
          setPrototypeOf &&
          // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
          typeof (NewTarget = dummy.constructor) === 'function' &&
          NewTarget !== Wrapper &&
          isObject(NewTargetPrototype = NewTarget.prototype) &&
          NewTargetPrototype !== Wrapper.prototype
        ) setPrototypeOf($this, NewTargetPrototype)
        return $this
      }
      /***/
    },

  /***/
  7418:
    /***/
    function (module, exports) {
      // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
      exports.f = Object.getOwnPropertySymbols
      /***/
    },

  /***/
  '746f':
    /***/
    function (module, exports, __webpack_require__) {
      var path = __webpack_require__('428f')
      var has = __webpack_require__('5135')
      var wrappedWellKnownSymbolModule = __webpack_require__('e538')
      var defineProperty = __webpack_require__('9bf2').f

      module.exports = function (NAME) {
        var Symbol = path.Symbol || (path.Symbol = {})
        if (!has(Symbol, NAME)) {
          defineProperty(Symbol, NAME, {
            value: wrappedWellKnownSymbolModule.f(NAME)
          })
        }
      }
      /***/
    },

  /***/
  7839:
    /***/
    function (module, exports) {
      // IE8- don't enum bug keys
      module.exports = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf'
      ]
      /***/
    },

  /***/
  '7b0b':
    /***/
    function (module, exports, __webpack_require__) {
      var requireObjectCoercible = __webpack_require__('1d80')

      // `ToObject` abstract operation
      // https://tc39.es/ecma262/#sec-toobject
      module.exports = function (argument) {
        return Object(requireObjectCoercible(argument))
      }
      /***/
    },

  /***/
  '7c73':
    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__('825a')
      var defineProperties = __webpack_require__('37e8')
      var enumBugKeys = __webpack_require__('7839')
      var hiddenKeys = __webpack_require__('d012')
      var html = __webpack_require__('1be4')
      var documentCreateElement = __webpack_require__('cc12')
      var sharedKey = __webpack_require__('f772')

      var GT = '>'
      var LT = '<'
      var PROTOTYPE = 'prototype'
      var SCRIPT = 'script'
      var IE_PROTO = sharedKey('IE_PROTO')

      var EmptyConstructor = function () {
        /* empty */
      }

      var scriptTag = function (content) {
        return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT
      }

      // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
      var NullProtoObjectViaActiveX = function (activeXDocument) {
        activeXDocument.write(scriptTag(''))
        activeXDocument.close()
        var temp = activeXDocument.parentWindow.Object
        activeXDocument = null // avoid memory leak
        return temp
      }

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var NullProtoObjectViaIFrame = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe')
        var JS = 'java' + SCRIPT + ':'
        var iframeDocument
        iframe.style.display = 'none'
        html.appendChild(iframe)
        // https://github.com/zloirock/core-js/issues/475
        iframe.src = String(JS)
        iframeDocument = iframe.contentWindow.document
        iframeDocument.open()
        iframeDocument.write(scriptTag('document.F=Object'))
        iframeDocument.close()
        return iframeDocument.F
      }

      // Check for document.domain and active x support
      // No need to use active x approach when document.domain is not set
      // see https://github.com/es-shims/es5-shim/issues/150
      // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
      // avoid IE GC bug
      var activeXDocument
      var NullProtoObject = function () {
        try {
          /* global ActiveXObject -- old IE */
          activeXDocument = document.domain && new ActiveXObject('htmlfile')
        } catch (error) {
          /* ignore */
        }
        NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame()
        var length = enumBugKeys.length
        while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]]
        return NullProtoObject()
      }

      hiddenKeys[IE_PROTO] = true

      // `Object.create` method
      // https://tc39.es/ecma262/#sec-object.create
      module.exports = Object.create || function create(O, Properties) {
        var result
        if (O !== null) {
          EmptyConstructor[PROTOTYPE] = anObject(O)
          result = new EmptyConstructor()
          EmptyConstructor[PROTOTYPE] = null
          // add "__proto__" for Object.getPrototypeOf polyfill
          result[IE_PROTO] = O
        } else result = NullProtoObject()
        return Properties === undefined ? result : defineProperties(result, Properties)
      }
      /***/
    },

  /***/
  '7db0':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var $ = __webpack_require__('23e7')
      var $find = __webpack_require__('b727').find
      var addToUnscopables = __webpack_require__('44d2')

      var FIND = 'find'
      var SKIPS_HOLES = true

      // Shouldn't skip holes
      if (FIND in []) {
        Array(1)[FIND](function () {
          SKIPS_HOLES = false
        })
      }

      // `Array.prototype.find` method
      // https://tc39.es/ecma262/#sec-array.prototype.find
      $({
        target: 'Array',
        proto: true,
        forced: SKIPS_HOLES
      }, {
        find: function find(callbackfn /* , that = undefined */) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined)
        }
      })

      // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
      addToUnscopables(FIND)
      /***/
    },

  /***/
  '7dd0':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var $ = __webpack_require__('23e7')
      var createIteratorConstructor = __webpack_require__('9ed3')
      var getPrototypeOf = __webpack_require__('e163')
      var setPrototypeOf = __webpack_require__('d2bb')
      var setToStringTag = __webpack_require__('d44e')
      var createNonEnumerableProperty = __webpack_require__('9112')
      var redefine = __webpack_require__('6eeb')
      var wellKnownSymbol = __webpack_require__('b622')
      var IS_PURE = __webpack_require__('c430')
      var Iterators = __webpack_require__('3f8c')
      var IteratorsCore = __webpack_require__('ae93')

      var IteratorPrototype = IteratorsCore.IteratorPrototype
      var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS
      var ITERATOR = wellKnownSymbol('iterator')
      var KEYS = 'keys'
      var VALUES = 'values'
      var ENTRIES = 'entries'

      var returnThis = function () {
        return this
      }

      module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next)

        var getIterationMethod = function (KIND) {
          if (KIND === DEFAULT && defaultIterator) return defaultIterator
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND]
          switch (KIND) {
            case KEYS:
              return function keys() {
                return new IteratorConstructor(this, KIND)
              }
            case VALUES:
              return function values() {
                return new IteratorConstructor(this, KIND)
              }
            case ENTRIES:
              return function entries() {
                return new IteratorConstructor(this, KIND)
              }
          }
          return function () {
            return new IteratorConstructor(this)
          }
        }

        var TO_STRING_TAG = NAME + ' Iterator'
        var INCORRECT_VALUES_NAME = false
        var IterablePrototype = Iterable.prototype
        var nativeIterator = IterablePrototype[ITERATOR] ||
          IterablePrototype['@@iterator'] ||
          DEFAULT && IterablePrototype[DEFAULT]
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT)
        var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator
        var CurrentIteratorPrototype, methods, KEY

        // fix native
        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()))
          if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf) {
                setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype)
              } else if (typeof CurrentIteratorPrototype[ITERATOR] !== 'function') {
                createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis)
              }
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true)
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis
          }
        }

        // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          INCORRECT_VALUES_NAME = true
          defaultIterator = function values() {
            return nativeIterator.call(this)
          }
        }

        // define iterator
        if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
          createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator)
        }
        Iterators[NAME] = defaultIterator

        // export additional methods
        if (DEFAULT) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          }
          if (FORCED) {
            for (KEY in methods) {
              if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                redefine(IterablePrototype, KEY, methods[KEY])
              }
            }
          } else {
            $({
              target: NAME,
              proto: true,
              forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods)
          }
        }

        return methods
      }
      /***/
    },

  /***/
  '7f9a':
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__('da84')
      var inspectSource = __webpack_require__('8925')

      var WeakMap = global.WeakMap

      module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap))
      /***/
    },

  /***/
  '825a':
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__('861d')

      module.exports = function (it) {
        if (!isObject(it)) {
          throw TypeError(String(it) + ' is not an object')
        }
        return it
      }
      /***/
    },

  /***/
  '83ab':
    /***/
    function (module, exports, __webpack_require__) {
      var fails = __webpack_require__('d039')

      // Detect IE8's incomplete defineProperty implementation
      module.exports = !fails(function () {
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        return Object.defineProperty({}, 1, {
          get: function () {
            return 7
          }
        })[1] != 7
      })
      /***/
    },

  /***/
  8418:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var toPrimitive = __webpack_require__('c04e')
      var definePropertyModule = __webpack_require__('9bf2')
      var createPropertyDescriptor = __webpack_require__('5c6c')

      module.exports = function (object, key, value) {
        var propertyKey = toPrimitive(key)
        if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value))
        else object[propertyKey] = value
      }
      /***/
    },

  /***/
  '841c':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var fixRegExpWellKnownSymbolLogic = __webpack_require__('d784')
      var anObject = __webpack_require__('825a')
      var requireObjectCoercible = __webpack_require__('1d80')
      var sameValue = __webpack_require__('129f')
      var regExpExec = __webpack_require__('14c3')

      // @@search logic
      fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
        return [
          // `String.prototype.search` method
          // https://tc39.es/ecma262/#sec-string.prototype.search
          function search(regexp) {
            var O = requireObjectCoercible(this)
            var searcher = regexp == undefined ? undefined : regexp[SEARCH]
            return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O))
          },
          // `RegExp.prototype[@@search]` method
          // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
          function (string) {
            var res = maybeCallNative(nativeSearch, this, string)
            if (res.done) return res.value

            var rx = anObject(this)
            var S = String(string)

            var previousLastIndex = rx.lastIndex
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0
            var result = regExpExec(rx, S)
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex
            return result === null ? -1 : result.index
          }
        ]
      })
      /***/
    },

  /***/
  '857a':
    /***/
    function (module, exports, __webpack_require__) {
      var requireObjectCoercible = __webpack_require__('1d80')

      var quot = /"/g

      // `CreateHTML` abstract operation
      // https://tc39.es/ecma262/#sec-createhtml
      module.exports = function (string, tag, attribute, value) {
        var S = String(requireObjectCoercible(string))
        var p1 = '<' + tag
        if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"'
        return p1 + '>' + S + '</' + tag + '>'
      }
      /***/
    },

  /***/
  '861d':
    /***/
    function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function'
      }
      /***/
    },

  /***/
  8875:
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // addapted from the document.currentScript polyfill by Adam Miller
      // MIT license
      // source: https://github.com/amiller-gh/currentScript-polyfill

      // added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

      (function (root, factory) {
        if (true) {
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
            __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        } else {}
      }(typeof self !== 'undefined' ? self : this, function () {
        function getCurrentScript() {
          var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
          // for chrome
          if (!descriptor && 'currentScript' in document && document.currentScript) {
            return document.currentScript
          }

          // for other browsers with native support for currentScript
          if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
            return document.currentScript
          }

          // IE 8-10 support script readyState
          // IE 11+ & Firefox support stack trace
          try {
            throw new Error()
          } catch (err) {
            // Find the second match for the "at" string to get file src url from stack.
            var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig
            var ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig
            var stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack)
            var scriptLocation = (stackDetails && stackDetails[1]) || false
            var line = (stackDetails && stackDetails[2]) || false
            var currentLocation = document.location.href.replace(document.location.hash, '')
            var pageSource
            var inlineScriptSourceRegExp
            var inlineScriptSource
            var scripts = document.getElementsByTagName('script') // Live NodeList collection

            if (scriptLocation === currentLocation) {
              pageSource = document.documentElement.outerHTML
              inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i')
              inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim()
            }

            for (var i = 0; i < scripts.length; i++) {
              // If ready state is interactive, return the script tag
              if (scripts[i].readyState === 'interactive') {
                return scripts[i]
              }

              // If src matches, return the script tag
              if (scripts[i].src === scriptLocation) {
                return scripts[i]
              }

              // If inline source matches, return the script tag
              if (
                scriptLocation === currentLocation &&
                scripts[i].innerHTML &&
                scripts[i].innerHTML.trim() === inlineScriptSource
              ) {
                return scripts[i]
              }
            }

            // If no match, return null
            return null
          }
        }

        return getCurrentScript
      }))
      /***/
    },

  /***/
  8925:
    /***/
    function (module, exports, __webpack_require__) {
      var store = __webpack_require__('c6cd')

      var functionToString = Function.toString

      // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
      if (typeof store.inspectSource !== 'function') {
        store.inspectSource = function (it) {
          return functionToString.call(it)
        }
      }

      module.exports = store.inspectSource
      /***/
    },

  /***/
  '8aa5':
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      var charAt = __webpack_require__('6547').charAt

      // `AdvanceStringIndex` abstract operation
      // https://tc39.es/ecma262/#sec-advancestringindex
      module.exports = function (S, index, unicode) {
        return index + (unicode ? charAt(S, index).length : 1)
      }
      /***/
    },

  /***/
  '8bbf':
    /***/
    function (module, exports) {
      module.exports = require('vue')
      /***/
    },

  /***/
  '90e3':
    /***/
    function (module, exports) {
      var id = 0
      var postfix = Math.random()

      module.exports = function (key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36)
      }
      /***/
    },

  /***/
  9112:
    /***/
    function (module, exports, __webpack_require__) {
      var DESCRIPTORS = __webpack_require__('83ab')
      var definePropertyModule = __webpack_require__('9bf2')
      var createPropertyDescriptor = __webpack_require__('5c6c')

      module.exports = DESCRIPTORS ? function (object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value))
      } : function (object, key, value) {
        object[key] = value
        return object
      }
      /***/
    },

  /***/
  9263:
    /***/
    function (module, exports, __webpack_require__) {
      'use strict'

      /* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
      /* eslint-disable regexp/no-useless-quantifier -- testing */
      var regexpFlags = __webpack_require__('ad6d')
      var stickyHelpers = __webpack_require__('9f7f')
      var shared = __webpack_require__('5692')
      var create = __webpack_require__('7c73')
      var getInternalState = __webpack_require__('69f3').get
      var UNSUPPORTED_DOT_ALL = __webpack_require__('fce3')
      var UNSUPPORTED_NCG = __webpack_require__('107c')

      var nativeExec = RegExp.prototype.exec
      var nativeReplace = shared('native-string-replace', String.prototype.replace)

      var patchedExec = nativeExec

      var UPDATES_LAST_INDEX_WRONG = (function () {
        var re1 = /a/
        var re2 = /b*/g
        nativeExec.call(re1, 'a')
        nativeExec.call(re2, 'a')
        return re1.lastIndex !== 0 || re2.lastIndex !== 0
      })()

      var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET

      // nonparticipating capturing group, copied from es5-shim's String#split patch.
      var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined

      var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG

      if (PATCH) {
        // eslint-disable-next-line max-statements -- TODO
        patchedExec = function exec(str) {
          var re = this
          var state = getInternalState(re)
          var raw = state.raw
          var result, reCopy, lastIndex, match, i, object, group

          if (raw) {
            raw.lastIndex = re.lastIndex
            result = patchedExec.call(raw, str)
            re.lastIndex = raw.lastIndex
            return result
          }

          var groups = state.groups
          var sticky = UNSUPPORTED_Y && re.sticky
          var flags = regexpFlags.call(re)
          var source = re.source
          var charsAdded = 0
          var strCopy = str

          if (sticky) {
            flags = flags.replace('y', '')
            if (flags.indexOf('g') === -1) {
              flags += 'g'
            }

            strCopy = String(str).slice(re.lastIndex)
            // Support anchored sticky behavior.
            if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
              source = '(?: ' + source + ')'
              strCopy = ' ' + strCopy
              charsAdded++
            }
            // ^(? + rx + ) is needed, in combination with some str slicing, to
            // simulate the 'y' flag.
            reCopy = new RegExp('^(?:' + source + ')', flags)
          }

          if (NPCG_INCLUDED) {
            reCopy = new RegExp('^' + source + '$(?!\\s)', flags)
          }
          if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex

          match = nativeExec.call(sticky ? reCopy : re, strCopy)

          if (sticky) {
            if (match) {
              match.input = match.input.slice(charsAdded)
              match[0] = match[0].slice(charsAdded)
              match.index = re.lastIndex
              re.lastIndex += match[0].length
            } else re.lastIndex = 0
          } else if (UPDATES_LAST_INDEX_WRONG && match) {
            re.lastIndex = re.global ? match.index + match[0].length : lastIndex
          }
          if (NPCG_INCLUDED && match && match.length > 1) {
            // Fix browsers whose `exec` methods don't consistently return `undefined`
            // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
            nativeReplace.call(match[0], reCopy, function () {
              for (i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === undefined) match[i] = undefined
              }
            })
          }

          if (match && groups) {
            match.groups = object = create(null)
            for (i = 0; i < groups.length; i++) {
              group = groups[i]
              object[group[0]] = match[group[1]]
            }
          }

          return match
        }
      }

      module.exports = patchedExec
      /***/
    },

  /***/
  '94ca':
    /***/
    function (module, exports, __webpack_require__) {
      var fails = __webpack_require__('d039')

      var replacement = /#|\.prototype\./

      var isForced = function (feature, detection) {
        var value = data[normalize(feature)]
        return value == POLYFILL ? true
          : value == NATIVE ? false
          : typeof detection === 'function' ? fails(detection)
          : !!detection
      }

      var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase()
      }

      var data = isForced.data = {}
      var NATIVE = isForced.NATIVE = 'N'
      var POLYFILL = isForced.POLYFILL = 'P'

      module.exports = isForced
      /***/
    },

  /***/
  '951d':
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__
      var _typeof = __webpack_require__('7037').default

      __webpack_require__('ac1f')

      __webpack_require__('841c')

      __webpack_require__('d3b7')

      __webpack_require__('25f0')

      __webpack_require__('1276')

      __webpack_require__('fb6a')

      __webpack_require__('99af')

      __webpack_require__('e260')

      __webpack_require__('ddb0')

      __webpack_require__('7db0')

      __webpack_require__('b680')

      __webpack_require__('1393')

      __webpack_require__('5319')

      __webpack_require__('a9e3')

      /* eslint-disable */
      // Ion.RangeSlider
      // version 2.3.1 Build: 382
      // © Denis Ineshin, 2019
      // https://github.com/IonDen
      //
      // Project page:    http://ionden.com/a/plugins/ion.rangeSlider/en.html
      // GitHub page:     https://github.com/IonDen/ion.rangeSlider
      //
      // Released under MIT licence:
      // http://ionden.com/a/plugins/licence-en.html
      // =====================================================================================================================
      var jQuery = __webpack_require__("1157");

      (function (factory) {
        if ((typeof jQuery === 'undefined' || !jQuery) && "function" === 'function' && __webpack_require__("3c35")) {
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("1157")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (jQuery) {
              return factory(jQuery, document, window, navigator);
            }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if ((typeof jQuery === 'undefined' || !jQuery) && (false ? undefined : _typeof(exports)) === 'object') {
          factory(__webpack_require__("1157"), document, window, navigator);
        } else {
          factory(jQuery, document, window, navigator);
        }
      })(function ($, document, window, navigator, undefined) {
        'use strict'; // =================================================================================================================
        // Service

        var plugin_count = 0; // IE8 fix

        var is_old_ie = function () {
          var n = navigator.userAgent,
            r = /msie\s\d+/i,
            v;

          if (n.search(r) > 0) {
            v = r.exec(n).toString();
            v = v.split(' ')[1];

            if (v < 9) {
              $('html').addClass('lt-ie9');
              return true;
            }
          }

          return false;
        }();

        if (!Function.prototype.bind) {
          Function.prototype.bind = function bind(that) {
            var target = this;
            var slice = [].slice;

            if (typeof target != 'function') {
              throw new TypeError();
            }

            var args = slice.call(arguments, 1),
              bound = function bound() {
                if (this instanceof bound) {
                  var F = function F() {};

                  F.prototype = target.prototype;
                  var self = new F();
                  var result = target.apply(self, args.concat(slice.call(arguments)));

                  if (Object(result) === result) {
                    return result;
                  }

                  return self;
                } else {
                  return target.apply(that, args.concat(slice.call(arguments)));
                }
              };

            return bound;
          };
        }

        if (!Array.prototype.indexOf) {
          Array.prototype.indexOf = function (searchElement, fromIndex) {
            var k;

            if (this == null) {
              throw new TypeError('"this" is null or not defined');
            }

            var O = Object(this);
            var len = O.length >>> 0;

            if (len === 0) {
              return -1;
            }

            var n = +fromIndex || 0;

            if (Math.abs(n) === Infinity) {
              n = 0;
            }

            if (n >= len) {
              return -1;
            }

            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            while (k < len) {
              if (k in O && O[k] === searchElement) {
                return k;
              }

              k++;
            }

            return -1;
          };
        } // =================================================================================================================
        // Template


        var base_html = '<span class="irs">' + '<span class="irs-line" tabindex="0"></span>' + '<span class="irs-min">0</span><span class="irs-max">1</span>' + '<span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span>' + '</span>' + '<span class="irs-grid"></span>';
        var single_html = '<span class="irs-bar irs-bar--single"></span>' + '<span class="irs-shadow shadow-single"></span>' + '<span class="irs-handle single"><i></i><i></i><i></i></span>';
        var double_html = '<span class="irs-bar"></span>' + '<span class="irs-shadow shadow-from"></span>' + '<span class="irs-shadow shadow-to"></span>' + '<span class="irs-handle from"><i></i><i></i><i></i></span>' + '<span class="irs-handle to"><i></i><i></i><i></i></span>';
        var disable_html = '<span class="irs-disable-mask"></span>'; // =================================================================================================================
        // Core

        /**
         * Main plugin constructor
         *
         * @param input {Object} link to base input element
         * @param options {Object} slider config
         * @param plugin_count {Number}
         * @constructor
         */

        var IonRangeSlider = function IonRangeSlider(input, options, plugin_count) {
          this.VERSION = '2.3.1';
          this.input = input;
          this.plugin_count = plugin_count;
          this.current_plugin = 0;
          this.calc_count = 0;
          this.update_tm = 0;
          this.old_from = 0;
          this.old_to = 0;
          this.old_min_interval = null;
          this.raf_id = null;
          this.dragging = false;
          this.force_redraw = false;
          this.no_diapason = false;
          this.has_tab_index = true;
          this.is_key = false;
          this.is_update = false;
          this.is_start = true;
          this.is_finish = false;
          this.is_active = false;
          this.is_resize = false;
          this.is_click = false;
          options = options || {}; // cache for links to all DOM elements

          this.$cache = {
            win: $(window),
            body: $(document.body),
            input: $(input),
            cont: null,
            rs: null,
            min: null,
            max: null,
            from: null,
            to: null,
            single: null,
            bar: null,
            line: null,
            s_single: null,
            s_from: null,
            s_to: null,
            shad_single: null,
            shad_from: null,
            shad_to: null,
            edge: null,
            grid: null,
            grid_labels: []
          }; // storage for measure variables

          this.coords = {
            // left
            x_gap: 0,
            x_pointer: 0,
            // width
            w_rs: 0,
            w_rs_old: 0,
            w_handle: 0,
            // percents
            p_gap: 0,
            p_gap_left: 0,
            p_gap_right: 0,
            p_step: 0,
            p_pointer: 0,
            p_handle: 0,
            p_single_fake: 0,
            p_single_real: 0,
            p_from_fake: 0,
            p_from_real: 0,
            p_to_fake: 0,
            p_to_real: 0,
            p_bar_x: 0,
            p_bar_w: 0,
            // grid
            grid_gap: 0,
            big_num: 0,
            big: [],
            big_w: [],
            big_p: [],
            big_x: []
          }; // storage for labels measure variables

          this.labels = {
            // width
            w_min: 0,
            w_max: 0,
            w_from: 0,
            w_to: 0,
            w_single: 0,
            // percents
            p_min: 0,
            p_max: 0,
            p_from_fake: 0,
            p_from_left: 0,
            p_to_fake: 0,
            p_to_left: 0,
            p_single_fake: 0,
            p_single_left: 0
          };
          /**
           * get and validate config
           */

          var $inp = this.$cache.input,
            val = $inp.prop('value'),
            config,
            config_from_data,
            prop; // default config

          config = {
            skin: 'flat',
            type: 'single',
            min: 10,
            max: 100,
            from: null,
            to: null,
            step: 1,
            min_interval: 0,
            max_interval: 0,
            drag_interval: false,
            values: [],
            p_values: [],
            from_fixed: false,
            from_min: null,
            from_max: null,
            from_shadow: false,
            to_fixed: false,
            to_min: null,
            to_max: null,
            to_shadow: false,
            prettify_enabled: true,
            prettify_separator: ' ',
            prettify: null,
            force_edges: false,
            keyboard: true,
            grid: false,
            grid_margin: true,
            grid_num: 4,
            grid_snap: false,
            hide_min_max: false,
            hide_from_to: false,
            prefix: '',
            postfix: '',
            max_postfix: '',
            decorate_both: true,
            values_separator: ' — ',
            input_values_separator: ';',
            disable: false,
            block: false,
            extra_classes: '',
            scope: null,
            onStart: null,
            onChange: null,
            onFinish: null,
            onUpdate: null
          }; // check if base element is input

          if ($inp[0].nodeName !== 'INPUT') {
            console && console.warn && console.warn('Base element should be <input>!', $inp[0]);
          } // config from data-attributes extends js config


          config_from_data = {
            skin: $inp.data('skin'),
            type: $inp.data('type'),
            min: $inp.data('min'),
            max: $inp.data('max'),
            from: $inp.data('from'),
            to: $inp.data('to'),
            step: $inp.data('step'),
            min_interval: $inp.data('minInterval'),
            max_interval: $inp.data('maxInterval'),
            drag_interval: $inp.data('dragInterval'),
            values: $inp.data('values'),
            from_fixed: $inp.data('fromFixed'),
            from_min: $inp.data('fromMin'),
            from_max: $inp.data('fromMax'),
            from_shadow: $inp.data('fromShadow'),
            to_fixed: $inp.data('toFixed'),
            to_min: $inp.data('toMin'),
            to_max: $inp.data('toMax'),
            to_shadow: $inp.data('toShadow'),
            prettify_enabled: $inp.data('prettifyEnabled'),
            prettify_separator: $inp.data('prettifySeparator'),
            force_edges: $inp.data('forceEdges'),
            keyboard: $inp.data('keyboard'),
            grid: $inp.data('grid'),
            grid_margin: $inp.data('gridMargin'),
            grid_num: $inp.data('gridNum'),
            grid_snap: $inp.data('gridSnap'),
            hide_min_max: $inp.data('hideMinMax'),
            hide_from_to: $inp.data('hideFromTo'),
            prefix: $inp.data('prefix'),
            postfix: $inp.data('postfix'),
            max_postfix: $inp.data('maxPostfix'),
            decorate_both: $inp.data('decorateBoth'),
            values_separator: $inp.data('valuesSeparator'),
            input_values_separator: $inp.data('inputValuesSeparator'),
            disable: $inp.data('disable'),
            block: $inp.data('block'),
            extra_classes: $inp.data('extraClasses')
          };
          config_from_data.values = config_from_data.values && config_from_data.values.split(',');

          for (prop in config_from_data) {
            if (config_from_data.hasOwnProperty(prop)) {
              if (config_from_data[prop] === undefined || config_from_data[prop] === '') {
                delete config_from_data[prop];
              }
            }
          } // input value extends default config


          if (val !== undefined && val !== '') {
            val = val.split(config_from_data.input_values_separator || options.input_values_separator || ';');

            if (val[0] && val[0] == +val[0]) {
              val[0] = +val[0];
            }

            if (val[1] && val[1] == +val[1]) {
              val[1] = +val[1];
            }

            if (options && options.values && options.values.length) {
              config.from = val[0] && options.values.indexOf(val[0]);
              config.to = val[1] && options.values.indexOf(val[1]);
            } else {
              config.from = val[0] && +val[0];
              config.to = val[1] && +val[1];
            }
          } // js config extends default config


          $.extend(config, options); // data config extends config

          $.extend(config, config_from_data);
          this.options = config; // validate config, to be sure that all data types are correct

          this.update_check = {};
          this.validate(); // default result object, returned to callbacks

          this.result = {
            input: this.$cache.input,
            slider: null,
            min: this.options.min,
            max: this.options.max,
            from: this.options.from,
            from_percent: 0,
            from_value: null,
            to: this.options.to,
            to_percent: 0,
            to_value: null
          };
          this.init();
        };

        IonRangeSlider.prototype = {
          /**
           * Starts or updates the plugin instance
           *
           * @param [is_update] {boolean}
           */
          init: function init(is_update) {
            this.no_diapason = false;
            this.coords.p_step = this.convertToPercent(this.options.step, true);
            this.target = 'base';
            this.toggleInput();
            this.append();
            this.setMinMax();

            if (is_update) {
              this.force_redraw = true;
              this.calc(true); // callbacks called

              this.callOnUpdate();
            } else {
              this.force_redraw = true;
              this.calc(true); // callbacks called

              this.callOnStart();
            }

            this.updateScene();
          },

          /**
           * Appends slider template to a DOM
           */
          append: function append() {
            var container_html = '<span class="irs irs--' + this.options.skin + ' js-irs-' + this.plugin_count + ' ' + this.options.extra_classes + '"></span>';
            this.$cache.input.before(container_html);
            this.$cache.input.prop('readonly', true);
            this.$cache.cont = this.$cache.input.prev();
            this.result.slider = this.$cache.cont;
            this.$cache.cont.html(base_html);
            this.$cache.rs = this.$cache.cont.find('.irs');
            this.$cache.min = this.$cache.cont.find('.irs-min');
            this.$cache.max = this.$cache.cont.find('.irs-max');
            this.$cache.from = this.$cache.cont.find('.irs-from');
            this.$cache.to = this.$cache.cont.find('.irs-to');
            this.$cache.single = this.$cache.cont.find('.irs-single');
            this.$cache.line = this.$cache.cont.find('.irs-line');
            this.$cache.grid = this.$cache.cont.find('.irs-grid');

            if (this.options.type === 'single') {
              this.$cache.cont.append(single_html);
              this.$cache.bar = this.$cache.cont.find('.irs-bar');
              this.$cache.edge = this.$cache.cont.find('.irs-bar-edge');
              this.$cache.s_single = this.$cache.cont.find('.single');
              this.$cache.from[0].style.visibility = 'hidden';
              this.$cache.to[0].style.visibility = 'hidden';
              this.$cache.shad_single = this.$cache.cont.find('.shadow-single');
            } else {
              this.$cache.cont.append(double_html);
              this.$cache.bar = this.$cache.cont.find('.irs-bar');
              this.$cache.s_from = this.$cache.cont.find('.from');
              this.$cache.s_to = this.$cache.cont.find('.to');
              this.$cache.shad_from = this.$cache.cont.find('.shadow-from');
              this.$cache.shad_to = this.$cache.cont.find('.shadow-to');
              this.setTopHandler();
            }

            if (this.options.hide_from_to) {
              this.$cache.from[0].style.display = 'none';
              this.$cache.to[0].style.display = 'none';
              this.$cache.single[0].style.display = 'none';
            }

            this.appendGrid();

            if (this.options.disable) {
              this.appendDisableMask();
              this.$cache.input[0].disabled = true;
            } else {
              this.$cache.input[0].disabled = false;
              this.removeDisableMask();
              this.bindEvents();
            } // block only if not disabled


            if (!this.options.disable) {
              if (this.options.block) {
                this.appendDisableMask();
              } else {
                this.removeDisableMask();
              }
            }

            if (this.options.drag_interval) {
              this.$cache.bar[0].style.cursor = 'ew-resize';
            }
          },

          /**
           * Determine which handler has a priority
           * works only for double slider type
           */
          setTopHandler: function setTopHandler() {
            var min = this.options.min,
              max = this.options.max,
              from = this.options.from,
              to = this.options.to;

            if (from > min && to === max) {
              this.$cache.s_from.addClass('type_last');
            } else if (to < max) {
              this.$cache.s_to.addClass('type_last');
            }
          },

          /**
           * Determine which handles was clicked last
           * and which handler should have hover effect
           *
           * @param target {String}
           */
          changeLevel: function changeLevel(target) {
            switch (target) {
              case 'single':
                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake);
                this.$cache.s_single.addClass('state_hover');
                break;

              case 'from':
                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                this.$cache.s_from.addClass('state_hover');
                this.$cache.s_from.addClass('type_last');
                this.$cache.s_to.removeClass('type_last');
                break;

              case 'to':
                this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake);
                this.$cache.s_to.addClass('state_hover');
                this.$cache.s_to.addClass('type_last');
                this.$cache.s_from.removeClass('type_last');
                break;

              case 'both':
                this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer);
                this.$cache.s_to.removeClass('type_last');
                this.$cache.s_from.removeClass('type_last');
                break;
            }
          },

          /**
           * Then slider is disabled
           * appends extra layer with opacity
           */
          appendDisableMask: function appendDisableMask() {
            this.$cache.cont.append(disable_html);
            this.$cache.cont.addClass('irs-disabled');
          },

          /**
           * Then slider is not disabled
           * remove disable mask
           */
          removeDisableMask: function removeDisableMask() {
            this.$cache.cont.remove('.irs-disable-mask');
            this.$cache.cont.removeClass('irs-disabled');
          },

          /**
           * Remove slider instance
           * and unbind all events
           */
          remove: function remove() {
            this.$cache.cont.remove();
            this.$cache.cont = null;
            this.$cache.line.off('keydown.irs_' + this.plugin_count);
            this.$cache.body.off('touchmove.irs_' + this.plugin_count);
            this.$cache.body.off('mousemove.irs_' + this.plugin_count);
            this.$cache.win.off('touchend.irs_' + this.plugin_count);
            this.$cache.win.off('mouseup.irs_' + this.plugin_count);

            if (is_old_ie) {
              this.$cache.body.off('mouseup.irs_' + this.plugin_count);
              this.$cache.body.off('mouseleave.irs_' + this.plugin_count);
            }

            this.$cache.grid_labels = [];
            this.coords.big = [];
            this.coords.big_w = [];
            this.coords.big_p = [];
            this.coords.big_x = [];
            cancelAnimationFrame(this.raf_id);
          },

          /**
           * bind all slider events
           */
          bindEvents: function bindEvents() {
            if (this.no_diapason) {
              return;
            }

            this.$cache.body.on('touchmove.irs_' + this.plugin_count, this.pointerMove.bind(this));
            this.$cache.body.on('mousemove.irs_' + this.plugin_count, this.pointerMove.bind(this));
            this.$cache.win.on('touchend.irs_' + this.plugin_count, this.pointerUp.bind(this));
            this.$cache.win.on('mouseup.irs_' + this.plugin_count, this.pointerUp.bind(this));
            this.$cache.line.on('touchstart.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
            this.$cache.line.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
            this.$cache.line.on('focus.irs_' + this.plugin_count, this.pointerFocus.bind(this));

            if (this.options.drag_interval && this.options.type === 'double') {
              this.$cache.bar.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'both'));
              this.$cache.bar.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'both'));
            } else {
              this.$cache.bar.on('touchstart.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.bar.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
            }

            if (this.options.type === 'single') {
              this.$cache.single.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'single'));
              this.$cache.s_single.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'single'));
              this.$cache.shad_single.on('touchstart.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.single.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'single'));
              this.$cache.s_single.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'single'));
              this.$cache.edge.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.shad_single.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
            } else {
              this.$cache.single.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, null));
              this.$cache.single.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, null));
              this.$cache.from.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'from'));
              this.$cache.s_from.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'from'));
              this.$cache.to.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'to'));
              this.$cache.s_to.on('touchstart.irs_' + this.plugin_count, this.pointerDown.bind(this, 'to'));
              this.$cache.shad_from.on('touchstart.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.shad_to.on('touchstart.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.from.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'from'));
              this.$cache.s_from.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'from'));
              this.$cache.to.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'to'));
              this.$cache.s_to.on('mousedown.irs_' + this.plugin_count, this.pointerDown.bind(this, 'to'));
              this.$cache.shad_from.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
              this.$cache.shad_to.on('mousedown.irs_' + this.plugin_count, this.pointerClick.bind(this, 'click'));
            }

            if (this.options.keyboard) {
              this.$cache.line.on('keydown.irs_' + this.plugin_count, this.key.bind(this, 'keyboard'));
            }

            if (is_old_ie) {
              this.$cache.body.on('mouseup.irs_' + this.plugin_count, this.pointerUp.bind(this));
              this.$cache.body.on('mouseleave.irs_' + this.plugin_count, this.pointerUp.bind(this));
            }
          },

          /**
           * Focus with tabIndex
           *
           * @param e {Object} event object
           */
          pointerFocus: function pointerFocus(e) {
            if (!this.target) {
              var x;
              var $handle;

              if (this.options.type === 'single') {
                $handle = this.$cache.single;
              } else {
                $handle = this.$cache.from;
              }

              x = $handle.offset().left;
              x += $handle.width() / 2 - 1;
              this.pointerClick('single', {
                preventDefault: function preventDefault() {},
                pageX: x
              });
            }
          },

          /**
           * Mousemove or touchmove
           * only for handlers
           *
           * @param e {Object} event object
           */
          pointerMove: function pointerMove(e) {
            if (!this.dragging) {
              return;
            }

            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            this.coords.x_pointer = x - this.coords.x_gap;
            this.calc();
          },

          /**
           * Mouseup or touchend
           * only for handlers
           *
           * @param e {Object} event object
           */
          pointerUp: function pointerUp(e) {
            if (this.current_plugin !== this.plugin_count) {
              return;
            }

            if (this.is_active) {
              this.is_active = false;
            } else {
              return;
            }

            this.$cache.cont.find('.state_hover').removeClass('state_hover');
            this.force_redraw = true;

            if (is_old_ie) {
              $('*').prop('unselectable', false);
            }

            this.updateScene();
            this.restoreOriginalMinInterval(); // callbacks call

            if ($.contains(this.$cache.cont[0], e.target) || this.dragging) {
              this.callOnFinish();
            }

            this.dragging = false;
          },

          /**
           * Mousedown or touchstart
           * only for handlers
           *
           * @param target {String|null}
           * @param e {Object} event object
           */
          pointerDown: function pointerDown(target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

            if (e.button === 2) {
              return;
            }

            if (target === 'both') {
              this.setTempMinInterval();
            }

            if (!target) {
              target = this.target || 'from';
            }

            this.current_plugin = this.plugin_count;
            this.target = target;
            this.is_active = true;
            this.dragging = true;
            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = x - this.coords.x_gap;
            this.calcPointerPercent();
            this.changeLevel(target);

            if (is_old_ie) {
              $('*').prop('unselectable', true);
            }

            this.$cache.line.trigger('focus');
            this.updateScene();
          },

          /**
           * Mousedown or touchstart
           * for other slider elements, like diapason line
           *
           * @param target {String}
           * @param e {Object} event object
           */
          pointerClick: function pointerClick(target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

            if (e.button === 2) {
              return;
            }

            this.current_plugin = this.plugin_count;
            this.target = target;
            this.is_click = true;
            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();
            this.force_redraw = true;
            this.calc();
            this.$cache.line.trigger('focus');
          },

          /**
           * Keyborard controls for focused slider
           *
           * @param target {String}
           * @param e {Object} event object
           * @returns {boolean|undefined}
           */
          key: function key(target, e) {
            if (this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
              return;
            }

            switch (e.which) {
              case 83: // W

              case 65: // A

              case 40: // DOWN

              case 37:
                // LEFT
                e.preventDefault();
                this.moveByKey(false);
                break;

              case 87: // S

              case 68: // D

              case 38: // UP

              case 39:
                // RIGHT
                e.preventDefault();
                this.moveByKey(true);
                break;
            }

            return true;
          },

          /**
           * Move by key
           *
           * @param right {boolean} direction to move
           */
          moveByKey: function moveByKey(right) {
            var p = this.coords.p_pointer;
            var p_step = (this.options.max - this.options.min) / 100;
            p_step = this.options.step / p_step;

            if (right) {
              p += p_step;
            } else {
              p -= p_step;
            }

            this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * p);
            this.is_key = true;
            this.calc();
          },

          /**
           * Set visibility and content
           * of Min and Max labels
           */
          setMinMax: function setMinMax() {
            if (!this.options) {
              return;
            }

            if (this.options.hide_min_max) {
              this.$cache.min[0].style.display = 'none';
              this.$cache.max[0].style.display = 'none';
              return;
            }

            if (this.options.values.length) {
              this.$cache.min.html(this.decorate(this.options.p_values[this.options.min]));
              this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]));
            } else {
              var min_pretty = this._prettify(this.options.min);

              var max_pretty = this._prettify(this.options.max);

              this.result.min_pretty = min_pretty;
              this.result.max_pretty = max_pretty;
              this.$cache.min.html(this.decorate(min_pretty, this.options.min));
              this.$cache.max.html(this.decorate(max_pretty, this.options.max));
            }

            this.labels.w_min = this.$cache.min.outerWidth(false);
            this.labels.w_max = this.$cache.max.outerWidth(false);
          },

          /**
           * Then dragging interval, prevent interval collapsing
           * using min_interval option
           */
          setTempMinInterval: function setTempMinInterval() {
            var interval = this.result.to - this.result.from;

            if (this.old_min_interval === null) {
              this.old_min_interval = this.options.min_interval;
            }

            this.options.min_interval = interval;
          },

          /**
           * Restore min_interval option to original
           */
          restoreOriginalMinInterval: function restoreOriginalMinInterval() {
            if (this.old_min_interval !== null) {
              this.options.min_interval = this.old_min_interval;
              this.old_min_interval = null;
            }
          },
          // =============================================================================================================
          // Calculations

          /**
           * All calculations and measures start here
           *
           * @param update {boolean=}
           */
          calc: function calc(update) {
            if (!this.options) {
              return;
            }

            this.calc_count++;

            if (this.calc_count === 10 || update) {
              this.calc_count = 0;
              this.coords.w_rs = this.$cache.rs.outerWidth(false);
              this.calcHandlePercent();
            }

            if (!this.coords.w_rs) {
              return;
            }

            this.calcPointerPercent();
            var handle_x = this.getHandleX();

            if (this.target === 'both') {
              this.coords.p_gap = 0;
              handle_x = this.getHandleX();
            }

            if (this.target === 'click') {
              this.coords.p_gap = this.coords.p_handle / 2;
              handle_x = this.getHandleX();

              if (this.options.drag_interval) {
                this.target = 'both_one';
              } else {
                this.target = this.chooseHandle(handle_x);
              }
            }

            switch (this.target) {
              case 'base':
                var w = (this.options.max - this.options.min) / 100,
                  f = (this.result.from - this.options.min) / w,
                  t = (this.result.to - this.options.min) / w;
                this.coords.p_single_real = this.toFixed(f);
                this.coords.p_from_real = this.toFixed(f);
                this.coords.p_to_real = this.toFixed(t);
                this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
                this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
                this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                this.target = null;
                break;

              case 'single':
                if (this.options.from_fixed) {
                  break;
                }

                this.coords.p_single_real = this.convertToRealPercent(handle_x);
                this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real);
                this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
                this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
                break;

              case 'from':
                if (this.options.from_fixed) {
                  break;
                }

                this.coords.p_from_real = this.convertToRealPercent(handle_x);
                this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);

                if (this.coords.p_from_real > this.coords.p_to_real) {
                  this.coords.p_from_real = this.coords.p_to_real;
                }

                this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, 'from');
                this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, 'from');
                this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                break;

              case 'to':
                if (this.options.to_fixed) {
                  break;
                }

                this.coords.p_to_real = this.convertToRealPercent(handle_x);
                this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);

                if (this.coords.p_to_real < this.coords.p_from_real) {
                  this.coords.p_to_real = this.coords.p_from_real;
                }

                this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, 'to');
                this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, 'to');
                this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                break;

              case 'both':
                if (this.options.from_fixed || this.options.to_fixed) {
                  break;
                }

                handle_x = this.toFixed(handle_x + this.coords.p_handle * 0.001);
                this.coords.p_from_real = this.convertToRealPercent(handle_x) - this.coords.p_gap_left;
                this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
                this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, 'from');
                this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                this.coords.p_to_real = this.convertToRealPercent(handle_x) + this.coords.p_gap_right;
                this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
                this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, 'to');
                this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                break;

              case 'both_one':
                if (this.options.from_fixed || this.options.to_fixed) {
                  break;
                }

                var real_x = this.convertToRealPercent(handle_x),
                  from = this.result.from_percent,
                  to = this.result.to_percent,
                  full = to - from,
                  half = full / 2,
                  new_from = real_x - half,
                  new_to = real_x + half;

                if (new_from < 0) {
                  new_from = 0;
                  new_to = new_from + full;
                }

                if (new_to > 100) {
                  new_to = 100;
                  new_from = new_to - full;
                }

                this.coords.p_from_real = this.calcWithStep(new_from);
                this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                this.coords.p_to_real = this.calcWithStep(new_to);
                this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
                break;
            }

            if (this.options.type === 'single') {
              this.coords.p_bar_x = this.coords.p_handle / 2;
              this.coords.p_bar_w = this.coords.p_single_fake;
              this.result.from_percent = this.coords.p_single_real;
              this.result.from = this.convertToValue(this.coords.p_single_real);
              this.result.from_pretty = this._prettify(this.result.from);

              if (this.options.values.length) {
                this.result.from_value = this.options.values[this.result.from];
              }
            } else {
              this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + this.coords.p_handle / 2);
              this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake);
              this.result.from_percent = this.coords.p_from_real;
              this.result.from = this.convertToValue(this.coords.p_from_real);
              this.result.from_pretty = this._prettify(this.result.from);
              this.result.to_percent = this.coords.p_to_real;
              this.result.to = this.convertToValue(this.coords.p_to_real);
              this.result.to_pretty = this._prettify(this.result.to);

              if (this.options.values.length) {
                this.result.from_value = this.options.values[this.result.from];
                this.result.to_value = this.options.values[this.result.to];
              }
            }

            this.calcMinMax();
            this.calcLabels();
          },

          /**
           * calculates pointer X in percent
           */
          calcPointerPercent: function calcPointerPercent() {
            if (!this.coords.w_rs) {
              this.coords.p_pointer = 0;
              return;
            }

            if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)) {
              this.coords.x_pointer = 0;
            } else if (this.coords.x_pointer > this.coords.w_rs) {
              this.coords.x_pointer = this.coords.w_rs;
            }

            this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
          },
          convertToRealPercent: function convertToRealPercent(fake) {
            var full = 100 - this.coords.p_handle;
            return fake / full * 100;
          },
          convertToFakePercent: function convertToFakePercent(real) {
            var full = 100 - this.coords.p_handle;
            return real / 100 * full;
          },
          getHandleX: function getHandleX() {
            var max = 100 - this.coords.p_handle,
              x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

            if (x < 0) {
              x = 0;
            } else if (x > max) {
              x = max;
            }

            return x;
          },
          calcHandlePercent: function calcHandlePercent() {
            if (this.options.type === 'single') {
              this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
              this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }

            this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
          },

          /**
           * Find closest handle to pointer click
           *
           * @param real_x {Number}
           * @returns {String}
           */
          chooseHandle: function chooseHandle(real_x) {
            if (this.options.type === 'single') {
              return 'single';
            } else {
              var m_point = this.coords.p_from_real + (this.coords.p_to_real - this.coords.p_from_real) / 2;

              if (real_x >= m_point) {
                return this.options.to_fixed ? 'from' : 'to';
              } else {
                return this.options.from_fixed ? 'to' : 'from';
              }
            }
          },

          /**
           * Measure Min and Max labels width in percent
           */
          calcMinMax: function calcMinMax() {
            if (!this.coords.w_rs) {
              return;
            }

            this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100;
            this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100;
          },

          /**
           * Measure labels width and X in percent
           */
          calcLabels: function calcLabels() {
            if (!this.coords.w_rs || this.options.hide_from_to) {
              return;
            }

            if (this.options.type === 'single') {
              this.labels.w_single = this.$cache.single.outerWidth(false);
              this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
              this.labels.p_single_left = this.coords.p_single_fake + this.coords.p_handle / 2 - this.labels.p_single_fake / 2;
              this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
            } else {
              this.labels.w_from = this.$cache.from.outerWidth(false);
              this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100;
              this.labels.p_from_left = this.coords.p_from_fake + this.coords.p_handle / 2 - this.labels.p_from_fake / 2;
              this.labels.p_from_left = this.toFixed(this.labels.p_from_left);
              this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake);
              this.labels.w_to = this.$cache.to.outerWidth(false);
              this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100;
              this.labels.p_to_left = this.coords.p_to_fake + this.coords.p_handle / 2 - this.labels.p_to_fake / 2;
              this.labels.p_to_left = this.toFixed(this.labels.p_to_left);
              this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake);
              this.labels.w_single = this.$cache.single.outerWidth(false);
              this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
              this.labels.p_single_left = (this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2 - this.labels.p_single_fake / 2;
              this.labels.p_single_left = this.toFixed(this.labels.p_single_left);
              this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
            }
          },
          // =============================================================================================================
          // Drawings

          /**
           * Main function called in request animation frame
           * to update everything
           */
          updateScene: function updateScene() {
            if (this.raf_id) {
              cancelAnimationFrame(this.raf_id);
              this.raf_id = null;
            }

            clearTimeout(this.update_tm);
            this.update_tm = null;

            if (!this.options) {
              return;
            }

            this.drawHandles();

            if (this.is_active) {
              this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
            } else {
              this.update_tm = setTimeout(this.updateScene.bind(this), 300);
            }
          },

          /**
           * Draw handles
           */
          drawHandles: function drawHandles() {
            this.coords.w_rs = this.$cache.rs.outerWidth(false);

            if (!this.coords.w_rs) {
              return;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old) {
              this.target = 'base';
              this.is_resize = true;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
              this.setMinMax();
              this.calc(true);
              this.drawLabels();

              if (this.options.grid) {
                this.calcGridMargin();
                this.calcGridLabels();
              }

              this.force_redraw = true;
              this.coords.w_rs_old = this.coords.w_rs;
              this.drawShadow();
            }

            if (!this.coords.w_rs) {
              return;
            }

            if (!this.dragging && !this.force_redraw && !this.is_key) {
              return;
            }

            if (this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) {
              this.drawLabels();
              this.$cache.bar[0].style.left = this.coords.p_bar_x < 50 ? (this.coords.p_bar_x + '%') : (this.coords.p_bar_x - 2.5 + '%');
              this.$cache.bar[0].style.width = this.coords.p_to_fake < 50 ? (this.coords.p_bar_w + 3 + '%') : (this.coords.p_bar_w + '%');

              if (this.options.type === 'single') {
                this.$cache.bar[0].style.left = 0;
                this.$cache.bar[0].style.width = this.coords.p_bar_w + this.coords.p_bar_x + '%';
                this.$cache.s_single[0].style.left = this.coords.p_single_fake + '%';
                this.$cache.single[0].style.left = this.labels.p_single_left + '%';
              } else {
                this.$cache.s_from[0].style.left = this.coords.p_from_fake < 50 ? this.coords.p_from_fake + 3.5 + '%' : (this.coords.p_from_fake - 1.5 + '%');
                this.$cache.s_to[0].style.left = this.coords.p_to_fake < 50 ? (this.coords.p_to_fake + 3.5 + '%') : (this.coords.p_to_fake + '%');

                if (this.old_from !== this.result.from || this.force_redraw) {
                  this.$cache.from[0].style.left = this.labels.p_from_left + '%';
                }

                if (this.old_to !== this.result.to || this.force_redraw) {
                  this.$cache.to[0].style.left = this.labels.p_to_left + '%';
                }

                this.$cache.single[0].style.left = this.labels.p_single_left + '%';
              }

              this.writeToInput();

              if ((this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start) {
                this.$cache.input.trigger('change');
                this.$cache.input.trigger('input');
              }

              this.old_from = this.result.from;
              this.old_to = this.result.to; // callbacks call

              if (!this.is_resize && !this.is_update && !this.is_start && !this.is_finish) {
                this.callOnChange();
              }

              if (this.is_key || this.is_click) {
                this.is_key = false;
                this.is_click = false;
                this.callOnFinish();
              }

              this.is_update = false;
              this.is_resize = false;
              this.is_finish = false;
            }

            this.is_start = false;
            this.is_key = false;
            this.is_click = false;
            this.force_redraw = false;
          },

          /**
           * Draw labels
           * measure labels collisions
           * collapse close labels
           */
          drawLabels: function drawLabels() {
            if (!this.options) {
              return;
            }

            var values_num = this.options.values.length;
            var p_values = this.options.p_values;
            var text_single;
            var text_from;
            var text_to;
            var from_pretty;
            var to_pretty;

            if (this.options.hide_from_to) {
              return;
            }

            if (this.options.type === 'single') {
              if (values_num) {
                text_single = this.decorate(p_values[this.result.from]);
                this.$cache.single.html(text_single);
              } else {
                from_pretty = this._prettify(this.result.from);
                text_single = this.decorate(from_pretty, this.result.from);
                this.$cache.single.html(text_single);
              }

              this.calcLabels();

              if (this.labels.p_single_left < this.labels.p_min + 1) {
                this.$cache.min[0].style.visibility = 'hidden';
              } else {
                this.$cache.min[0].style.visibility = 'visible';
              }

              if (this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1) {
                this.$cache.max[0].style.visibility = 'hidden';
              } else {
                this.$cache.max[0].style.visibility = 'visible';
              }
            } else {
              if (values_num) {
                if (this.options.decorate_both) {
                  text_single = this.decorate(p_values[this.result.from]);
                  text_single += this.options.values_separator;
                  text_single += this.decorate(p_values[this.result.to]);
                } else {
                  text_single = this.decorate(p_values[this.result.from] + this.options.values_separator + p_values[this.result.to]);
                }

                text_from = this.decorate(p_values[this.result.from]);
                text_to = this.decorate(p_values[this.result.to]);
                this.$cache.single.html(text_single);
                this.$cache.from.html(text_from);
                this.$cache.to.html(text_to);
              } else {
                from_pretty = this._prettify(this.result.from);
                to_pretty = this._prettify(this.result.to);

                if (this.options.decorate_both) {
                  text_single = this.decorate(from_pretty, this.result.from);
                  text_single += this.options.values_separator;
                  text_single += this.decorate(to_pretty, this.result.to);
                } else {
                  text_single = this.decorate(from_pretty + this.options.values_separator + to_pretty, this.result.to);
                }

                text_from = this.decorate(from_pretty, this.result.from);
                text_to = this.decorate(to_pretty, this.result.to);
                this.$cache.single.html(text_single);
                this.$cache.from.html(text_from);
                this.$cache.to.html(text_to);
              }

              this.calcLabels();
              var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
                single_left = this.labels.p_single_left + this.labels.p_single_fake,
                to_left = this.labels.p_to_left + this.labels.p_to_fake,
                max = Math.max(single_left, to_left);

              if (this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left) {
                this.$cache.from[0].style.visibility = 'hidden';
                this.$cache.to[0].style.visibility = 'hidden';
                this.$cache.single[0].style.visibility = 'visible';

                if (this.result.from === this.result.to) {
                  if (this.target === 'from') {
                    this.$cache.from[0].style.visibility = 'visible';
                  } else if (this.target === 'to') {
                    this.$cache.to[0].style.visibility = 'visible';
                  } else if (!this.target) {
                    this.$cache.from[0].style.visibility = 'visible';
                  }

                  this.$cache.single[0].style.visibility = 'hidden';
                  max = to_left;
                } else {
                  this.$cache.from[0].style.visibility = 'hidden';
                  this.$cache.to[0].style.visibility = 'hidden';
                  this.$cache.single[0].style.visibility = 'visible';
                  max = Math.max(single_left, to_left);
                }
              } else {
                this.$cache.from[0].style.visibility = 'visible';
                this.$cache.to[0].style.visibility = 'visible';
                this.$cache.single[0].style.visibility = 'hidden';
              }

              if (min < this.labels.p_min + 1) {
                this.$cache.min[0].style.visibility = 'hidden';
              } else {
                this.$cache.min[0].style.visibility = 'visible';
              }

              if (max > 100 - this.labels.p_max - 1) {
                this.$cache.max[0].style.visibility = 'hidden';
              } else {
                this.$cache.max[0].style.visibility = 'visible';
              }
            }
          },

          /**
           * Draw shadow intervals
           */
          drawShadow: function drawShadow() {
            var o = this.options,
              c = this.$cache,
              is_from_min = typeof o.from_min === 'number' && !isNaN(o.from_min),
              is_from_max = typeof o.from_max === 'number' && !isNaN(o.from_max),
              is_to_min = typeof o.to_min === 'number' && !isNaN(o.to_min),
              is_to_max = typeof o.to_max === 'number' && !isNaN(o.to_max),
              from_min,
              from_max,
              to_min,
              to_max;

            if (o.type === 'single') {
              if (o.from_shadow && (is_from_min || is_from_max)) {
                from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
                from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
                from_min = from_min + this.coords.p_handle / 2;
                c.shad_single[0].style.display = 'block';
                c.shad_single[0].style.left = from_min + '%';
                c.shad_single[0].style.width = from_max + '%';
              } else {
                c.shad_single[0].style.display = 'none';
              }
            } else {
              if (o.from_shadow && (is_from_min || is_from_max)) {
                from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
                from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
                from_min = from_min + this.coords.p_handle / 2;
                c.shad_from[0].style.display = 'block';
                c.shad_from[0].style.left = from_min + '%';
                c.shad_from[0].style.width = from_max + '%';
              } else {
                c.shad_from[0].style.display = 'none';
              }

              if (o.to_shadow && (is_to_min || is_to_max)) {
                to_min = this.convertToPercent(is_to_min ? o.to_min : o.min);
                to_max = this.convertToPercent(is_to_max ? o.to_max : o.max) - to_min;
                to_min = this.toFixed(to_min - this.coords.p_handle / 100 * to_min);
                to_max = this.toFixed(to_max - this.coords.p_handle / 100 * to_max);
                to_min = to_min + this.coords.p_handle / 2;
                c.shad_to[0].style.display = 'block';
                c.shad_to[0].style.left = to_min + '%';
                c.shad_to[0].style.width = to_max + '%';
              } else {
                c.shad_to[0].style.display = 'none';
              }
            }
          },

          /**
           * Write values to input element
           */
          writeToInput: function writeToInput() {
            if (this.options.type === 'single') {
              if (this.options.values.length) {
                this.$cache.input.prop('value', this.result.from_value);
              } else {
                this.$cache.input.prop('value', this.result.from);
              }

              this.$cache.input.data('from', this.result.from);
            } else {
              if (this.options.values.length) {
                this.$cache.input.prop('value', this.result.from_value + this.options.input_values_separator + this.result.to_value);
              } else {
                this.$cache.input.prop('value', this.result.from + this.options.input_values_separator + this.result.to);
              }

              this.$cache.input.data('from', this.result.from);
              this.$cache.input.data('to', this.result.to);
            }
          },
          // =============================================================================================================
          // Callbacks
          callOnStart: function callOnStart() {
            this.writeToInput();

            if (this.options.onStart && typeof this.options.onStart === 'function') {
              if (this.options.scope) {
                this.options.onStart.call(this.options.scope, this.result);
              } else {
                this.options.onStart(this.result);
              }
            }
          },
          callOnChange: function callOnChange() {
            this.writeToInput();

            if (this.options.onChange && typeof this.options.onChange === 'function') {
              if (this.options.scope) {
                this.options.onChange.call(this.options.scope, this.result);
              } else {
                this.options.onChange(this.result);
              }
            }
          },
          callOnFinish: function callOnFinish() {
            this.writeToInput();

            if (this.options.onFinish && typeof this.options.onFinish === 'function') {
              if (this.options.scope) {
                this.options.onFinish.call(this.options.scope, this.result);
              } else {
                this.options.onFinish(this.result);
              }
            }
          },
          callOnUpdate: function callOnUpdate() {
            this.writeToInput();

            if (this.options.onUpdate && typeof this.options.onUpdate === 'function') {
              if (this.options.scope) {
                this.options.onUpdate.call(this.options.scope, this.result);
              } else {
                this.options.onUpdate(this.result);
              }
            }
          },
          // =============================================================================================================
          // Service methods
          toggleInput: function toggleInput() {
            this.$cache.input.toggleClass('irs-hidden-input');

            if (this.has_tab_index) {
              this.$cache.input.prop('tabindex', -1);
            } else {
              this.$cache.input.removeProp('tabindex');
            }

            this.has_tab_index = !this.has_tab_index;
          },

          /**
           * Convert real value to percent
           *
           * @param value {Number} X in real
           * @param no_min {boolean=} don't use min value
           * @returns {Number} X in percent
           */
          convertToPercent: function convertToPercent(value, no_min) {
            var diapason = this.options.max - this.options.min,
              one_percent = diapason / 100,
              val,
              percent;

            if (!diapason) {
              this.no_diapason = true;
              return 0;
            }

            if (no_min) {
              val = value;
            } else {
              val = value - this.options.min;
            }

            percent = val / one_percent;
            return this.toFixed(percent);
          },

          /**
           * Convert percent to real values
           *
           * @param percent {Number} X in percent
           * @returns {Number} X in real
           */
          convertToValue: function convertToValue(percent) {
            var min = this.options.min,
              max = this.options.max,
              min_decimals = min.toString().split('.')[1],
              max_decimals = max.toString().split('.')[1],
              min_length,
              max_length,
              avg_decimals = 0,
              abs = 0;

            if (percent === 0) {
              return this.options.min;
            }

            if (percent === 100) {
              return this.options.max;
            }

            if (min_decimals) {
              min_length = min_decimals.length;
              avg_decimals = min_length;
            }

            if (max_decimals) {
              max_length = max_decimals.length;
              avg_decimals = max_length;
            }

            if (min_length && max_length) {
              avg_decimals = min_length >= max_length ? min_length : max_length;
            }

            if (min < 0) {
              abs = Math.abs(min);
              min = +(min + abs).toFixed(avg_decimals);
              max = +(max + abs).toFixed(avg_decimals);
            }

            var number = (max - min) / 100 * percent + min,
              string = this.options.step.toString().split('.')[1],
              result;

            if (string) {
              number = +number.toFixed(string.length);
            } else {
              number = number / this.options.step;
              number = number * this.options.step;
              number = +number.toFixed(0);
            }

            if (abs) {
              number -= abs;
            }

            if (string) {
              result = +number.toFixed(string.length);
            } else {
              result = this.toFixed(number);
            }

            if (result < this.options.min) {
              result = this.options.min;
            } else if (result > this.options.max) {
              result = this.options.max;
            }

            return result;
          },

          /**
           * Round percent value with step
           *
           * @param percent {Number}
           * @returns percent {Number} rounded
           */
          calcWithStep: function calcWithStep(percent) {
            var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

            if (rounded > 100) {
              rounded = 100;
            }

            if (percent === 100) {
              rounded = 100;
            }

            return this.toFixed(rounded);
          },
          checkMinInterval: function checkMinInterval(p_current, p_next, type) {
            var o = this.options,
              current,
              next;

            if (!o.min_interval) {
              return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === 'from') {
              if (next - current < o.min_interval) {
                current = next - o.min_interval;
              }
            } else {
              if (current - next < o.min_interval) {
                current = next + o.min_interval;
              }
            }

            return this.convertToPercent(current);
          },
          checkMaxInterval: function checkMaxInterval(p_current, p_next, type) {
            var o = this.options,
              current,
              next;

            if (!o.max_interval) {
              return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === 'from') {
              if (next - current > o.max_interval) {
                current = next - o.max_interval;
              }
            } else {
              if (current - next > o.max_interval) {
                current = next + o.max_interval;
              }
            }

            return this.convertToPercent(current);
          },
          checkDiapason: function checkDiapason(p_num, min, max) {
            var num = this.convertToValue(p_num),
              o = this.options;

            if (typeof min !== 'number') {
              min = o.min;
            }

            if (typeof max !== 'number') {
              max = o.max;
            }

            if (num < min) {
              num = min;
            }

            if (num > max) {
              num = max;
            }

            return this.convertToPercent(num);
          },
          toFixed: function toFixed(num) {
            num = num.toFixed(20);
            return +num;
          },
          _prettify: function _prettify(num) {
            if (!this.options.prettify_enabled) {
              return num;
            }

            if (this.options.prettify && typeof this.options.prettify === 'function') {
              return this.options.prettify(num);
            } else {
              return this.prettify(num);
            }
          },
          prettify: function prettify(num) {
            var n = num.toString();
            return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + this.options.prettify_separator);
          },
          checkEdges: function checkEdges(left, width) {
            if (!this.options.force_edges) {
              return this.toFixed(left);
            }

            if (left < 0) {
              left = 0;
            } else if (left > 100 - width) {
              left = 100 - width;
            }

            return this.toFixed(left);
          },
          validate: function validate() {
            var o = this.options,
              r = this.result,
              v = o.values,
              vl = v.length,
              value,
              i;
            if (typeof o.min === 'string') o.min = +o.min;
            if (typeof o.max === 'string') o.max = +o.max;
            if (typeof o.from === 'string') o.from = +o.from;
            if (typeof o.to === 'string') o.to = +o.to;
            if (typeof o.step === 'string') o.step = +o.step;
            if (typeof o.from_min === 'string') o.from_min = +o.from_min;
            if (typeof o.from_max === 'string') o.from_max = +o.from_max;
            if (typeof o.to_min === 'string') o.to_min = +o.to_min;
            if (typeof o.to_max === 'string') o.to_max = +o.to_max;
            if (typeof o.grid_num === 'string') o.grid_num = +o.grid_num;

            if (o.max < o.min) {
              o.max = o.min;
            }

            if (vl) {
              o.p_values = [];
              o.min = 0;
              o.max = vl - 1;
              o.step = 1;
              o.grid_num = o.max;
              o.grid_snap = true;

              for (i = 0; i < vl; i++) {
                value = +v[i];

                if (!isNaN(value)) {
                  v[i] = value;
                  value = this._prettify(value);
                } else {
                  value = v[i];
                }

                o.p_values.push(value);
              }
            }

            if (typeof o.from !== 'number' || isNaN(o.from)) {
              o.from = o.min;
            }

            if (typeof o.to !== 'number' || isNaN(o.to)) {
              o.to = o.max;
            }

            if (o.type === 'single') {
              if (o.from < o.min) o.from = o.min;
              if (o.from > o.max) o.from = o.max;
            } else {
              if (o.from < o.min) o.from = o.min;
              if (o.from > o.max) o.from = o.max;
              if (o.to < o.min) o.to = o.min;
              if (o.to > o.max) o.to = o.max;

              if (this.update_check.from) {
                if (this.update_check.from !== o.from) {
                  if (o.from > o.to) o.from = o.to;
                }

                if (this.update_check.to !== o.to) {
                  if (o.to < o.from) o.to = o.from;
                }
              }

              if (o.from > o.to) o.from = o.to;
              if (o.to < o.from) o.to = o.from;
            }

            if (typeof o.step !== 'number' || isNaN(o.step) || !o.step || o.step < 0) {
              o.step = 1;
            }

            if (typeof o.from_min === 'number' && o.from < o.from_min) {
              o.from = o.from_min;
            }

            if (typeof o.from_max === 'number' && o.from > o.from_max) {
              o.from = o.from_max;
            }

            if (typeof o.to_min === 'number' && o.to < o.to_min) {
              o.to = o.to_min;
            }

            if (typeof o.to_max === 'number' && o.from > o.to_max) {
              o.to = o.to_max;
            }

            if (r) {
              if (r.min !== o.min) {
                r.min = o.min;
              }

              if (r.max !== o.max) {
                r.max = o.max;
              }

              if (r.from < r.min || r.from > r.max) {
                r.from = o.from;
              }

              if (r.to < r.min || r.to > r.max) {
                r.to = o.to;
              }
            }

            if (typeof o.min_interval !== 'number' || isNaN(o.min_interval) || !o.min_interval || o.min_interval < 0) {
              o.min_interval = 0;
            }

            if (typeof o.max_interval !== 'number' || isNaN(o.max_interval) || !o.max_interval || o.max_interval < 0) {
              o.max_interval = 0;
            }

            if (o.min_interval && o.min_interval > o.max - o.min) {
              o.min_interval = o.max - o.min;
            }

            if (o.max_interval && o.max_interval > o.max - o.min) {
              o.max_interval = o.max - o.min;
            }
          },
          decorate: function decorate(num, original) {
            var decorated = '',
              o = this.options;

            if (o.prefix) {
              decorated += o.prefix;
            }

            decorated += num;

            if (o.max_postfix) {
              if (o.values.length && num === o.p_values[o.max]) {
                decorated += o.max_postfix;

                if (o.postfix) {
                  decorated += ' ';
                }
              } else if (original === o.max) {
                decorated += o.max_postfix;

                if (o.postfix) {
                  decorated += ' ';
                }
              }
            }

            if (o.postfix) {
              decorated += o.postfix;
            }

            return decorated;
          },
          updateFrom: function updateFrom() {
            this.result.from = this.options.from;
            this.result.from_percent = this.convertToPercent(this.result.from);
            this.result.from_pretty = this._prettify(this.result.from);

            if (this.options.values) {
              this.result.from_value = this.options.values[this.result.from];
            }
          },
          updateTo: function updateTo() {
            this.result.to = this.options.to;
            this.result.to_percent = this.convertToPercent(this.result.to);
            this.result.to_pretty = this._prettify(this.result.to);

            if (this.options.values) {
              this.result.to_value = this.options.values[this.result.to];
            }
          },
          updateResult: function updateResult() {
            this.result.min = this.options.min;
            this.result.max = this.options.max;
            this.updateFrom();
            this.updateTo();
          },
          // =============================================================================================================
          // Grid
          appendGrid: function appendGrid() {
            if (!this.options.grid) {
              return;
            }

            var o = this.options,
              i,
              z,
              total = o.max - o.min,
              big_num = o.grid_num,
              big_p = 0,
              big_w = 0,
              small_max = 4,
              local_small_max,
              small_p,
              small_w = 0,
              result,
              html = '';
            this.calcGridMargin();

            if (o.grid_snap) {
              big_num = total / o.step;
            }

            if (big_num > 50) big_num = 50;
            big_p = this.toFixed(100 / big_num);

            if (big_num > 4) {
              small_max = 3;
            }

            if (big_num > 7) {
              small_max = 2;
            }

            if (big_num > 14) {
              small_max = 1;
            }

            if (big_num > 28) {
              small_max = 0;
            }

            for (i = 0; i < big_num + 1; i++) {
              local_small_max = small_max;
              big_w = this.toFixed(big_p * i);

              if (big_w > 100) {
                big_w = 100;
              }

              this.coords.big[i] = big_w;
              small_p = (big_w - big_p * (i - 1)) / (local_small_max + 1);

              for (z = 1; z <= local_small_max; z++) {
                if (big_w === 0) {
                  break;
                }

                small_w = this.toFixed(big_w - small_p * z);
                html += '<span class="irs-grid-pol small" style="left: ' + small_w + '%"></span>';
              }

              html += '<span class="irs-grid-pol" style="left: ' + big_w + '%"></span>';
              result = this.convertToValue(big_w);

              if (o.values.length) {
                result = o.p_values[result];
              } else {
                result = this._prettify(result);
              }

              html += '<span class="irs-grid-text js-grid-text-' + i + '" style="left: ' + big_w + '%">' + result + '</span>';
            }

            this.coords.big_num = Math.ceil(big_num + 1);
            this.$cache.cont.addClass('irs-with-grid');
            this.$cache.grid.html(html);
            this.cacheGridLabels();
          },
          cacheGridLabels: function cacheGridLabels() {
            var $label,
              i,
              num = this.coords.big_num;

            for (i = 0; i < num; i++) {
              $label = this.$cache.grid.find('.js-grid-text-' + i);
              this.$cache.grid_labels.push($label);
            }

            this.calcGridLabels();
          },
          calcGridLabels: function calcGridLabels() {
            var i,
              label,
              start = [],
              finish = [],
              num = this.coords.big_num;

            for (i = 0; i < num; i++) {
              this.coords.big_w[i] = this.$cache.grid_labels[i].outerWidth(false);
              this.coords.big_p[i] = this.toFixed(this.coords.big_w[i] / this.coords.w_rs * 100);
              this.coords.big_x[i] = this.toFixed(this.coords.big_p[i] / 2);
              start[i] = this.toFixed(this.coords.big[i] - this.coords.big_x[i]);
              finish[i] = this.toFixed(start[i] + this.coords.big_p[i]);
            }

            if (this.options.force_edges) {
              if (start[0] < -this.coords.grid_gap) {
                start[0] = -this.coords.grid_gap;
                finish[0] = this.toFixed(start[0] + this.coords.big_p[0]);
                this.coords.big_x[0] = this.coords.grid_gap;
              }

              if (finish[num - 1] > 100 + this.coords.grid_gap) {
                finish[num - 1] = 100 + this.coords.grid_gap;
                start[num - 1] = this.toFixed(finish[num - 1] - this.coords.big_p[num - 1]);
                this.coords.big_x[num - 1] = this.toFixed(this.coords.big_p[num - 1] - this.coords.grid_gap);
              }
            }

            this.calcGridCollision(2, start, finish);
            this.calcGridCollision(4, start, finish);

            for (i = 0; i < num; i++) {
              label = this.$cache.grid_labels[i][0];

              if (this.coords.big_x[i] !== Number.POSITIVE_INFINITY) {
                label.style.marginLeft = -this.coords.big_x[i] + '%';
              }
            }
          },
          // Collisions Calc Beta
          // TODO: Refactor then have plenty of time
          calcGridCollision: function calcGridCollision(step, start, finish) {
            var i,
              next_i,
              label,
              num = this.coords.big_num;

            for (i = 0; i < num; i += step) {
              next_i = i + step / 2;

              if (next_i >= num) {
                break;
              }

              label = this.$cache.grid_labels[next_i][0];

              if (finish[i] <= start[next_i]) {
                label.style.visibility = 'visible';
              } else {
                label.style.visibility = 'hidden';
              }
            }
          },
          calcGridMargin: function calcGridMargin() {
            if (!this.options.grid_margin) {
              return;
            }

            this.coords.w_rs = this.$cache.rs.outerWidth(false);

            if (!this.coords.w_rs) {
              return;
            }

            if (this.options.type === 'single') {
              this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
              this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }

            this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
            this.coords.grid_gap = this.toFixed(this.coords.p_handle / 2 - 0.1);
            this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + '%';
            this.$cache.grid[0].style.left = this.coords.grid_gap + '%';
          },
          // =============================================================================================================
          // Public methods
          update: function update(options) {
            if (!this.input) {
              return;
            }

            this.is_update = true;
            this.options.from = this.result.from;
            this.options.to = this.result.to;
            this.update_check.from = this.result.from;
            this.update_check.to = this.result.to;
            this.options = $.extend(this.options, options);
            this.validate();
            this.updateResult(options);
            this.toggleInput();
            this.remove();
            this.init(true);
          },
          reset: function reset() {
            if (!this.input) {
              return;
            }

            this.updateResult();
            this.update();
          },
          destroy: function destroy() {
            if (!this.input) {
              return;
            }

            this.toggleInput();
            this.$cache.input.prop('readonly', false);
            $.data(this.input, 'ionRangeSlider', null);
            this.remove();
            this.input = null;
            this.options = null;
          }
        };

        $.fn.ionRangeSlider = function (options) {
          return this.each(function () {
            if (!$.data(this, 'ionRangeSlider')) {
              $.data(this, 'ionRangeSlider', new IonRangeSlider(this, options, plugin_count++));
            }
          });
        } // =================================================================================================================
        // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
        // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
        // MIT license
        ;

        (function () {
          var lastTime = 0;
          var vendors = ['ms', 'moz', 'webkit', 'o'];

          for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
          }

          if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
              callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
          };
          if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
          };
        })();
      });

      /***/
    },

  /***/
  "96cf":
    /***/
    (function (module, exports, __webpack_require__) {

      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var runtime = (function (exports) {
        "use strict";

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

        function define(obj, key, value) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
          return obj[key];
        }
        try {
          // IE 8 has a broken Object.defineProperty that only works on DOM objects.
          define({}, "");
        } catch (err) {
          define = function (obj, key, value) {
            return obj[key] = value;
          };
        }

        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);

          // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.
          generator._invoke = makeInvokeMethod(innerFn, self, context);

          return generator;
        }
        exports.wrap = wrap;

        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: "normal",
              arg: fn.call(obj, arg)
            };
          } catch (err) {
            return {
              type: "throw",
              arg: err
            };
          }
        }

        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";

        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};

        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}

        function GeneratorFunction() {}

        function GeneratorFunctionPrototype() {}

        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };

        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype &&
          NativeIteratorPrototype !== Op &&
          hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }

        var Gp = GeneratorFunctionPrototype.prototype =
          Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunction.displayName = define(
          GeneratorFunctionPrototype,
          toStringTagSymbol,
          "GeneratorFunction"
        );

        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function (method) {
            define(prototype, method, function (arg) {
              return this._invoke(method, arg);
            });
          });
        }

        exports.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ?
            ctor === GeneratorFunction ||
            // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" :
            false;
        };

        exports.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };

        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function (arg) {
          return {
            __await: arg
          };
        };

        function AsyncIterator(generator, PromiseImpl) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value &&
                typeof value === "object" &&
                hasOwn.call(value, "__await")) {
                return PromiseImpl.resolve(value.__await).then(function (value) {
                  invoke("next", value, resolve, reject);
                }, function (err) {
                  invoke("throw", err, resolve, reject);
                });
              }

              return PromiseImpl.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration.
                result.value = unwrapped;
                resolve(result);
              }, function (error) {
                // If a rejected Promise was yielded, throw the rejection back
                // into the async generator function so it can be handled there.
                return invoke("throw", error, resolve, reject);
              });
            }
          }

          var previousPromise;

          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new PromiseImpl(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }

            return previousPromise =
              // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(
                callInvokeWithMethodAndArg,
                // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                callInvokeWithMethodAndArg
              ) : callInvokeWithMethodAndArg();
          }

          // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).
          this._invoke = enqueue;
        }

        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };
        exports.AsyncIterator = AsyncIterator;

        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
          if (PromiseImpl === void 0) PromiseImpl = Promise;

          var iter = new AsyncIterator(
            wrap(innerFn, outerFn, self, tryLocsList),
            PromiseImpl
          );

          return exports.isGeneratorFunction(outerFn) ?
            iter // If outerFn is a generator, return the full iterator.
            :
            iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
        };

        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;

          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }

            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              }

              // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
              return doneResult();
            }

            context.method = method;
            context.arg = arg;

            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }

              if (context.method === "next") {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;

              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }

                context.dispatchException(context.arg);

              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }

              state = GenStateExecuting;

              var record = tryCatch(innerFn, self, context);
              if (record.type === "normal") {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ?
                  GenStateCompleted :
                  GenStateSuspendedYield;

                if (record.arg === ContinueSentinel) {
                  continue;
                }

                return {
                  value: record.arg,
                  done: context.done
                };

              } else if (record.type === "throw") {
                state = GenStateCompleted;
                // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.
                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        }

        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];
          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;

            if (context.method === "throw") {
              // Note: ["return"] must be used for ES3 parsing compatibility.
              if (delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);

                if (context.method === "throw") {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }

              context.method = "throw";
              context.arg = new TypeError(
                "The iterator does not provide a 'throw' method");
            }

            return ContinueSentinel;
          }

          var record = tryCatch(method, delegate.iterator, context.arg);

          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }

          var info = record.arg;

          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }

          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;

            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;

            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined;
            }

          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          }

          // The delegate iterator is finished, so forget it and continue with
          // the outer generator.
          context.delegate = null;
          return ContinueSentinel;
        }

        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);

        define(Gp, toStringTagSymbol, "Generator");

        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        Gp[iteratorSymbol] = function () {
          return this;
        };

        Gp.toString = function () {
          return "[object Generator]";
        };

        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0]
          };

          if (1 in locs) {
            entry.catchLoc = locs[1];
          }

          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }

          this.tryEntries.push(entry);
        }

        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }

        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{
            tryLoc: "root"
          }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }

        exports.keys = function (object) {
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();

          // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.
          return function next() {
            while (keys.length) {
              var key = keys.pop();
              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            }

            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
          };
        };

        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }

            if (typeof iterable.next === "function") {
              return iterable;
            }

            if (!isNaN(iterable.length)) {
              var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;

                  return next;
                };

              return next.next = next;
            }
          }

          // Return an iterator with no values.
          return {
            next: doneResult
          };
        }
        exports.values = values;

        function doneResult() {
          return {
            value: undefined,
            done: true
          };
        }

        Context.prototype = {
          constructor: Context,

          reset: function (skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;

            this.method = "next";
            this.arg = undefined;

            this.tryEntries.forEach(resetTryEntry);

            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" &&
                  hasOwn.call(this, name) &&
                  !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },

          stop: function () {
            this.done = true;

            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }

            return this.rval;
          },

          dispatchException: function (exception) {
            if (this.done) {
              throw exception;
            }

            var context = this;

            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;

              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = "next";
                context.arg = undefined;
              }

              return !!caught;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;

              if (entry.tryLoc === "root") {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
              }

              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");

                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }

                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }

                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }

                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },

          abrupt: function (type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev &&
                hasOwn.call(entry, "finallyLoc") &&
                this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }

            if (finallyEntry &&
              (type === "break" ||
                type === "continue") &&
              finallyEntry.tryLoc <= arg &&
              arg <= finallyEntry.finallyLoc) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }

            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;

            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }

            return this.complete(record);
          },

          complete: function (record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }

            if (record.type === "break" ||
              record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }

            return ContinueSentinel;
          },

          finish: function (finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },

          "catch": function (tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }

            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
          },

          delegateYield: function (iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };

            if (this.method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }

            return ContinueSentinel;
          }
        };

        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;

      }(
        // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        true ? module.exports : undefined
      ));

      try {
        regeneratorRuntime = runtime;
      } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        Function("r", "regeneratorRuntime = r")(runtime);
      }


      /***/
    }),

  /***/
  "99af":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var fails = __webpack_require__("d039");
      var isArray = __webpack_require__("e8b5");
      var isObject = __webpack_require__("861d");
      var toObject = __webpack_require__("7b0b");
      var toLength = __webpack_require__("50c4");
      var createProperty = __webpack_require__("8418");
      var arraySpeciesCreate = __webpack_require__("65f0");
      var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
      var wellKnownSymbol = __webpack_require__("b622");
      var V8_VERSION = __webpack_require__("2d00");

      var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
      var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
      var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

      // We can't use this feature detection in V8 since it causes
      // deoptimization and serious performance degradation
      // https://github.com/zloirock/core-js/issues/679
      var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
      });

      var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

      var isConcatSpreadable = function (O) {
        if (!isObject(O)) return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== undefined ? !!spreadable : isArray(O);
      };

      var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

      // `Array.prototype.concat` method
      // https://tc39.es/ecma262/#sec-array.prototype.concat
      // with adding support of @@isConcatSpreadable and @@species
      $({
        target: 'Array',
        proto: true,
        forced: FORCED
      }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        concat: function concat(arg) {
          var O = toObject(this);
          var A = arraySpeciesCreate(O, 0);
          var n = 0;
          var i, k, length, len, E;
          for (i = -1, length = arguments.length; i < length; i++) {
            E = i === -1 ? O : arguments[i];
            if (isConcatSpreadable(E)) {
              len = toLength(E.length);
              if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
              for (k = 0; k < len; k++, n++)
                if (k in E) createProperty(A, n, E[k]);
            } else {
              if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
              createProperty(A, n++, E);
            }
          }
          A.length = n;
          return A;
        }
      });


      /***/
    }),

  /***/
  "9bdd":
    /***/
    (function (module, exports, __webpack_require__) {

      var anObject = __webpack_require__("825a");
      var iteratorClose = __webpack_require__("2a62");

      // call something on iterator step with safe closing on error
      module.exports = function (iterator, fn, value, ENTRIES) {
        try {
          return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (error) {
          iteratorClose(iterator);
          throw error;
        }
      };


      /***/
    }),

  /***/
  "9bf2":
    /***/
    (function (module, exports, __webpack_require__) {

      var DESCRIPTORS = __webpack_require__("83ab");
      var IE8_DOM_DEFINE = __webpack_require__("0cfb");
      var anObject = __webpack_require__("825a");
      var toPrimitive = __webpack_require__("c04e");

      // eslint-disable-next-line es/no-object-defineproperty -- safe
      var $defineProperty = Object.defineProperty;

      // `Object.defineProperty` method
      // https://tc39.es/ecma262/#sec-object.defineproperty
      exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return $defineProperty(O, P, Attributes);
        } catch (error) {
          /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };


      /***/
    }),

  /***/
  "9ed3":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
      var create = __webpack_require__("7c73");
      var createPropertyDescriptor = __webpack_require__("5c6c");
      var setToStringTag = __webpack_require__("d44e");
      var Iterators = __webpack_require__("3f8c");

      var returnThis = function () {
        return this;
      };

      module.exports = function (IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = create(IteratorPrototype, {
          next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        Iterators[TO_STRING_TAG] = returnThis;
        return IteratorConstructor;
      };


      /***/
    }),

  /***/
  "9f7f":
    /***/
    (function (module, exports, __webpack_require__) {

      var fails = __webpack_require__("d039");

      // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
      var RE = function (s, f) {
        return RegExp(s, f);
      };

      exports.UNSUPPORTED_Y = fails(function () {
        var re = RE('a', 'y');
        re.lastIndex = 2;
        return re.exec('abcd') != null;
      });

      exports.BROKEN_CARET = fails(function () {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
        var re = RE('^r', 'gy');
        re.lastIndex = 2;
        return re.exec('str') != null;
      });


      /***/
    }),

  /***/
  "a4b4":
    /***/
    (function (module, exports, __webpack_require__) {

      var userAgent = __webpack_require__("342f");

      module.exports = /web0s(?!.*chrome)/i.test(userAgent);


      /***/
    }),

  /***/
  "a4d3":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var global = __webpack_require__("da84");
      var getBuiltIn = __webpack_require__("d066");
      var IS_PURE = __webpack_require__("c430");
      var DESCRIPTORS = __webpack_require__("83ab");
      var NATIVE_SYMBOL = __webpack_require__("4930");
      var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
      var fails = __webpack_require__("d039");
      var has = __webpack_require__("5135");
      var isArray = __webpack_require__("e8b5");
      var isObject = __webpack_require__("861d");
      var anObject = __webpack_require__("825a");
      var toObject = __webpack_require__("7b0b");
      var toIndexedObject = __webpack_require__("fc6a");
      var toPrimitive = __webpack_require__("c04e");
      var createPropertyDescriptor = __webpack_require__("5c6c");
      var nativeObjectCreate = __webpack_require__("7c73");
      var objectKeys = __webpack_require__("df75");
      var getOwnPropertyNamesModule = __webpack_require__("241c");
      var getOwnPropertyNamesExternal = __webpack_require__("057f");
      var getOwnPropertySymbolsModule = __webpack_require__("7418");
      var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
      var definePropertyModule = __webpack_require__("9bf2");
      var propertyIsEnumerableModule = __webpack_require__("d1e7");
      var createNonEnumerableProperty = __webpack_require__("9112");
      var redefine = __webpack_require__("6eeb");
      var shared = __webpack_require__("5692");
      var sharedKey = __webpack_require__("f772");
      var hiddenKeys = __webpack_require__("d012");
      var uid = __webpack_require__("90e3");
      var wellKnownSymbol = __webpack_require__("b622");
      var wrappedWellKnownSymbolModule = __webpack_require__("e538");
      var defineWellKnownSymbol = __webpack_require__("746f");
      var setToStringTag = __webpack_require__("d44e");
      var InternalStateModule = __webpack_require__("69f3");
      var $forEach = __webpack_require__("b727").forEach;

      var HIDDEN = sharedKey('hidden');
      var SYMBOL = 'Symbol';
      var PROTOTYPE = 'prototype';
      var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(SYMBOL);
      var ObjectPrototype = Object[PROTOTYPE];
      var $Symbol = global.Symbol;
      var $stringify = getBuiltIn('JSON', 'stringify');
      var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      var nativeDefineProperty = definePropertyModule.f;
      var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
      var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
      var AllSymbols = shared('symbols');
      var ObjectPrototypeSymbols = shared('op-symbols');
      var StringToSymbolRegistry = shared('string-to-symbol-registry');
      var SymbolToStringRegistry = shared('symbol-to-string-registry');
      var WellKnownSymbolsStore = shared('wks');
      var QObject = global.QObject;
      // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
      var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

      // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
      var setSymbolDescriptor = DESCRIPTORS && fails(function () {
        return nativeObjectCreate(nativeDefineProperty({}, 'a', {
          get: function () {
            return nativeDefineProperty(this, 'a', {
              value: 7
            }).a;
          }
        })).a != 7;
      }) ? function (O, P, Attributes) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
        if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
        nativeDefineProperty(O, P, Attributes);
        if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
          nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
        }
      } : nativeDefineProperty;

      var wrap = function (tag, description) {
        var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
        setInternalState(symbol, {
          type: SYMBOL,
          tag: tag,
          description: description
        });
        if (!DESCRIPTORS) symbol.description = description;
        return symbol;
      };

      var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
        return typeof it == 'symbol';
      } : function (it) {
        return Object(it) instanceof $Symbol;
      };

      var $defineProperty = function defineProperty(O, P, Attributes) {
        if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
        anObject(O);
        var key = toPrimitive(P, true);
        anObject(Attributes);
        if (has(AllSymbols, key)) {
          if (!Attributes.enumerable) {
            if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
            O[HIDDEN][key] = true;
          } else {
            if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
            Attributes = nativeObjectCreate(Attributes, {
              enumerable: createPropertyDescriptor(0, false)
            });
          }
          return setSymbolDescriptor(O, key, Attributes);
        }
        return nativeDefineProperty(O, key, Attributes);
      };

      var $defineProperties = function defineProperties(O, Properties) {
        anObject(O);
        var properties = toIndexedObject(Properties);
        var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
        $forEach(keys, function (key) {
          if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
        });
        return O;
      };

      var $create = function create(O, Properties) {
        return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
      };

      var $propertyIsEnumerable = function propertyIsEnumerable(V) {
        var P = toPrimitive(V, true);
        var enumerable = nativePropertyIsEnumerable.call(this, P);
        if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
        return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
      };

      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
        var it = toIndexedObject(O);
        var key = toPrimitive(P, true);
        if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
        var descriptor = nativeGetOwnPropertyDescriptor(it, key);
        if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
          descriptor.enumerable = true;
        }
        return descriptor;
      };

      var $getOwnPropertyNames = function getOwnPropertyNames(O) {
        var names = nativeGetOwnPropertyNames(toIndexedObject(O));
        var result = [];
        $forEach(names, function (key) {
          if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
        });
        return result;
      };

      var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
        var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
        var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
        var result = [];
        $forEach(names, function (key) {
          if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
            result.push(AllSymbols[key]);
          }
        });
        return result;
      };

      // `Symbol` constructor
      // https://tc39.es/ecma262/#sec-symbol-constructor
      if (!NATIVE_SYMBOL) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
          var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
          var tag = uid(description);
          var setter = function (value) {
            if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
          };
          if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
            configurable: true,
            set: setter
          });
          return wrap(tag, description);
        };

        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return getInternalState(this).tag;
        });

        redefine($Symbol, 'withoutSetter', function (description) {
          return wrap(uid(description), description);
        });

        propertyIsEnumerableModule.f = $propertyIsEnumerable;
        definePropertyModule.f = $defineProperty;
        getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
        getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

        wrappedWellKnownSymbolModule.f = function (name) {
          return wrap(wellKnownSymbol(name), name);
        };

        if (DESCRIPTORS) {
          // https://github.com/tc39/proposal-Symbol-description
          nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
            configurable: true,
            get: function description() {
              return getInternalState(this).description;
            }
          });
          if (!IS_PURE) {
            redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
              unsafe: true
            });
          }
        }
      }

      $({
        global: true,
        wrap: true,
        forced: !NATIVE_SYMBOL,
        sham: !NATIVE_SYMBOL
      }, {
        Symbol: $Symbol
      });

      $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
        defineWellKnownSymbol(name);
      });

      $({
        target: SYMBOL,
        stat: true,
        forced: !NATIVE_SYMBOL
      }, {
        // `Symbol.for` method
        // https://tc39.es/ecma262/#sec-symbol.for
        'for': function (key) {
          var string = String(key);
          if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
          var symbol = $Symbol(string);
          StringToSymbolRegistry[string] = symbol;
          SymbolToStringRegistry[symbol] = string;
          return symbol;
        },
        // `Symbol.keyFor` method
        // https://tc39.es/ecma262/#sec-symbol.keyfor
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
          if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
        },
        useSetter: function () {
          USE_SETTER = true;
        },
        useSimple: function () {
          USE_SETTER = false;
        }
      });

      $({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL,
        sham: !DESCRIPTORS
      }, {
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
      });

      $({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL
      }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames,
        // `Object.getOwnPropertySymbols` method
        // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
        getOwnPropertySymbols: $getOwnPropertySymbols
      });

      // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
      // https://bugs.chromium.org/p/v8/issues/detail?id=3443
      $({
        target: 'Object',
        stat: true,
        forced: fails(function () {
          getOwnPropertySymbolsModule.f(1);
        })
      }, {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return getOwnPropertySymbolsModule.f(toObject(it));
        }
      });

      // `JSON.stringify` method behavior with symbols
      // https://tc39.es/ecma262/#sec-json.stringify
      if ($stringify) {
        var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
          var symbol = $Symbol();
          // MS Edge converts symbol values to JSON as {}
          return $stringify([symbol]) != '[null]'
            // WebKit converts symbol values to JSON as null
            ||
            $stringify({
              a: symbol
            }) != '{}'
            // V8 throws on boxed symbols
            ||
            $stringify(Object(symbol)) != '{}';
        });

        $({
          target: 'JSON',
          stat: true,
          forced: FORCED_JSON_STRINGIFY
        }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          stringify: function stringify(it, replacer, space) {
            var args = [it];
            var index = 1;
            var $replacer;
            while (arguments.length > index) args.push(arguments[index++]);
            $replacer = replacer;
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
            if (!isArray(replacer)) replacer = function (key, value) {
              if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return $stringify.apply(null, args);
          }
        });
      }

      // `Symbol.prototype[@@toPrimitive]` method
      // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
      if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
        createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
      }
      // `Symbol.prototype[@@toStringTag]` property
      // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
      setToStringTag($Symbol, SYMBOL);

      hiddenKeys[HIDDEN] = true;


      /***/
    }),

  /***/
  "a630":
    /***/
    (function (module, exports, __webpack_require__) {

      var $ = __webpack_require__("23e7");
      var from = __webpack_require__("4df4");
      var checkCorrectnessOfIteration = __webpack_require__("1c7e");

      var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
        // eslint-disable-next-line es/no-array-from -- required for testing
        Array.from(iterable);
      });

      // `Array.from` method
      // https://tc39.es/ecma262/#sec-array.from
      $({
        target: 'Array',
        stat: true,
        forced: INCORRECT_ITERATION
      }, {
        from: from
      });


      /***/
    }),

  /***/
  "a691":
    /***/
    (function (module, exports) {

      var ceil = Math.ceil;
      var floor = Math.floor;

      // `ToInteger` abstract operation
      // https://tc39.es/ecma262/#sec-tointeger
      module.exports = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
      };


      /***/
    }),

  /***/
  "a9e3":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var DESCRIPTORS = __webpack_require__("83ab");
      var global = __webpack_require__("da84");
      var isForced = __webpack_require__("94ca");
      var redefine = __webpack_require__("6eeb");
      var has = __webpack_require__("5135");
      var classof = __webpack_require__("c6b6");
      var inheritIfRequired = __webpack_require__("7156");
      var toPrimitive = __webpack_require__("c04e");
      var fails = __webpack_require__("d039");
      var create = __webpack_require__("7c73");
      var getOwnPropertyNames = __webpack_require__("241c").f;
      var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
      var defineProperty = __webpack_require__("9bf2").f;
      var trim = __webpack_require__("58a8").trim;

      var NUMBER = 'Number';
      var NativeNumber = global[NUMBER];
      var NumberPrototype = NativeNumber.prototype;

      // Opera ~12 has broken Object#toString
      var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

      // `ToNumber` abstract operation
      // https://tc39.es/ecma262/#sec-tonumber
      var toNumber = function (argument) {
        var it = toPrimitive(argument, false);
        var first, third, radix, maxCode, digits, length, index, code;
        if (typeof it == 'string' && it.length > 2) {
          it = trim(it);
          first = it.charCodeAt(0);
          if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
          } else if (first === 48) {
            switch (it.charCodeAt(1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break; // fast equal of /^0b[01]+$/i
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break; // fast equal of /^0o[0-7]+$/i
              default:
                return +it;
            }
            digits = it.slice(2);
            length = digits.length;
            for (index = 0; index < length; index++) {
              code = digits.charCodeAt(index);
              // parseInt parses a string to a first unavailable symbol
              // but ToNumber should return NaN if a string contains unavailable symbols
              if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };

      // `Number` constructor
      // https://tc39.es/ecma262/#sec-number-constructor
      if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
        var NumberWrapper = function Number(value) {
          var it = arguments.length < 1 ? 0 : value;
          var dummy = this;
          return dummy instanceof NumberWrapper
            // check on 1..constructor(foo) case
            &&
            (BROKEN_CLASSOF ? fails(function () {
              NumberPrototype.valueOf.call(dummy);
            }) : classof(dummy) != NUMBER) ?
            inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
        };
        for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
            // ES3:
            'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
            // ES2015 (in case, if modules with ES2015 Number statics required before):
            'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
            'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
            // ESNext
            'fromString,range'
          ).split(','), j = 0, key; keys.length > j; j++) {
          if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
            defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
          }
        }
        NumberWrapper.prototype = NumberPrototype;
        NumberPrototype.constructor = NumberWrapper;
        redefine(global, NUMBER, NumberWrapper);
      }


      /***/
    }),

  /***/
  "ac1f":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var exec = __webpack_require__("9263");

      // `RegExp.prototype.exec` method
      // https://tc39.es/ecma262/#sec-regexp.prototype.exec
      $({
        target: 'RegExp',
        proto: true,
        forced: /./.exec !== exec
      }, {
        exec: exec
      });


      /***/
    }),

  /***/
  "ad6d":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var anObject = __webpack_require__("825a");

      // `RegExp.prototype.flags` getter implementation
      // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
      module.exports = function () {
        var that = anObject(this);
        var result = '';
        if (that.global) result += 'g';
        if (that.ignoreCase) result += 'i';
        if (that.multiline) result += 'm';
        if (that.dotAll) result += 's';
        if (that.unicode) result += 'u';
        if (that.sticky) result += 'y';
        return result;
      };


      /***/
    }),

  /***/
  "ae93":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var fails = __webpack_require__("d039");
      var getPrototypeOf = __webpack_require__("e163");
      var createNonEnumerableProperty = __webpack_require__("9112");
      var has = __webpack_require__("5135");
      var wellKnownSymbol = __webpack_require__("b622");
      var IS_PURE = __webpack_require__("c430");

      var ITERATOR = wellKnownSymbol('iterator');
      var BUGGY_SAFARI_ITERATORS = false;

      var returnThis = function () {
        return this;
      };

      // `%IteratorPrototype%` object
      // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
      var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

      /* eslint-disable es/no-array-prototype-keys -- safe */
      if ([].keys) {
        arrayIterator = [].keys();
        // Safari 8 has buggy iterators w/o `next`
        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
        else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
      }

      var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
        var test = {};
        // FF44- legacy iterators case
        return IteratorPrototype[ITERATOR].call(test) !== test;
      });

      if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

      // `%IteratorPrototype%[@@iterator]()` method
      // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
      if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
        createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
      }

      module.exports = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
      };


      /***/
    }),

  /***/
  "af03":
    /***/
    (function (module, exports, __webpack_require__) {

      var fails = __webpack_require__("d039");

      // check the existence of a method, lowercase
      // of a tag and escaping quotes in arguments
      module.exports = function (METHOD_NAME) {
        return fails(function () {
          var test = '' [METHOD_NAME]('"');
          return test !== test.toLowerCase() || test.split('"').length > 3;
        });
      };


      /***/
    }),

  /***/
  "b041":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
      var classof = __webpack_require__("f5df");

      // `Object.prototype.toString` method implementation
      // https://tc39.es/ecma262/#sec-object.prototype.tostring
      module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
        return '[object ' + classof(this) + ']';
      };


      /***/
    }),

  /***/
  "b0c0":
    /***/
    (function (module, exports, __webpack_require__) {

      var DESCRIPTORS = __webpack_require__("83ab");
      var defineProperty = __webpack_require__("9bf2").f;

      var FunctionPrototype = Function.prototype;
      var FunctionPrototypeToString = FunctionPrototype.toString;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = 'name';

      // Function instances `.name` property
      // https://tc39.es/ecma262/#sec-function-instances-name
      if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
        defineProperty(FunctionPrototype, NAME, {
          configurable: true,
          get: function () {
            try {
              return FunctionPrototypeToString.call(this).match(nameRE)[1];
            } catch (error) {
              return '';
            }
          }
        });
      }


      /***/
    }),

  /***/
  "b575":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
      var macrotask = __webpack_require__("2cf4").set;
      var IS_IOS = __webpack_require__("1cdc");
      var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
      var IS_NODE = __webpack_require__("605d");

      var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
      var document = global.document;
      var process = global.process;
      var Promise = global.Promise;
      // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
      var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
      var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

      var flush, head, last, notify, toggle, node, promise, then;

      // modern engines have queueMicrotask method
      if (!queueMicrotask) {
        flush = function () {
          var parent, fn;
          if (IS_NODE && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (error) {
              if (head) notify();
              else last = undefined;
              throw error;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };

        // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
        // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
        if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
          toggle = true;
          node = document.createTextNode('');
          new MutationObserver(flush).observe(node, {
            characterData: true
          });
          notify = function () {
            node.data = toggle = !toggle;
          };
          // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          // Promise.resolve without an argument throws an error in LG WebOS 2
          promise = Promise.resolve(undefined);
          // workaround of WebKit ~ iOS Safari 10.1 bug
          promise.constructor = Promise;
          then = promise.then;
          notify = function () {
            then.call(promise, flush);
          };
          // Node.js without promises
        } else if (IS_NODE) {
          notify = function () {
            process.nextTick(flush);
          };
          // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout
        } else {
          notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }
      }

      module.exports = queueMicrotask || function (fn) {
        var task = {
          fn: fn,
          next: undefined
        };
        if (last) last.next = task;
        if (!head) {
          head = task;
          notify();
        }
        last = task;
      };


      /***/
    }),

  /***/
  "b622":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var shared = __webpack_require__("5692");
      var has = __webpack_require__("5135");
      var uid = __webpack_require__("90e3");
      var NATIVE_SYMBOL = __webpack_require__("4930");
      var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

      var WellKnownSymbolsStore = shared('wks');
      var Symbol = global.Symbol;
      var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

      module.exports = function (name) {
        if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
          if (NATIVE_SYMBOL && has(Symbol, name)) {
            WellKnownSymbolsStore[name] = Symbol[name];
          } else {
            WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
          }
        }
        return WellKnownSymbolsStore[name];
      };


      /***/
    }),

  /***/
  "b680":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var toInteger = __webpack_require__("a691");
      var thisNumberValue = __webpack_require__("408a");
      var repeat = __webpack_require__("1148");
      var fails = __webpack_require__("d039");

      var nativeToFixed = 1.0.toFixed;
      var floor = Math.floor;

      var pow = function (x, n, acc) {
        return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
      };

      var log = function (x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };

      var multiply = function (data, n, c) {
        var index = -1;
        var c2 = c;
        while (++index < 6) {
          c2 += n * data[index];
          data[index] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };

      var divide = function (data, n) {
        var index = 6;
        var c = 0;
        while (--index >= 0) {
          c += data[index];
          data[index] = floor(c / n);
          c = (c % n) * 1e7;
        }
      };

      var dataToString = function (data) {
        var index = 6;
        var s = '';
        while (--index >= 0) {
          if (s !== '' || index === 0 || data[index] !== 0) {
            var t = String(data[index]);
            s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
          }
        }
        return s;
      };

      var FORCED = nativeToFixed && (
        0.00008.toFixed(3) !== '0.000' ||
        0.9.toFixed(0) !== '1' ||
        1.255.toFixed(2) !== '1.25' ||
        1000000000000000128.0.toFixed(0) !== '1000000000000000128'
      ) || !fails(function () {
        // V8 ~ Android 4.3-
        nativeToFixed.call({});
      });

      // `Number.prototype.toFixed` method
      // https://tc39.es/ecma262/#sec-number.prototype.tofixed
      $({
        target: 'Number',
        proto: true,
        forced: FORCED
      }, {
        toFixed: function toFixed(fractionDigits) {
          var number = thisNumberValue(this);
          var fractDigits = toInteger(fractionDigits);
          var data = [0, 0, 0, 0, 0, 0];
          var sign = '';
          var result = '0';
          var e, z, j, k;

          if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
          // eslint-disable-next-line no-self-compare -- NaN check
          if (number != number) return 'NaN';
          if (number <= -1e21 || number >= 1e21) return String(number);
          if (number < 0) {
            sign = '-';
            number = -number;
          }
          if (number > 1e-21) {
            e = log(number * pow(2, 69, 1)) - 69;
            z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
              multiply(data, 0, z);
              j = fractDigits;
              while (j >= 7) {
                multiply(data, 1e7, 0);
                j -= 7;
              }
              multiply(data, pow(10, j, 1), 0);
              j = e - 1;
              while (j >= 23) {
                divide(data, 1 << 23);
                j -= 23;
              }
              divide(data, 1 << j);
              multiply(data, 1, 1);
              divide(data, 2);
              result = dataToString(data);
            } else {
              multiply(data, 0, z);
              multiply(data, 1 << -e, 0);
              result = dataToString(data) + repeat.call('0', fractDigits);
            }
          }
          if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ?
              '0.' + repeat.call('0', fractDigits - k) + result :
              result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
          } else {
            result = sign + result;
          }
          return result;
        }
      });


      /***/
    }),

  /***/
  "b727":
    /***/
    (function (module, exports, __webpack_require__) {

      var bind = __webpack_require__("0366");
      var IndexedObject = __webpack_require__("44ad");
      var toObject = __webpack_require__("7b0b");
      var toLength = __webpack_require__("50c4");
      var arraySpeciesCreate = __webpack_require__("65f0");

      var push = [].push;

      // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
      var createMethod = function (TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var IS_FILTER_OUT = TYPE == 7;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        return function ($this, callbackfn, that, specificCreate) {
          var O = toObject($this);
          var self = IndexedObject(O);
          var boundFunction = bind(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var create = specificCreate || arraySpeciesCreate;
          var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
          var value, result;
          for (; length > index; index++)
            if (NO_HOLES || index in self) {
              value = self[index];
              result = boundFunction(value, index, O);
              if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch (TYPE) {
                  case 3:
                    return true; // some
                  case 5:
                    return value; // find
                  case 6:
                    return index; // findIndex
                  case 2:
                    push.call(target, value); // filter
                } else switch (TYPE) {
                  case 4:
                    return false; // every
                  case 7:
                    push.call(target, value); // filterOut
                }
              }
            }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
      };

      module.exports = {
        // `Array.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        forEach: createMethod(0),
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        map: createMethod(1),
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        filter: createMethod(2),
        // `Array.prototype.some` method
        // https://tc39.es/ecma262/#sec-array.prototype.some
        some: createMethod(3),
        // `Array.prototype.every` method
        // https://tc39.es/ecma262/#sec-array.prototype.every
        every: createMethod(4),
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        find: createMethod(5),
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod(6),
        // `Array.prototype.filterOut` method
        // https://github.com/tc39/proposal-array-filtering
        filterOut: createMethod(7)
      };


      /***/
    }),

  /***/
  "c04e":
    /***/
    (function (module, exports, __webpack_require__) {

      var isObject = __webpack_require__("861d");

      // `ToPrimitive` abstract operation
      // https://tc39.es/ecma262/#sec-toprimitive
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (input, PREFERRED_STRING) {
        if (!isObject(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
      };


      /***/
    }),

  /***/
  "c410":
    /***/
    (function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony import */
      var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_HistogramSlider_vue_vue_type_style_index_0_id_3a112b68_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6ba");
      /* harmony import */
      var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_HistogramSlider_vue_vue_type_style_index_0_id_3a112b68_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_HistogramSlider_vue_vue_type_style_index_0_id_3a112b68_lang_css__WEBPACK_IMPORTED_MODULE_0__);
      /* unused harmony reexport * */


      /***/
    }),

  /***/
  "c430":
    /***/
    (function (module, exports) {

      module.exports = false;


      /***/
    }),

  /***/
  "c6b6":
    /***/
    (function (module, exports) {

      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };


      /***/
    }),

  /***/
  "c6ba":
    /***/
    (function (module, exports, __webpack_require__) {

      // extracted by mini-css-extract-plugin

      /***/
    }),

  /***/
  "c6cd":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var setGlobal = __webpack_require__("ce4e");

      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || setGlobal(SHARED, {});

      module.exports = store;


      /***/
    }),

  /***/
  "c8ba":
    /***/
    (function (module, exports) {

      var g;

      // This works in non-strict mode
      g = (function () {
        return this;
      })();

      try {
        // This works if eval is allowed (see CSP)
        g = g || new Function("return this")();
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      }

      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}

      module.exports = g;


      /***/
    }),

  /***/
  "ca84":
    /***/
    (function (module, exports, __webpack_require__) {

      var has = __webpack_require__("5135");
      var toIndexedObject = __webpack_require__("fc6a");
      var indexOf = __webpack_require__("4d64").indexOf;
      var hiddenKeys = __webpack_require__("d012");

      module.exports = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i)
          if (has(O, key = names[i++])) {
            ~indexOf(result, key) || result.push(key);
          }
        return result;
      };


      /***/
    }),

  /***/
  "cc12":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var isObject = __webpack_require__("861d");

      var document = global.document;
      // typeof document.createElement is 'object' in old IE
      var EXISTS = isObject(document) && isObject(document.createElement);

      module.exports = function (it) {
        return EXISTS ? document.createElement(it) : {};
      };


      /***/
    }),

  /***/
  "cdf9":
    /***/
    (function (module, exports, __webpack_require__) {

      var anObject = __webpack_require__("825a");
      var isObject = __webpack_require__("861d");
      var newPromiseCapability = __webpack_require__("f069");

      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };


      /***/
    }),

  /***/
  "ce4e":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var createNonEnumerableProperty = __webpack_require__("9112");

      module.exports = function (key, value) {
        try {
          createNonEnumerableProperty(global, key, value);
        } catch (error) {
          global[key] = value;
        }
        return value;
      };


      /***/
    }),

  /***/
  "d012":
    /***/
    (function (module, exports) {

      module.exports = {};


      /***/
    }),

  /***/
  "d039":
    /***/
    (function (module, exports) {

      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (error) {
          return true;
        }
      };


      /***/
    }),

  /***/
  "d066":
    /***/
    (function (module, exports, __webpack_require__) {

      var path = __webpack_require__("428f");
      var global = __webpack_require__("da84");

      var aFunction = function (variable) {
        return typeof variable == 'function' ? variable : undefined;
      };

      module.exports = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) :
          path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
      };


      /***/
    }),

  /***/
  "d1e7":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $propertyIsEnumerable = {}.propertyIsEnumerable;
      // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

      // Nashorn ~ JDK8 bug
      var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
        1: 2
      }, 1);

      // `Object.prototype.propertyIsEnumerable` method implementation
      // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
      exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
      } : $propertyIsEnumerable;


      /***/
    }),

  /***/
  "d28b":
    /***/
    (function (module, exports, __webpack_require__) {

      var defineWellKnownSymbol = __webpack_require__("746f");

      // `Symbol.iterator` well-known symbol
      // https://tc39.es/ecma262/#sec-symbol.iterator
      defineWellKnownSymbol('iterator');


      /***/
    }),

  /***/
  "d2bb":
    /***/
    (function (module, exports, __webpack_require__) {

      /* eslint-disable no-proto -- safe */
      var anObject = __webpack_require__("825a");
      var aPossiblePrototype = __webpack_require__("3bbe");

      // `Object.setPrototypeOf` method
      // https://tc39.es/ecma262/#sec-object.setprototypeof
      // Works with __proto__ only. Old v8 can't work with null proto objects.
      // eslint-disable-next-line es/no-object-setprototypeof -- safe
      module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
          // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
          setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
          setter.call(test, []);
          CORRECT_SETTER = test instanceof Array;
        } catch (error) {
          /* empty */
        }
        return function setPrototypeOf(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER) setter.call(O, proto);
          else O.__proto__ = proto;
          return O;
        };
      }() : undefined);


      /***/
    }),

  /***/
  "d3b7":
    /***/
    (function (module, exports, __webpack_require__) {

      var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
      var redefine = __webpack_require__("6eeb");
      var toString = __webpack_require__("b041");

      // `Object.prototype.toString` method
      // https://tc39.es/ecma262/#sec-object.prototype.tostring
      if (!TO_STRING_TAG_SUPPORT) {
        redefine(Object.prototype, 'toString', toString, {
          unsafe: true
        });
      }


      /***/
    }),

  /***/
  "d44e":
    /***/
    (function (module, exports, __webpack_require__) {

      var defineProperty = __webpack_require__("9bf2").f;
      var has = __webpack_require__("5135");
      var wellKnownSymbol = __webpack_require__("b622");

      var TO_STRING_TAG = wellKnownSymbol('toStringTag');

      module.exports = function (it, TAG, STATIC) {
        if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
          defineProperty(it, TO_STRING_TAG, {
            configurable: true,
            value: TAG
          });
        }
      };


      /***/
    }),

  /***/
  "d784":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      // TODO: Remove from `core-js@4` since it's moved to entry points
      __webpack_require__("ac1f");
      var redefine = __webpack_require__("6eeb");
      var regexpExec = __webpack_require__("9263");
      var fails = __webpack_require__("d039");
      var wellKnownSymbol = __webpack_require__("b622");
      var createNonEnumerableProperty = __webpack_require__("9112");

      var SPECIES = wellKnownSymbol('species');
      var RegExpPrototype = RegExp.prototype;

      module.exports = function (KEY, exec, FORCED, SHAM) {
        var SYMBOL = wellKnownSymbol(KEY);

        var DELEGATES_TO_SYMBOL = !fails(function () {
          // String methods call symbol-named RegEp methods
          var O = {};
          O[SYMBOL] = function () {
            return 7;
          };
          return '' [KEY](O) != 7;
        });

        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
          // Symbol-named RegExp methods call .exec
          var execCalled = false;
          var re = /a/;

          if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function () {
              return re;
            };
            re.flags = '';
            re[SYMBOL] = /./ [SYMBOL];
          }

          re.exec = function () {
            execCalled = true;
            return null;
          };

          re[SYMBOL]('');
          return !execCalled;
        });

        if (
          !DELEGATES_TO_SYMBOL ||
          !DELEGATES_TO_EXEC ||
          FORCED
        ) {
          var nativeRegExpMethod = /./ [SYMBOL];
          var methods = exec(SYMBOL, '' [KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
              if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                  done: true,
                  value: nativeRegExpMethod.call(regexp, str, arg2)
                };
              }
              return {
                done: true,
                value: nativeMethod.call(str, regexp, arg2)
              };
            }
            return {
              done: false
            };
          });

          redefine(String.prototype, KEY, methods[0]);
          redefine(RegExpPrototype, SYMBOL, methods[1]);
        }

        if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
      };


      /***/
    }),

  /***/
  "da84":
    /***/
    (function (module, exports, __webpack_require__) {

      /* WEBPACK VAR INJECTION */
      (function (global) {
        var check = function (it) {
          return it && it.Math == Math && it;
        };

        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports =
          // eslint-disable-next-line es/no-global-this -- safe
          check(typeof globalThis == 'object' && globalThis) ||
          check(typeof window == 'object' && window) ||
          // eslint-disable-next-line no-restricted-globals -- safe
          check(typeof self == 'object' && self) ||
          check(typeof global == 'object' && global) ||
          // eslint-disable-next-line no-new-func -- fallback
          (function () {
            return this;
          })() || Function('return this')();

        /* WEBPACK VAR INJECTION */
      }.call(this, __webpack_require__("c8ba")))

      /***/
    }),

  /***/
  "ddb0":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");
      var DOMIterables = __webpack_require__("fdbc");
      var ArrayIteratorMethods = __webpack_require__("e260");
      var createNonEnumerableProperty = __webpack_require__("9112");
      var wellKnownSymbol = __webpack_require__("b622");

      var ITERATOR = wellKnownSymbol('iterator');
      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      var ArrayValues = ArrayIteratorMethods.values;

      for (var COLLECTION_NAME in DOMIterables) {
        var Collection = global[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;
        if (CollectionPrototype) {
          // some Chrome versions have non-configurable methods on DOMTokenList
          if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
          } catch (error) {
            CollectionPrototype[ITERATOR] = ArrayValues;
          }
          if (!CollectionPrototype[TO_STRING_TAG]) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
          }
          if (DOMIterables[COLLECTION_NAME])
            for (var METHOD_NAME in ArrayIteratorMethods) {
              // some Chrome versions have non-configurable methods on DOMTokenList
              if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
              } catch (error) {
                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
              }
            }
        }
      }


      /***/
    }),

  /***/
  "df75":
    /***/
    (function (module, exports, __webpack_require__) {

      var internalObjectKeys = __webpack_require__("ca84");
      var enumBugKeys = __webpack_require__("7839");

      // `Object.keys` method
      // https://tc39.es/ecma262/#sec-object.keys
      // eslint-disable-next-line es/no-object-keys -- safe
      module.exports = Object.keys || function keys(O) {
        return internalObjectKeys(O, enumBugKeys);
      };


      /***/
    }),

  /***/
  "e01a":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";
      // `Symbol.prototype.description` getter
      // https://tc39.es/ecma262/#sec-symbol.prototype.description

      var $ = __webpack_require__("23e7");
      var DESCRIPTORS = __webpack_require__("83ab");
      var global = __webpack_require__("da84");
      var has = __webpack_require__("5135");
      var isObject = __webpack_require__("861d");
      var defineProperty = __webpack_require__("9bf2").f;
      var copyConstructorProperties = __webpack_require__("e893");

      var NativeSymbol = global.Symbol;

      if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
          // Safari 12 bug
          NativeSymbol().description !== undefined
        )) {
        var EmptyStringDescriptionStore = {};
        // wrap Symbol constructor for correct work with undefined description
        var SymbolWrapper = function Symbol() {
          var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
          var result = this instanceof SymbolWrapper ?
            new NativeSymbol(description)
            // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
            :
            description === undefined ? NativeSymbol() : NativeSymbol(description);
          if (description === '') EmptyStringDescriptionStore[result] = true;
          return result;
        };
        copyConstructorProperties(SymbolWrapper, NativeSymbol);
        var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
        symbolPrototype.constructor = SymbolWrapper;

        var symbolToString = symbolPrototype.toString;
        var native = String(NativeSymbol('test')) == 'Symbol(test)';
        var regexp = /^Symbol\((.*)\)[^)]+$/;
        defineProperty(symbolPrototype, 'description', {
          configurable: true,
          get: function description() {
            var symbol = isObject(this) ? this.valueOf() : this;
            var string = symbolToString.call(symbol);
            if (has(EmptyStringDescriptionStore, symbol)) return '';
            var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
            return desc === '' ? undefined : desc;
          }
        });

        $({
          global: true,
          forced: true
        }, {
          Symbol: SymbolWrapper
        });
      }


      /***/
    }),

  /***/
  "e163":
    /***/
    (function (module, exports, __webpack_require__) {

      var has = __webpack_require__("5135");
      var toObject = __webpack_require__("7b0b");
      var sharedKey = __webpack_require__("f772");
      var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

      var IE_PROTO = sharedKey('IE_PROTO');
      var ObjectPrototype = Object.prototype;

      // `Object.getPrototypeOf` method
      // https://tc39.es/ecma262/#sec-object.getprototypeof
      // eslint-disable-next-line es/no-object-getprototypeof -- safe
      module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectPrototype : null;
      };


      /***/
    }),

  /***/
  "e177":
    /***/
    (function (module, exports, __webpack_require__) {

      var fails = __webpack_require__("d039");

      module.exports = !fails(function () {
        function F() {
          /* empty */
        }
        F.prototype.constructor = null;
        // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
        return Object.getPrototypeOf(new F()) !== F.prototype;
      });


      /***/
    }),

  /***/
  "e260":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var toIndexedObject = __webpack_require__("fc6a");
      var addToUnscopables = __webpack_require__("44d2");
      var Iterators = __webpack_require__("3f8c");
      var InternalStateModule = __webpack_require__("69f3");
      var defineIterator = __webpack_require__("7dd0");

      var ARRAY_ITERATOR = 'Array Iterator';
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

      // `Array.prototype.entries` method
      // https://tc39.es/ecma262/#sec-array.prototype.entries
      // `Array.prototype.keys` method
      // https://tc39.es/ecma262/#sec-array.prototype.keys
      // `Array.prototype.values` method
      // https://tc39.es/ecma262/#sec-array.prototype.values
      // `Array.prototype[@@iterator]` method
      // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
      // `CreateArrayIterator` internal method
      // https://tc39.es/ecma262/#sec-createarrayiterator
      module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
        setInternalState(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(iterated), // target
          index: 0, // next index
          kind: kind // kind
        });
        // `%ArrayIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
      }, function () {
        var state = getInternalState(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;
        if (!target || index >= target.length) {
          state.target = undefined;
          return {
            value: undefined,
            done: true
          };
        }
        if (kind == 'keys') return {
          value: index,
          done: false
        };
        if (kind == 'values') return {
          value: target[index],
          done: false
        };
        return {
          value: [index, target[index]],
          done: false
        };
      }, 'values');

      // argumentsList[@@iterator] is %ArrayProto_values%
      // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
      // https://tc39.es/ecma262/#sec-createmappedargumentsobject
      Iterators.Arguments = Iterators.Array;

      // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');


      /***/
    }),

  /***/
  "e2cc":
    /***/
    (function (module, exports, __webpack_require__) {

      var redefine = __webpack_require__("6eeb");

      module.exports = function (target, src, options) {
        for (var key in src) redefine(target, key, src[key], options);
        return target;
      };


      /***/
    }),

  /***/
  "e538":
    /***/
    (function (module, exports, __webpack_require__) {

      var wellKnownSymbol = __webpack_require__("b622");

      exports.f = wellKnownSymbol;


      /***/
    }),

  /***/
  "e667":
    /***/
    (function (module, exports) {

      module.exports = function (exec) {
        try {
          return {
            error: false,
            value: exec()
          };
        } catch (error) {
          return {
            error: true,
            value: error
          };
        }
      };


      /***/
    }),

  /***/
  "e6cf":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var IS_PURE = __webpack_require__("c430");
      var global = __webpack_require__("da84");
      var getBuiltIn = __webpack_require__("d066");
      var NativePromise = __webpack_require__("fea9");
      var redefine = __webpack_require__("6eeb");
      var redefineAll = __webpack_require__("e2cc");
      var setPrototypeOf = __webpack_require__("d2bb");
      var setToStringTag = __webpack_require__("d44e");
      var setSpecies = __webpack_require__("2626");
      var isObject = __webpack_require__("861d");
      var aFunction = __webpack_require__("1c0b");
      var anInstance = __webpack_require__("19aa");
      var inspectSource = __webpack_require__("8925");
      var iterate = __webpack_require__("2266");
      var checkCorrectnessOfIteration = __webpack_require__("1c7e");
      var speciesConstructor = __webpack_require__("4840");
      var task = __webpack_require__("2cf4").set;
      var microtask = __webpack_require__("b575");
      var promiseResolve = __webpack_require__("cdf9");
      var hostReportErrors = __webpack_require__("44de");
      var newPromiseCapabilityModule = __webpack_require__("f069");
      var perform = __webpack_require__("e667");
      var InternalStateModule = __webpack_require__("69f3");
      var isForced = __webpack_require__("94ca");
      var wellKnownSymbol = __webpack_require__("b622");
      var IS_BROWSER = __webpack_require__("6069");
      var IS_NODE = __webpack_require__("605d");
      var V8_VERSION = __webpack_require__("2d00");

      var SPECIES = wellKnownSymbol('species');
      var PROMISE = 'Promise';
      var getInternalState = InternalStateModule.get;
      var setInternalState = InternalStateModule.set;
      var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
      var NativePromisePrototype = NativePromise && NativePromise.prototype;
      var PromiseConstructor = NativePromise;
      var PromiseConstructorPrototype = NativePromisePrototype;
      var TypeError = global.TypeError;
      var document = global.document;
      var process = global.process;
      var newPromiseCapability = newPromiseCapabilityModule.f;
      var newGenericPromiseCapability = newPromiseCapability;
      var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
      var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
      var UNHANDLED_REJECTION = 'unhandledrejection';
      var REJECTION_HANDLED = 'rejectionhandled';
      var PENDING = 0;
      var FULFILLED = 1;
      var REJECTED = 2;
      var HANDLED = 1;
      var UNHANDLED = 2;
      var SUBCLASSING = false;
      var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

      var FORCED = isForced(PROMISE, function () {
        var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
        // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
        // We can't detect it synchronously, so just check versions
        if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
        // We need Promise#finally in the pure version for preventing prototype pollution
        if (IS_PURE && !PromiseConstructorPrototype['finally']) return true;
        // We can't use @@species feature detection in V8 since it causes
        // deoptimization and performance degradation
        // https://github.com/zloirock/core-js/issues/679
        if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
        // Detect correctness of subclassing with @@species support
        var promise = new PromiseConstructor(function (resolve) {
          resolve(1);
        });
        var FakePromise = function (exec) {
          exec(function () {
            /* empty */
          }, function () {
            /* empty */
          });
        };
        var constructor = promise.constructor = {};
        constructor[SPECIES] = FakePromise;
        SUBCLASSING = promise.then(function () {
          /* empty */
        }) instanceof FakePromise;
        if (!SUBCLASSING) return true;
        // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
      });

      var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
        PromiseConstructor.all(iterable)['catch'](function () {
          /* empty */
        });
      });

      // helpers
      var isThenable = function (it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };

      var notify = function (state, isReject) {
        if (state.notified) return;
        state.notified = true;
        var chain = state.reactions;
        microtask(function () {
          var value = state.value;
          var ok = state.state == FULFILLED;
          var index = 0;
          // variable length - can't use forEach
          while (chain.length > index) {
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                  state.rejection = HANDLED;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value); // can throw
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (error) {
              if (domain && !exited) domain.exit();
              reject(error);
            }
          }
          state.reactions = [];
          state.notified = false;
          if (isReject && !state.rejection) onUnhandled(state);
        });
      };

      var dispatchEvent = function (name, promise, reason) {
        var event, handler;
        if (DISPATCH_EVENT) {
          event = document.createEvent('Event');
          event.promise = promise;
          event.reason = reason;
          event.initEvent(name, false, true);
          global.dispatchEvent(event);
        } else event = {
          promise: promise,
          reason: reason
        };
        if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
        else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
      };

      var onUnhandled = function (state) {
        task.call(global, function () {
          var promise = state.facade;
          var value = state.value;
          var IS_UNHANDLED = isUnhandled(state);
          var result;
          if (IS_UNHANDLED) {
            result = perform(function () {
              if (IS_NODE) {
                process.emit('unhandledRejection', value, promise);
              } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error) throw result.value;
          }
        });
      };

      var isUnhandled = function (state) {
        return state.rejection !== HANDLED && !state.parent;
      };

      var onHandleUnhandled = function (state) {
        task.call(global, function () {
          var promise = state.facade;
          if (IS_NODE) {
            process.emit('rejectionHandled', promise);
          } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
        });
      };

      var bind = function (fn, state, unwrap) {
        return function (value) {
          fn(state, value, unwrap);
        };
      };

      var internalReject = function (state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        state.value = value;
        state.state = REJECTED;
        notify(state, true);
      };

      var internalResolve = function (state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        try {
          if (state.facade === value) throw TypeError("Promise can't be resolved itself");
          var then = isThenable(value);
          if (then) {
            microtask(function () {
              var wrapper = {
                done: false
              };
              try {
                then.call(value,
                  bind(internalResolve, wrapper, state),
                  bind(internalReject, wrapper, state)
                );
              } catch (error) {
                internalReject(wrapper, error, state);
              }
            });
          } else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
          }
        } catch (error) {
          internalReject({
            done: false
          }, error, state);
        }
      };

      // constructor polyfill
      if (FORCED) {
        // 25.4.3.1 Promise(executor)
        PromiseConstructor = function Promise(executor) {
          anInstance(this, PromiseConstructor, PROMISE);
          aFunction(executor);
          Internal.call(this);
          var state = getInternalState(this);
          try {
            executor(bind(internalResolve, state), bind(internalReject, state));
          } catch (error) {
            internalReject(state, error);
          }
        };
        PromiseConstructorPrototype = PromiseConstructor.prototype;
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        Internal = function Promise(executor) {
          setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: undefined
          });
        };
        Internal.prototype = redefineAll(PromiseConstructorPrototype, {
          // `Promise.prototype.then` method
          // https://tc39.es/ecma262/#sec-promise.prototype.then
          then: function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = IS_NODE ? process.domain : undefined;
            state.parent = true;
            state.reactions.push(reaction);
            if (state.state != PENDING) notify(state, false);
            return reaction.promise;
          },
          // `Promise.prototype.catch` method
          // https://tc39.es/ecma262/#sec-promise.prototype.catch
          'catch': function (onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function () {
          var promise = new Internal();
          var state = getInternalState(promise);
          this.promise = promise;
          this.resolve = bind(internalResolve, state);
          this.reject = bind(internalReject, state);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === PromiseConstructor || C === PromiseWrapper ?
            new OwnPromiseCapability(C) :
            newGenericPromiseCapability(C);
        };

        if (!IS_PURE && typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
          nativeThen = NativePromisePrototype.then;

          if (!SUBCLASSING) {
            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
            redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
              var that = this;
              return new PromiseConstructor(function (resolve, reject) {
                nativeThen.call(that, resolve, reject);
              }).then(onFulfilled, onRejected);
              // https://github.com/zloirock/core-js/issues/640
            }, {
              unsafe: true
            });

            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
            redefine(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], {
              unsafe: true
            });
          }

          // make `.constructor === Promise` work for native promise-based APIs
          try {
            delete NativePromisePrototype.constructor;
          } catch (error) {
            /* empty */
          }

          // make `instanceof Promise` work for native promise-based APIs
          if (setPrototypeOf) {
            setPrototypeOf(NativePromisePrototype, PromiseConstructorPrototype);
          }
        }
      }

      $({
        global: true,
        wrap: true,
        forced: FORCED
      }, {
        Promise: PromiseConstructor
      });

      setToStringTag(PromiseConstructor, PROMISE, false, true);
      setSpecies(PROMISE);

      PromiseWrapper = getBuiltIn(PROMISE);

      // statics
      $({
        target: PROMISE,
        stat: true,
        forced: FORCED
      }, {
        // `Promise.reject` method
        // https://tc39.es/ecma262/#sec-promise.reject
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          capability.reject.call(undefined, r);
          return capability.promise;
        }
      });

      $({
        target: PROMISE,
        stat: true,
        forced: IS_PURE || FORCED
      }, {
        // `Promise.resolve` method
        // https://tc39.es/ecma262/#sec-promise.resolve
        resolve: function resolve(x) {
          return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
        }
      });

      $({
        target: PROMISE,
        stat: true,
        forced: INCORRECT_ITERATION
      }, {
        // `Promise.all` method
        // https://tc39.es/ecma262/#sec-promise.all
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var $promiseResolve = aFunction(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function (promise) {
              var index = counter++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              $promiseResolve.call(C, promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.error) reject(result.value);
          return capability.promise;
        },
        // `Promise.race` method
        // https://tc39.es/ecma262/#sec-promise.race
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            var $promiseResolve = aFunction(C.resolve);
            iterate(iterable, function (promise) {
              $promiseResolve.call(C, promise).then(capability.resolve, reject);
            });
          });
          if (result.error) reject(result.value);
          return capability.promise;
        }
      });


      /***/
    }),

  /***/
  "e893":
    /***/
    (function (module, exports, __webpack_require__) {

      var has = __webpack_require__("5135");
      var ownKeys = __webpack_require__("56ef");
      var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
      var definePropertyModule = __webpack_require__("9bf2");

      module.exports = function (target, source) {
        var keys = ownKeys(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      };


      /***/
    }),

  /***/
  "e8b5":
    /***/
    (function (module, exports, __webpack_require__) {

      var classof = __webpack_require__("c6b6");

      // `IsArray` abstract operation
      // https://tc39.es/ecma262/#sec-isarray
      // eslint-disable-next-line es/no-array-isarray -- safe
      module.exports = Array.isArray || function isArray(arg) {
        return classof(arg) == 'Array';
      };


      /***/
    }),

  /***/
  "e95a":
    /***/
    (function (module, exports, __webpack_require__) {

      var wellKnownSymbol = __webpack_require__("b622");
      var Iterators = __webpack_require__("3f8c");

      var ITERATOR = wellKnownSymbol('iterator');
      var ArrayPrototype = Array.prototype;

      // check on default Array iterator
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
      };


      /***/
    }),

  /***/
  "f069":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var aFunction = __webpack_require__("1c0b");

      var PromiseCapability = function (C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      };

      // `NewPromiseCapability` abstract operation
      // https://tc39.es/ecma262/#sec-newpromisecapability
      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };


      /***/
    }),

  /***/
  "f5df":
    /***/
    (function (module, exports, __webpack_require__) {

      var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
      var classofRaw = __webpack_require__("c6b6");
      var wellKnownSymbol = __webpack_require__("b622");

      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      // ES3 wrong here
      var CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments;
      }()) == 'Arguments';

      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (error) {
          /* empty */
        }
      };

      // getting tag from ES6+ `Object.prototype.toString`
      module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null'
          // @@toStringTag case
          :
          typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
          // builtinTag case
          :
          CORRECT_ARGUMENTS ? classofRaw(O)
          // ES3 arguments fallback
          :
          (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
      };


      /***/
    }),

  /***/
  "f772":
    /***/
    (function (module, exports, __webpack_require__) {

      var shared = __webpack_require__("5692");
      var uid = __webpack_require__("90e3");

      var keys = shared('keys');

      module.exports = function (key) {
        return keys[key] || (keys[key] = uid(key));
      };


      /***/
    }),

  /***/
  "fb15":
    /***/
    (function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      __webpack_require__.r(__webpack_exports__);

      // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
      // This file is imported into lib/wc client bundles.

      if (typeof window !== 'undefined') {
        var currentScript = window.document.currentScript
        if (true) {
          var getCurrentScript = __webpack_require__("8875")
          currentScript = getCurrentScript()

          // for backward compatibility, because previously we directly included the polyfill
          if (!('currentScript' in document)) {
            Object.defineProperty(document, 'currentScript', {
              get: getCurrentScript
            })
          }
        }

        var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
        if (src) {
          __webpack_require__.p = src[1] // eslint-disable-line
        }
      }

      // Indicate to webpack that this file can be concatenated
      /* harmony default export */
      var setPublicPath = (null);

      // EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
      var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");

      // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/lib/HistogramSlider.vue?vue&type=template&id=3a112b68

      var _hoisted_1 = {
        class: "slider-wrapper"
      };

      function render(_ctx, _cache, $props, $setup, $data, $options) {
        return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("div", {
          style: $options.style,
          id: "parent_".concat($options.elementId),
          class: "vue-histogram-slider-wrapper"
        }, [_ctx.resettable && $data.zoomed ? Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderSlot"])(_ctx.$slots, "default", {
          key: 0,
          reset: $options.reset
        }, function () {
          return [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("button", {
            onClick: _cache[1] || (_cache[1] = function () {
              return $options.reset && $options.reset.apply($options, arguments);
            })
          }, "Reset zoom")];
        }) : Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createCommentVNode"])("", true), (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
          id: $options.elementId,
          class: "vue-histogram-view"
        }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("defs", null, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("clipPath", {
          id: $options.clipId
        }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
          width: "100%",
          height: _ctx.barHeight,
          x: "0",
          y: "0"
        }, null, 8, ["height"])], 8, ["id"])])], 8, ["id"])), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("div", _hoisted_1, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("input", {
          type: "text",
          id: $options.histogramId,
          name: $options.histogramId,
          value: ""
        }, null, 8, ["id", "name"])])], 12, ["id"]);
      }
      // CONCATENATED MODULE: ./src/lib/HistogramSlider.vue?vue&type=template&id=3a112b68

      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
      var es_symbol = __webpack_require__("a4d3");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
      var es_symbol_description = __webpack_require__("e01a");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
      var es_object_to_string = __webpack_require__("d3b7");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
      var es_symbol_iterator = __webpack_require__("d28b");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
      var es_array_iterator = __webpack_require__("e260");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
      var es_string_iterator = __webpack_require__("3ca3");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
      var web_dom_collections_iterator = __webpack_require__("ddb0");

      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







      function _iterableToArrayLimit(arr, i) {
        var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;

        var _s, _e;

        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }
      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
      var es_array_slice = __webpack_require__("fb6a");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
      var es_function_name = __webpack_require__("b0c0");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
      var es_array_from = __webpack_require__("a630");

      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      }
      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js






      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
      var es_promise = __webpack_require__("e6cf");

      // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }
      // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
      var runtime = __webpack_require__("96cf");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
      var es_array_concat = __webpack_require__("99af");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
      var es_number_to_fixed = __webpack_require__("b680");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
      var es_regexp_exec = __webpack_require__("ac1f");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
      var es_string_replace = __webpack_require__("5319");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
      var es_regexp_to_string = __webpack_require__("25f0");

      // EXTERNAL MODULE: ./src/lib/range-slider.js
      var range_slider = __webpack_require__("951d");

      // EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
      var es_number_constructor = __webpack_require__("a9e3");

      // CONCATENATED MODULE: ./src/lib/props.js

      /* harmony default export */
      var props = ({
        data: {
          type: Array,
          required: true
        },
        min: {
          type: Number
        },
        max: {
          type: Number
        },
        clip: {
          type: Boolean,
          default: true
        },
        block: {
          type: Boolean,
          default: false
        },
        grid: {
          type: Boolean,
          default: true
        },
        gridNum: {
          type: Number,
          default: 4
        },
        step: {
          type: Number,
          default: 1
        },
        hideMinMax: {
          type: Boolean,
          default: true
        },
        hideFromTo: {
          type: Boolean,
          default: false
        },
        toFixed: {
          type: Boolean,
          default: false
        },
        fromFixed: {
          type: Boolean,
          default: false
        },
        forceEdges: {
          type: Boolean,
          default: false
        },
        dragInterval: {
          type: Boolean,
          default: false
        },
        keyboard: {
          type: Boolean,
          default: true
        },
        type: {
          type: String,
          default: 'double',
          validator: function validator(value) {
            return ['double', 'single'].indexOf(value) !== -1;
          }
        },
        width: {
          type: [Number, String],
          default: 650
        },
        barHeight: {
          type: Number,
          default: 100
        },
        barWidth: {
          type: Number,
          default: 6
        },
        barGap: {
          type: Number,
          default: 5
        },
        barRadius: {
          type: Number,
          default: 4
        },
        prettify: Function,
        labelColor: {
          type: String,
          default: '#0091ff'
        },
        primaryColor: {
          type: String,
          default: '#0091ff'
        },
        holderColor: {
          type: String,
          default: '#dee4ec'
        },
        handleColor: {
          type: String,
          default: '#ffffff'
        },
        gridTextColor: {
          type: String,
          default: 'silver'
        },
        lineHeight: {
          type: Number,
          default: 6
        },
        transitionDuration: {
          type: Number,
          default: 80
        },
        fontFamily: {
          type: String,
          default: 'Arial, sans-serif'
        },
        fontSize: {
          type: Number,
          default: 12
        },
        histSliderGap: {
          type: Number,
          default: 6
        },
        colors: {
          type: Array
        },
        updateColorOnChange: {
          type: Boolean,
          default: true
        },
        handleSize: {
          type: Number,
          default: 26
        },
        resettable: {
          type: Boolean,
          default: false
        }
      });
      // CONCATENATED MODULE: ./node_modules/d3-array/src/ticks.js
      var e10 = Math.sqrt(50),
        e5 = Math.sqrt(10),
        e2 = Math.sqrt(2);

      /* harmony default export */
      var ticks = (function (start, stop, count) {
        var reverse,
          i = -1,
          n,
          ticks,
          step;

        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [start];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

        if (step > 0) {
          start = Math.ceil(start / step);
          stop = Math.floor(stop / step);
          ticks = new Array(n = Math.ceil(stop - start + 1));
          while (++i < n) ticks[i] = (start + i) * step;
        } else {
          start = Math.floor(start * step);
          stop = Math.ceil(stop * step);
          ticks = new Array(n = Math.ceil(start - stop + 1));
          while (++i < n) ticks[i] = (start - i) / step;
        }

        if (reverse) ticks.reverse();

        return ticks;
      });

      function tickIncrement(start, stop, count) {
        var step = (stop - start) / Math.max(0, count),
          power = Math.floor(Math.log(step) / Math.LN10),
          error = step / Math.pow(10, power);
        return power >= 0 ?
          (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) :
          -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
      }

      function tickStep(start, stop, count) {
        var step0 = Math.abs(stop - start) / Math.max(0, count),
          step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
          error = step0 / step1;
        if (error >= e10) step1 *= 10;
        else if (error >= e5) step1 *= 5;
        else if (error >= e2) step1 *= 2;
        return stop < start ? -step1 : step1;
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/ascending.js
      /* harmony default export */
      var ascending = (function (a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/bisector.js


      /* harmony default export */
      var bisector = (function (compare) {
        if (compare.length === 1) compare = ascendingComparator(compare);
        return {
          left: function (a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) < 0) lo = mid + 1;
              else hi = mid;
            }
            return lo;
          },
          right: function (a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) > 0) hi = mid;
              else lo = mid + 1;
            }
            return lo;
          }
        };
      });

      function ascendingComparator(f) {
        return function (d, x) {
          return ascending(f(d), x);
        };
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/bisect.js



      var ascendingBisect = bisector(ascending);
      var bisectRight = ascendingBisect.right;
      var bisectLeft = ascendingBisect.left;
      /* harmony default export */
      var bisect = (bisectRight);

      // CONCATENATED MODULE: ./node_modules/d3-color/src/define.js
      /* harmony default export */
      var define = (function (constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
      });

      function extend(parent, definition) {
        var prototype = Object.create(parent.prototype);
        for (var key in definition) prototype[key] = definition[key];
        return prototype;
      }

      // CONCATENATED MODULE: ./node_modules/d3-color/src/color.js


      function Color() {}

      var darker = 0.7;
      var brighter = 1 / darker;

      var reI = "\\s*([+-]?\\d+)\\s*",
        reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        reHex = /^#([0-9a-f]{3,8})$/,
        reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
        reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
        reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
        reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
        reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
        reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

      var named = {
        aliceblue: 0xf0f8ff,
        antiquewhite: 0xfaebd7,
        aqua: 0x00ffff,
        aquamarine: 0x7fffd4,
        azure: 0xf0ffff,
        beige: 0xf5f5dc,
        bisque: 0xffe4c4,
        black: 0x000000,
        blanchedalmond: 0xffebcd,
        blue: 0x0000ff,
        blueviolet: 0x8a2be2,
        brown: 0xa52a2a,
        burlywood: 0xdeb887,
        cadetblue: 0x5f9ea0,
        chartreuse: 0x7fff00,
        chocolate: 0xd2691e,
        coral: 0xff7f50,
        cornflowerblue: 0x6495ed,
        cornsilk: 0xfff8dc,
        crimson: 0xdc143c,
        cyan: 0x00ffff,
        darkblue: 0x00008b,
        darkcyan: 0x008b8b,
        darkgoldenrod: 0xb8860b,
        darkgray: 0xa9a9a9,
        darkgreen: 0x006400,
        darkgrey: 0xa9a9a9,
        darkkhaki: 0xbdb76b,
        darkmagenta: 0x8b008b,
        darkolivegreen: 0x556b2f,
        darkorange: 0xff8c00,
        darkorchid: 0x9932cc,
        darkred: 0x8b0000,
        darksalmon: 0xe9967a,
        darkseagreen: 0x8fbc8f,
        darkslateblue: 0x483d8b,
        darkslategray: 0x2f4f4f,
        darkslategrey: 0x2f4f4f,
        darkturquoise: 0x00ced1,
        darkviolet: 0x9400d3,
        deeppink: 0xff1493,
        deepskyblue: 0x00bfff,
        dimgray: 0x696969,
        dimgrey: 0x696969,
        dodgerblue: 0x1e90ff,
        firebrick: 0xb22222,
        floralwhite: 0xfffaf0,
        forestgreen: 0x228b22,
        fuchsia: 0xff00ff,
        gainsboro: 0xdcdcdc,
        ghostwhite: 0xf8f8ff,
        gold: 0xffd700,
        goldenrod: 0xdaa520,
        gray: 0x808080,
        green: 0x008000,
        greenyellow: 0xadff2f,
        grey: 0x808080,
        honeydew: 0xf0fff0,
        hotpink: 0xff69b4,
        indianred: 0xcd5c5c,
        indigo: 0x4b0082,
        ivory: 0xfffff0,
        khaki: 0xf0e68c,
        lavender: 0xe6e6fa,
        lavenderblush: 0xfff0f5,
        lawngreen: 0x7cfc00,
        lemonchiffon: 0xfffacd,
        lightblue: 0xadd8e6,
        lightcoral: 0xf08080,
        lightcyan: 0xe0ffff,
        lightgoldenrodyellow: 0xfafad2,
        lightgray: 0xd3d3d3,
        lightgreen: 0x90ee90,
        lightgrey: 0xd3d3d3,
        lightpink: 0xffb6c1,
        lightsalmon: 0xffa07a,
        lightseagreen: 0x20b2aa,
        lightskyblue: 0x87cefa,
        lightslategray: 0x778899,
        lightslategrey: 0x778899,
        lightsteelblue: 0xb0c4de,
        lightyellow: 0xffffe0,
        lime: 0x00ff00,
        limegreen: 0x32cd32,
        linen: 0xfaf0e6,
        magenta: 0xff00ff,
        maroon: 0x800000,
        mediumaquamarine: 0x66cdaa,
        mediumblue: 0x0000cd,
        mediumorchid: 0xba55d3,
        mediumpurple: 0x9370db,
        mediumseagreen: 0x3cb371,
        mediumslateblue: 0x7b68ee,
        mediumspringgreen: 0x00fa9a,
        mediumturquoise: 0x48d1cc,
        mediumvioletred: 0xc71585,
        midnightblue: 0x191970,
        mintcream: 0xf5fffa,
        mistyrose: 0xffe4e1,
        moccasin: 0xffe4b5,
        navajowhite: 0xffdead,
        navy: 0x000080,
        oldlace: 0xfdf5e6,
        olive: 0x808000,
        olivedrab: 0x6b8e23,
        orange: 0xffa500,
        orangered: 0xff4500,
        orchid: 0xda70d6,
        palegoldenrod: 0xeee8aa,
        palegreen: 0x98fb98,
        paleturquoise: 0xafeeee,
        palevioletred: 0xdb7093,
        papayawhip: 0xffefd5,
        peachpuff: 0xffdab9,
        peru: 0xcd853f,
        pink: 0xffc0cb,
        plum: 0xdda0dd,
        powderblue: 0xb0e0e6,
        purple: 0x800080,
        rebeccapurple: 0x663399,
        red: 0xff0000,
        rosybrown: 0xbc8f8f,
        royalblue: 0x4169e1,
        saddlebrown: 0x8b4513,
        salmon: 0xfa8072,
        sandybrown: 0xf4a460,
        seagreen: 0x2e8b57,
        seashell: 0xfff5ee,
        sienna: 0xa0522d,
        silver: 0xc0c0c0,
        skyblue: 0x87ceeb,
        slateblue: 0x6a5acd,
        slategray: 0x708090,
        slategrey: 0x708090,
        snow: 0xfffafa,
        springgreen: 0x00ff7f,
        steelblue: 0x4682b4,
        tan: 0xd2b48c,
        teal: 0x008080,
        thistle: 0xd8bfd8,
        tomato: 0xff6347,
        turquoise: 0x40e0d0,
        violet: 0xee82ee,
        wheat: 0xf5deb3,
        white: 0xffffff,
        whitesmoke: 0xf5f5f5,
        yellow: 0xffff00,
        yellowgreen: 0x9acd32
      };

      define(Color, color_color, {
        copy: function (channels) {
          return Object.assign(new this.constructor, this, channels);
        },
        displayable: function () {
          return this.rgb().displayable();
        },
        hex: color_formatHex, // Deprecated! Use color.formatHex.
        formatHex: color_formatHex,
        formatHsl: color_formatHsl,
        formatRgb: color_formatRgb,
        toString: color_formatRgb
      });

      function color_formatHex() {
        return this.rgb().formatHex();
      }

      function color_formatHsl() {
        return hslConvert(this).formatHsl();
      }

      function color_formatRgb() {
        return this.rgb().formatRgb();
      }

      function color_color(format) {
        var m, l;
        format = (format + "").trim().toLowerCase();
        return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
            :
            l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
            :
            l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
            :
            l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
            :
            null) // invalid hex
          :
          (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
          :
          (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
          :
          (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
          :
          (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
          :
          (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
          :
          (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
          :
          named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
          :
          format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) :
          null;
      }

      function rgbn(n) {
        return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
      }

      function rgba(r, g, b, a) {
        if (a <= 0) r = g = b = NaN;
        return new Rgb(r, g, b, a);
      }

      function rgbConvert(o) {
        if (!(o instanceof Color)) o = color_color(o);
        if (!o) return new Rgb;
        o = o.rgb();
        return new Rgb(o.r, o.g, o.b, o.opacity);
      }

      function color_rgb(r, g, b, opacity) {
        return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
      }

      function Rgb(r, g, b, opacity) {
        this.r = +r;
        this.g = +g;
        this.b = +b;
        this.opacity = +opacity;
      }

      define(Rgb, color_rgb, extend(Color, {
        brighter: function (k) {
          k = k == null ? brighter : Math.pow(brighter, k);
          return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        darker: function (k) {
          k = k == null ? darker : Math.pow(darker, k);
          return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        rgb: function () {
          return this;
        },
        displayable: function () {
          return (-0.5 <= this.r && this.r < 255.5) &&
            (-0.5 <= this.g && this.g < 255.5) &&
            (-0.5 <= this.b && this.b < 255.5) &&
            (0 <= this.opacity && this.opacity <= 1);
        },
        hex: rgb_formatHex, // Deprecated! Use color.formatHex.
        formatHex: rgb_formatHex,
        formatRgb: rgb_formatRgb,
        toString: rgb_formatRgb
      }));

      function rgb_formatHex() {
        return "#" + hex(this.r) + hex(this.g) + hex(this.b);
      }

      function rgb_formatRgb() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "rgb(" : "rgba(") +
          Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " +
          Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " +
          Math.max(0, Math.min(255, Math.round(this.b) || 0)) +
          (a === 1 ? ")" : ", " + a + ")");
      }

      function hex(value) {
        value = Math.max(0, Math.min(255, Math.round(value) || 0));
        return (value < 16 ? "0" : "") + value.toString(16);
      }

      function hsla(h, s, l, a) {
        if (a <= 0) h = s = l = NaN;
        else if (l <= 0 || l >= 1) h = s = NaN;
        else if (s <= 0) h = NaN;
        return new Hsl(h, s, l, a);
      }

      function hslConvert(o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Color)) o = color_color(o);
        if (!o) return new Hsl;
        if (o instanceof Hsl) return o;
        o = o.rgb();
        var r = o.r / 255,
          g = o.g / 255,
          b = o.b / 255,
          min = Math.min(r, g, b),
          max = Math.max(r, g, b),
          h = NaN,
          s = max - min,
          l = (max + min) / 2;
        if (s) {
          if (r === max) h = (g - b) / s + (g < b) * 6;
          else if (g === max) h = (b - r) / s + 2;
          else h = (r - g) / s + 4;
          s /= l < 0.5 ? max + min : 2 - max - min;
          h *= 60;
        } else {
          s = l > 0 && l < 1 ? 0 : h;
        }
        return new Hsl(h, s, l, o.opacity);
      }

      function hsl(h, s, l, opacity) {
        return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
      }

      function Hsl(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
      }

      define(Hsl, hsl, extend(Color, {
        brighter: function (k) {
          k = k == null ? brighter : Math.pow(brighter, k);
          return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        darker: function (k) {
          k = k == null ? darker : Math.pow(darker, k);
          return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        rgb: function () {
          var h = this.h % 360 + (this.h < 0) * 360,
            s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
            l = this.l,
            m2 = l + (l < 0.5 ? l : 1 - l) * s,
            m1 = 2 * l - m2;
          return new Rgb(
            hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
            hsl2rgb(h, m1, m2),
            hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
            this.opacity
          );
        },
        displayable: function () {
          return (0 <= this.s && this.s <= 1 || isNaN(this.s)) &&
            (0 <= this.l && this.l <= 1) &&
            (0 <= this.opacity && this.opacity <= 1);
        },
        formatHsl: function () {
          var a = this.opacity;
          a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
          return (a === 1 ? "hsl(" : "hsla(") +
            (this.h || 0) + ", " +
            (this.s || 0) * 100 + "%, " +
            (this.l || 0) * 100 + "%" +
            (a === 1 ? ")" : ", " + a + ")");
        }
      }));

      /* From FvD 13.37, CSS Color Module Level 3 */
      function hsl2rgb(h, m1, m2) {
        return (h < 60 ? m1 + (m2 - m1) * h / 60 :
          h < 180 ? m2 :
          h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 :
          m1) * 255;
      }

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basis.js
      function basis(t1, v0, v1, v2, v3) {
        var t2 = t1 * t1,
          t3 = t2 * t1;
        return ((1 - 3 * t1 + 3 * t2 - t3) * v0 +
          (4 - 6 * t2 + 3 * t3) * v1 +
          (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 +
          t3 * v3) / 6;
      }

      /* harmony default export */
      var src_basis = (function (values) {
        var n = values.length - 1;
        return function (t) {
          var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
            v1 = values[i],
            v2 = values[i + 1],
            v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
            v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
          return basis((t - i / n) * n, v0, v1, v2, v3);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basisClosed.js


      /* harmony default export */
      var basisClosed = (function (values) {
        var n = values.length;
        return function (t) {
          var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
            v0 = values[(i + n - 1) % n],
            v1 = values[i % n],
            v2 = values[(i + 1) % n],
            v3 = values[(i + 2) % n];
          return basis((t - i / n) * n, v0, v1, v2, v3);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/constant.js
      /* harmony default export */
      var constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/color.js


      function linear(a, d) {
        return function (t) {
          return a + t * d;
        };
      }

      function exponential(a, b, y) {
        return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y,
          function (t) {
            return Math.pow(a + t * b, y);
          };
      }

      function color_hue(a, b) {
        var d = b - a;
        return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
      }

      function gamma(y) {
        return (y = +y) === 1 ? nogamma : function (a, b) {
          return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
        };
      }

      function nogamma(a, b) {
        var d = b - a;
        return d ? linear(a, d) : constant(isNaN(a) ? b : a);
      }

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/rgb.js





      /* harmony default export */
      var src_rgb = ((function rgbGamma(y) {
        var color = gamma(y);

        function rgb(start, end) {
          var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
            g = color(start.g, end.g),
            b = color(start.b, end.b),
            opacity = nogamma(start.opacity, end.opacity);
          return function (t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
          };
        }

        rgb.gamma = rgbGamma;

        return rgb;
      })(1));

      function rgbSpline(spline) {
        return function (colors) {
          var n = colors.length,
            r = new Array(n),
            g = new Array(n),
            b = new Array(n),
            i, color;
          for (i = 0; i < n; ++i) {
            color = color_rgb(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
          }
          r = spline(r);
          g = spline(g);
          b = spline(b);
          color.opacity = 1;
          return function (t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
          };
        };
      }

      var rgbBasis = rgbSpline(src_basis);
      var rgbBasisClosed = rgbSpline(basisClosed);

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/array.js


      /* harmony default export */
      var array = (function (a, b) {
        var nb = b ? b.length : 0,
          na = a ? Math.min(nb, a.length) : 0,
          x = new Array(na),
          c = new Array(nb),
          i;

        for (i = 0; i < na; ++i) x[i] = src_value(a[i], b[i]);
        for (; i < nb; ++i) c[i] = b[i];

        return function (t) {
          for (i = 0; i < na; ++i) c[i] = x[i](t);
          return c;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/date.js
      /* harmony default export */
      var date = (function (a, b) {
        var d = new Date;
        return a = +a, b -= a,
          function (t) {
            return d.setTime(a + b * t), d;
          };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/number.js
      /* harmony default export */
      var number = (function (a, b) {
        return a = +a, b -= a,
          function (t) {
            return a + b * t;
          };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/object.js


      /* harmony default export */
      var object = (function (a, b) {
        var i = {},
          c = {},
          k;

        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};

        for (k in b) {
          if (k in a) {
            i[k] = src_value(a[k], b[k]);
          } else {
            c[k] = b[k];
          }
        }

        return function (t) {
          for (k in i) c[k] = i[k](t);
          return c;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/string.js


      var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        reB = new RegExp(reA.source, "g");

      function string_zero(b) {
        return function () {
          return b;
        };
      }

      function one(b) {
        return function (t) {
          return b(t) + "";
        };
      }

      /* harmony default export */
      var string = (function (a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
          am, // current match in a
          bm, // current match in b
          bs, // string preceding current number in b, if any
          i = -1, // index in s
          s = [], // string constants and placeholders
          q = []; // number interpolators

        // Coerce inputs to strings.
        a = a + "", b = b + "";

        // Interpolate pairs of numbers in a & b.
        while ((am = reA.exec(a)) &&
          (bm = reB.exec(b))) {
          if ((bs = bm.index) > bi) { // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
          }
          if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
          } else { // interpolate non-matching numbers
            s[++i] = null;
            q.push({
              i: i,
              x: number(am, bm)
            });
          }
          bi = reB.lastIndex;
        }

        // Add remains of b.
        if (bi < b.length) {
          bs = b.slice(bi);
          if (s[i]) s[i] += bs; // coalesce with previous string
          else s[++i] = bs;
        }

        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? (q[0] ?
            one(q[0].x) :
            string_zero(b)) :
          (b = q.length, function (t) {
            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
            return s.join("");
          });
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/value.js









      /* harmony default export */
      var src_value = (function (a, b) {
        var t = typeof b,
          c;
        return b == null || t === "boolean" ? constant(b) :
          (t === "number" ? number :
            t === "string" ? ((c = color_color(b)) ? (b = c, src_rgb) : string) :
            b instanceof color_color ? src_rgb :
            b instanceof Date ? date :
            Array.isArray(b) ? array :
            typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object :
            number)(a, b);
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/discrete.js
      /* harmony default export */
      var discrete = (function (range) {
        var n = range.length;
        return function (t) {
          return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hue.js


      /* harmony default export */
      var src_hue = (function (a, b) {
        var i = color_hue(+a, +b);
        return function (t) {
          var x = i(t);
          return x - 360 * Math.floor(x / 360);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/round.js
      /* harmony default export */
      var round = (function (a, b) {
        return a = +a, b -= a,
          function (t) {
            return Math.round(a + b * t);
          };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/decompose.js
      var degrees = 180 / Math.PI;

      var identity = {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        skewX: 0,
        scaleX: 1,
        scaleY: 1
      };

      /* harmony default export */
      var decompose = (function (a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
          translateX: e,
          translateY: f,
          rotate: Math.atan2(b, a) * degrees,
          skewX: Math.atan(skewX) * degrees,
          scaleX: scaleX,
          scaleY: scaleY
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/parse.js


      var cssNode,
        cssRoot,
        cssView,
        svgNode;

      function parseCss(value) {
        if (value === "none") return identity;
        if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
        cssNode.style.transform = value;
        value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
        cssRoot.removeChild(cssNode);
        value = value.slice(7, -1).split(",");
        return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
      }

      function parseSvg(value) {
        if (value == null) return identity;
        if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
        svgNode.setAttribute("transform", value);
        if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
        value = value.matrix;
        return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
      }

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/index.js



      function interpolateTransform(parse, pxComma, pxParen, degParen) {

        function pop(s) {
          return s.length ? s.pop() + " " : "";
        }

        function translate(xa, ya, xb, yb, s, q) {
          if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
              i: i - 4,
              x: number(xa, xb)
            }, {
              i: i - 2,
              x: number(ya, yb)
            });
          } else if (xb || yb) {
            s.push("translate(" + xb + pxComma + yb + pxParen);
          }
        }

        function rotate(a, b, s, q) {
          if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
              i: s.push(pop(s) + "rotate(", null, degParen) - 2,
              x: number(a, b)
            });
          } else if (b) {
            s.push(pop(s) + "rotate(" + b + degParen);
          }
        }

        function skewX(a, b, s, q) {
          if (a !== b) {
            q.push({
              i: s.push(pop(s) + "skewX(", null, degParen) - 2,
              x: number(a, b)
            });
          } else if (b) {
            s.push(pop(s) + "skewX(" + b + degParen);
          }
        }

        function scale(xa, ya, xb, yb, s, q) {
          if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
              i: i - 4,
              x: number(xa, xb)
            }, {
              i: i - 2,
              x: number(ya, yb)
            });
          } else if (xb !== 1 || yb !== 1) {
            s.push(pop(s) + "scale(" + xb + "," + yb + ")");
          }
        }

        return function (a, b) {
          var s = [], // string constants and placeholders
            q = []; // number interpolators
          a = parse(a), b = parse(b);
          translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
          rotate(a.rotate, b.rotate, s, q);
          skewX(a.skewX, b.skewX, s, q);
          scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
          a = b = null; // gc
          return function (t) {
            var i = -1,
              n = q.length,
              o;
            while (++i < n) s[(o = q[i]).i] = o.x(t);
            return s.join("");
          };
        };
      }

      var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
      var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/zoom.js
      var rho = Math.SQRT2,
        rho2 = 2,
        rho4 = 4,
        epsilon2 = 1e-12;

      function zoom_cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
      }

      function zoom_sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
      }

      function tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
      }

      // p0 = [ux0, uy0, w0]
      // p1 = [ux1, uy1, w1]
      /* harmony default export */
      var zoom = (function (p0, p1) {
        var ux0 = p0[0],
          uy0 = p0[1],
          w0 = p0[2],
          ux1 = p1[0],
          uy1 = p1[1],
          w1 = p1[2],
          dx = ux1 - ux0,
          dy = uy1 - uy0,
          d2 = dx * dx + dy * dy,
          i,
          S;

        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
          S = Math.log(w1 / w0) / rho;
          i = function (t) {
            return [
              ux0 + t * dx,
              uy0 + t * dy,
              w0 * Math.exp(rho * t * S)
            ];
          }
        }

        // General case.
        else {
          var d1 = Math.sqrt(d2),
            b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
            b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
            r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
            r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
          S = (r1 - r0) / rho;
          i = function (t) {
            var s = t * S,
              coshr0 = zoom_cosh(r0),
              u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - zoom_sinh(r0));
            return [
              ux0 + u * dx,
              uy0 + u * dy,
              w0 * coshr0 / zoom_cosh(rho * s + r0)
            ];
          }
        }

        i.duration = S * 1000;

        return i;
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hsl.js



      function hsl_hsl(hue) {
        return function (start, end) {
          var h = hue((start = hsl(start)).h, (end = hsl(end)).h),
            s = nogamma(start.s, end.s),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
          return function (t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
          };
        }
      }

      /* harmony default export */
      var src_hsl = (hsl_hsl(color_hue));
      var hslLong = hsl_hsl(nogamma);

      // CONCATENATED MODULE: ./node_modules/d3-color/src/math.js
      var deg2rad = Math.PI / 180;
      var rad2deg = 180 / Math.PI;

      // CONCATENATED MODULE: ./node_modules/d3-color/src/lab.js




      // https://observablehq.com/@mbostock/lab-and-rgb
      var K = 18,
        Xn = 0.96422,
        Yn = 1,
        Zn = 0.82521,
        t0 = 4 / 29,
        t1 = 6 / 29,
        t2 = 3 * t1 * t1,
        t3 = t1 * t1 * t1;

      function labConvert(o) {
        if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
        if (o instanceof Hcl) return hcl2lab(o);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = rgb2lrgb(o.r),
          g = rgb2lrgb(o.g),
          b = rgb2lrgb(o.b),
          y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
          x, z;
        if (r === g && g === b) x = z = y;
        else {
          x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
          z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
        }
        return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
      }

      function gray(l, opacity) {
        return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
      }

      function lab(l, a, b, opacity) {
        return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
      }

      function Lab(l, a, b, opacity) {
        this.l = +l;
        this.a = +a;
        this.b = +b;
        this.opacity = +opacity;
      }

      define(Lab, lab, extend(Color, {
        brighter: function (k) {
          return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        darker: function (k) {
          return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        rgb: function () {
          var y = (this.l + 16) / 116,
            x = isNaN(this.a) ? y : y + this.a / 500,
            z = isNaN(this.b) ? y : y - this.b / 200;
          x = Xn * lab2xyz(x);
          y = Yn * lab2xyz(y);
          z = Zn * lab2xyz(z);
          return new Rgb(
            lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
            lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
            lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
            this.opacity
          );
        }
      }));

      function xyz2lab(t) {
        return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
      }

      function lab2xyz(t) {
        return t > t1 ? t * t * t : t2 * (t - t0);
      }

      function lrgb2rgb(x) {
        return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
      }

      function rgb2lrgb(x) {
        return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
      }

      function hclConvert(o) {
        if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
        if (!(o instanceof Lab)) o = labConvert(o);
        if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
        var h = Math.atan2(o.b, o.a) * rad2deg;
        return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
      }

      function lch(l, c, h, opacity) {
        return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
      }

      function hcl(h, c, l, opacity) {
        return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
      }

      function Hcl(h, c, l, opacity) {
        this.h = +h;
        this.c = +c;
        this.l = +l;
        this.opacity = +opacity;
      }

      function hcl2lab(o) {
        if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
        var h = o.h * deg2rad;
        return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
      }

      define(Hcl, hcl, extend(Color, {
        brighter: function (k) {
          return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
        },
        darker: function (k) {
          return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
        },
        rgb: function () {
          return hcl2lab(this).rgb();
        }
      }));

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/lab.js



      function lab_lab(start, end) {
        var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
          a = nogamma(start.a, end.a),
          b = nogamma(start.b, end.b),
          opacity = nogamma(start.opacity, end.opacity);
        return function (t) {
          start.l = l(t);
          start.a = a(t);
          start.b = b(t);
          start.opacity = opacity(t);
          return start + "";
        };
      }

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hcl.js



      function hcl_hcl(hue) {
        return function (start, end) {
          var h = hue((start = hcl(start)).h, (end = hcl(end)).h),
            c = nogamma(start.c, end.c),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
          return function (t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
          };
        }
      }

      /* harmony default export */
      var src_hcl = (hcl_hcl(color_hue));
      var hclLong = hcl_hcl(nogamma);

      // CONCATENATED MODULE: ./node_modules/d3-color/src/cubehelix.js




      var A = -0.14861,
        B = +1.78277,
        C = -0.29227,
        D = -0.90649,
        cubehelix_E = +1.97294,
        ED = cubehelix_E * D,
        EB = cubehelix_E * B,
        BC_DA = B * C - D * A;

      function cubehelixConvert(o) {
        if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = o.r / 255,
          g = o.g / 255,
          b = o.b / 255,
          l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
          bl = b - l,
          k = (cubehelix_E * (g - l) - C * bl) / D,
          s = Math.sqrt(k * k + bl * bl) / (cubehelix_E * l * (1 - l)), // NaN if l=0 or l=1
          h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
        return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
      }

      function cubehelix_cubehelix(h, s, l, opacity) {
        return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
      }

      function Cubehelix(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
      }

      define(Cubehelix, cubehelix_cubehelix, extend(Color, {
        brighter: function (k) {
          k = k == null ? brighter : Math.pow(brighter, k);
          return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        darker: function (k) {
          k = k == null ? darker : Math.pow(darker, k);
          return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        rgb: function () {
          var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
            l = +this.l,
            a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
            cosh = Math.cos(h),
            sinh = Math.sin(h);
          return new Rgb(
            255 * (l + a * (A * cosh + B * sinh)),
            255 * (l + a * (C * cosh + D * sinh)),
            255 * (l + a * (cubehelix_E * cosh)),
            this.opacity
          );
        }
      }));

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/cubehelix.js



      function src_cubehelix_cubehelix(hue) {
        return (function cubehelixGamma(y) {
          y = +y;

          function cubehelix(start, end) {
            var h = hue((start = cubehelix_cubehelix(start)).h, (end = cubehelix_cubehelix(end)).h),
              s = nogamma(start.s, end.s),
              l = nogamma(start.l, end.l),
              opacity = nogamma(start.opacity, end.opacity);
            return function (t) {
              start.h = h(t);
              start.s = s(t);
              start.l = l(Math.pow(t, y));
              start.opacity = opacity(t);
              return start + "";
            };
          }

          cubehelix.gamma = cubehelixGamma;

          return cubehelix;
        })(1);
      }

      /* harmony default export */
      var src_cubehelix = (src_cubehelix_cubehelix(color_hue));
      var cubehelixLong = src_cubehelix_cubehelix(nogamma);

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/piecewise.js
      function piecewise_piecewise(interpolate, values) {
        var i = 0,
          n = values.length - 1,
          v = values[0],
          I = new Array(n < 0 ? 0 : n);
        while (i < n) I[i] = interpolate(v, v = values[++i]);
        return function (t) {
          var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
          return I[i](t - i);
        };
      }

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/quantize.js
      /* harmony default export */
      var quantize = (function (interpolator, n) {
        var samples = new Array(n);
        for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
        return samples;
      });

      // CONCATENATED MODULE: ./node_modules/d3-interpolate/src/index.js





















      // CONCATENATED MODULE: ./node_modules/d3-scale/src/constant.js
      /* harmony default export */
      var src_constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-scale/src/number.js
      /* harmony default export */
      var src_number = (function (x) {
        return +x;
      });

      // CONCATENATED MODULE: ./node_modules/d3-scale/src/continuous.js





      var unit = [0, 1];

      function continuous_identity(x) {
        return x;
      }

      function normalize(a, b) {
        return (b -= (a = +a)) ?
          function (x) {
            return (x - a) / b;
          } :
          src_constant(isNaN(b) ? NaN : 0.5);
      }

      function clamper(a, b) {
        var t;
        if (a > b) t = a, a = b, b = t;
        return function (x) {
          return Math.max(a, Math.min(b, x));
        };
      }

      // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
      // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
      function bimap(domain, range, interpolate) {
        var d0 = domain[0],
          d1 = domain[1],
          r0 = range[0],
          r1 = range[1];
        if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
        else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
        return function (x) {
          return r0(d0(x));
        };
      }

      function polymap(domain, range, interpolate) {
        var j = Math.min(domain.length, range.length) - 1,
          d = new Array(j),
          r = new Array(j),
          i = -1;

        // Reverse descending domains.
        if (domain[j] < domain[0]) {
          domain = domain.slice().reverse();
          range = range.slice().reverse();
        }

        while (++i < j) {
          d[i] = normalize(domain[i], domain[i + 1]);
          r[i] = interpolate(range[i], range[i + 1]);
        }

        return function (x) {
          var i = bisect(domain, x, 1, j) - 1;
          return r[i](d[i](x));
        };
      }

      function copy(source, target) {
        return target
          .domain(source.domain())
          .range(source.range())
          .interpolate(source.interpolate())
          .clamp(source.clamp())
          .unknown(source.unknown());
      }

      function transformer() {
        var domain = unit,
          range = unit,
          interpolate = src_value,
          transform,
          untransform,
          unknown,
          clamp = continuous_identity,
          piecewise,
          output,
          input;

        function rescale() {
          var n = Math.min(domain.length, range.length);
          if (clamp !== continuous_identity) clamp = clamper(domain[0], domain[n - 1]);
          piecewise = n > 2 ? polymap : bimap;
          output = input = null;
          return scale;
        }

        function scale(x) {
          return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
        }

        scale.invert = function (y) {
          return clamp(untransform((input || (input = piecewise(range, domain.map(transform), number)))(y)));
        };

        scale.domain = function (_) {
          return arguments.length ? (domain = Array.from(_, src_number), rescale()) : domain.slice();
        };

        scale.range = function (_) {
          return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };

        scale.rangeRound = function (_) {
          return range = Array.from(_), interpolate = round, rescale();
        };

        scale.clamp = function (_) {
          return arguments.length ? (clamp = _ ? true : continuous_identity, rescale()) : clamp !== continuous_identity;
        };

        scale.interpolate = function (_) {
          return arguments.length ? (interpolate = _, rescale()) : interpolate;
        };

        scale.unknown = function (_) {
          return arguments.length ? (unknown = _, scale) : unknown;
        };

        return function (t, u) {
          transform = t, untransform = u;
          return rescale();
        };
      }

      function continuous() {
        return transformer()(continuous_identity, continuous_identity);
      }

      // CONCATENATED MODULE: ./node_modules/d3-scale/src/init.js
      function initRange(domain, range) {
        switch (arguments.length) {
          case 0:
            break;
          case 1:
            this.range(domain);
            break;
          default:
            this.range(range).domain(domain);
            break;
        }
        return this;
      }

      function initInterpolator(domain, interpolator) {
        switch (arguments.length) {
          case 0:
            break;
          case 1:
            this.interpolator(domain);
            break;
          default:
            this.interpolator(interpolator).domain(domain);
            break;
        }
        return this;
      }

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatDecimal.js
      // Computes the decimal coefficient and exponent of the specified number x with
      // significant digits p, where x is positive and p is in [1, 21] or undefined.
      // For example, formatDecimal(1.23) returns ["123", 0].
      /* harmony default export */
      var formatDecimal = (function (x, p) {
        if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
        var i, coefficient = x.slice(0, i);

        // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
        // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
        return [
          coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
          +x.slice(i + 1)
        ];
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/exponent.js


      /* harmony default export */
      var src_exponent = (function (x) {
        return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatGroup.js
      /* harmony default export */
      var formatGroup = (function (grouping, thousands) {
        return function (value, width) {
          var i = value.length,
            t = [],
            j = 0,
            g = grouping[0],
            length = 0;

          while (i > 0 && g > 0) {
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
          }

          return t.reverse().join(thousands);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatNumerals.js
      /* harmony default export */
      var formatNumerals = (function (numerals) {
        return function (value) {
          return value.replace(/[0-9]/g, function (i) {
            return numerals[+i];
          });
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatSpecifier.js
      // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
      var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

      function formatSpecifier(specifier) {
        if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
        var match;
        return new FormatSpecifier({
          fill: match[1],
          align: match[2],
          sign: match[3],
          symbol: match[4],
          zero: match[5],
          width: match[6],
          comma: match[7],
          precision: match[8] && match[8].slice(1),
          trim: match[9],
          type: match[10]
        });
      }

      formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

      function FormatSpecifier(specifier) {
        this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
        this.align = specifier.align === undefined ? ">" : specifier.align + "";
        this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
        this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
        this.zero = !!specifier.zero;
        this.width = specifier.width === undefined ? undefined : +specifier.width;
        this.comma = !!specifier.comma;
        this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
        this.trim = !!specifier.trim;
        this.type = specifier.type === undefined ? "" : specifier.type + "";
      }

      FormatSpecifier.prototype.toString = function () {
        return this.fill +
          this.align +
          this.sign +
          this.symbol +
          (this.zero ? "0" : "") +
          (this.width === undefined ? "" : Math.max(1, this.width | 0)) +
          (this.comma ? "," : "") +
          (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) +
          (this.trim ? "~" : "") +
          this.type;
      };

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatTrim.js
      // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
      /* harmony default export */
      var formatTrim = (function (s) {
        out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
          switch (s[i]) {
            case ".":
              i0 = i1 = i;
              break;
            case "0":
              if (i0 === 0) i0 = i;
              i1 = i;
              break;
            default:
              if (i0 > 0) {
                if (!+s[i]) break out;
                i0 = 0;
              }
              break;
          }
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatPrefixAuto.js


      var prefixExponent;

      /* harmony default export */
      var formatPrefixAuto = (function (x, p) {
        var d = formatDecimal(x, p);
        if (!d) return x + "";
        var coefficient = d[0],
          exponent = d[1],
          i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
          n = coefficient.length;
        return i === n ? coefficient :
          i > n ? coefficient + new Array(i - n + 1).join("0") :
          i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) :
          "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatRounded.js


      /* harmony default export */
      var formatRounded = (function (x, p) {
        var d = formatDecimal(x, p);
        if (!d) return x + "";
        var coefficient = d[0],
          exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient :
          coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) :
          coefficient + new Array(exponent - coefficient.length + 2).join("0");
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/formatTypes.js



      /* harmony default export */
      var formatTypes = ({
        "%": function (x, p) {
          return (x * 100).toFixed(p);
        },
        "b": function (x) {
          return Math.round(x).toString(2);
        },
        "c": function (x) {
          return x + "";
        },
        "d": function (x) {
          return Math.round(x).toString(10);
        },
        "e": function (x, p) {
          return x.toExponential(p);
        },
        "f": function (x, p) {
          return x.toFixed(p);
        },
        "g": function (x, p) {
          return x.toPrecision(p);
        },
        "o": function (x) {
          return Math.round(x).toString(8);
        },
        "p": function (x, p) {
          return formatRounded(x * 100, p);
        },
        "r": formatRounded,
        "s": formatPrefixAuto,
        "X": function (x) {
          return Math.round(x).toString(16).toUpperCase();
        },
        "x": function (x) {
          return Math.round(x).toString(16);
        }
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/identity.js
      /* harmony default export */
      var src_identity = (function (x) {
        return x;
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/locale.js









      var map = Array.prototype.map,
        prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

      /* harmony default export */
      var src_locale = (function (locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? src_identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
          currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
          currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
          decimal = locale.decimal === undefined ? "." : locale.decimal + "",
          numerals = locale.numerals === undefined ? src_identity : formatNumerals(map.call(locale.numerals, String)),
          percent = locale.percent === undefined ? "%" : locale.percent + "",
          minus = locale.minus === undefined ? "-" : locale.minus + "",
          nan = locale.nan === undefined ? "NaN" : locale.nan + "";

        function newFormat(specifier) {
          specifier = formatSpecifier(specifier);

          var fill = specifier.fill,
            align = specifier.align,
            sign = specifier.sign,
            symbol = specifier.symbol,
            zero = specifier.zero,
            width = specifier.width,
            comma = specifier.comma,
            precision = specifier.precision,
            trim = specifier.trim,
            type = specifier.type;

          // The "n" type is an alias for ",g".
          if (type === "n") comma = true, type = "g";

          // The "" type, and any invalid type, is an alias for ".12~g".
          else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

          // If zero fill is specified, padding goes after sign and before digits.
          if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

          // Compute the prefix and suffix.
          // For SI-prefix, the suffix is lazily computed.
          var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
            suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

          // What format function should we use?
          // Is this an integer type?
          // Can this type generate exponential notation?
          var formatType = formatTypes[type],
            maybeSuffix = /[defgprs%]/.test(type);

          // Set the default precision if not specified,
          // or clamp the specified precision to the supported range.
          // For significant precision, it must be in [1, 21].
          // For fixed precision, it must be in [0, 20].
          precision = precision === undefined ? 6 :
            /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) :
            Math.max(0, Math.min(20, precision));

          function format(value) {
            var valuePrefix = prefix,
              valueSuffix = suffix,
              i, n, c;

            if (type === "c") {
              valueSuffix = formatType(value) + valueSuffix;
              value = "";
            } else {
              value = +value;

              // Perform the initial formatting.
              var valueNegative = value < 0;
              value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

              // Trim insignificant zeros.
              if (trim) value = formatTrim(value);

              // If a negative value rounds to zero during formatting, treat as positive.
              if (valueNegative && +value === 0) valueNegative = false;

              // Compute the prefix and suffix.
              valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;

              valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

              // Break the formatted value into the integer “value” part that can be
              // grouped, and fractional or exponential “suffix” part that is not.
              if (maybeSuffix) {
                i = -1, n = value.length;
                while (++i < n) {
                  if (c = value.charCodeAt(i), 48 > c || c > 57) {
                    valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                    value = value.slice(0, i);
                    break;
                  }
                }
              }
            }

            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);

            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length,
              padding = length < width ? new Array(width - length + 1).join(fill) : "";

            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

            // Reconstruct the final output based on the desired alignment.
            switch (align) {
              case "<":
                value = valuePrefix + value + valueSuffix + padding;
                break;
              case "=":
                value = valuePrefix + padding + value + valueSuffix;
                break;
              case "^":
                value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                break;
              default:
                value = padding + valuePrefix + value + valueSuffix;
                break;
            }

            return numerals(value);
          }

          format.toString = function () {
            return specifier + "";
          };

          return format;
        }

        function formatPrefix(specifier, value) {
          var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
            e = Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))) * 3,
            k = Math.pow(10, -e),
            prefix = prefixes[8 + e / 3];
          return function (value) {
            return f(k * value) + prefix;
          };
        }

        return {
          format: newFormat,
          formatPrefix: formatPrefix
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/defaultLocale.js


      var defaultLocale_locale;
      var defaultLocale_format;
      var defaultLocale_formatPrefix;

      defaultLocale({
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["$", ""],
        minus: "-"
      });

      function defaultLocale(definition) {
        defaultLocale_locale = src_locale(definition);
        defaultLocale_format = defaultLocale_locale.format;
        defaultLocale_formatPrefix = defaultLocale_locale.formatPrefix;
        return defaultLocale_locale;
      }

      // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionFixed.js


      /* harmony default export */
      var precisionFixed = (function (step) {
        return Math.max(0, -src_exponent(Math.abs(step)));
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionPrefix.js


      /* harmony default export */
      var precisionPrefix = (function (step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))) * 3 - src_exponent(Math.abs(step)));
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/precisionRound.js


      /* harmony default export */
      var precisionRound = (function (step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, src_exponent(max) - src_exponent(step)) + 1;
      });

      // CONCATENATED MODULE: ./node_modules/d3-format/src/index.js







      // CONCATENATED MODULE: ./node_modules/d3-scale/src/tickFormat.js



      /* harmony default export */
      var tickFormat = (function (start, stop, count, specifier) {
        var step = tickStep(start, stop, count),
          precision;
        specifier = formatSpecifier(specifier == null ? ",f" : specifier);
        switch (specifier.type) {
          case "s": {
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
            return defaultLocale_formatPrefix(specifier, value);
          }
          case "":
          case "e":
          case "g":
          case "p":
          case "r": {
            if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
          }
          case "f":
          case "%": {
            if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
          }
        }
        return defaultLocale_format(specifier);
      });

      // CONCATENATED MODULE: ./node_modules/d3-scale/src/linear.js





      function linearish(scale) {
        var domain = scale.domain;

        scale.ticks = function (count) {
          var d = domain();
          return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
        };

        scale.tickFormat = function (count, specifier) {
          var d = domain();
          return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
        };

        scale.nice = function (count) {
          if (count == null) count = 10;

          var d = domain(),
            i0 = 0,
            i1 = d.length - 1,
            start = d[i0],
            stop = d[i1],
            step;

          if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
          }

          step = tickIncrement(start, stop, count);

          if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = tickIncrement(start, stop, count);
          } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = tickIncrement(start, stop, count);
          }

          if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
          } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
          }

          return scale;
        };

        return scale;
      }

      function linear_linear() {
        var scale = continuous();

        scale.copy = function () {
          return copy(scale, linear_linear());
        };

        initRange.apply(scale, arguments);

        return linearish(scale);
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/min.js
      function min_min(values, valueof) {
        let min;
        if (valueof === undefined) {
          for (const value of values) {
            if (value != null &&
              (min > value || (min === undefined && value >= value))) {
              min = value;
            }
          }
        } else {
          let index = -1;
          for (let value of values) {
            if ((value = valueof(value, ++index, values)) != null &&
              (min > value || (min === undefined && value >= value))) {
              min = value;
            }
          }
        }
        return min;
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/max.js
      function max_max(values, valueof) {
        let max;
        if (valueof === undefined) {
          for (const value of values) {
            if (value != null &&
              (max < value || (max === undefined && value >= value))) {
              max = value;
            }
          }
        } else {
          let index = -1;
          for (let value of values) {
            if ((value = valueof(value, ++index, values)) != null &&
              (max < value || (max === undefined && value >= value))) {
              max = value;
            }
          }
        }
        return max;
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/array.js
      var array_array = Array.prototype;

      var slice = array_array.slice;
      var array_map = array_array.map;

      // CONCATENATED MODULE: ./node_modules/d3-array/src/constant.js
      /* harmony default export */
      var d3_array_src_constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/extent.js
      /* harmony default export */
      var src_extent = (function (values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
          for (const value of values) {
            if (value != null) {
              if (min === undefined) {
                if (value >= value) min = max = value;
              } else {
                if (min > value) min = value;
                if (max < value) max = value;
              }
            }
          }
        } else {
          let index = -1;
          for (let value of values) {
            if ((value = valueof(value, ++index, values)) != null) {
              if (min === undefined) {
                if (value >= value) min = max = value;
              } else {
                if (min > value) min = value;
                if (max < value) max = value;
              }
            }
          }
        }
        return [min, max];
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/identity.js
      /* harmony default export */
      var d3_array_src_identity = (function (x) {
        return x;
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/range.js
      /* harmony default export */
      var src_range = (function (start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

        var i = -1,
          n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
          range = new Array(n);

        while (++i < n) {
          range[i] = start + i * step;
        }

        return range;
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/count.js
      function count_count(values, valueof) {
        let count = 0;
        if (valueof === undefined) {
          for (let value of values) {
            if (value != null && (value = +value) >= value) {
              ++count;
            }
          }
        } else {
          let index = -1;
          for (let value of values) {
            if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
              ++count;
            }
          }
        }
        return count;
      }

      // CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/sturges.js


      /* harmony default export */
      var sturges = (function (values) {
        return Math.ceil(Math.log(count_count(values)) / Math.LN2) + 1;
      });

      // CONCATENATED MODULE: ./node_modules/d3-array/src/bin.js









      /* harmony default export */
      var src_bin = (function () {
        var value = d3_array_src_identity,
          domain = src_extent,
          threshold = sturges;

        function histogram(data) {
          if (!Array.isArray(data)) data = Array.from(data);

          var i,
            n = data.length,
            x,
            values = new Array(n);

          for (i = 0; i < n; ++i) {
            values[i] = value(data[i], i, data);
          }

          var xz = domain(values),
            x0 = xz[0],
            x1 = xz[1],
            tz = threshold(values, x0, x1);

          // Convert number of thresholds into uniform thresholds.
          if (!Array.isArray(tz)) {
            tz = tickStep(x0, x1, tz);
            tz = src_range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
          }

          // Remove any thresholds outside the domain.
          var m = tz.length;
          while (tz[0] <= x0) tz.shift(), --m;
          while (tz[m - 1] > x1) tz.pop(), --m;

          var bins = new Array(m + 1),
            bin;

          // Initialize bins.
          for (i = 0; i <= m; ++i) {
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
          }

          // Assign data to bins by value, ignoring any outside the domain.
          for (i = 0; i < n; ++i) {
            x = values[i];
            if (x0 <= x && x <= x1) {
              bins[bisect(tz, x, 0, m)].push(data[i]);
            }
          }

          return bins;
        }

        histogram.value = function (_) {
          return arguments.length ? (value = typeof _ === "function" ? _ : d3_array_src_constant(_), histogram) : value;
        };

        histogram.domain = function (_) {
          return arguments.length ? (domain = typeof _ === "function" ? _ : d3_array_src_constant([_[0], _[1]]), histogram) : domain;
        };

        histogram.thresholds = function (_) {
          return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? d3_array_src_constant(slice.call(_)) : d3_array_src_constant(_), histogram) : threshold;
        };

        return histogram;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/namespaces.js
      var xhtml = "http://www.w3.org/1999/xhtml";

      /* harmony default export */
      var namespaces = ({
        svg: "http://www.w3.org/2000/svg",
        xhtml: xhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/namespace.js


      /* harmony default export */
      var namespace = (function (name) {
        var prefix = name += "",
          i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return namespaces.hasOwnProperty(prefix) ? {
          space: namespaces[prefix],
          local: name
        } : name;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/creator.js



      function creatorInherit(name) {
        return function () {
          var document = this.ownerDocument,
            uri = this.namespaceURI;
          return uri === xhtml && document.documentElement.namespaceURI === xhtml ?
            document.createElement(name) :
            document.createElementNS(uri, name);
        };
      }

      function creatorFixed(fullname) {
        return function () {
          return this.ownerDocument.createElementNS(fullname.space, fullname.local);
        };
      }

      /* harmony default export */
      var creator = (function (name) {
        var fullname = namespace(name);
        return (fullname.local ?
          creatorFixed :
          creatorInherit)(fullname);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selector.js
      function none() {}

      /* harmony default export */
      var src_selector = (function (selector) {
        return selector == null ? none : function () {
          return this.querySelector(selector);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/select.js



      /* harmony default export */
      var selection_select = (function (select) {
        if (typeof select !== "function") select = src_selector(select);

        for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
            if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
              if ("__data__" in node) subnode.__data__ = node.__data__;
              subgroup[i] = subnode;
            }
          }
        }

        return new Selection(subgroups, this._parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selectorAll.js
      function selectorAll_empty() {
        return [];
      }

      /* harmony default export */
      var selectorAll = (function (selector) {
        return selector == null ? selectorAll_empty : function () {
          return this.querySelectorAll(selector);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectAll.js



      /* harmony default export */
      var selectAll = (function (select) {
        if (typeof select !== "function") select = selectorAll(select);

        for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
            if (node = group[i]) {
              subgroups.push(select.call(node, node.__data__, i, group));
              parents.push(node);
            }
          }
        }

        return new Selection(subgroups, parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/matcher.js
      /* harmony default export */
      var matcher = (function (selector) {
        return function () {
          return this.matches(selector);
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/filter.js



      /* harmony default export */
      var selection_filter = (function (match) {
        if (typeof match !== "function") match = matcher(match);

        for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
            if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
              subgroup.push(node);
            }
          }
        }

        return new Selection(subgroups, this._parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sparse.js
      /* harmony default export */
      var sparse = (function (update) {
        return new Array(update.length);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/enter.js



      /* harmony default export */
      var selection_enter = (function () {
        return new Selection(this._enter || this._groups.map(sparse), this._parents);
      });

      function EnterNode(parent, datum) {
        this.ownerDocument = parent.ownerDocument;
        this.namespaceURI = parent.namespaceURI;
        this._next = null;
        this._parent = parent;
        this.__data__ = datum;
      }

      EnterNode.prototype = {
        constructor: EnterNode,
        appendChild: function (child) {
          return this._parent.insertBefore(child, this._next);
        },
        insertBefore: function (child, next) {
          return this._parent.insertBefore(child, next);
        },
        querySelector: function (selector) {
          return this._parent.querySelector(selector);
        },
        querySelectorAll: function (selector) {
          return this._parent.querySelectorAll(selector);
        }
      };

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/constant.js
      /* harmony default export */
      var d3_selection_src_constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/data.js




      var keyPrefix = "$"; // Protect against keys like “__proto__”.

      function bindIndex(parent, group, enter, update, exit, data) {
        var i = 0,
          node,
          groupLength = group.length,
          dataLength = data.length;

        // Put any non-null nodes that fit into update.
        // Put any null nodes into enter.
        // Put any remaining data into enter.
        for (; i < dataLength; ++i) {
          if (node = group[i]) {
            node.__data__ = data[i];
            update[i] = node;
          } else {
            enter[i] = new EnterNode(parent, data[i]);
          }
        }

        // Put any non-null nodes that don’t fit into exit.
        for (; i < groupLength; ++i) {
          if (node = group[i]) {
            exit[i] = node;
          }
        }
      }

      function bindKey(parent, group, enter, update, exit, data, key) {
        var i,
          node,
          nodeByKeyValue = {},
          groupLength = group.length,
          dataLength = data.length,
          keyValues = new Array(groupLength),
          keyValue;

        // Compute the key for each node.
        // If multiple nodes have the same key, the duplicates are added to exit.
        for (i = 0; i < groupLength; ++i) {
          if (node = group[i]) {
            keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
            if (keyValue in nodeByKeyValue) {
              exit[i] = node;
            } else {
              nodeByKeyValue[keyValue] = node;
            }
          }
        }

        // Compute the key for each datum.
        // If there a node associated with this key, join and add it to update.
        // If there is not (or the key is a duplicate), add it to enter.
        for (i = 0; i < dataLength; ++i) {
          keyValue = keyPrefix + key.call(parent, data[i], i, data);
          if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
          } else {
            enter[i] = new EnterNode(parent, data[i]);
          }
        }

        // Add any remaining nodes that were not bound to data to exit.
        for (i = 0; i < groupLength; ++i) {
          if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
            exit[i] = node;
          }
        }
      }

      /* harmony default export */
      var selection_data = (function (value, key) {
        if (!value) {
          data = new Array(this.size()), j = -1;
          this.each(function (d) {
            data[++j] = d;
          });
          return data;
        }

        var bind = key ? bindKey : bindIndex,
          parents = this._parents,
          groups = this._groups;

        if (typeof value !== "function") value = d3_selection_src_constant(value);

        for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
          var parent = parents[j],
            group = groups[j],
            groupLength = group.length,
            data = value.call(parent, parent && parent.__data__, j, parents),
            dataLength = data.length,
            enterGroup = enter[j] = new Array(dataLength),
            updateGroup = update[j] = new Array(dataLength),
            exitGroup = exit[j] = new Array(groupLength);

          bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

          // Now connect the enter nodes to their following update node, such that
          // appendChild can insert the materialized enter node before this node,
          // rather than at the end of the parent node.
          for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
            if (previous = enterGroup[i0]) {
              if (i0 >= i1) i1 = i0 + 1;
              while (!(next = updateGroup[i1]) && ++i1 < dataLength);
              previous._next = next || null;
            }
          }
        }

        update = new Selection(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/exit.js



      /* harmony default export */
      var selection_exit = (function () {
        return new Selection(this._exit || this._groups.map(sparse), this._parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/join.js
      /* harmony default export */
      var join = (function (onenter, onupdate, onexit) {
        var enter = this.enter(),
          update = this,
          exit = this.exit();
        enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
        if (onupdate != null) update = onupdate(update);
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/merge.js


      /* harmony default export */
      var selection_merge = (function (selection) {

        for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
          for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
            if (node = group0[i] || group1[i]) {
              merge[i] = node;
            }
          }
        }

        for (; j < m0; ++j) {
          merges[j] = groups0[j];
        }

        return new Selection(merges, this._parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/order.js
      /* harmony default export */
      var order = (function () {

        for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
          for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
            if (node = group[i]) {
              if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
              next = node;
            }
          }
        }

        return this;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sort.js


      /* harmony default export */
      var sort = (function (compare) {
        if (!compare) compare = sort_ascending;

        function compareNode(a, b) {
          return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }

        for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
            if (node = group[i]) {
              sortgroup[i] = node;
            }
          }
          sortgroup.sort(compareNode);
        }

        return new Selection(sortgroups, this._parents).order();
      });

      function sort_ascending(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
      }

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/call.js
      /* harmony default export */
      var call = (function () {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/nodes.js
      /* harmony default export */
      var nodes = (function () {
        var nodes = new Array(this.size()),
          i = -1;
        this.each(function () {
          nodes[++i] = this;
        });
        return nodes;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/node.js
      /* harmony default export */
      var selection_node = (function () {

        for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
          for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
            var node = group[i];
            if (node) return node;
          }
        }

        return null;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/size.js
      /* harmony default export */
      var selection_size = (function () {
        var size = 0;
        this.each(function () {
          ++size;
        });
        return size;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/empty.js
      /* harmony default export */
      var selection_empty = (function () {
        return !this.node();
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/each.js
      /* harmony default export */
      var each = (function (callback) {

        for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
          for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
            if (node = group[i]) callback.call(node, node.__data__, i, group);
          }
        }

        return this;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/attr.js


      function attrRemove(name) {
        return function () {
          this.removeAttribute(name);
        };
      }

      function attrRemoveNS(fullname) {
        return function () {
          this.removeAttributeNS(fullname.space, fullname.local);
        };
      }

      function attrConstant(name, value) {
        return function () {
          this.setAttribute(name, value);
        };
      }

      function attrConstantNS(fullname, value) {
        return function () {
          this.setAttributeNS(fullname.space, fullname.local, value);
        };
      }

      function attrFunction(name, value) {
        return function () {
          var v = value.apply(this, arguments);
          if (v == null) this.removeAttribute(name);
          else this.setAttribute(name, v);
        };
      }

      function attrFunctionNS(fullname, value) {
        return function () {
          var v = value.apply(this, arguments);
          if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
          else this.setAttributeNS(fullname.space, fullname.local, v);
        };
      }

      /* harmony default export */
      var attr = (function (name, value) {
        var fullname = namespace(name);

        if (arguments.length < 2) {
          var node = this.node();
          return fullname.local ?
            node.getAttributeNS(fullname.space, fullname.local) :
            node.getAttribute(fullname);
        }

        return this.each((value == null ?
          (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function" ?
            (fullname.local ? attrFunctionNS : attrFunction) :
            (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/window.js
      /* harmony default export */
      var src_window = (function (node) {
        return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
          ||
          (node.document && node) // node is a Window
          ||
          node.defaultView; // node is a Document
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/style.js


      function styleRemove(name) {
        return function () {
          this.style.removeProperty(name);
        };
      }

      function styleConstant(name, value, priority) {
        return function () {
          this.style.setProperty(name, value, priority);
        };
      }

      function styleFunction(name, value, priority) {
        return function () {
          var v = value.apply(this, arguments);
          if (v == null) this.style.removeProperty(name);
          else this.style.setProperty(name, v, priority);
        };
      }

      /* harmony default export */
      var style = (function (name, value, priority) {
        return arguments.length > 1 ?
          this.each((value == null ?
            styleRemove : typeof value === "function" ?
            styleFunction :
            styleConstant)(name, value, priority == null ? "" : priority)) :
          styleValue(this.node(), name);
      });

      function styleValue(node, name) {
        return node.style.getPropertyValue(name) ||
          src_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/property.js
      function propertyRemove(name) {
        return function () {
          delete this[name];
        };
      }

      function propertyConstant(name, value) {
        return function () {
          this[name] = value;
        };
      }

      function propertyFunction(name, value) {
        return function () {
          var v = value.apply(this, arguments);
          if (v == null) delete this[name];
          else this[name] = v;
        };
      }

      /* harmony default export */
      var property = (function (name, value) {
        return arguments.length > 1 ?
          this.each((value == null ?
            propertyRemove : typeof value === "function" ?
            propertyFunction :
            propertyConstant)(name, value)) :
          this.node()[name];
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/classed.js
      function classArray(string) {
        return string.trim().split(/^|\s+/);
      }

      function classList(node) {
        return node.classList || new ClassList(node);
      }

      function ClassList(node) {
        this._node = node;
        this._names = classArray(node.getAttribute("class") || "");
      }

      ClassList.prototype = {
        add: function (name) {
          var i = this._names.indexOf(name);
          if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
          }
        },
        remove: function (name) {
          var i = this._names.indexOf(name);
          if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
          }
        },
        contains: function (name) {
          return this._names.indexOf(name) >= 0;
        }
      };

      function classedAdd(node, names) {
        var list = classList(node),
          i = -1,
          n = names.length;
        while (++i < n) list.add(names[i]);
      }

      function classedRemove(node, names) {
        var list = classList(node),
          i = -1,
          n = names.length;
        while (++i < n) list.remove(names[i]);
      }

      function classedTrue(names) {
        return function () {
          classedAdd(this, names);
        };
      }

      function classedFalse(names) {
        return function () {
          classedRemove(this, names);
        };
      }

      function classedFunction(names, value) {
        return function () {
          (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
        };
      }

      /* harmony default export */
      var classed = (function (name, value) {
        var names = classArray(name + "");

        if (arguments.length < 2) {
          var list = classList(this.node()),
            i = -1,
            n = names.length;
          while (++i < n)
            if (!list.contains(names[i])) return false;
          return true;
        }

        return this.each((typeof value === "function" ?
          classedFunction : value ?
          classedTrue :
          classedFalse)(names, value));
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/text.js
      function textRemove() {
        this.textContent = "";
      }

      function textConstant(value) {
        return function () {
          this.textContent = value;
        };
      }

      function textFunction(value) {
        return function () {
          var v = value.apply(this, arguments);
          this.textContent = v == null ? "" : v;
        };
      }

      /* harmony default export */
      var selection_text = (function (value) {
        return arguments.length ?
          this.each(value == null ?
            textRemove : (typeof value === "function" ?
              textFunction :
              textConstant)(value)) :
          this.node().textContent;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/html.js
      function htmlRemove() {
        this.innerHTML = "";
      }

      function htmlConstant(value) {
        return function () {
          this.innerHTML = value;
        };
      }

      function htmlFunction(value) {
        return function () {
          var v = value.apply(this, arguments);
          this.innerHTML = v == null ? "" : v;
        };
      }

      /* harmony default export */
      var html = (function (value) {
        return arguments.length ?
          this.each(value == null ?
            htmlRemove : (typeof value === "function" ?
              htmlFunction :
              htmlConstant)(value)) :
          this.node().innerHTML;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/raise.js
      function raise() {
        if (this.nextSibling) this.parentNode.appendChild(this);
      }

      /* harmony default export */
      var selection_raise = (function () {
        return this.each(raise);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/lower.js
      function lower() {
        if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
      }

      /* harmony default export */
      var selection_lower = (function () {
        return this.each(lower);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/append.js


      /* harmony default export */
      var append = (function (name) {
        var create = typeof name === "function" ? name : creator(name);
        return this.select(function () {
          return this.appendChild(create.apply(this, arguments));
        });
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/insert.js



      function constantNull() {
        return null;
      }

      /* harmony default export */
      var insert = (function (name, before) {
        var create = typeof name === "function" ? name : creator(name),
          select = before == null ? constantNull : typeof before === "function" ? before : src_selector(before);
        return this.select(function () {
          return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/remove.js
      function remove_remove() {
        var parent = this.parentNode;
        if (parent) parent.removeChild(this);
      }

      /* harmony default export */
      var selection_remove = (function () {
        return this.each(remove_remove);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/clone.js
      function selection_cloneShallow() {
        return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
      }

      function selection_cloneDeep() {
        return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
      }

      /* harmony default export */
      var clone = (function (deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/datum.js
      /* harmony default export */
      var datum = (function (value) {
        return arguments.length ?
          this.property("__data__", value) :
          this.node().__data__;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/on.js
      var filterEvents = {};

      var on_event = null;

      if (typeof document !== "undefined") {
        var on_element = document.documentElement;
        if (!("onmouseenter" in on_element)) {
          filterEvents = {
            mouseenter: "mouseover",
            mouseleave: "mouseout"
          };
        }
      }

      function filterContextListener(listener, index, group) {
        listener = contextListener(listener, index, group);
        return function (event) {
          var related = event.relatedTarget;
          if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
            listener.call(this, event);
          }
        };
      }

      function contextListener(listener, index, group) {
        return function (event1) {
          var event0 = on_event; // Events can be reentrant (e.g., focus).
          on_event = event1;
          try {
            listener.call(this, this.__data__, index, group);
          } finally {
            on_event = event0;
          }
        };
      }

      function parseTypenames(typenames) {
        return typenames.trim().split(/^|\s+/).map(function (t) {
          var name = "",
            i = t.indexOf(".");
          if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
          return {
            type: t,
            name: name
          };
        });
      }

      function onRemove(typename) {
        return function () {
          var on = this.__on;
          if (!on) return;
          for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
            if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
              this.removeEventListener(o.type, o.listener, o.capture);
            } else {
              on[++i] = o;
            }
          }
          if (++i) on.length = i;
          else delete this.__on;
        };
      }

      function onAdd(typename, value, capture) {
        var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
        return function (d, i, group) {
          var on = this.__on,
            o, listener = wrap(value, i, group);
          if (on)
            for (var j = 0, m = on.length; j < m; ++j) {
              if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
              }
            }
          this.addEventListener(typename.type, listener, capture);
          o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
          };
          if (!on) this.__on = [o];
          else on.push(o);
        };
      }

      /* harmony default export */
      var selection_on = (function (typename, value, capture) {
        var typenames = parseTypenames(typename + ""),
          i, n = typenames.length,
          t;

        if (arguments.length < 2) {
          var on = this.node().__on;
          if (on)
            for (var j = 0, m = on.length, o; j < m; ++j) {
              for (i = 0, o = on[j]; i < n; ++i) {
                if ((t = typenames[i]).type === o.type && t.name === o.name) {
                  return o.value;
                }
              }
            }
          return;
        }

        on = value ? onAdd : onRemove;
        if (capture == null) capture = false;
        for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
        return this;
      });

      function customEvent(event1, listener, that, args) {
        var event0 = on_event;
        event1.sourceEvent = on_event;
        on_event = event1;
        try {
          return listener.apply(that, args);
        } finally {
          on_event = event0;
        }
      }

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/dispatch.js


      function dispatchEvent(node, type, params) {
        var window = src_window(node),
          event = window.CustomEvent;

        if (typeof event === "function") {
          event = new event(type, params);
        } else {
          event = window.document.createEvent("Event");
          if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
          else event.initEvent(type, false, false);
        }

        node.dispatchEvent(event);
      }

      function dispatchConstant(type, params) {
        return function () {
          return dispatchEvent(this, type, params);
        };
      }

      function dispatchFunction(type, params) {
        return function () {
          return dispatchEvent(this, type, params.apply(this, arguments));
        };
      }

      /* harmony default export */
      var dispatch = (function (type, params) {
        return this.each((typeof params === "function" ?
          dispatchFunction :
          dispatchConstant)(type, params));
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/index.js
































      var selection_root = [null];

      function Selection(groups, parents) {
        this._groups = groups;
        this._parents = parents;
      }

      function selection_selection() {
        return new Selection([
          [document.documentElement]
        ], selection_root);
      }

      Selection.prototype = selection_selection.prototype = {
        constructor: Selection,
        select: selection_select,
        selectAll: selectAll,
        filter: selection_filter,
        data: selection_data,
        enter: selection_enter,
        exit: selection_exit,
        join: join,
        merge: selection_merge,
        order: order,
        sort: sort,
        call: call,
        nodes: nodes,
        node: selection_node,
        size: selection_size,
        empty: selection_empty,
        each: each,
        attr: attr,
        style: style,
        property: property,
        classed: classed,
        text: selection_text,
        html: html,
        raise: selection_raise,
        lower: selection_lower,
        append: append,
        insert: insert,
        remove: selection_remove,
        clone: clone,
        datum: datum,
        on: selection_on,
        dispatch: dispatch
      };

      /* harmony default export */
      var src_selection = (selection_selection);

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/select.js


      /* harmony default export */
      var src_select = (function (selector) {
        return typeof selector === "string" ?
          new Selection([
            [document.querySelector(selector)]
          ], [document.documentElement]) :
          new Selection([
            [selector]
          ], selection_root);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/create.js



      /* harmony default export */
      var src_create = (function (name) {
        return src_select(creator(name).call(document.documentElement));
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/local.js
      var nextId = 0;

      function local() {
        return new Local;
      }

      function Local() {
        this._ = "@" + (++nextId).toString(36);
      }

      Local.prototype = local.prototype = {
        constructor: Local,
        get: function (node) {
          var id = this._;
          while (!(id in node))
            if (!(node = node.parentNode)) return;
          return node[id];
        },
        set: function (node, value) {
          return node[this._] = value;
        },
        remove: function (node) {
          return this._ in node && delete node[this._];
        },
        toString: function () {
          return this._;
        }
      };

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/sourceEvent.js


      /* harmony default export */
      var sourceEvent = (function () {
        var current = on_event,
          source;
        while (source = current.sourceEvent) current = source;
        return current;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/point.js
      /* harmony default export */
      var src_point = (function (node, event) {
        var svg = node.ownerSVGElement || node;

        if (svg.createSVGPoint) {
          var point = svg.createSVGPoint();
          point.x = event.clientX, point.y = event.clientY;
          point = point.matrixTransform(node.getScreenCTM().inverse());
          return [point.x, point.y];
        }

        var rect = node.getBoundingClientRect();
        return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/mouse.js



      /* harmony default export */
      var mouse = (function (node) {
        var event = sourceEvent();
        if (event.changedTouches) event = event.changedTouches[0];
        return src_point(node, event);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/selectAll.js


      /* harmony default export */
      var src_selectAll = (function (selector) {
        return typeof selector === "string" ?
          new Selection([document.querySelectorAll(selector)], [document.documentElement]) :
          new Selection([selector == null ? [] : selector], selection_root);
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/touch.js



      /* harmony default export */
      var src_touch = (function (node, touches, identifier) {
        if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

        for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
          if ((touch = touches[i]).identifier === identifier) {
            return src_point(node, touch);
          }
        }

        return null;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/touches.js



      /* harmony default export */
      var src_touches = (function (node, touches) {
        if (touches == null) touches = sourceEvent().touches;

        for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
          points[i] = src_point(node, touches[i]);
        }

        return points;
      });

      // CONCATENATED MODULE: ./node_modules/d3-selection/src/index.js



















      // CONCATENATED MODULE: ./node_modules/d3-dispatch/src/dispatch.js
      var noop = {
        value: function () {}
      };

      function dispatch_dispatch() {
        for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
          if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
          _[t] = [];
        }
        return new Dispatch(_);
      }

      function Dispatch(_) {
        this._ = _;
      }

      function dispatch_parseTypenames(typenames, types) {
        return typenames.trim().split(/^|\s+/).map(function (t) {
          var name = "",
            i = t.indexOf(".");
          if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
          if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
          return {
            type: t,
            name: name
          };
        });
      }

      Dispatch.prototype = dispatch_dispatch.prototype = {
        constructor: Dispatch,
        on: function (typename, callback) {
          var _ = this._,
            T = dispatch_parseTypenames(typename + "", _),
            t,
            i = -1,
            n = T.length;

          // If no callback was specified, return the callback of the given type and name.
          if (arguments.length < 2) {
            while (++i < n)
              if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
          }

          // If a type was specified, set the callback for the given type and name.
          // Otherwise, if a null callback was specified, remove callbacks of the given name.
          if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
          while (++i < n) {
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null)
              for (t in _) _[t] = set(_[t], typename.name, null);
          }

          return this;
        },
        copy: function () {
          var copy = {},
            _ = this._;
          for (var t in _) copy[t] = _[t].slice();
          return new Dispatch(copy);
        },
        call: function (type, that) {
          if ((n = arguments.length - 2) > 0)
            for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
          if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
          for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
        },
        apply: function (type, that, args) {
          if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
          for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
        }
      };

      function get(type, name) {
        for (var i = 0, n = type.length, c; i < n; ++i) {
          if ((c = type[i]).name === name) {
            return c.value;
          }
        }
      }

      function set(type, name, callback) {
        for (var i = 0, n = type.length; i < n; ++i) {
          if (type[i].name === name) {
            type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
            break;
          }
        }
        if (callback != null) type.push({
          name: name,
          value: callback
        });
        return type;
      }

      /* harmony default export */
      var src_dispatch = (dispatch_dispatch);

      // CONCATENATED MODULE: ./node_modules/d3-dispatch/src/index.js


      // CONCATENATED MODULE: ./node_modules/d3-timer/src/timer.js
      var timer_frame = 0, // is an animation frame pending?
        timeout = 0, // is a timeout pending?
        interval = 0, // are any timers active?
        pokeDelay = 1000, // how frequently we check for clock skew
        taskHead,
        taskTail,
        clockLast = 0,
        clockNow = 0,
        clockSkew = 0,
        clock = typeof performance === "object" && performance.now ? performance : Date,
        setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) {
          setTimeout(f, 17);
        };

      function now() {
        return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
      }

      function clearNow() {
        clockNow = 0;
      }

      function Timer() {
        this._call =
          this._time =
          this._next = null;
      }

      Timer.prototype = timer.prototype = {
        constructor: Timer,
        restart: function (callback, delay, time) {
          if (typeof callback !== "function") throw new TypeError("callback is not a function");
          time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
          if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
          }
          this._call = callback;
          this._time = time;
          sleep();
        },
        stop: function () {
          if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
          }
        }
      };

      function timer(callback, delay, time) {
        var t = new Timer;
        t.restart(callback, delay, time);
        return t;
      }

      function timerFlush() {
        now(); // Get the current time, if not already set.
        ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
        var t = taskHead,
          e;
        while (t) {
          if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
          t = t._next;
        }
        --timer_frame;
      }

      function wake() {
        clockNow = (clockLast = clock.now()) + clockSkew;
        timer_frame = timeout = 0;
        try {
          timerFlush();
        } finally {
          timer_frame = 0;
          nap();
          clockNow = 0;
        }
      }

      function poke() {
        var now = clock.now(),
          delay = now - clockLast;
        if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
      }

      function nap() {
        var t0, t1 = taskHead,
          t2, time = Infinity;
        while (t1) {
          if (t1._call) {
            if (time > t1._time) time = t1._time;
            t0 = t1, t1 = t1._next;
          } else {
            t2 = t1._next, t1._next = null;
            t1 = t0 ? t0._next = t2 : taskHead = t2;
          }
        }
        taskTail = t0;
        sleep(time);
      }

      function sleep(time) {
        if (timer_frame) return; // Soonest alarm already set, or will be.
        if (timeout) timeout = clearTimeout(timeout);
        var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
        if (delay > 24) {
          if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
          if (interval) interval = clearInterval(interval);
        } else {
          if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
          timer_frame = 1, setFrame(wake);
        }
      }

      // CONCATENATED MODULE: ./node_modules/d3-timer/src/timeout.js


      /* harmony default export */
      var src_timeout = (function (callback, delay, time) {
        var t = new Timer;
        delay = delay == null ? 0 : +delay;
        t.restart(function (elapsed) {
          t.stop();
          callback(elapsed + delay);
        }, delay, time);
        return t;
      });

      // CONCATENATED MODULE: ./node_modules/d3-timer/src/interval.js


      /* harmony default export */
      var src_interval = (function (callback, delay, time) {
        var t = new Timer,
          total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        delay = +delay, time = time == null ? now() : +time;
        t.restart(function tick(elapsed) {
          elapsed += total;
          t.restart(tick, total += delay, time);
          callback(elapsed);
        }, delay, time);
        return t;
      });

      // CONCATENATED MODULE: ./node_modules/d3-timer/src/index.js






      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/schedule.js



      var emptyOn = src_dispatch("start", "end", "cancel", "interrupt");
      var emptyTween = [];

      var CREATED = 0;
      var SCHEDULED = 1;
      var STARTING = 2;
      var STARTED = 3;
      var RUNNING = 4;
      var ENDING = 5;
      var ENDED = 6;

      /* harmony default export */
      var transition_schedule = (function (node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        schedule_create(node, id, {
          name: name,
          index: index, // For context during callback.
          group: group, // For context during callback.
          on: emptyOn,
          tween: emptyTween,
          time: timing.time,
          delay: timing.delay,
          duration: timing.duration,
          ease: timing.ease,
          timer: null,
          state: CREATED
        });
      });

      function schedule_init(node, id) {
        var schedule = schedule_get(node, id);
        if (schedule.state > CREATED) throw new Error("too late; already scheduled");
        return schedule;
      }

      function schedule_set(node, id) {
        var schedule = schedule_get(node, id);
        if (schedule.state > STARTED) throw new Error("too late; already running");
        return schedule;
      }

      function schedule_get(node, id) {
        var schedule = node.__transition;
        if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
        return schedule;
      }

      function schedule_create(node, id, self) {
        var schedules = node.__transition,
          tween;

        // Initialize the self timer when the transition is created.
        // Note the actual delay is not known until the first callback!
        schedules[id] = self;
        self.timer = timer(schedule, 0, self.time);

        function schedule(elapsed) {
          self.state = SCHEDULED;
          self.timer.restart(start, self.delay, self.time);

          // If the elapsed delay is less than our first sleep, start immediately.
          if (self.delay <= elapsed) start(elapsed - self.delay);
        }

        function start(elapsed) {
          var i, j, n, o;

          // If the state is not SCHEDULED, then we previously errored on start.
          if (self.state !== SCHEDULED) return stop();

          for (i in schedules) {
            o = schedules[i];
            if (o.name !== self.name) continue;

            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return src_timeout(start);

            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
              o.state = ENDED;
              o.timer.stop();
              o.on.call("interrupt", node, node.__data__, o.index, o.group);
              delete schedules[i];
            }

            // Cancel any pre-empted transitions.
            else if (+i < id) {
              o.state = ENDED;
              o.timer.stop();
              o.on.call("cancel", node, node.__data__, o.index, o.group);
              delete schedules[i];
            }
          }

          // Defer the first tick to end of the current frame; see d3/d3#1576.
          // Note the transition may be canceled after start and before the first tick!
          // Note this must be scheduled before the start event; see d3/d3-transition#16!
          // Assuming this is successful, subsequent callbacks go straight to tick.
          src_timeout(function () {
            if (self.state === STARTED) {
              self.state = RUNNING;
              self.timer.restart(tick, self.delay, self.time);
              tick(elapsed);
            }
          });

          // Dispatch the start event.
          // Note this must be done before the tween are initialized.
          self.state = STARTING;
          self.on.call("start", node, node.__data__, self.index, self.group);
          if (self.state !== STARTING) return; // interrupted
          self.state = STARTED;

          // Initialize the tween, deleting null tween.
          tween = new Array(n = self.tween.length);
          for (i = 0, j = -1; i < n; ++i) {
            if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
              tween[++j] = o;
            }
          }
          tween.length = j + 1;
        }

        function tick(elapsed) {
          var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
            i = -1,
            n = tween.length;

          while (++i < n) {
            tween[i].call(node, t);
          }

          // Dispatch the end event.
          if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
          }
        }

        function stop() {
          self.state = ENDED;
          self.timer.stop();
          delete schedules[id];
          for (var i in schedules) return; // eslint-disable-line no-unused-vars
          delete node.__transition;
        }
      }

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/interrupt.js


      /* harmony default export */
      var interrupt = (function (node, name) {
        var schedules = node.__transition,
          schedule,
          active,
          empty = true,
          i;

        if (!schedules) return;

        name = name == null ? null : name + "";

        for (i in schedules) {
          if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
          }
          active = schedule.state > STARTING && schedule.state < ENDING;
          schedule.state = ENDED;
          schedule.timer.stop();
          schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
          delete schedules[i];
        }

        if (empty) delete node.__transition;
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/interrupt.js


      /* harmony default export */
      var selection_interrupt = (function (name) {
        return this.each(function () {
          interrupt(this, name);
        });
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/tween.js


      function tweenRemove(id, name) {
        var tween0, tween1;
        return function () {
          var schedule = schedule_set(this, id),
            tween = schedule.tween;

          // If this node shared tween with the previous node,
          // just assign the updated shared tween and we’re done!
          // Otherwise, copy-on-write.
          if (tween !== tween0) {
            tween1 = tween0 = tween;
            for (var i = 0, n = tween1.length; i < n; ++i) {
              if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
              }
            }
          }

          schedule.tween = tween1;
        };
      }

      function tweenFunction(id, name, value) {
        var tween0, tween1;
        if (typeof value !== "function") throw new Error;
        return function () {
          var schedule = schedule_set(this, id),
            tween = schedule.tween;

          // If this node shared tween with the previous node,
          // just assign the updated shared tween and we’re done!
          // Otherwise, copy-on-write.
          if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for (var t = {
                name: name,
                value: value
              }, i = 0, n = tween1.length; i < n; ++i) {
              if (tween1[i].name === name) {
                tween1[i] = t;
                break;
              }
            }
            if (i === n) tween1.push(t);
          }

          schedule.tween = tween1;
        };
      }

      /* harmony default export */
      var transition_tween = (function (name, value) {
        var id = this._id;

        name += "";

        if (arguments.length < 2) {
          var tween = schedule_get(this.node(), id).tween;
          for (var i = 0, n = tween.length, t; i < n; ++i) {
            if ((t = tween[i]).name === name) {
              return t.value;
            }
          }
          return null;
        }

        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
      });

      function tweenValue(transition, name, value) {
        var id = transition._id;

        transition.each(function () {
          var schedule = schedule_set(this, id);
          (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
        });

        return function (node) {
          return schedule_get(node, id).value[name];
        };
      }

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/interpolate.js



      /* harmony default export */
      var transition_interpolate = (function (a, b) {
        var c;
        return (typeof b === "number" ? number :
          b instanceof color_color ? src_rgb :
          (c = color_color(b)) ? (b = c, src_rgb) :
          string)(a, b);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attr.js





      function attr_attrRemove(name) {
        return function () {
          this.removeAttribute(name);
        };
      }

      function attr_attrRemoveNS(fullname) {
        return function () {
          this.removeAttributeNS(fullname.space, fullname.local);
        };
      }

      function attr_attrConstant(name, interpolate, value1) {
        var string00,
          string1 = value1 + "",
          interpolate0;
        return function () {
          var string0 = this.getAttribute(name);
          return string0 === string1 ? null :
            string0 === string00 ? interpolate0 :
            interpolate0 = interpolate(string00 = string0, value1);
        };
      }

      function attr_attrConstantNS(fullname, interpolate, value1) {
        var string00,
          string1 = value1 + "",
          interpolate0;
        return function () {
          var string0 = this.getAttributeNS(fullname.space, fullname.local);
          return string0 === string1 ? null :
            string0 === string00 ? interpolate0 :
            interpolate0 = interpolate(string00 = string0, value1);
        };
      }

      function attr_attrFunction(name, interpolate, value) {
        var string00,
          string10,
          interpolate0;
        return function () {
          var string0, value1 = value(this),
            string1;
          if (value1 == null) return void this.removeAttribute(name);
          string0 = this.getAttribute(name);
          string1 = value1 + "";
          return string0 === string1 ? null :
            string0 === string00 && string1 === string10 ? interpolate0 :
            (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
      }

      function attr_attrFunctionNS(fullname, interpolate, value) {
        var string00,
          string10,
          interpolate0;
        return function () {
          var string0, value1 = value(this),
            string1;
          if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
          string0 = this.getAttributeNS(fullname.space, fullname.local);
          string1 = value1 + "";
          return string0 === string1 ? null :
            string0 === string00 && string1 === string10 ? interpolate0 :
            (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
      }

      /* harmony default export */
      var transition_attr = (function (name, value) {
        var fullname = namespace(name),
          i = fullname === "transform" ? interpolateTransformSvg : transition_interpolate;
        return this.attrTween(name, typeof value === "function" ?
          (fullname.local ? attr_attrFunctionNS : attr_attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) :
          value == null ? (fullname.local ? attr_attrRemoveNS : attr_attrRemove)(fullname) :
          (fullname.local ? attr_attrConstantNS : attr_attrConstant)(fullname, i, value));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attrTween.js


      function attrInterpolate(name, i) {
        return function (t) {
          this.setAttribute(name, i(t));
        };
      }

      function attrInterpolateNS(fullname, i) {
        return function (t) {
          this.setAttributeNS(fullname.space, fullname.local, i(t));
        };
      }

      function attrTweenNS(fullname, value) {
        var t0, i0;

        function tween() {
          var i = value.apply(this, arguments);
          if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
          return t0;
        }
        tween._value = value;
        return tween;
      }

      function attrTween(name, value) {
        var t0, i0;

        function tween() {
          var i = value.apply(this, arguments);
          if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
          return t0;
        }
        tween._value = value;
        return tween;
      }

      /* harmony default export */
      var transition_attrTween = (function (name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = namespace(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/delay.js


      function delayFunction(id, value) {
        return function () {
          schedule_init(this, id).delay = +value.apply(this, arguments);
        };
      }

      function delayConstant(id, value) {
        return value = +value,
          function () {
            schedule_init(this, id).delay = value;
          };
      }

      /* harmony default export */
      var transition_delay = (function (value) {
        var id = this._id;

        return arguments.length ?
          this.each((typeof value === "function" ?
            delayFunction :
            delayConstant)(id, value)) :
          schedule_get(this.node(), id).delay;
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/duration.js


      function durationFunction(id, value) {
        return function () {
          schedule_set(this, id).duration = +value.apply(this, arguments);
        };
      }

      function durationConstant(id, value) {
        return value = +value,
          function () {
            schedule_set(this, id).duration = value;
          };
      }

      /* harmony default export */
      var duration = (function (value) {
        var id = this._id;

        return arguments.length ?
          this.each((typeof value === "function" ?
            durationFunction :
            durationConstant)(id, value)) :
          schedule_get(this.node(), id).duration;
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/ease.js


      function easeConstant(id, value) {
        if (typeof value !== "function") throw new Error;
        return function () {
          schedule_set(this, id).ease = value;
        };
      }

      /* harmony default export */
      var ease = (function (value) {
        var id = this._id;

        return arguments.length ?
          this.each(easeConstant(id, value)) :
          schedule_get(this.node(), id).ease;
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/filter.js



      /* harmony default export */
      var transition_filter = (function (match) {
        if (typeof match !== "function") match = matcher(match);

        for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
            if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
              subgroup.push(node);
            }
          }
        }

        return new Transition(subgroups, this._parents, this._name, this._id);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/merge.js


      /* harmony default export */
      var transition_merge = (function (transition) {
        if (transition._id !== this._id) throw new Error;

        for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
          for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
            if (node = group0[i] || group1[i]) {
              merge[i] = node;
            }
          }
        }

        for (; j < m0; ++j) {
          merges[j] = groups0[j];
        }

        return new Transition(merges, this._parents, this._name, this._id);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/on.js


      function on_start(name) {
        return (name + "").trim().split(/^|\s+/).every(function (t) {
          var i = t.indexOf(".");
          if (i >= 0) t = t.slice(0, i);
          return !t || t === "start";
        });
      }

      function onFunction(id, name, listener) {
        var on0, on1, sit = on_start(name) ? schedule_init : schedule_set;
        return function () {
          var schedule = sit(this, id),
            on = schedule.on;

          // If this node shared a dispatch with the previous node,
          // just assign the updated shared dispatch and we’re done!
          // Otherwise, copy-on-write.
          if (on !== on0)(on1 = (on0 = on).copy()).on(name, listener);

          schedule.on = on1;
        };
      }

      /* harmony default export */
      var transition_on = (function (name, listener) {
        var id = this._id;

        return arguments.length < 2 ?
          schedule_get(this.node(), id).on.on(name) :
          this.each(onFunction(id, name, listener));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/remove.js
      function removeFunction(id) {
        return function () {
          var parent = this.parentNode;
          for (var i in this.__transition)
            if (+i !== id) return;
          if (parent) parent.removeChild(this);
        };
      }

      /* harmony default export */
      var transition_remove = (function () {
        return this.on("end.remove", removeFunction(this._id));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/select.js




      /* harmony default export */
      var transition_select = (function (select) {
        var name = this._name,
          id = this._id;

        if (typeof select !== "function") select = src_selector(select);

        for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
            if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
              if ("__data__" in node) subnode.__data__ = node.__data__;
              subgroup[i] = subnode;
              transition_schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
            }
          }
        }

        return new Transition(subgroups, this._parents, name, id);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selectAll.js




      /* harmony default export */
      var transition_selectAll = (function (select) {
        var name = this._name,
          id = this._id;

        if (typeof select !== "function") select = selectorAll(select);

        for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
            if (node = group[i]) {
              for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
                if (child = children[k]) {
                  transition_schedule(child, name, id, k, children, inherit);
                }
              }
              subgroups.push(children);
              parents.push(node);
            }
          }
        }

        return new Transition(subgroups, parents, name, id);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selection.js


      var selection_Selection = src_selection.prototype.constructor;

      /* harmony default export */
      var transition_selection = (function () {
        return new selection_Selection(this._groups, this._parents);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/style.js






      function styleNull(name, interpolate) {
        var string00,
          string10,
          interpolate0;
        return function () {
          var string0 = styleValue(this, name),
            string1 = (this.style.removeProperty(name), styleValue(this, name));
          return string0 === string1 ? null :
            string0 === string00 && string1 === string10 ? interpolate0 :
            interpolate0 = interpolate(string00 = string0, string10 = string1);
        };
      }

      function style_styleRemove(name) {
        return function () {
          this.style.removeProperty(name);
        };
      }

      function style_styleConstant(name, interpolate, value1) {
        var string00,
          string1 = value1 + "",
          interpolate0;
        return function () {
          var string0 = styleValue(this, name);
          return string0 === string1 ? null :
            string0 === string00 ? interpolate0 :
            interpolate0 = interpolate(string00 = string0, value1);
        };
      }

      function style_styleFunction(name, interpolate, value) {
        var string00,
          string10,
          interpolate0;
        return function () {
          var string0 = styleValue(this, name),
            value1 = value(this),
            string1 = value1 + "";
          if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
          return string0 === string1 ? null :
            string0 === string00 && string1 === string10 ? interpolate0 :
            (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
      }

      function styleMaybeRemove(id, name) {
        var on0, on1, listener0, key = "style." + name,
          event = "end." + key,
          remove;
        return function () {
          var schedule = schedule_set(this, id),
            on = schedule.on,
            listener = schedule.value[key] == null ? remove || (remove = style_styleRemove(name)) : undefined;

          // If this node shared a dispatch with the previous node,
          // just assign the updated shared dispatch and we’re done!
          // Otherwise, copy-on-write.
          if (on !== on0 || listener0 !== listener)(on1 = (on0 = on).copy()).on(event, listener0 = listener);

          schedule.on = on1;
        };
      }

      /* harmony default export */
      var transition_style = (function (name, value, priority) {
        var i = (name += "") === "transform" ? interpolateTransformCss : transition_interpolate;
        return value == null ? this
          .styleTween(name, styleNull(name, i))
          .on("end.style." + name, style_styleRemove(name)) :
          typeof value === "function" ? this
          .styleTween(name, style_styleFunction(name, i, tweenValue(this, "style." + name, value)))
          .each(styleMaybeRemove(this._id, name)) :
          this
          .styleTween(name, style_styleConstant(name, i, value), priority)
          .on("end.style." + name, null);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/styleTween.js
      function styleInterpolate(name, i, priority) {
        return function (t) {
          this.style.setProperty(name, i(t), priority);
        };
      }

      function styleTween(name, value, priority) {
        var t, i0;

        function tween() {
          var i = value.apply(this, arguments);
          if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
          return t;
        }
        tween._value = value;
        return tween;
      }

      /* harmony default export */
      var transition_styleTween = (function (name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/text.js


      function text_textConstant(value) {
        return function () {
          this.textContent = value;
        };
      }

      function text_textFunction(value) {
        return function () {
          var value1 = value(this);
          this.textContent = value1 == null ? "" : value1;
        };
      }

      /* harmony default export */
      var transition_text = (function (value) {
        return this.tween("text", typeof value === "function" ?
          text_textFunction(tweenValue(this, "text", value)) :
          text_textConstant(value == null ? "" : value + ""));
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/transition.js



      /* harmony default export */
      var transition_transition = (function () {
        var name = this._name,
          id0 = this._id,
          id1 = newId();

        for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
            if (node = group[i]) {
              var inherit = schedule_get(node, id0);
              transition_schedule(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
              });
            }
          }
        }

        return new Transition(groups, this._parents, name, id1);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/end.js


      /* harmony default export */
      var transition_end = (function () {
        var on0, on1, that = this,
          id = that._id,
          size = that.size();
        return new Promise(function (resolve, reject) {
          var cancel = {
              value: reject
            },
            end = {
              value: function () {
                if (--size === 0) resolve();
              }
            };

          that.each(function () {
            var schedule = schedule_set(this, id),
              on = schedule.on;

            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
              on1 = (on0 = on).copy();
              on1._.cancel.push(cancel);
              on1._.interrupt.push(cancel);
              on1._.end.push(end);
            }

            schedule.on = on1;
          });
        });
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/index.js




















      var transition_id = 0;

      function Transition(groups, parents, name, id) {
        this._groups = groups;
        this._parents = parents;
        this._name = name;
        this._id = id;
      }

      function src_transition_transition(name) {
        return src_selection().transition(name);
      }

      function newId() {
        return ++transition_id;
      }

      var selection_prototype = src_selection.prototype;

      Transition.prototype = src_transition_transition.prototype = {
        constructor: Transition,
        select: transition_select,
        selectAll: transition_selectAll,
        filter: transition_filter,
        merge: transition_merge,
        selection: transition_selection,
        transition: transition_transition,
        call: selection_prototype.call,
        nodes: selection_prototype.nodes,
        node: selection_prototype.node,
        size: selection_prototype.size,
        empty: selection_prototype.empty,
        each: selection_prototype.each,
        on: transition_on,
        attr: transition_attr,
        attrTween: transition_attrTween,
        style: transition_style,
        styleTween: transition_styleTween,
        text: transition_text,
        remove: transition_remove,
        tween: transition_tween,
        delay: transition_delay,
        duration: duration,
        ease: ease,
        end: transition_end
      };

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/linear.js
      function src_linear_linear(t) {
        return +t;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/quad.js
      function quadIn(t) {
        return t * t;
      }

      function quadOut(t) {
        return t * (2 - t);
      }

      function quadInOut(t) {
        return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/cubic.js
      function cubicIn(t) {
        return t * t * t;
      }

      function cubicOut(t) {
        return --t * t * t + 1;
      }

      function cubicInOut(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/poly.js
      var poly_exponent = 3;

      var polyIn = (function custom(e) {
        e = +e;

        function polyIn(t) {
          return Math.pow(t, e);
        }

        polyIn.exponent = custom;

        return polyIn;
      })(poly_exponent);

      var polyOut = (function custom(e) {
        e = +e;

        function polyOut(t) {
          return 1 - Math.pow(1 - t, e);
        }

        polyOut.exponent = custom;

        return polyOut;
      })(poly_exponent);

      var polyInOut = (function custom(e) {
        e = +e;

        function polyInOut(t) {
          return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
        }

        polyInOut.exponent = custom;

        return polyInOut;
      })(poly_exponent);

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/sin.js
      var pi = Math.PI,
        halfPi = pi / 2;

      function sinIn(t) {
        return 1 - Math.cos(t * halfPi);
      }

      function sinOut(t) {
        return Math.sin(t * halfPi);
      }

      function sinInOut(t) {
        return (1 - Math.cos(pi * t)) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/exp.js
      function expIn(t) {
        return Math.pow(2, 10 * t - 10);
      }

      function expOut(t) {
        return 1 - Math.pow(2, -10 * t);
      }

      function expInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/circle.js
      function circleIn(t) {
        return 1 - Math.sqrt(1 - t * t);
      }

      function circleOut(t) {
        return Math.sqrt(1 - --t * t);
      }

      function circleInOut(t) {
        return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/bounce.js
      var b1 = 4 / 11,
        b2 = 6 / 11,
        b3 = 8 / 11,
        b4 = 3 / 4,
        b5 = 9 / 11,
        b6 = 10 / 11,
        b7 = 15 / 16,
        b8 = 21 / 22,
        b9 = 63 / 64,
        b0 = 1 / b1 / b1;

      function bounceIn(t) {
        return 1 - bounceOut(1 - t);
      }

      function bounceOut(t) {
        return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
      }

      function bounceInOut(t) {
        return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
      }

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/back.js
      var overshoot = 1.70158;

      var backIn = (function custom(s) {
        s = +s;

        function backIn(t) {
          return t * t * ((s + 1) * t - s);
        }

        backIn.overshoot = custom;

        return backIn;
      })(overshoot);

      var backOut = (function custom(s) {
        s = +s;

        function backOut(t) {
          return --t * t * ((s + 1) * t + s) + 1;
        }

        backOut.overshoot = custom;

        return backOut;
      })(overshoot);

      var backInOut = (function custom(s) {
        s = +s;

        function backInOut(t) {
          return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
        }

        backInOut.overshoot = custom;

        return backInOut;
      })(overshoot);

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/elastic.js
      var tau = 2 * Math.PI,
        amplitude = 1,
        period = 0.3;

      var elasticIn = (function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

        function elasticIn(t) {
          return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
        }

        elasticIn.amplitude = function (a) {
          return custom(a, p * tau);
        };
        elasticIn.period = function (p) {
          return custom(a, p);
        };

        return elasticIn;
      })(amplitude, period);

      var elasticOut = (function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

        function elasticOut(t) {
          return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
        }

        elasticOut.amplitude = function (a) {
          return custom(a, p * tau);
        };
        elasticOut.period = function (p) {
          return custom(a, p);
        };

        return elasticOut;
      })(amplitude, period);

      var elasticInOut = (function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

        function elasticInOut(t) {
          return ((t = t * 2 - 1) < 0 ?
            a * Math.pow(2, 10 * t) * Math.sin((s - t) / p) :
            2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
        }

        elasticInOut.amplitude = function (a) {
          return custom(a, p * tau);
        };
        elasticInOut.period = function (p) {
          return custom(a, p);
        };

        return elasticInOut;
      })(amplitude, period);

      // CONCATENATED MODULE: ./node_modules/d3-ease/src/index.js




















      // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/transition.js





      var defaultTiming = {
        time: null, // Set on use.
        delay: 0,
        duration: 250,
        ease: cubicInOut
      };

      function transition_inherit(node, id) {
        var timing;
        while (!(timing = node.__transition) || !(timing = timing[id])) {
          if (!(node = node.parentNode)) {
            return defaultTiming.time = now(), defaultTiming;
          }
        }
        return timing;
      }

      /* harmony default export */
      var selection_transition = (function (name) {
        var id,
          timing;

        if (name instanceof Transition) {
          id = name._id, name = name._name;
        } else {
          id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
        }

        for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
          for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
            if (node = group[i]) {
              transition_schedule(node, name, id, i, group, timing || transition_inherit(node, id));
            }
          }
        }

        return new Transition(groups, this._parents, name, id);
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/index.js




      src_selection.prototype.interrupt = selection_interrupt;
      src_selection.prototype.transition = selection_transition;

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/active.js



      var active_root = [null];

      /* harmony default export */
      var src_active = (function (node, name) {
        var schedules = node.__transition,
          schedule,
          i;

        if (schedules) {
          name = name == null ? null : name + "";
          for (i in schedules) {
            if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
              return new Transition([
                [node]
              ], active_root, name, +i);
            }
          }
        }

        return null;
      });

      // CONCATENATED MODULE: ./node_modules/d3-transition/src/index.js





      // CONCATENATED MODULE: ./node_modules/d3-drag/src/noevent.js


      function nopropagation() {
        on_event.stopImmediatePropagation();
      }

      /* harmony default export */
      var noevent = (function () {
        on_event.preventDefault();
        on_event.stopImmediatePropagation();
      });

      // CONCATENATED MODULE: ./node_modules/d3-drag/src/nodrag.js



      /* harmony default export */
      var nodrag = (function (view) {
        var root = view.document.documentElement,
          selection = src_select(view).on("dragstart.drag", noevent, true);
        if ("onselectstart" in root) {
          selection.on("selectstart.drag", noevent, true);
        } else {
          root.__noselect = root.style.MozUserSelect;
          root.style.MozUserSelect = "none";
        }
      });

      function yesdrag(view, noclick) {
        var root = view.document.documentElement,
          selection = src_select(view).on("dragstart.drag", null);
        if (noclick) {
          selection.on("click.drag", noevent, true);
          setTimeout(function () {
            selection.on("click.drag", null);
          }, 0);
        }
        if ("onselectstart" in root) {
          selection.on("selectstart.drag", null);
        } else {
          root.style.MozUserSelect = root.__noselect;
          delete root.__noselect;
        }
      }

      // CONCATENATED MODULE: ./node_modules/d3-drag/src/constant.js
      /* harmony default export */
      var d3_drag_src_constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-drag/src/event.js
      function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
        this.target = target;
        this.type = type;
        this.subject = subject;
        this.identifier = id;
        this.active = active;
        this.x = x;
        this.y = y;
        this.dx = dx;
        this.dy = dy;
        this._ = dispatch;
      }

      DragEvent.prototype.on = function () {
        var value = this._.on.apply(this._, arguments);
        return value === this._ ? this : value;
      };

      // CONCATENATED MODULE: ./node_modules/d3-drag/src/drag.js







      // Ignore right-click, since that should open the context menu.
      function defaultFilter() {
        return !on_event.ctrlKey && !on_event.button;
      }

      function defaultContainer() {
        return this.parentNode;
      }

      function defaultSubject(d) {
        return d == null ? {
          x: on_event.x,
          y: on_event.y
        } : d;
      }

      function defaultTouchable() {
        return navigator.maxTouchPoints || ("ontouchstart" in this);
      }

      /* harmony default export */
      var src_drag = (function () {
        var filter = defaultFilter,
          container = defaultContainer,
          subject = defaultSubject,
          touchable = defaultTouchable,
          gestures = {},
          listeners = src_dispatch("start", "drag", "end"),
          active = 0,
          mousedownx,
          mousedowny,
          mousemoving,
          touchending,
          clickDistance2 = 0;

        function drag(selection) {
          selection
            .on("mousedown.drag", mousedowned)
            .filter(touchable)
            .on("touchstart.drag", touchstarted)
            .on("touchmove.drag", touchmoved)
            .on("touchend.drag touchcancel.drag", touchended)
            .style("touch-action", "none")
            .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }

        function mousedowned() {
          if (touchending || !filter.apply(this, arguments)) return;
          var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
          if (!gesture) return;
          src_select(on_event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
          nodrag(on_event.view);
          nopropagation();
          mousemoving = false;
          mousedownx = on_event.clientX;
          mousedowny = on_event.clientY;
          gesture("start");
        }

        function mousemoved() {
          noevent();
          if (!mousemoving) {
            var dx = on_event.clientX - mousedownx,
              dy = on_event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
          }
          gestures.mouse("drag");
        }

        function mouseupped() {
          src_select(on_event.view).on("mousemove.drag mouseup.drag", null);
          yesdrag(on_event.view, mousemoving);
          noevent();
          gestures.mouse("end");
        }

        function touchstarted() {
          if (!filter.apply(this, arguments)) return;
          var touches = on_event.changedTouches,
            c = container.apply(this, arguments),
            n = touches.length,
            i, gesture;

          for (i = 0; i < n; ++i) {
            if (gesture = beforestart(touches[i].identifier, c, src_touch, this, arguments)) {
              nopropagation();
              gesture("start");
            }
          }
        }

        function touchmoved() {
          var touches = on_event.changedTouches,
            n = touches.length,
            i, gesture;

          for (i = 0; i < n; ++i) {
            if (gesture = gestures[touches[i].identifier]) {
              noevent();
              gesture("drag");
            }
          }
        }

        function touchended() {
          var touches = on_event.changedTouches,
            n = touches.length,
            i, gesture;

          if (touchending) clearTimeout(touchending);
          touchending = setTimeout(function () {
            touchending = null;
          }, 500); // Ghost clicks are delayed!
          for (i = 0; i < n; ++i) {
            if (gesture = gestures[touches[i].identifier]) {
              nopropagation();
              gesture("end");
            }
          }
        }

        function beforestart(id, container, point, that, args) {
          var p = point(container, id),
            s, dx, dy,
            sublisteners = listeners.copy();

          if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function () {
              if ((on_event.subject = s = subject.apply(that, args)) == null) return false;
              dx = s.x - p[0] || 0;
              dy = s.y - p[1] || 0;
              return true;
            })) return;

          return function gesture(type) {
            var p0 = p,
              n;
            switch (type) {
              case "start":
                gestures[id] = gesture, n = active++;
                break;
              case "end":
                delete gestures[id], --active; // nobreak
              case "drag":
                p = point(container, id), n = active;
                break;
            }
            customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
          };
        }

        drag.filter = function (_) {
          return arguments.length ? (filter = typeof _ === "function" ? _ : d3_drag_src_constant(!!_), drag) : filter;
        };

        drag.container = function (_) {
          return arguments.length ? (container = typeof _ === "function" ? _ : d3_drag_src_constant(_), drag) : container;
        };

        drag.subject = function (_) {
          return arguments.length ? (subject = typeof _ === "function" ? _ : d3_drag_src_constant(_), drag) : subject;
        };

        drag.touchable = function (_) {
          return arguments.length ? (touchable = typeof _ === "function" ? _ : d3_drag_src_constant(!!_), drag) : touchable;
        };

        drag.on = function () {
          var value = listeners.on.apply(listeners, arguments);
          return value === listeners ? drag : value;
        };

        drag.clickDistance = function (_) {
          return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };

        return drag;
      });

      // CONCATENATED MODULE: ./node_modules/d3-drag/src/index.js



      // CONCATENATED MODULE: ./node_modules/d3-brush/src/constant.js
      /* harmony default export */
      var d3_brush_src_constant = (function (x) {
        return function () {
          return x;
        };
      });

      // CONCATENATED MODULE: ./node_modules/d3-brush/src/event.js
      /* harmony default export */
      var src_event = (function (target, type, selection) {
        this.target = target;
        this.type = type;
        this.selection = selection;
      });

      // CONCATENATED MODULE: ./node_modules/d3-brush/src/noevent.js


      function noevent_nopropagation() {
        on_event.stopImmediatePropagation();
      }

      /* harmony default export */
      var src_noevent = (function () {
        on_event.preventDefault();
        on_event.stopImmediatePropagation();
      });

      // CONCATENATED MODULE: ./node_modules/d3-brush/src/brush.js









      var MODE_DRAG = {
          name: "drag"
        },
        MODE_SPACE = {
          name: "space"
        },
        MODE_HANDLE = {
          name: "handle"
        },
        MODE_CENTER = {
          name: "center"
        };

      function number1(e) {
        return [+e[0], +e[1]];
      }

      function number2(e) {
        return [number1(e[0]), number1(e[1])];
      }

      function toucher(identifier) {
        return function (target) {
          return src_touch(target, on_event.touches, identifier);
        };
      }

      var X = {
        name: "x",
        handles: ["w", "e"].map(brush_type),
        input: function (x, e) {
          return x == null ? null : [
            [+x[0], e[0][1]],
            [+x[1], e[1][1]]
          ];
        },
        output: function (xy) {
          return xy && [xy[0][0], xy[1][0]];
        }
      };

      var Y = {
        name: "y",
        handles: ["n", "s"].map(brush_type),
        input: function (y, e) {
          return y == null ? null : [
            [e[0][0], +y[0]],
            [e[1][0], +y[1]]
          ];
        },
        output: function (xy) {
          return xy && [xy[0][1], xy[1][1]];
        }
      };

      var XY = {
        name: "xy",
        handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(brush_type),
        input: function (xy) {
          return xy == null ? null : number2(xy);
        },
        output: function (xy) {
          return xy;
        }
      };

      var cursors = {
        overlay: "crosshair",
        selection: "move",
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
      };

      var flipX = {
        e: "w",
        w: "e",
        nw: "ne",
        ne: "nw",
        se: "sw",
        sw: "se"
      };

      var flipY = {
        n: "s",
        s: "n",
        nw: "sw",
        ne: "se",
        se: "ne",
        sw: "nw"
      };

      var signsX = {
        overlay: +1,
        selection: +1,
        n: null,
        e: +1,
        s: null,
        w: -1,
        nw: -1,
        ne: +1,
        se: +1,
        sw: -1
      };

      var signsY = {
        overlay: +1,
        selection: +1,
        n: -1,
        e: null,
        s: +1,
        w: null,
        nw: -1,
        ne: -1,
        se: +1,
        sw: +1
      };

      function brush_type(t) {
        return {
          type: t
        };
      }

      // Ignore right-click, since that should open the context menu.
      function brush_defaultFilter() {
        return !on_event.ctrlKey && !on_event.button;
      }

      function defaultExtent() {
        var svg = this.ownerSVGElement || this;
        if (svg.hasAttribute("viewBox")) {
          svg = svg.viewBox.baseVal;
          return [
            [svg.x, svg.y],
            [svg.x + svg.width, svg.y + svg.height]
          ];
        }
        return [
          [0, 0],
          [svg.width.baseVal.value, svg.height.baseVal.value]
        ];
      }

      function brush_defaultTouchable() {
        return navigator.maxTouchPoints || ("ontouchstart" in this);
      }

      // Like d3.local, but with the name “__brush” rather than auto-generated.
      function brush_local(node) {
        while (!node.__brush)
          if (!(node = node.parentNode)) return;
        return node.__brush;
      }

      function brush_empty(extent) {
        return extent[0][0] === extent[1][0] ||
          extent[0][1] === extent[1][1];
      }

      function brushSelection(node) {
        var state = node.__brush;
        return state ? state.dim.output(state.selection) : null;
      }

      function brushX() {
        return brush_brush(X);
      }

      function brushY() {
        return brush_brush(Y);
      }

      /* harmony default export */
      var src_brush = (function () {
        return brush_brush(XY);
      });

      function brush_brush(dim) {
        var extent = defaultExtent,
          filter = brush_defaultFilter,
          touchable = brush_defaultTouchable,
          keys = true,
          listeners = src_dispatch(brush, "start", "brush", "end"),
          handleSize = 6,
          touchending;

        function brush(group) {
          var overlay = group
            .property("__brush", initialize)
            .selectAll(".overlay")
            .data([brush_type("overlay")]);

          overlay.enter().append("rect")
            .attr("class", "overlay")
            .attr("pointer-events", "all")
            .attr("cursor", cursors.overlay)
            .merge(overlay)
            .each(function () {
              var extent = brush_local(this).extent;
              src_select(this)
                .attr("x", extent[0][0])
                .attr("y", extent[0][1])
                .attr("width", extent[1][0] - extent[0][0])
                .attr("height", extent[1][1] - extent[0][1]);
            });

          group.selectAll(".selection")
            .data([brush_type("selection")])
            .enter().append("rect")
            .attr("class", "selection")
            .attr("cursor", cursors.selection)
            .attr("fill", "#777")
            .attr("fill-opacity", 0.3)
            .attr("stroke", "#fff")
            .attr("shape-rendering", "crispEdges");

          var handle = group.selectAll(".handle")
            .data(dim.handles, function (d) {
              return d.type;
            });

          handle.exit().remove();

          handle.enter().append("rect")
            .attr("class", function (d) {
              return "handle handle--" + d.type;
            })
            .attr("cursor", function (d) {
              return cursors[d.type];
            });

          group
            .each(redraw)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mousedown.brush", started)
            .filter(touchable)
            .on("touchstart.brush", started)
            .on("touchmove.brush", touchmoved)
            .on("touchend.brush touchcancel.brush", touchended)
            .style("touch-action", "none")
            .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }

        brush.move = function (group, selection) {
          if (group.selection) {
            group
              .on("start.brush", function () {
                emitter(this, arguments).beforestart().start();
              })
              .on("interrupt.brush end.brush", function () {
                emitter(this, arguments).end();
              })
              .tween("brush", function () {
                var that = this,
                  state = that.__brush,
                  emit = emitter(that, arguments),
                  selection0 = state.selection,
                  selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                  i = src_value(selection0, selection1);

                function tween(t) {
                  state.selection = t === 1 && selection1 === null ? null : i(t);
                  redraw.call(that);
                  emit.brush();
                }

                return selection0 !== null && selection1 !== null ? tween : tween(1);
              });
          } else {
            group
              .each(function () {
                var that = this,
                  args = arguments,
                  state = that.__brush,
                  selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                  emit = emitter(that, args).beforestart();

                interrupt(that);
                state.selection = selection1 === null ? null : selection1;
                redraw.call(that);
                emit.start().brush().end();
              });
          }
        };

        brush.clear = function (group) {
          brush.move(group, null);
        };

        function redraw() {
          var group = src_select(this),
            selection = brush_local(this).selection;

          if (selection) {
            group.selectAll(".selection")
              .style("display", null)
              .attr("x", selection[0][0])
              .attr("y", selection[0][1])
              .attr("width", selection[1][0] - selection[0][0])
              .attr("height", selection[1][1] - selection[0][1]);

            group.selectAll(".handle")
              .style("display", null)
              .attr("x", function (d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
              })
              .attr("y", function (d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
              })
              .attr("width", function (d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
              })
              .attr("height", function (d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
              });
          } else {
            group.selectAll(".selection,.handle")
              .style("display", "none")
              .attr("x", null)
              .attr("y", null)
              .attr("width", null)
              .attr("height", null);
          }
        }

        function emitter(that, args, clean) {
          return (!clean && that.__brush.emitter) || new Emitter(that, args);
        }

        function Emitter(that, args) {
          this.that = that;
          this.args = args;
          this.state = that.__brush;
          this.active = 0;
        }

        Emitter.prototype = {
          beforestart: function () {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
          },
          start: function () {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
          },
          brush: function () {
            this.emit("brush");
            return this;
          },
          end: function () {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
          },
          emit: function (type) {
            customEvent(new src_event(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
          }
        };

        function started() {
          if (touchending && !on_event.touches) return;
          if (!filter.apply(this, arguments)) return;

          var that = this,
            type = on_event.target.__data__.type,
            mode = (keys && on_event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (keys && on_event.altKey ? MODE_CENTER : MODE_HANDLE),
            signX = dim === Y ? null : signsX[type],
            signY = dim === X ? null : signsY[type],
            state = brush_local(that),
            extent = state.extent,
            selection = state.selection,
            W = extent[0][0],
            w0, w1,
            N = extent[0][1],
            n0, n1,
            E = extent[1][0],
            e0, e1,
            S = extent[1][1],
            s0, s1,
            dx = 0,
            dy = 0,
            moving,
            shifting = signX && signY && keys && on_event.shiftKey,
            lockX,
            lockY,
            pointer = on_event.touches ? toucher(on_event.changedTouches[0].identifier) : mouse,
            point0 = pointer(that),
            point = point0,
            emit = emitter(that, arguments, true).beforestart();

          if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
              [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
              [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
            ];
          } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
          }

          w1 = w0;
          n1 = n0;
          e1 = e0;
          s1 = s0;

          var group = src_select(that)
            .attr("pointer-events", "none");

          var overlay = group.selectAll(".overlay")
            .attr("cursor", cursors[type]);

          if (on_event.touches) {
            emit.moved = moved;
            emit.ended = ended;
          } else {
            var view = src_select(on_event.view)
              .on("mousemove.brush", moved, true)
              .on("mouseup.brush", ended, true);
            if (keys) view
              .on("keydown.brush", keydowned, true)
              .on("keyup.brush", keyupped, true)

            nodrag(on_event.view);
          }

          noevent_nopropagation();
          interrupt(that);
          redraw.call(that);
          emit.start();

          function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
              if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
              else lockX = true;
            }
            point = point1;
            moving = true;
            src_noevent();
            move();
          }

          function move() {
            var t;

            dx = point[0] - point0[0];
            dy = point[1] - point0[1];

            switch (mode) {
              case MODE_SPACE:
              case MODE_DRAG: {
                if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                break;
              }
              case MODE_HANDLE: {
                if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                break;
              }
              case MODE_CENTER: {
                if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                break;
              }
            }

            if (e1 < w1) {
              signX *= -1;
              t = w0, w0 = e0, e0 = t;
              t = w1, w1 = e1, e1 = t;
              if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
            }

            if (s1 < n1) {
              signY *= -1;
              t = n0, n0 = s0, s0 = t;
              t = n1, n1 = s1, s1 = t;
              if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
            }

            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];

            if (selection[0][0] !== w1 ||
              selection[0][1] !== n1 ||
              selection[1][0] !== e1 ||
              selection[1][1] !== s1) {
              state.selection = [
                [w1, n1],
                [e1, s1]
              ];
              redraw.call(that);
              emit.brush();
            }
          }

          function ended() {
            noevent_nopropagation();
            if (on_event.touches) {
              if (on_event.touches.length) return;
              if (touchending) clearTimeout(touchending);
              touchending = setTimeout(function () {
                touchending = null;
              }, 500); // Ghost clicks are delayed!
            } else {
              yesdrag(on_event.view, moving);
              view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if (brush_empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
          }

          function keydowned() {
            switch (on_event.keyCode) {
              case 16: { // SHIFT
                shifting = signX && signY;
                break;
              }
              case 18: { // ALT
                if (mode === MODE_HANDLE) {
                  if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                  if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                  mode = MODE_CENTER;
                  move();
                }
                break;
              }
              case 32: { // SPACE; takes priority over ALT
                if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                  if (signX < 0) e0 = e1 - dx;
                  else if (signX > 0) w0 = w1 - dx;
                  if (signY < 0) s0 = s1 - dy;
                  else if (signY > 0) n0 = n1 - dy;
                  mode = MODE_SPACE;
                  overlay.attr("cursor", cursors.selection);
                  move();
                }
                break;
              }
              default:
                return;
            }
            src_noevent();
          }

          function keyupped() {
            switch (on_event.keyCode) {
              case 16: { // SHIFT
                if (shifting) {
                  lockX = lockY = shifting = false;
                  move();
                }
                break;
              }
              case 18: { // ALT
                if (mode === MODE_CENTER) {
                  if (signX < 0) e0 = e1;
                  else if (signX > 0) w0 = w1;
                  if (signY < 0) s0 = s1;
                  else if (signY > 0) n0 = n1;
                  mode = MODE_HANDLE;
                  move();
                }
                break;
              }
              case 32: { // SPACE
                if (mode === MODE_SPACE) {
                  if (on_event.altKey) {
                    if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                    if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                    mode = MODE_CENTER;
                  } else {
                    if (signX < 0) e0 = e1;
                    else if (signX > 0) w0 = w1;
                    if (signY < 0) s0 = s1;
                    else if (signY > 0) n0 = n1;
                    mode = MODE_HANDLE;
                  }
                  overlay.attr("cursor", cursors[type]);
                  move();
                }
                break;
              }
              default:
                return;
            }
            src_noevent();
          }
        }

        function touchmoved() {
          emitter(this, arguments).moved();
        }

        function touchended() {
          emitter(this, arguments).ended();
        }

        function initialize() {
          var state = this.__brush || {
            selection: null
          };
          state.extent = number2(extent.apply(this, arguments));
          state.dim = dim;
          return state;
        }

        brush.extent = function (_) {
          return arguments.length ? (extent = typeof _ === "function" ? _ : d3_brush_src_constant(number2(_)), brush) : extent;
        };

        brush.filter = function (_) {
          return arguments.length ? (filter = typeof _ === "function" ? _ : d3_brush_src_constant(!!_), brush) : filter;
        };

        brush.handleSize = function (_) {
          return arguments.length ? (handleSize = +_, brush) : handleSize;
        };

        brush.keyModifiers = function (_) {
          return arguments.length ? (keys = !!_, brush) : keys;
        };

        brush.on = function () {
          var value = listeners.on.apply(listeners, arguments);
          return value === listeners ? brush : value;
        };

        return brush;
      }

      // CONCATENATED MODULE: ./node_modules/d3-brush/src/index.js


      // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/lib/HistogramSlider.vue?vue&type=script&lang=js










      var $ = __webpack_require__("1157");









      /* harmony default export */
      var HistogramSlidervue_type_script_lang_js = ({
        name: 'HistogramSlider',
        props: props,
        data: function data() {
          return {
            zoomed: false,
            uid: this.uuidv4()
          };
        },
        computed: {
          style: function style() {
            return "\n        width: ".concat(this.computedWidth, ";\n        --primary-color: ").concat(this.primaryColor, ";\n        --label-color: ").concat(this.labelColor, ";\n        --holder-color: ").concat(this.holderColor, ";\n        --handle-color: ").concat(this.handleColor, ";\n        --grid-text-color: ").concat(this.gridTextColor, ";\n        --line-height: ").concat(this.lineHeight, "px;\n        --font-family: ").concat(this.fontFamily, ";\n        --font-size: ").concat(this.fontSize, ";\n        --hist-slider-gap: ").concat(-36 + this.histSliderGap, "px;\n        --handle-size: ").concat(this.handleSize, "px;\n      ");
          },
          computedWidth: function computedWidth() {
            return Object.prototype.toString.call(this.width) === '[object String]' ? this.width : this.width + 'px';
          },
          elementId: function elementId() {
            return "vue-histogram-".concat(this.uid);
          },
          histogramId: function histogramId() {
            return "histogram-slider-".concat(this.uid);
          },
          clipId: function clipId() {
            return "clip-".concat(this.uid);
          }
        },
        methods: {
          init: function init() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
              var width, min, max, isTypeSingle, svg, histogram, x, y, hist, bins, colors, brush, updateHistogram;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])();

                    case 2:
                      console.log(_this.elementId);
                      width = document.querySelector("#parent_".concat(_this.elementId)).clientWidth - 20;
                      min = _this.min || min_min(_this.data);
                      max = _this.max || max_max(_this.data);
                      isTypeSingle = _this.type == 'single';

                      _this.updateBarColor = function (val) {
                        var transition = src_transition_transition().duration(_this.transitionDuration);
                        src_transition_transition(transition).selectAll(".vue-histogram-slider-bar-".concat(_this.elementId)).attr('fill', function (d) {
                          if (isTypeSingle) {
                            return d.x0 < val.from ? colors(d.x0) : _this.holderColor;
                          }

                          return d.x0 <= val.to && d.x0 >= val.from ? colors(d.x0) : _this.holderColor;
                        });
                      }; // x scale for time


                      x = linear_linear().domain([min, max]).range([0, width]).clamp(true); // y scale for histogram

                      y = linear_linear().range([_this.barHeight, 0]);
                      svg = src_select("#".concat(_this.elementId)).attr('width', width).attr('height', _this.barHeight);
                      hist = svg.append('g').attr('class', 'histogram');

                      if (_this.clip) {
                        hist.attr('clip-path', "url(#".concat(_this.clipId, ")"));
                      }

                      if (_this.colors) {
                        colors = linear_linear().domain([min, max]).range(_this.colors);
                      } else {
                        colors = function colors() {
                          return _this.primaryColor;
                        };
                      }

                      updateHistogram = function updateHistogram(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                          min = _ref2[0],
                          max = _ref2[1];

                        var transition = src_transition_transition().duration(_this.transitionDuration);
                        hist.selectAll(".vue-histogram-slider-bar-".concat(_this.elementId)).remove();
                        histogram = src_bin().domain(x.domain()).thresholds(width / (_this.barWidth + _this.barGap)); // group data for bars

                        bins = histogram(_this.data);
                        y.domain([0, max_max(bins, function (d) {
                          return d.length;
                        })]);
                        hist.selectAll(".vue-histogram-slider-bar-".concat(_this.elementId)).data(bins).enter().insert('rect', 'rect.overlay').attr('class', "vue-histogram-slider-bar-".concat(_this.elementId)).attr('x', function (d) {
                          return x(d.x0);
                        }).attr('y', function (d) {
                          return y(d.length);
                        }).attr('rx', _this.barRadius).attr('width', _this.barWidth).transition(transition).attr('height', function (d) {
                          return _this.barHeight - y(d.length);
                        }).attr('fill', function (d) {
                          return isTypeSingle ? _this.holderColor : colors(d.x0);
                        });

                        if (_this.ionRangeSlider) {
                          _this.ionRangeSlider.destroy();
                        }

                        _this.histSlider = $("#".concat(_this.histogramId)).ionRangeSlider({
                          skin: 'round',
                          min: min,
                          max: max,
                          from: min,
                          to: max,
                          type: _this.type,
                          grid: _this.grid,
                          step: _this.step,
                          from_fixed: _this.fromFixed,
                          to_fixed: _this.toFixed,
                          hide_min_max: _this.hideMinMax,
                          hide_from_to: _this.hideFromTo,
                          force_edges: _this.forceEdges,
                          drag_interval: _this.dragInterval,
                          grid_num: _this.gridNum,
                          block: _this.block,
                          keyboard: _this.keyboard,
                          prettify: _this.prettify,
                          onStart: function onStart(val) {
                            _this.$emit('start', val);
                          },
                          onUpdate: function onUpdate(val) {
                            _this.$emit('update', val);
                          },
                          onFinish: function onFinish(val) {
                            if (!_this.updateColorOnChange) {
                              _this.updateBarColor(val);
                            }

                            _this.$emit('finish', val);
                          },
                          onChange: function onChange(val) {
                            if (_this.updateColorOnChange) {
                              _this.updateBarColor(val);
                            }

                            _this.$emit('change', val);
                          }
                        });
                        _this.ionRangeSlider = _this.histSlider.data('ionRangeSlider');
                        setTimeout(function () {
                          return _this.updateBarColor(_this.ionRangeSlider.result);
                        }, _this.transitionDuration + 10);
                      };

                      if (_this.clip) {
                        brush = brushX().on('end', function () {
                          var extent = on_event.selection;

                          if (extent) {
                            var domain = [x.invert(extent[0]), x.invert(extent[1])];
                            x.domain(domain);
                            _this.minPos = _this.ionRangeSlider.result.from;
                            _this.maxPos = _this.ionRangeSlider.result.to;
                            var pos = {
                              from: Math.max(domain[0], _this.ionRangeSlider.result.from),
                              to: Math.min(domain[1], _this.ionRangeSlider.result.to)
                            };

                            _this.$emit('finish', pos);

                            _this.$emit('change', pos);

                            _this.zoomed = true;
                            updateHistogram(domain);
                            hist.call(brush.clear);
                          }
                        });
                        hist.call(brush);
                      }

                      updateHistogram([min, max]);

                    case 17:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          },
          update: function update(_ref3) {
            var from = _ref3.from,
              to = _ref3.to;

            if (this.ionRangeSlider) {
              this.ionRangeSlider.update({
                from: from,
                to: to
              });
              this.updateBarColor({
                from: from,
                to: to
              });
            }
          },
          reset: function reset() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/ regeneratorRuntime.mark(function _callee2() {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      src_select("#".concat(_this2.elementId)).selectAll('*').remove();
                      _context2.next = 3;
                      return _this2.init();

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }))();
          },
          uuidv4: function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
              var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
              return v.toString(16);
            });
          }
        },
        mounted: function mounted() {
          var _this3 = this;

          return _asyncToGenerator( /*#__PURE__*/ regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this3.uid = _this3.uuidv4();
                    _context3.next = 3;
                    return _this3.init();

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))();
        },
        unmounted: function unmounted() {
          this.ionRangeSlider.destroy();
        }
      });
      // CONCATENATED MODULE: ./src/lib/HistogramSlider.vue?vue&type=script&lang=js

      // EXTERNAL MODULE: ./src/lib/HistogramSlider.vue?vue&type=style&index=0&id=3a112b68&lang=css
      var HistogramSlidervue_type_style_index_0_id_3a112b68_lang_css = __webpack_require__("c410");

      // CONCATENATED MODULE: ./src/lib/HistogramSlider.vue





      HistogramSlidervue_type_script_lang_js.render = render

      /* harmony default export */
      var HistogramSlider = (HistogramSlidervue_type_script_lang_js);
      // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


      /* harmony default export */
      var entry_lib = __webpack_exports__["default"] = (HistogramSlider);



      /***/
    }),

  /***/
  "fb6a":
    /***/
    (function (module, exports, __webpack_require__) {

      "use strict";

      var $ = __webpack_require__("23e7");
      var isObject = __webpack_require__("861d");
      var isArray = __webpack_require__("e8b5");
      var toAbsoluteIndex = __webpack_require__("23cb");
      var toLength = __webpack_require__("50c4");
      var toIndexedObject = __webpack_require__("fc6a");
      var createProperty = __webpack_require__("8418");
      var wellKnownSymbol = __webpack_require__("b622");
      var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

      var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

      var SPECIES = wellKnownSymbol('species');
      var nativeSlice = [].slice;
      var max = Math.max;

      // `Array.prototype.slice` method
      // https://tc39.es/ecma262/#sec-array.prototype.slice
      // fallback for not array-like ES3 strings and DOM objects
      $({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT
      }, {
        slice: function slice(start, end) {
          var O = toIndexedObject(this);
          var length = toLength(O.length);
          var k = toAbsoluteIndex(start, length);
          var fin = toAbsoluteIndex(end === undefined ? length : end, length);
          // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
          var Constructor, result, n;
          if (isArray(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
              Constructor = undefined;
            } else if (isObject(Constructor)) {
              Constructor = Constructor[SPECIES];
              if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === Array || Constructor === undefined) {
              return nativeSlice.call(O, k, fin);
            }
          }
          result = new(Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
          for (n = 0; k < fin; k++, n++)
            if (k in O) createProperty(result, n, O[k]);
          result.length = n;
          return result;
        }
      });


      /***/
    }),

  /***/
  "fc6a":
    /***/
    (function (module, exports, __webpack_require__) {

      // toObject with fallback for non-array-like ES3 strings
      var IndexedObject = __webpack_require__("44ad");
      var requireObjectCoercible = __webpack_require__("1d80");

      module.exports = function (it) {
        return IndexedObject(requireObjectCoercible(it));
      };


      /***/
    }),

  /***/
  "fce3":
    /***/
    (function (module, exports, __webpack_require__) {

      var fails = __webpack_require__("d039");

      module.exports = fails(function () {
        // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
        var re = RegExp('.', (typeof '').charAt(0));
        return !(re.dotAll && re.exec('\n') && re.flags === 's');
      });


      /***/
    }),

  /***/
  "fdbc":
    /***/
    (function (module, exports) {

      // iterable DOM collections
      // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
      module.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };


      /***/
    }),

  /***/
  "fdbf":
    /***/
    (function (module, exports, __webpack_require__) {

      /* eslint-disable es/no-symbol -- required for testing */
      var NATIVE_SYMBOL = __webpack_require__("4930");

      module.exports = NATIVE_SYMBOL &&
        !Symbol.sham &&
        typeof Symbol.iterator == 'symbol';


      /***/
    }),

  /***/
  "fea9":
    /***/
    (function (module, exports, __webpack_require__) {

      var global = __webpack_require__("da84");

      module.exports = global.Promise;


      /***/
    })

  /******/
})["default"];
//# sourceMappingURL=histogram-slider.common.js.map
